/* eslint-disable */
var SLDP = (function (e) {
  function t(r) {
    if (i[r]) return i[r].exports;
    var n = (i[r] = { i: r, l: !1, exports: {} });
    return e[r].call(n.exports, n, n.exports, t), (n.l = !0), n.exports;
  }
  var i = {};
  return (
    (t.m = e),
    (t.c = i),
    (t.i = function (e) {
      return e;
    }),
    (t.d = function (e, i, r) {
      t.o(e, i) ||
        Object.defineProperty(e, i, {
          configurable: !1,
          enumerable: !0,
          get: r,
        });
    }),
    (t.n = function (e) {
      var i =
        e && e.__esModule
          ? function () {
              return e.default;
            }
          : function () {
              return e;
            };
      return t.d(i, "a", i), i;
    }),
    (t.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }),
    (t.p = ""),
    t((t.s = 225))
  );
})([
  function (e, t, i) {
    var r = i(1),
      n = i(8);
    r(
      { target: "Object", stat: !0, forced: !n, sham: !n },
      { defineProperty: i(12).f }
    );
  },
  function (e, t, i) {
    var r = i(4),
      n = i(81).f,
      s = i(15),
      a = i(17),
      o = i(106),
      u = i(125),
      c = i(197);
    e.exports = function (e, t) {
      var i,
        l,
        h,
        f,
        d,
        p = e.target,
        v = e.global,
        m = e.stat;
      if ((i = v ? r : m ? r[p] || o(p, {}) : (r[p] || {}).prototype))
        for (l in t) {
          if (
            ((f = t[l]),
            (h = e.noTargetGet ? (d = n(i, l)) && d.value : i[l]),
            !c(v ? l : p + (m ? "." : "#") + l, e.forced) && void 0 !== h)
          ) {
            if (typeof f == typeof h) continue;
            u(f, h);
          }
          (e.sham || (h && h.sham)) && s(f, "sham", !0), a(i, l, f, e);
        }
    };
  },
  function (e, t, i) {
    "use strict";
    var r,
      n = i(95),
      s = i(8),
      a = i(4),
      o = i(9),
      u = i(11),
      c = i(61),
      l = i(15),
      h = i(17),
      f = i(12).f,
      d = i(66),
      p = i(56),
      v = i(5),
      m = i(85),
      g = a.Int8Array,
      y = g && g.prototype,
      _ = a.Uint8ClampedArray,
      b = _ && _.prototype,
      A = g && d(g),
      w = y && d(y),
      S = Object.prototype,
      k = S.isPrototypeOf,
      T = v("toStringTag"),
      x = m("TYPED_ARRAY_TAG"),
      C = n && !!p && "Opera" !== c(a.opera),
      E = !1,
      P = {
        Int8Array: 1,
        Uint8Array: 1,
        Uint8ClampedArray: 1,
        Int16Array: 2,
        Uint16Array: 2,
        Int32Array: 4,
        Uint32Array: 4,
        Float32Array: 4,
        Float64Array: 8,
      },
      B = { BigInt64Array: 8, BigUint64Array: 8 },
      I = function (e) {
        if (!o(e)) return !1;
        var t = c(e);
        return u(P, t) || u(B, t);
      };
    for (r in P) a[r] || (C = !1);
    if (
      (!C || "function" != typeof A || A === Function.prototype) &&
      ((A = function () {
        throw TypeError("Incorrect invocation");
      }),
      C)
    )
      for (r in P) a[r] && p(a[r], A);
    if ((!C || !w || w === S) && ((w = A.prototype), C))
      for (r in P) a[r] && p(a[r].prototype, w);
    if ((C && d(b) !== w && p(b, w), s && !u(w, T)))
      for (r in ((E = !0),
      f(w, T, {
        get: function () {
          return o(this) ? this[x] : void 0;
        },
      }),
      P))
        a[r] && l(a[r], x, r);
    e.exports = {
      NATIVE_ARRAY_BUFFER_VIEWS: C,
      TYPED_ARRAY_TAG: E && x,
      aTypedArray: function (e) {
        if (I(e)) return e;
        throw TypeError("Target is not a typed array");
      },
      aTypedArrayConstructor: function (e) {
        if (p) {
          if (k.call(A, e)) return e;
        } else
          for (var t in P)
            if (u(P, r)) {
              var i = a[t];
              if (i && (e === i || k.call(i, e))) return e;
            }
        throw TypeError("Target is not a typed array constructor");
      },
      exportTypedArrayMethod: function (e, t, i) {
        if (s) {
          if (i)
            for (var r in P) {
              var n = a[r];
              if (n && u(n.prototype, e))
                try {
                  delete n.prototype[e];
                } catch (e) {}
            }
          (w[e] && !i) || h(w, e, i ? t : (C && y[e]) || t);
        }
      },
      exportTypedArrayStaticMethod: function (e, t, i) {
        var r, n;
        if (s) {
          if (p) {
            if (i)
              for (r in P)
                if ((n = a[r]) && u(n, e))
                  try {
                    delete n[e];
                  } catch (e) {}
            if (A[e] && !i) return;
            try {
              return h(A, e, i ? t : (C && A[e]) || t);
            } catch (e) {}
          }
          for (r in P) !(n = a[r]) || (n[e] && !i) || h(n, e, t);
        }
      },
      isView: function (e) {
        if (!o(e)) return !1;
        var t = c(e);
        return "DataView" === t || u(P, t) || u(B, t);
      },
      isTypedArray: I,
      TypedArray: A,
      TypedArrayPrototype: w,
    };
  },
  function (e, t) {
    e.exports = function (e) {
      try {
        return !!e();
      } catch (e) {
        return !0;
      }
    };
  },
  function (e, t, i) {
    (function (t) {
      var i = function (e) {
        return e && e.Math == Math && e;
      };
      e.exports =
        i("object" == typeof globalThis && globalThis) ||
        i("object" == typeof window && window) ||
        i("object" == typeof self && self) ||
        i("object" == typeof t && t) ||
        (function () {
          return this;
        })() ||
        Function("return this")();
    }.call(t, i(224)));
  },
  function (e, t, i) {
    var r = i(4),
      n = i(84),
      s = i(11),
      a = i(85),
      o = i(100),
      u = i(149),
      c = n("wks"),
      l = r.Symbol,
      h = u ? l : (l && l.withoutSetter) || a;
    e.exports = function (e) {
      return (
        (s(c, e) && (o || "string" == typeof c[e])) ||
          (o && s(l, e) ? (c[e] = l[e]) : (c[e] = h("Symbol." + e))),
        c[e]
      );
    };
  },
  function (e, t, i) {
    var r = i(18),
      n = Math.min;
    e.exports = function (e) {
      return e > 0 ? n(r(e), 9007199254740991) : 0;
    };
  },
  function (e, t, i) {
    var r = i(9);
    e.exports = function (e) {
      if (!r(e)) throw TypeError(String(e) + " is not an object");
      return e;
    };
  },
  function (e, t, i) {
    var r = i(3);
    e.exports = !r(function () {
      return (
        7 !=
        Object.defineProperty({}, 1, {
          get: function () {
            return 7;
          },
        })[1]
      );
    });
  },
  function (e, t) {
    e.exports = function (e) {
      return "object" == typeof e ? null !== e : "function" == typeof e;
    };
  },
  function (e, t, i) {
    "use strict";

    function r(e, t) {
      for (var i = 0; i < t.length; i++) {
        var r = t[i];
        (r.enumerable = r.enumerable || !1),
          (r.configurable = !0),
          "value" in r && (r.writable = !0),
          Object.defineProperty(e, r.key, r);
      }
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.default = void 0),
      i(217),
      i(88),
      i(215),
      i(69),
      i(0);
    var n,
      s,
      a,
      o =
        ((n = "warn"),
        (s = []),
        (a = (function () {
          function e(t, i) {
            !(function (e, t) {
              if (!(e instanceof t))
                throw new TypeError("Cannot call a class as a function");
            })(this, e),
              (this.div = !1),
              (this.id = t),
              (this.prefix = i),
              (this.lf = "log");
          }
          var t, i;
          return (
            (t = e),
            (i = [
              {
                key: "setDiv",
                value: function (e) {
                  "string" == typeof e &&
                    (this.div = document.getElementById(e));
                },
              },
              {
                key: "setPrefix",
                value: function (e) {
                  this.prefix = e;
                },
              },
              {
                key: "error",
                value: function () {
                  (this.lf = "error"), this._log.apply(this, arguments);
                },
              },
              {
                key: "warn",
                value: function () {
                  ("warn" != n && "debug" != n) ||
                    ((this.lf = "warn"), this._log.apply(this, arguments));
                },
              },
              {
                key: "debug",
                value: function () {
                  "debug" == n &&
                    ((this.lf = "log"), this._log.apply(this, arguments));
                },
              },
              {
                key: "_log",
                value: function () {
                  var e = Date.now(),
                    t = e % 1e3;
                  t < 10 ? (t = "00" + t) : t < 100 && (t = "0" + t);
                  var i = (e = (e / 1e3) >>> 0) % 86400,
                    r = (i / 3600) >>> 0;
                  r < 10 && (r = "0" + r);
                  var n = ((i -= 3600 * r) / 60) >>> 0;
                  n < 10 && (n = "0" + n),
                    (i -= 60 * n) < 10 && (i = "0" + i),
                    (arguments[0] =
                      "[" +
                      r +
                      ":" +
                      n +
                      ":" +
                      i +
                      "." +
                      t +
                      "][" +
                      this.id +
                      "][" +
                      this.prefix +
                      "]: " +
                      arguments[0]),
                    console[this.lf].apply(console, arguments);
                  var a = this.div ? this.div : s[this.id];
                  if (a) {
                    var o = Array.prototype.slice.call(arguments),
                      u = document.createElement("div"),
                      c = document.createTextNode(o.join(" "));
                    u.appendChild(c),
                      a.appendChild(u),
                      30 < a.children.length && a.removeChild(a.children[0]),
                      (a.scrollTop = a.scrollHeight);
                  }
                },
              },
            ]) && r(t.prototype, i),
            e
          );
        })()),
        {
          create: function (e, t) {
            return new a(e, t);
          },
          setLevel: function (e) {
            n = e;
          },
          setDiv: function (e, t) {
            "string" == typeof t && (s[e] = document.getElementById(t));
          },
        });
    t.default = o;
  },
  function (e, t, i) {
    var r = i(13),
      n = {}.hasOwnProperty;
    e.exports = function (e, t) {
      return n.call(r(e), t);
    };
  },
  function (e, t, i) {
    var r = i(8),
      n = i(134),
      s = i(7),
      a = i(67),
      o = Object.defineProperty;
    t.f = r
      ? o
      : function (e, t, i) {
          if ((s(e), (t = a(t, !0)), s(i), n))
            try {
              return o(e, t, i);
            } catch (e) {}
          if ("get" in i || "set" in i)
            throw TypeError("Accessors not supported");
          return "value" in i && (e[t] = i.value), e;
        };
  },
  function (e, t, i) {
    var r = i(27);
    e.exports = function (e) {
      return Object(r(e));
    };
  },
  function (e, t, i) {
    "use strict";
    var r = i(20),
      n = i(187),
      s = i(64),
      a = i(22),
      o = i(128),
      u = a.set,
      c = a.getterFor("Array Iterator");
    (e.exports = o(
      Array,
      "Array",
      function (e, t) {
        u(this, { type: "Array Iterator", target: r(e), index: 0, kind: t });
      },
      function () {
        var e = c(this),
          t = e.target,
          i = e.kind,
          r = e.index++;
        return !t || r >= t.length
          ? ((e.target = void 0), { value: void 0, done: !0 })
          : "keys" == i
          ? { value: r, done: !1 }
          : "values" == i
          ? { value: t[r], done: !1 }
          : { value: [r, t[r]], done: !1 };
      },
      "values"
    )),
      (s.Arguments = s.Array),
      n("keys"),
      n("values"),
      n("entries");
  },
  function (e, t, i) {
    var r = i(8),
      n = i(12),
      s = i(24);
    e.exports = r
      ? function (e, t, i) {
          return n.f(e, t, s(1, i));
        }
      : function (e, t, i) {
          return (e[t] = i), e;
        };
  },
  function (e, t, i) {
    var r = i(109),
      n = i(17),
      s = i(204);
    r || n(Object.prototype, "toString", s, { unsafe: !0 });
  },
  function (e, t, i) {
    var r = i(4),
      n = i(15),
      s = i(11),
      a = i(106),
      o = i(135),
      u = i(22),
      c = u.get,
      l = u.enforce,
      h = String(String).split("String");
    (e.exports = function (e, t, i, o) {
      var u,
        c = !!o && !!o.unsafe,
        f = !!o && !!o.enumerable,
        d = !!o && !!o.noTargetGet;
      "function" == typeof i &&
        ("string" != typeof t || s(i, "name") || n(i, "name", t),
        (u = l(i)).source ||
          (u.source = h.join("string" == typeof t ? t : ""))),
        e !== r
          ? (c ? !d && e[t] && (f = !0) : delete e[t],
            f ? (e[t] = i) : n(e, t, i))
          : f
          ? (e[t] = i)
          : a(t, i);
    })(Function.prototype, "toString", function () {
      return ("function" == typeof this && c(this).source) || o(this);
    });
  },
  function (e, t) {
    var i = Math.ceil,
      r = Math.floor;
    e.exports = function (e) {
      return isNaN((e = +e)) ? 0 : (e > 0 ? r : i)(e);
    };
  },
  function (e, t, i) {
    var r = i(77),
      n = i(62),
      s = i(13),
      a = i(6),
      o = i(97),
      u = [].push,
      c = function (e) {
        var t = 1 == e,
          i = 2 == e,
          c = 3 == e,
          l = 4 == e,
          h = 6 == e,
          f = 7 == e,
          d = 5 == e || h;
        return function (p, v, m, g) {
          for (
            var y,
              _,
              b = s(p),
              A = n(b),
              w = r(v, m, 3),
              S = a(A.length),
              k = 0,
              T = g || o,
              x = t ? T(p, S) : i || f ? T(p, 0) : void 0;
            S > k;
            k++
          )
            if ((d || k in A) && ((_ = w((y = A[k]), k, b)), e))
              if (t) x[k] = _;
              else if (_)
                switch (e) {
                  case 3:
                    return !0;
                  case 5:
                    return y;
                  case 6:
                    return k;
                  case 2:
                    u.call(x, y);
                }
              else
                switch (e) {
                  case 4:
                    return !1;
                  case 7:
                    u.call(x, y);
                }
          return h ? -1 : c || l ? l : x;
        };
      };
    e.exports = {
      forEach: c(0),
      map: c(1),
      filter: c(2),
      some: c(3),
      every: c(4),
      find: c(5),
      findIndex: c(6),
      filterOut: c(7),
    };
  },
  function (e, t, i) {
    var r = i(62),
      n = i(27);
    e.exports = function (e) {
      return r(n(e));
    };
  },
  function (e, t, i) {
    "use strict";
    var r = i(1),
      n = i(3),
      s = i(80),
      a = i(9),
      o = i(13),
      u = i(6),
      c = i(76),
      l = i(97),
      h = i(96),
      f = i(5),
      d = i(98),
      p = f("isConcatSpreadable"),
      v =
        d >= 51 ||
        !n(function () {
          var e = [];
          return (e[p] = !1), e.concat()[0] !== e;
        }),
      m = h("concat"),
      g = function (e) {
        if (!a(e)) return !1;
        var t = e[p];
        return void 0 !== t ? !!t : s(e);
      };
    r(
      { target: "Array", proto: !0, forced: !v || !m },
      {
        concat: function (e) {
          var t,
            i,
            r,
            n,
            s,
            a = o(this),
            h = l(a, 0),
            f = 0;
          for (t = -1, r = arguments.length; t < r; t++)
            if (((s = -1 === t ? a : arguments[t]), g(s))) {
              if (f + (n = u(s.length)) > 9007199254740991)
                throw TypeError("Maximum allowed index exceeded");
              for (i = 0; i < n; i++, f++) i in s && c(h, f, s[i]);
            } else {
              if (f >= 9007199254740991)
                throw TypeError("Maximum allowed index exceeded");
              c(h, f++, s);
            }
          return (h.length = f), h;
        },
      }
    );
  },
  function (e, t, i) {
    var r,
      n,
      s,
      a = i(200),
      o = i(4),
      u = i(9),
      c = i(15),
      l = i(11),
      h = i(107),
      f = i(83),
      d = i(79),
      p = o.WeakMap;
    if (a || h.state) {
      var v = h.state || (h.state = new p()),
        m = v.get,
        g = v.has,
        y = v.set;
      (r = function (e, t) {
        if (g.call(v, e)) throw new TypeError("Object already initialized");
        return (t.facade = e), y.call(v, e, t), t;
      }),
        (n = function (e) {
          return m.call(v, e) || {};
        }),
        (s = function (e) {
          return g.call(v, e);
        });
    } else {
      var _ = f("state");
      (d[_] = !0),
        (r = function (e, t) {
          if (l(e, _)) throw new TypeError("Object already initialized");
          return (t.facade = e), c(e, _, t), t;
        }),
        (n = function (e) {
          return l(e, _) ? e[_] : {};
        }),
        (s = function (e) {
          return l(e, _);
        });
    }
    e.exports = {
      set: r,
      get: n,
      has: s,
      enforce: function (e) {
        return s(e) ? n(e) : r(e, {});
      },
      getterFor: function (e) {
        return function (t) {
          var i;
          if (!u(t) || (i = n(t)).type !== e)
            throw TypeError("Incompatible receiver, " + e + " required");
          return i;
        };
      },
    };
  },
  function (e, t, i) {
    var r = i(1),
      n = i(4),
      s = i(131),
      a = [].slice,
      o = function (e) {
        return function (t, i) {
          var r = arguments.length > 2,
            n = r ? a.call(arguments, 2) : void 0;
          return e(
            r
              ? function () {
                  ("function" == typeof t ? t : Function(t)).apply(this, n);
                }
              : t,
            i
          );
        };
      };
    r(
      { global: !0, bind: !0, forced: /MSIE .\./.test(s) },
      { setTimeout: o(n.setTimeout), setInterval: o(n.setInterval) }
    );
  },
  function (e, t) {
    e.exports = function (e, t) {
      return {
        enumerable: !(1 & e),
        configurable: !(2 & e),
        writable: !(4 & e),
        value: t,
      };
    };
  },
  function (e, t, i) {
    var r = i(142),
      n = i(4),
      s = function (e) {
        return "function" == typeof e ? e : void 0;
      };
    e.exports = function (e, t) {
      return arguments.length < 2
        ? s(r[e]) || s(n[e])
        : (r[e] && r[e][t]) || (n[e] && n[e][t]);
    };
  },
  function (e, t, i) {
    var r,
      n = i(7),
      s = i(140),
      a = i(99),
      o = i(79),
      u = i(194),
      c = i(130),
      l = i(83)("IE_PROTO"),
      h = function () {},
      f = function (e) {
        return "<script>" + e + "</script>";
      },
      d = function () {
        try {
          r = document.domain && new ActiveXObject("htmlfile");
        } catch (e) {}
        var e, t;
        d = r
          ? (function (e) {
              e.write(f("")), e.close();
              var t = e.parentWindow.Object;
              return (e = null), t;
            })(r)
          : (((t = c("iframe")).style.display = "none"),
            u.appendChild(t),
            (t.src = String("javascript:")),
            (e = t.contentWindow.document).open(),
            e.write(f("document.F=Object")),
            e.close(),
            e.F);
        for (var i = a.length; i--; ) delete d.prototype[a[i]];
        return d();
      };
    (o[l] = !0),
      (e.exports =
        Object.create ||
        function (e, t) {
          var i;
          return (
            null !== e
              ? ((h.prototype = n(e)),
                (i = new h()),
                (h.prototype = null),
                (i[l] = e))
              : (i = d()),
            void 0 === t ? i : s(i, t)
          );
        });
  },
  function (e, t) {
    e.exports = function (e) {
      if (void 0 == e) throw TypeError("Can't call method on " + e);
      return e;
    };
  },
  function (e, t, i) {
    var r = i(18),
      n = Math.max,
      s = Math.min;
    e.exports = function (e, t) {
      var i = r(e);
      return i < 0 ? n(i + t, 0) : s(i, t);
    };
  },
  function (e, t, i) {
    "use strict";
    var r = i(1),
      n = i(3),
      s = i(73),
      a = i(7),
      o = i(28),
      u = i(6),
      c = i(58),
      l = s.ArrayBuffer,
      h = s.DataView,
      f = l.prototype.slice;
    r(
      {
        target: "ArrayBuffer",
        proto: !0,
        unsafe: !0,
        forced: n(function () {
          return !new l(2).slice(1, void 0).byteLength;
        }),
      },
      {
        slice: function (e, t) {
          if (void 0 !== f && void 0 === t) return f.call(a(this), e);
          for (
            var i = a(this).byteLength,
              r = o(e, i),
              n = o(void 0 === t ? i : t, i),
              s = new (c(this, l))(u(n - r)),
              d = new h(this),
              p = new h(s),
              v = 0;
            r < n;

          )
            p.setUint8(v++, d.getUint8(r++));
          return s;
        },
      }
    );
  },
  function (e, t, i) {
    "use strict";
    var r = i(2),
      n = i(188),
      s = r.aTypedArray;
    (0, r.exportTypedArrayMethod)("copyWithin", function (e, t) {
      return n.call(
        s(this),
        e,
        t,
        arguments.length > 2 ? arguments[2] : void 0
      );
    });
  },
  function (e, t, i) {
    "use strict";
    var r = i(2),
      n = i(19).every,
      s = r.aTypedArray;
    (0, r.exportTypedArrayMethod)("every", function (e) {
      return n(s(this), e, arguments.length > 1 ? arguments[1] : void 0);
    });
  },
  function (e, t, i) {
    "use strict";
    var r = i(2),
      n = i(122),
      s = r.aTypedArray;
    (0, r.exportTypedArrayMethod)("fill", function (e) {
      return n.apply(s(this), arguments);
    });
  },
  function (e, t, i) {
    "use strict";
    var r = i(2),
      n = i(19).filter,
      s = i(212),
      a = r.aTypedArray;
    (0, r.exportTypedArrayMethod)("filter", function (e) {
      var t = n(a(this), e, arguments.length > 1 ? arguments[1] : void 0);
      return s(this, t);
    });
  },
  function (e, t, i) {
    "use strict";
    var r = i(2),
      n = i(19).findIndex,
      s = r.aTypedArray;
    (0, r.exportTypedArrayMethod)("findIndex", function (e) {
      return n(s(this), e, arguments.length > 1 ? arguments[1] : void 0);
    });
  },
  function (e, t, i) {
    "use strict";
    var r = i(2),
      n = i(19).find,
      s = r.aTypedArray;
    (0, r.exportTypedArrayMethod)("find", function (e) {
      return n(s(this), e, arguments.length > 1 ? arguments[1] : void 0);
    });
  },
  function (e, t, i) {
    "use strict";
    var r = i(2),
      n = i(19).forEach,
      s = r.aTypedArray;
    (0, r.exportTypedArrayMethod)("forEach", function (e) {
      n(s(this), e, arguments.length > 1 ? arguments[1] : void 0);
    });
  },
  function (e, t, i) {
    "use strict";
    var r = i(2),
      n = i(74).includes,
      s = r.aTypedArray;
    (0, r.exportTypedArrayMethod)("includes", function (e) {
      return n(s(this), e, arguments.length > 1 ? arguments[1] : void 0);
    });
  },
  function (e, t, i) {
    "use strict";
    var r = i(2),
      n = i(74).indexOf,
      s = r.aTypedArray;
    (0, r.exportTypedArrayMethod)("indexOf", function (e) {
      return n(s(this), e, arguments.length > 1 ? arguments[1] : void 0);
    });
  },
  function (e, t, i) {
    "use strict";
    var r = i(4),
      n = i(2),
      s = i(14),
      a = i(5)("iterator"),
      o = r.Uint8Array,
      u = s.values,
      c = s.keys,
      l = s.entries,
      h = n.aTypedArray,
      f = n.exportTypedArrayMethod,
      d = o && o.prototype[a],
      p = !!d && ("values" == d.name || void 0 == d.name),
      v = function () {
        return u.call(h(this));
      };
    f("entries", function () {
      return l.call(h(this));
    }),
      f("keys", function () {
        return c.call(h(this));
      }),
      f("values", v, !p),
      f(a, v, !p);
  },
  function (e, t, i) {
    "use strict";
    var r = i(2),
      n = r.aTypedArray,
      s = [].join;
    (0, r.exportTypedArrayMethod)("join", function (e) {
      return s.apply(n(this), arguments);
    });
  },
  function (e, t, i) {
    "use strict";
    var r = i(2),
      n = i(123),
      s = r.aTypedArray;
    (0, r.exportTypedArrayMethod)("lastIndexOf", function (e) {
      return n.apply(s(this), arguments);
    });
  },
  function (e, t, i) {
    "use strict";
    var r = i(2),
      n = i(19).map,
      s = i(58),
      a = r.aTypedArray,
      o = r.aTypedArrayConstructor;
    (0, r.exportTypedArrayMethod)("map", function (e) {
      return n(
        a(this),
        e,
        arguments.length > 1 ? arguments[1] : void 0,
        function (e, t) {
          return new (o(s(e, e.constructor)))(t);
        }
      );
    });
  },
  function (e, t, i) {
    "use strict";
    var r = i(2),
      n = i(124).right,
      s = r.aTypedArray;
    (0, r.exportTypedArrayMethod)("reduceRight", function (e) {
      return n(
        s(this),
        e,
        arguments.length,
        arguments.length > 1 ? arguments[1] : void 0
      );
    });
  },
  function (e, t, i) {
    "use strict";
    var r = i(2),
      n = i(124).left,
      s = r.aTypedArray;
    (0, r.exportTypedArrayMethod)("reduce", function (e) {
      return n(
        s(this),
        e,
        arguments.length,
        arguments.length > 1 ? arguments[1] : void 0
      );
    });
  },
  function (e, t, i) {
    "use strict";
    var r = i(2),
      n = r.aTypedArray,
      s = r.exportTypedArrayMethod,
      a = Math.floor;
    s("reverse", function () {
      for (var e, t = n(this).length, i = a(t / 2), r = 0; r < i; )
        (e = this[r]), (this[r++] = this[--t]), (this[t] = e);
      return this;
    });
  },
  function (e, t, i) {
    "use strict";
    var r = i(2),
      n = i(6),
      s = i(148),
      a = i(13),
      o = i(3),
      u = r.aTypedArray;
    (0, r.exportTypedArrayMethod)(
      "set",
      function (e) {
        u(this);
        var t = s(arguments.length > 1 ? arguments[1] : void 0, 1),
          i = this.length,
          r = a(e),
          o = n(r.length),
          c = 0;
        if (o + t > i) throw RangeError("Wrong length");
        for (; c < o; ) this[t + c] = r[c++];
      },
      o(function () {
        new Int8Array(1).set({});
      })
    );
  },
  function (e, t, i) {
    "use strict";
    var r = i(2),
      n = i(58),
      s = i(3),
      a = r.aTypedArray,
      o = r.aTypedArrayConstructor,
      u = [].slice;
    (0, r.exportTypedArrayMethod)(
      "slice",
      function (e, t) {
        for (
          var i = u.call(a(this), e, t),
            r = n(this, this.constructor),
            s = 0,
            c = i.length,
            l = new (o(r))(c);
          c > s;

        )
          l[s] = i[s++];
        return l;
      },
      s(function () {
        new Int8Array(1).slice();
      })
    );
  },
  function (e, t, i) {
    "use strict";
    var r = i(2),
      n = i(19).some,
      s = r.aTypedArray;
    (0, r.exportTypedArrayMethod)("some", function (e) {
      return n(s(this), e, arguments.length > 1 ? arguments[1] : void 0);
    });
  },
  function (e, t, i) {
    "use strict";
    var r = i(2),
      n = r.aTypedArray,
      s = [].sort;
    (0, r.exportTypedArrayMethod)("sort", function (e) {
      return s.call(n(this), e);
    });
  },
  function (e, t, i) {
    "use strict";
    var r = i(2),
      n = i(6),
      s = i(28),
      a = i(58),
      o = r.aTypedArray;
    (0, r.exportTypedArrayMethod)("subarray", function (e, t) {
      var i = o(this),
        r = i.length,
        u = s(e, r);
      return new (a(i, i.constructor))(
        i.buffer,
        i.byteOffset + u * i.BYTES_PER_ELEMENT,
        n((void 0 === t ? r : s(t, r)) - u)
      );
    });
  },
  function (e, t, i) {
    "use strict";
    var r = i(4),
      n = i(2),
      s = i(3),
      a = r.Int8Array,
      o = n.aTypedArray,
      u = n.exportTypedArrayMethod,
      c = [].toLocaleString,
      l = [].slice,
      h =
        !!a &&
        s(function () {
          c.call(new a(1));
        });
    u(
      "toLocaleString",
      function () {
        return c.apply(h ? l.call(o(this)) : o(this), arguments);
      },
      s(function () {
        return [1, 2].toLocaleString() != new a([1, 2]).toLocaleString();
      }) ||
        !s(function () {
          a.prototype.toLocaleString.call([1, 2]);
        })
    );
  },
  function (e, t, i) {
    "use strict";
    var r = i(2).exportTypedArrayMethod,
      n = i(3),
      s = i(4).Uint8Array,
      a = (s && s.prototype) || {},
      o = [].toString,
      u = [].join;
    n(function () {
      o.call({});
    }) &&
      (o = function () {
        return u.call(this);
      }),
      r("toString", o, a.toString != o);
  },
  function (e, t, i) {
    i(210)("Uint8", function (e) {
      return function (t, i, r) {
        return e(this, t, i, r);
      };
    });
  },
  function (e, t) {
    e.exports = function (e) {
      if ("function" != typeof e)
        throw TypeError(String(e) + " is not a function");
      return e;
    };
  },
  function (e, t) {
    var i = {}.toString;
    e.exports = function (e) {
      return i.call(e).slice(8, -1);
    };
  },
  function (e, t, i) {
    var r = i(7),
      n = i(186);
    e.exports =
      Object.setPrototypeOf ||
      ("__proto__" in {}
        ? (function () {
            var e,
              t = !1,
              i = {};
            try {
              (e = Object.getOwnPropertyDescriptor(
                Object.prototype,
                "__proto__"
              ).set).call(i, []),
                (t = i instanceof Array);
            } catch (e) {}
            return function (i, s) {
              return r(i), n(s), t ? e.call(i, s) : (i.__proto__ = s), i;
            };
          })()
        : void 0);
  },
  function (e, t, i) {
    var r = i(12).f,
      n = i(11),
      s = i(5)("toStringTag");
    e.exports = function (e, t, i) {
      e &&
        !n((e = i ? e : e.prototype), s) &&
        r(e, s, { configurable: !0, value: t });
    };
  },
  function (e, t, i) {
    var r = i(7),
      n = i(54),
      s = i(5)("species");
    e.exports = function (e, t) {
      var i,
        a = r(e).constructor;
      return void 0 === a || void 0 == (i = r(a)[s]) ? t : n(i);
    };
  },
  function (e, t, i) {
    "use strict";
    var r = i(108).charAt,
      n = i(22),
      s = i(128),
      a = n.set,
      o = n.getterFor("String Iterator");
    s(
      String,
      "String",
      function (e) {
        a(this, { type: "String Iterator", string: String(e), index: 0 });
      },
      function () {
        var e,
          t = o(this),
          i = t.string,
          n = t.index;
        return n >= i.length
          ? { value: void 0, done: !0 }
          : ((e = r(i, n)), (t.index += e.length), { value: e, done: !1 });
      }
    );
  },
  function (e, t, i) {
    var r = i(4),
      n = i(192),
      s = i(14),
      a = i(15),
      o = i(5),
      u = o("iterator"),
      c = o("toStringTag"),
      l = s.values;
    for (var h in n) {
      var f = r[h],
        d = f && f.prototype;
      if (d) {
        if (d[u] !== l)
          try {
            a(d, u, l);
          } catch (e) {
            d[u] = l;
          }
        if ((d[c] || a(d, c, h), n[h]))
          for (var p in s)
            if (d[p] !== s[p])
              try {
                a(d, p, s[p]);
              } catch (e) {
                d[p] = s[p];
              }
      }
    }
  },
  function (e, t, i) {
    var r = i(109),
      n = i(55),
      s = i(5)("toStringTag"),
      a =
        "Arguments" ==
        n(
          (function () {
            return arguments;
          })()
        );
    e.exports = r
      ? n
      : function (e) {
          var t, i, r;
          return void 0 === e
            ? "Undefined"
            : null === e
            ? "Null"
            : "string" ==
              typeof (i = (function (e, t) {
                try {
                  return e[t];
                } catch (e) {}
              })((t = Object(e)), s))
            ? i
            : a
            ? n(t)
            : "Object" == (r = n(t)) && "function" == typeof t.callee
            ? "Arguments"
            : r;
        };
  },
  function (e, t, i) {
    var r = i(3),
      n = i(55),
      s = "".split;
    e.exports = r(function () {
      return !Object("z").propertyIsEnumerable(0);
    })
      ? function (e) {
          return "String" == n(e) ? s.call(e, "") : Object(e);
        }
      : Object;
  },
  function (e, t) {
    e.exports = !1;
  },
  function (e, t) {
    e.exports = {};
  },
  function (e, t, i) {
    var r = i(141),
      n = i(99).concat("length", "prototype");
    t.f =
      Object.getOwnPropertyNames ||
      function (e) {
        return r(e, n);
      };
  },
  function (e, t, i) {
    var r = i(11),
      n = i(13),
      s = i(83),
      a = i(126),
      o = s("IE_PROTO"),
      u = Object.prototype;
    e.exports = a
      ? Object.getPrototypeOf
      : function (e) {
          return (
            (e = n(e)),
            r(e, o)
              ? e[o]
              : "function" == typeof e.constructor && e instanceof e.constructor
              ? e.constructor.prototype
              : e instanceof Object
              ? u
              : null
          );
        };
  },
  function (e, t, i) {
    var r = i(9);
    e.exports = function (e, t) {
      if (!r(e)) return e;
      var i, n;
      if (t && "function" == typeof (i = e.toString) && !r((n = i.call(e))))
        return n;
      if ("function" == typeof (i = e.valueOf) && !r((n = i.call(e)))) return n;
      if (!t && "function" == typeof (i = e.toString) && !r((n = i.call(e))))
        return n;
      throw TypeError("Can't convert object to primitive value");
    };
  },
  function (e, t, i) {
    "use strict";
    var r = i(1),
      n = i(74).indexOf,
      s = i(75),
      a = [].indexOf,
      o = !!a && 1 / [1].indexOf(1, -0) < 0,
      u = s("indexOf");
    r(
      { target: "Array", proto: !0, forced: o || !u },
      {
        indexOf: function (e) {
          return o
            ? a.apply(this, arguments) || 0
            : n(this, e, arguments.length > 1 ? arguments[1] : void 0);
        },
      }
    );
  },
  function (e, t, i) {
    "use strict";
    var r = i(1),
      n = i(62),
      s = i(20),
      a = i(75),
      o = [].join,
      u = n != Object,
      c = a("join", ",");
    r(
      { target: "Array", proto: !0, forced: u || !c },
      {
        join: function (e) {
          return o.call(s(this), void 0 === e ? "," : e);
        },
      }
    );
  },
  function (e, t, i) {
    var r = i(8),
      n = i(12).f,
      s = Function.prototype,
      a = s.toString,
      o = /^\s*function ([^ (]*)/;
    !r ||
      "name" in s ||
      n(s, "name", {
        configurable: !0,
        get: function () {
          try {
            return a.call(this).match(o)[1];
          } catch (e) {
            return "";
          }
        },
      });
  },
  function (e, t, i) {
    "use strict";
    i(0),
      Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.default = void 0);
    var r = function (e) {
      this.offset = void 0 === e ? 0 : e;
    };
    t.default = r;
  },
  function (e, t) {
    e.exports = function (e, t, i) {
      if (!(e instanceof t))
        throw TypeError("Incorrect " + (i ? i + " " : "") + "invocation");
      return e;
    };
  },
  function (e, t, i) {
    "use strict";
    var r = i(4),
      n = i(8),
      s = i(95),
      a = i(15),
      o = i(143),
      u = i(3),
      c = i(72),
      l = i(18),
      h = i(6),
      f = i(147),
      d = i(195),
      p = i(66),
      v = i(56),
      m = i(65).f,
      g = i(12).f,
      y = i(122),
      _ = i(57),
      b = i(22),
      A = b.get,
      w = b.set,
      S = r.ArrayBuffer,
      k = S,
      T = r.DataView,
      x = T && T.prototype,
      C = Object.prototype,
      E = r.RangeError,
      P = d.pack,
      B = d.unpack,
      I = function (e) {
        return [255 & e];
      },
      M = function (e) {
        return [255 & e, (e >> 8) & 255];
      },
      R = function (e) {
        return [255 & e, (e >> 8) & 255, (e >> 16) & 255, (e >> 24) & 255];
      },
      L = function (e) {
        return (e[3] << 24) | (e[2] << 16) | (e[1] << 8) | e[0];
      },
      F = function (e) {
        return P(e, 23, 4);
      },
      O = function (e) {
        return P(e, 52, 8);
      },
      D = function (e, t) {
        g(e.prototype, t, {
          get: function () {
            return A(this)[t];
          },
        });
      },
      U = function (e, t, i, r) {
        var n = f(i),
          s = A(e);
        if (n + t > s.byteLength) throw E("Wrong index");
        var a = A(s.buffer).bytes,
          o = n + s.byteOffset,
          u = a.slice(o, o + t);
        return r ? u : u.reverse();
      },
      V = function (e, t, i, r, n, s) {
        var a = f(i),
          o = A(e);
        if (a + t > o.byteLength) throw E("Wrong index");
        for (
          var u = A(o.buffer).bytes, c = a + o.byteOffset, l = r(+n), h = 0;
          h < t;
          h++
        )
          u[c + h] = l[s ? h : t - h - 1];
      };
    if (s) {
      if (
        !u(function () {
          S(1);
        }) ||
        !u(function () {
          new S(-1);
        }) ||
        u(function () {
          return new S(), new S(1.5), new S(NaN), "ArrayBuffer" != S.name;
        })
      ) {
        for (
          var N,
            j = ((k = function (e) {
              return c(this, k), new S(f(e));
            }).prototype = S.prototype),
            H = m(S),
            z = 0;
          H.length > z;

        )
          (N = H[z++]) in k || a(k, N, S[N]);
        j.constructor = k;
      }
      v && p(x) !== C && v(x, C);
      var W = new T(new k(2)),
        Y = x.setInt8;
      W.setInt8(0, 2147483648),
        W.setInt8(1, 2147483649),
        (!W.getInt8(0) && W.getInt8(1)) ||
          o(
            x,
            {
              setInt8: function (e, t) {
                Y.call(this, e, (t << 24) >> 24);
              },
              setUint8: function (e, t) {
                Y.call(this, e, (t << 24) >> 24);
              },
            },
            { unsafe: !0 }
          );
    } else
      (k = function (e) {
        c(this, k, "ArrayBuffer");
        var t = f(e);
        w(this, { bytes: y.call(new Array(t), 0), byteLength: t }),
          n || (this.byteLength = t);
      }),
        (T = function (e, t, i) {
          c(this, T, "DataView"), c(e, k, "DataView");
          var r = A(e).byteLength,
            s = l(t);
          if (s < 0 || s > r) throw E("Wrong offset");
          if (s + (i = void 0 === i ? r - s : h(i)) > r)
            throw E("Wrong length");
          w(this, { buffer: e, byteLength: i, byteOffset: s }),
            n ||
              ((this.buffer = e), (this.byteLength = i), (this.byteOffset = s));
        }),
        n &&
          (D(k, "byteLength"),
          D(T, "buffer"),
          D(T, "byteLength"),
          D(T, "byteOffset")),
        o(T.prototype, {
          getInt8: function (e) {
            return (U(this, 1, e)[0] << 24) >> 24;
          },
          getUint8: function (e) {
            return U(this, 1, e)[0];
          },
          getInt16: function (e) {
            var t = U(this, 2, e, arguments.length > 1 ? arguments[1] : void 0);
            return (((t[1] << 8) | t[0]) << 16) >> 16;
          },
          getUint16: function (e) {
            var t = U(this, 2, e, arguments.length > 1 ? arguments[1] : void 0);
            return (t[1] << 8) | t[0];
          },
          getInt32: function (e) {
            return L(
              U(this, 4, e, arguments.length > 1 ? arguments[1] : void 0)
            );
          },
          getUint32: function (e) {
            return (
              L(U(this, 4, e, arguments.length > 1 ? arguments[1] : void 0)) >>>
              0
            );
          },
          getFloat32: function (e) {
            return B(
              U(this, 4, e, arguments.length > 1 ? arguments[1] : void 0),
              23
            );
          },
          getFloat64: function (e) {
            return B(
              U(this, 8, e, arguments.length > 1 ? arguments[1] : void 0),
              52
            );
          },
          setInt8: function (e, t) {
            V(this, 1, e, I, t);
          },
          setUint8: function (e, t) {
            V(this, 1, e, I, t);
          },
          setInt16: function (e, t) {
            V(this, 2, e, M, t, arguments.length > 2 ? arguments[2] : void 0);
          },
          setUint16: function (e, t) {
            V(this, 2, e, M, t, arguments.length > 2 ? arguments[2] : void 0);
          },
          setInt32: function (e, t) {
            V(this, 4, e, R, t, arguments.length > 2 ? arguments[2] : void 0);
          },
          setUint32: function (e, t) {
            V(this, 4, e, R, t, arguments.length > 2 ? arguments[2] : void 0);
          },
          setFloat32: function (e, t) {
            V(this, 4, e, F, t, arguments.length > 2 ? arguments[2] : void 0);
          },
          setFloat64: function (e, t) {
            V(this, 8, e, O, t, arguments.length > 2 ? arguments[2] : void 0);
          },
        });
    _(k, "ArrayBuffer"),
      _(T, "DataView"),
      (e.exports = { ArrayBuffer: k, DataView: T });
  },
  function (e, t, i) {
    var r = i(20),
      n = i(6),
      s = i(28),
      a = function (e) {
        return function (t, i, a) {
          var o,
            u = r(t),
            c = n(u.length),
            l = s(a, c);
          if (e && i != i) {
            for (; c > l; ) if ((o = u[l++]) != o) return !0;
          } else
            for (; c > l; l++)
              if ((e || l in u) && u[l] === i) return e || l || 0;
          return !e && -1;
        };
      };
    e.exports = { includes: a(!0), indexOf: a(!1) };
  },
  function (e, t, i) {
    "use strict";
    var r = i(3);
    e.exports = function (e, t) {
      var i = [][e];
      return (
        !!i &&
        r(function () {
          i.call(
            null,
            t ||
              function () {
                throw 1;
              },
            1
          );
        })
      );
    };
  },
  function (e, t, i) {
    "use strict";
    var r = i(67),
      n = i(12),
      s = i(24);
    e.exports = function (e, t, i) {
      var a = r(t);
      a in e ? n.f(e, a, s(0, i)) : (e[a] = i);
    };
  },
  function (e, t, i) {
    var r = i(54);
    e.exports = function (e, t, i) {
      if ((r(e), void 0 === t)) return e;
      switch (i) {
        case 0:
          return function () {
            return e.call(t);
          };
        case 1:
          return function (i) {
            return e.call(t, i);
          };
        case 2:
          return function (i, r) {
            return e.call(t, i, r);
          };
        case 3:
          return function (i, r, n) {
            return e.call(t, i, r, n);
          };
      }
      return function () {
        return e.apply(t, arguments);
      };
    };
  },
  function (e, t, i) {
    var r = i(61),
      n = i(64),
      s = i(5)("iterator");
    e.exports = function (e) {
      if (void 0 != e) return e[s] || e["@@iterator"] || n[r(e)];
    };
  },
  function (e, t) {
    e.exports = {};
  },
  function (e, t, i) {
    var r = i(55);
    e.exports =
      Array.isArray ||
      function (e) {
        return "Array" == r(e);
      };
  },
  function (e, t, i) {
    var r = i(8),
      n = i(103),
      s = i(24),
      a = i(20),
      o = i(67),
      u = i(11),
      c = i(134),
      l = Object.getOwnPropertyDescriptor;
    t.f = r
      ? l
      : function (e, t) {
          if (((e = a(e)), (t = o(t, !0)), c))
            try {
              return l(e, t);
            } catch (e) {}
          if (u(e, t)) return s(!n.f.call(e, t), e[t]);
        };
  },
  function (e, t, i) {
    "use strict";
    var r,
      n,
      s = i(104),
      a = i(105),
      o = i(84),
      u = RegExp.prototype.exec,
      c = o("native-string-replace", String.prototype.replace),
      l = u,
      h =
        ((r = /a/),
        (n = /b*/g),
        u.call(r, "a"),
        u.call(n, "a"),
        0 !== r.lastIndex || 0 !== n.lastIndex),
      f = a.UNSUPPORTED_Y || a.BROKEN_CARET,
      d = void 0 !== /()??/.exec("")[1];
    (h || d || f) &&
      (l = function (e) {
        var t,
          i,
          r,
          n,
          a = this,
          o = f && a.sticky,
          l = s.call(a),
          p = a.source,
          v = 0,
          m = e;
        return (
          o &&
            (-1 === (l = l.replace("y", "")).indexOf("g") && (l += "g"),
            (m = String(e).slice(a.lastIndex)),
            a.lastIndex > 0 &&
              (!a.multiline || (a.multiline && "\n" !== e[a.lastIndex - 1])) &&
              ((p = "(?: " + p + ")"), (m = " " + m), v++),
            (i = new RegExp("^(?:" + p + ")", l))),
          d && (i = new RegExp("^" + p + "$(?!\\s)", l)),
          h && (t = a.lastIndex),
          (r = u.call(o ? i : a, m)),
          o
            ? r
              ? ((r.input = r.input.slice(v)),
                (r[0] = r[0].slice(v)),
                (r.index = a.lastIndex),
                (a.lastIndex += r[0].length))
              : (a.lastIndex = 0)
            : h && r && (a.lastIndex = a.global ? r.index + r[0].length : t),
          d &&
            r &&
            r.length > 1 &&
            c.call(r[0], i, function () {
              for (n = 1; n < arguments.length - 2; n++)
                void 0 === arguments[n] && (r[n] = void 0);
            }),
          r
        );
      }),
      (e.exports = l);
  },
  function (e, t, i) {
    var r = i(84),
      n = i(85),
      s = r("keys");
    e.exports = function (e) {
      return s[e] || (s[e] = n(e));
    };
  },
  function (e, t, i) {
    var r = i(63),
      n = i(107);
    (e.exports = function (e, t) {
      return n[e] || (n[e] = void 0 !== t ? t : {});
    })("versions", []).push({
      version: "3.12.1",
      mode: r ? "pure" : "global",
      copyright: "В© 2021 Denis Pushkarev (zloirock.ru)",
    });
  },
  function (e, t) {
    var i = 0,
      r = Math.random();
    e.exports = function (e) {
      return (
        "Symbol(" +
        String(void 0 === e ? "" : e) +
        ")_" +
        (++i + r).toString(36)
      );
    };
  },
  function (e, t, i) {
    "use strict";
    var r = i(1),
      n = i(28),
      s = i(18),
      a = i(6),
      o = i(13),
      u = i(97),
      c = i(76),
      l = i(96)("splice"),
      h = Math.max,
      f = Math.min;
    r(
      { target: "Array", proto: !0, forced: !l },
      {
        splice: function (e, t) {
          var i,
            r,
            l,
            d,
            p,
            v,
            m = o(this),
            g = a(m.length),
            y = n(e, g),
            _ = arguments.length;
          if (
            (0 === _
              ? (i = r = 0)
              : 1 === _
              ? ((i = 0), (r = g - y))
              : ((i = _ - 2), (r = f(h(s(t), 0), g - y))),
            g + i - r > 9007199254740991)
          )
            throw TypeError("Maximum allowed length exceeded");
          for (l = u(m, r), d = 0; d < r; d++)
            (p = y + d) in m && c(l, d, m[p]);
          if (((l.length = r), i < r)) {
            for (d = y; d < g - r; d++)
              (v = d + i), (p = d + r) in m ? (m[v] = m[p]) : delete m[v];
            for (d = g; d > g - r + i; d--) delete m[d - 1];
          } else if (i > r)
            for (d = g - r; d > y; d--)
              (v = d + i - 1),
                (p = d + r - 1) in m ? (m[v] = m[p]) : delete m[v];
          for (d = 0; d < i; d++) m[d + y] = arguments[d + 2];
          return (m.length = g - r + i), l;
        },
      }
    );
  },
  function (e, t, i) {
    var r = i(1),
      n = i(73);
    r({ global: !0, forced: !i(95) }, { DataView: n.DataView });
  },
  function (e, t, i) {
    var r = i(17),
      n = Date.prototype,
      s = n.toString,
      a = n.getTime;
    new Date(NaN) + "" != "Invalid Date" &&
      r(n, "toString", function () {
        var e = a.call(this);
        return e == e ? s.call(this) : "Invalid Date";
      });
  },
  function (e, t, i) {
    i(1)({ target: "Function", proto: !0 }, { bind: i(133) });
  },
  function (e, t, i) {
    var r = i(1),
      n = i(202);
    r({ global: !0, forced: parseInt != n }, { parseInt: n });
  },
  function (e, t, i) {
    "use strict";
    var r = i(1),
      n = i(8),
      s = i(4),
      a = i(11),
      o = i(9),
      u = i(12).f,
      c = i(125),
      l = s.Symbol;
    if (
      n &&
      "function" == typeof l &&
      (!("description" in l.prototype) || void 0 !== l().description)
    ) {
      var h = {},
        f = function () {
          var e =
              arguments.length < 1 || void 0 === arguments[0]
                ? void 0
                : String(arguments[0]),
            t = this instanceof f ? new l(e) : void 0 === e ? l() : l(e);
          return "" === e && (h[t] = !0), t;
        };
      c(f, l);
      var d = (f.prototype = l.prototype);
      d.constructor = f;
      var p = d.toString,
        v = "Symbol(test)" == String(l("test")),
        m = /^Symbol\((.*)\)[^)]+$/;
      u(d, "description", {
        configurable: !0,
        get: function () {
          var e = o(this) ? this.valueOf() : this,
            t = p.call(e);
          if (a(h, e)) return "";
          var i = v ? t.slice(7, -1) : t.replace(m, "$1");
          return "" === i ? void 0 : i;
        },
      }),
        r({ global: !0, forced: !0 }, { Symbol: f });
    }
  },
  function (e, t, i) {
    i(129)("iterator");
  },
  function (e, t, i) {
    "use strict";
    var r = i(1),
      n = i(4),
      s = i(25),
      a = i(63),
      o = i(8),
      u = i(100),
      c = i(149),
      l = i(3),
      h = i(11),
      f = i(80),
      d = i(9),
      p = i(7),
      v = i(13),
      m = i(20),
      g = i(67),
      y = i(24),
      _ = i(26),
      b = i(102),
      A = i(65),
      w = i(203),
      S = i(101),
      k = i(81),
      T = i(12),
      x = i(103),
      C = i(15),
      E = i(17),
      P = i(84),
      B = i(83),
      I = i(79),
      M = i(85),
      R = i(5),
      L = i(150),
      F = i(129),
      O = i(57),
      D = i(22),
      U = i(19).forEach,
      V = B("hidden"),
      N = R("toPrimitive"),
      j = D.set,
      H = D.getterFor("Symbol"),
      z = Object.prototype,
      W = n.Symbol,
      Y = s("JSON", "stringify"),
      Q = k.f,
      q = T.f,
      G = w.f,
      J = x.f,
      K = P("symbols"),
      X = P("op-symbols"),
      Z = P("string-to-symbol-registry"),
      $ = P("symbol-to-string-registry"),
      ee = P("wks"),
      te = n.QObject,
      ie = !te || !te.prototype || !te.prototype.findChild,
      re =
        o &&
        l(function () {
          return (
            7 !=
            _(
              q({}, "a", {
                get: function () {
                  return q(this, "a", { value: 7 }).a;
                },
              })
            ).a
          );
        })
          ? function (e, t, i) {
              var r = Q(z, t);
              r && delete z[t], q(e, t, i), r && e !== z && q(z, t, r);
            }
          : q,
      ne = function (e, t) {
        var i = (K[e] = _(W.prototype));
        return (
          j(i, { type: "Symbol", tag: e, description: t }),
          o || (i.description = t),
          i
        );
      },
      se = c
        ? function (e) {
            return "symbol" == typeof e;
          }
        : function (e) {
            return Object(e) instanceof W;
          },
      ae = function (e, t, i) {
        e === z && ae(X, t, i), p(e);
        var r = g(t, !0);
        return (
          p(i),
          h(K, r)
            ? (i.enumerable
                ? (h(e, V) && e[V][r] && (e[V][r] = !1),
                  (i = _(i, { enumerable: y(0, !1) })))
                : (h(e, V) || q(e, V, y(1, {})), (e[V][r] = !0)),
              re(e, r, i))
            : q(e, r, i)
        );
      },
      oe = function (e, t) {
        p(e);
        var i = m(t),
          r = b(i).concat(he(i));
        return (
          U(r, function (t) {
            (o && !ue.call(i, t)) || ae(e, t, i[t]);
          }),
          e
        );
      },
      ue = function (e) {
        var t = g(e, !0),
          i = J.call(this, t);
        return (
          !(this === z && h(K, t) && !h(X, t)) &&
          (!(i || !h(this, t) || !h(K, t) || (h(this, V) && this[V][t])) || i)
        );
      },
      ce = function (e, t) {
        var i = m(e),
          r = g(t, !0);
        if (i !== z || !h(K, r) || h(X, r)) {
          var n = Q(i, r);
          return (
            !n || !h(K, r) || (h(i, V) && i[V][r]) || (n.enumerable = !0), n
          );
        }
      },
      le = function (e) {
        var t = G(m(e)),
          i = [];
        return (
          U(t, function (e) {
            h(K, e) || h(I, e) || i.push(e);
          }),
          i
        );
      },
      he = function (e) {
        var t = e === z,
          i = G(t ? X : m(e)),
          r = [];
        return (
          U(i, function (e) {
            !h(K, e) || (t && !h(z, e)) || r.push(K[e]);
          }),
          r
        );
      };
    u ||
      (E(
        (W = function () {
          if (this instanceof W) throw TypeError("Symbol is not a constructor");
          var e =
              arguments.length && void 0 !== arguments[0]
                ? String(arguments[0])
                : void 0,
            t = M(e),
            i = function (e) {
              this === z && i.call(X, e),
                h(this, V) && h(this[V], t) && (this[V][t] = !1),
                re(this, t, y(1, e));
            };
          return o && ie && re(z, t, { configurable: !0, set: i }), ne(t, e);
        }).prototype,
        "toString",
        function () {
          return H(this).tag;
        }
      ),
      E(W, "withoutSetter", function (e) {
        return ne(M(e), e);
      }),
      (x.f = ue),
      (T.f = ae),
      (k.f = ce),
      (A.f = w.f = le),
      (S.f = he),
      (L.f = function (e) {
        return ne(R(e), e);
      }),
      o &&
        (q(W.prototype, "description", {
          configurable: !0,
          get: function () {
            return H(this).description;
          },
        }),
        a || E(z, "propertyIsEnumerable", ue, { unsafe: !0 }))),
      r({ global: !0, wrap: !0, forced: !u, sham: !u }, { Symbol: W }),
      U(b(ee), function (e) {
        F(e);
      }),
      r(
        { target: "Symbol", stat: !0, forced: !u },
        {
          for: function (e) {
            var t = String(e);
            if (h(Z, t)) return Z[t];
            var i = W(t);
            return (Z[t] = i), ($[i] = t), i;
          },
          keyFor: function (e) {
            if (!se(e)) throw TypeError(e + " is not a symbol");
            if (h($, e)) return $[e];
          },
          useSetter: function () {
            ie = !0;
          },
          useSimple: function () {
            ie = !1;
          },
        }
      ),
      r(
        { target: "Object", stat: !0, forced: !u, sham: !o },
        {
          create: function (e, t) {
            return void 0 === t ? _(e) : oe(_(e), t);
          },
          defineProperty: ae,
          defineProperties: oe,
          getOwnPropertyDescriptor: ce,
        }
      ),
      r(
        { target: "Object", stat: !0, forced: !u },
        { getOwnPropertyNames: le, getOwnPropertySymbols: he }
      ),
      r(
        {
          target: "Object",
          stat: !0,
          forced: l(function () {
            S.f(1);
          }),
        },
        {
          getOwnPropertySymbols: function (e) {
            return S.f(v(e));
          },
        }
      ),
      Y &&
        r(
          {
            target: "JSON",
            stat: !0,
            forced:
              !u ||
              l(function () {
                var e = W();
                return (
                  "[null]" != Y([e]) ||
                  "{}" != Y({ a: e }) ||
                  "{}" != Y(Object(e))
                );
              }),
          },
          {
            stringify: function (e, t, i) {
              for (var r, n = [e], s = 1; arguments.length > s; )
                n.push(arguments[s++]);
              if (((r = t), (d(t) || void 0 !== e) && !se(e)))
                return (
                  f(t) ||
                    (t = function (e, t) {
                      if (
                        ("function" == typeof r && (t = r.call(this, e, t)),
                        !se(t))
                      )
                        return t;
                    }),
                  (n[1] = t),
                  Y.apply(null, n)
                );
            },
          }
        ),
      W.prototype[N] || C(W.prototype, N, W.prototype.valueOf),
      O(W, "Symbol"),
      (I[V] = !0);
  },
  function (e, t, i) {
    "use strict";
    i(0),
      Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.default = void 0);
    var r = new (function () {
      var e = {};
      (this.init = function (t, i) {
        if (i)
          for (var r in ((e[t] = {}), i)) {
            var n = document.getElementById(i[r]);
            n && (e[t][r] = n);
          }
      }),
        (this.display = function (t, i, r) {
          if (e[t]) {
            var n = e[t][i];
            n && (n.innerHTML = r);
          }
        });
    })();
    t.default = r;
  },
  function (e, t) {
    e.exports =
      "undefined" != typeof ArrayBuffer && "undefined" != typeof DataView;
  },
  function (e, t, i) {
    var r = i(3),
      n = i(5),
      s = i(98),
      a = n("species");
    e.exports = function (e) {
      return (
        s >= 51 ||
        !r(function () {
          var t = [];
          return (
            ((t.constructor = {})[a] = function () {
              return { foo: 1 };
            }),
            1 !== t[e](Boolean).foo
          );
        })
      );
    };
  },
  function (e, t, i) {
    var r = i(9),
      n = i(80),
      s = i(5)("species");
    e.exports = function (e, t) {
      var i;
      return (
        n(e) &&
          ("function" != typeof (i = e.constructor) ||
          (i !== Array && !n(i.prototype))
            ? r(i) && null === (i = i[s]) && (i = void 0)
            : (i = void 0)),
        new (void 0 === i ? Array : i)(0 === t ? 0 : t)
      );
    };
  },
  function (e, t, i) {
    var r,
      n,
      s = i(4),
      a = i(131),
      o = s.process,
      u = o && o.versions,
      c = u && u.v8;
    c
      ? (n = (r = c.split("."))[0] < 4 ? 1 : r[0] + r[1])
      : a &&
        (!(r = a.match(/Edge\/(\d+)/)) || r[1] >= 74) &&
        (r = a.match(/Chrome\/(\d+)/)) &&
        (n = r[1]),
      (e.exports = n && +n);
  },
  function (e, t) {
    e.exports = [
      "constructor",
      "hasOwnProperty",
      "isPrototypeOf",
      "propertyIsEnumerable",
      "toLocaleString",
      "toString",
      "valueOf",
    ];
  },
  function (e, t, i) {
    var r = i(98),
      n = i(3);
    e.exports =
      !!Object.getOwnPropertySymbols &&
      !n(function () {
        return !String(Symbol()) || (!Symbol.sham && r && r < 41);
      });
  },
  function (e, t) {
    t.f = Object.getOwnPropertySymbols;
  },
  function (e, t, i) {
    var r = i(141),
      n = i(99);
    e.exports =
      Object.keys ||
      function (e) {
        return r(e, n);
      };
  },
  function (e, t, i) {
    "use strict";
    var r = {}.propertyIsEnumerable,
      n = Object.getOwnPropertyDescriptor,
      s = n && !r.call({ 1: 2 }, 1);
    t.f = s
      ? function (e) {
          var t = n(this, e);
          return !!t && t.enumerable;
        }
      : r;
  },
  function (e, t, i) {
    "use strict";
    var r = i(7);
    e.exports = function () {
      var e = r(this),
        t = "";
      return (
        e.global && (t += "g"),
        e.ignoreCase && (t += "i"),
        e.multiline && (t += "m"),
        e.dotAll && (t += "s"),
        e.unicode && (t += "u"),
        e.sticky && (t += "y"),
        t
      );
    };
  },
  function (e, t, i) {
    "use strict";

    function r(e, t) {
      return RegExp(e, t);
    }
    var n = i(3);
    (t.UNSUPPORTED_Y = n(function () {
      var e = r("a", "y");
      return (e.lastIndex = 2), null != e.exec("abcd");
    })),
      (t.BROKEN_CARET = n(function () {
        var e = r("^r", "gy");
        return (e.lastIndex = 2), null != e.exec("str");
      }));
  },
  function (e, t, i) {
    var r = i(4),
      n = i(15);
    e.exports = function (e, t) {
      try {
        n(r, e, t);
      } catch (i) {
        r[e] = t;
      }
      return t;
    };
  },
  function (e, t, i) {
    var r = i(4),
      n = i(106),
      s = r["__core-js_shared__"] || n("__core-js_shared__", {});
    e.exports = s;
  },
  function (e, t, i) {
    var r = i(18),
      n = i(27),
      s = function (e) {
        return function (t, i) {
          var s,
            a,
            o = String(n(t)),
            u = r(i),
            c = o.length;
          return u < 0 || u >= c
            ? e
              ? ""
              : void 0
            : (s = o.charCodeAt(u)) < 55296 ||
              s > 56319 ||
              u + 1 === c ||
              (a = o.charCodeAt(u + 1)) < 56320 ||
              a > 57343
            ? e
              ? o.charAt(u)
              : s
            : e
            ? o.slice(u, u + 2)
            : a - 56320 + ((s - 55296) << 10) + 65536;
        };
      };
    e.exports = { codeAt: s(!1), charAt: s(!0) };
  },
  function (e, t, i) {
    var r = {};
    (r[i(5)("toStringTag")] = "z"), (e.exports = "[object z]" === String(r));
  },
  function (e, t) {
    e.exports =
      "\t\n\v\f\r В бљЂвЂЂвЂЃвЂ‚вЂѓвЂ„вЂ…вЂ†вЂ‡вЂ€вЂ‰вЂЉвЂЇвЃџгЂЂ\u2028\u2029\ufeff";
  },
  function (e, t, i) {
    var r = i(1),
      n = i(201);
    r({ global: !0, forced: parseFloat != n }, { parseFloat: n });
  },
  function (e, t, i) {
    "use strict";
    var r = i(1),
      n = i(82);
    r({ target: "RegExp", proto: !0, forced: /./.exec !== n }, { exec: n });
  },
  function (e, t, i) {
    var r = i(8),
      n = i(12),
      s = i(104),
      a = i(105).UNSUPPORTED_Y;
    r &&
      ("g" != /./g.flags || a) &&
      n.f(RegExp.prototype, "flags", { configurable: !0, get: s });
  },
  function (e, t, i) {
    "use strict";
    var r = i(17),
      n = i(7),
      s = i(3),
      a = i(104),
      o = RegExp.prototype,
      u = o.toString,
      c = s(function () {
        return "/a/b" != u.call({ source: "a", flags: "b" });
      }),
      l = "toString" != u.name;
    (c || l) &&
      r(
        RegExp.prototype,
        "toString",
        function () {
          var e = n(this),
            t = String(e.source),
            i = e.flags;
          return (
            "/" +
            t +
            "/" +
            String(
              void 0 === i && e instanceof RegExp && !("flags" in o)
                ? a.call(e)
                : i
            )
          );
        },
        { unsafe: !0 }
      );
  },
  function (e, t, i) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : { default: e };
    }
    i(0),
      Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.default = void 0),
      i(21),
      i(14),
      i(29),
      i(16),
      i(53),
      i(30),
      i(31),
      i(32),
      i(33),
      i(35),
      i(34),
      i(36),
      i(37),
      i(38),
      i(39),
      i(40),
      i(41),
      i(42),
      i(44),
      i(43),
      i(45),
      i(46),
      i(47),
      i(48),
      i(49),
      i(50),
      i(51),
      i(52),
      i(113),
      i(70),
      i(60);
    var n = r(i(178)),
      s = r(i(10)),
      a = function (e) {
        function t() {
          function t(e, t) {
            switch (((e.codecData = t.codecData), e.type)) {
              case "video":
                !(function (e, t) {
                  var i = t.codec.substring(0, 4);
                  switch (i) {
                    case "AVC1":
                    case "AVC2":
                    case "HVC1":
                    case "HEV1":
                      e.codec = i;
                      break;
                    default:
                      _.error(
                        "Unknown video codec " +
                          t.codec +
                          ". Trying to substitute with AVC1"
                      ),
                        (e.codec = "AVC1");
                  }
                })(e, t);
                break;
              case "audio":
                !(function (e, t) {
                  switch (t.codec) {
                    case "MP4A.40.34":
                      (e.codec = "MP3"),
                        (function (e) {
                          if (e.codecData) {
                            var t = e.codecData;
                            if (255 == (255 & t[0]) && 224 == (224 & t[1])) {
                              var i = (t[1] >> 3) & 3;
                              1 == i && (i = 0);
                              var r = (t[1] >> 1) & 3;
                              if (0 != r) {
                                e.sampleDuration = [
                                  [0, 576, 1152, 384],
                                  [0, 0, 0, 0],
                                  [0, 576, 1152, 384],
                                  [0, 1152, 1152, 384],
                                ][i][r];
                                var n = (t[2] >> 4) & 21;
                                e.bitrate = [
                                  [
                                    [0, 0, 0, 0],
                                    [0, 0, 0, 0],
                                    [0, 0, 0, 0],
                                    [0, 0, 0, 0],
                                  ],
                                  [
                                    [0, 8192, 8192, 32768],
                                    [0, 0, 0, 0],
                                    [0, 8192, 8192, 32768],
                                    [0, 32768, 32768, 32768],
                                  ],
                                  [
                                    [0, 16384, 16384, 49152],
                                    [0, 0, 0, 0],
                                    [0, 16384, 16384, 49152],
                                    [0, 40960, 49152, 65536],
                                  ],
                                  [
                                    [0, 24576, 24576, 57344],
                                    [0, 0, 0, 0],
                                    [0, 24576, 24576, 57344],
                                    [0, 49152, 57344, 98304],
                                  ],
                                  [
                                    [0, 32768, 32768, 65536],
                                    [0, 0, 0, 0],
                                    [0, 32768, 32768, 65536],
                                    [0, 57344, 65536, 131072],
                                  ],
                                  [
                                    [0, 40960, 40960, 81920],
                                    [0, 0, 0, 0],
                                    [0, 40960, 40960, 81920],
                                    [0, 65536, 81920, 163840],
                                  ],
                                  [
                                    [0, 49152, 49152, 98304],
                                    [0, 0, 0, 0],
                                    [0, 49152, 49152, 98304],
                                    [0, 81920, 98304, 196608],
                                  ],
                                  [
                                    [0, 57344, 57344, 114688],
                                    [0, 0, 0, 0],
                                    [0, 57344, 57344, 114688],
                                    [0, 98304, 114688, 229376],
                                  ],
                                  [
                                    [0, 65536, 65536, 131072],
                                    [0, 0, 0, 0],
                                    [0, 65536, 65536, 131072],
                                    [0, 114688, 131072, 262144],
                                  ],
                                  [
                                    [0, 81920, 81920, 147456],
                                    [0, 0, 0, 0],
                                    [0, 81920, 81920, 147456],
                                    [0, 131072, 163840, 294912],
                                  ],
                                  [
                                    [0, 98304, 98304, 163840],
                                    [0, 0, 0, 0],
                                    [0, 98304, 98304, 163840],
                                    [0, 163840, 196608, 327680],
                                  ],
                                  [
                                    [0, 114688, 114688, 180224],
                                    [0, 0, 0, 0],
                                    [0, 114688, 114688, 180224],
                                    [0, 196608, 229376, 360448],
                                  ],
                                  [
                                    [0, 131072, 131072, 196608],
                                    [0, 0, 0, 0],
                                    [0, 131072, 131072, 196608],
                                    [0, 229376, 262144, 393216],
                                  ],
                                  [
                                    [0, 147456, 147456, 229376],
                                    [0, 0, 0, 0],
                                    [0, 147456, 147456, 229376],
                                    [0, 262144, 327680, 425984],
                                  ],
                                  [
                                    [0, 163840, 163840, 262144],
                                    [0, 0, 0, 0],
                                    [0, 163840, 163840, 262144],
                                    [0, 327680, 393216, 458752],
                                  ],
                                  [
                                    [0, 0, 0, 0],
                                    [0, 0, 0, 0],
                                    [0, 0, 0, 0],
                                    [0, 0, 0, 0],
                                  ],
                                ][n][i][r];
                                var s = (t[2] >> 2) & 3;
                                e.samplingRate = [
                                  [11025, 0, 22050, 44100],
                                  [12e3, 0, 24e3, 48e3],
                                  [8e3, 0, 16e3, 32e3],
                                  [0, 0, 0, 0],
                                ][s][i];
                                var a = (t[3] >> 6) & 3;
                                e.audioChannels = 3 == a ? 1 : 2;
                                var o = void 0,
                                  u = void 0;
                                switch (
                                  ((e.silence = void 0), e.audioChannels)
                                ) {
                                  case 2:
                                    switch (
                                      ((u = (o = [
                                        255,
                                        251,
                                        null,
                                        100,
                                        null,
                                        143,
                                        240,
                                        0,
                                        0,
                                        105,
                                        0,
                                        0,
                                        0,
                                        8,
                                        0,
                                        0,
                                        13,
                                        32,
                                        0,
                                        0,
                                        1,
                                        0,
                                        0,
                                        1,
                                        164,
                                        0,
                                        0,
                                        0,
                                        32,
                                        0,
                                        0,
                                        52,
                                        128,
                                        0,
                                        0,
                                        4,
                                      ]).length),
                                      e.samplingRate)
                                    ) {
                                      case 48e3:
                                        (o[2] = 148), (o[4] = 81), (u += 348);
                                        break;
                                      case 44100:
                                        (o[2] = 146), (o[4] = 64), (u += 382);
                                        break;
                                      case 32e3:
                                        (o[2] = 120), (o[4] = 57), (u += 396);
                                        break;
                                      default:
                                        return void _.error(
                                          "sampling rate " +
                                            e.samplingRate +
                                            " is not supported"
                                        );
                                    }
                                    break;
                                  case 1:
                                    switch (
                                      ((u = (o = [
                                        255,
                                        251,
                                        null,
                                        196,
                                        null,
                                        null,
                                        192,
                                        0,
                                        1,
                                        164,
                                        0,
                                        0,
                                        0,
                                        32,
                                        0,
                                        0,
                                        52,
                                        128,
                                        0,
                                        0,
                                        4,
                                      ]).length),
                                      e.samplingRate)
                                    ) {
                                      case 48e3:
                                        (o[2] = 84),
                                          (o[4] = 170),
                                          (o[5] = 3),
                                          (u += 171);
                                        break;
                                      case 44100:
                                        (o[2] = 82),
                                          (o[4] = 161),
                                          (o[5] = 131),
                                          (u += 188);
                                        break;
                                      case 32e3:
                                        (o[2] = 56),
                                          (o[4] = 158),
                                          (o[5] = 3),
                                          (u += 195);
                                        break;
                                      default:
                                        return void _.error(
                                          "sampling rate " +
                                            e.samplingRate +
                                            " is not supported"
                                        );
                                    }
                                }
                                if (u) {
                                  e.silence = new Uint8Array(u);
                                  var c = 0;
                                  for (c = 0; c < o.length; c++)
                                    e.silence[c] = o[c];
                                  for (c = o.length; c < u; c++)
                                    e.silence[c] = 85;
                                  _.debug(
                                    "MP3 track codec data",
                                    e.samplingRate,
                                    e.sampleDuration,
                                    e.audioChannels
                                  );
                                }
                              }
                            }
                          }
                        })(e);
                      break;
                    default:
                      (e.codec = "AAC"),
                        (function (e) {
                          if (e.codecData) {
                            var t = [1024, 960],
                              i = e.codecData,
                              r = i[0] >> 3,
                              n = 0;
                            switch (
                              ((n =
                                31 == r
                                  ? (i[1] >> 1) & 15
                                  : ((7 & i[0]) << 1) | (i[1] >> 7)),
                              (e.bitrate = 0),
                              15 == n
                                ? 31 == r
                                  ? ((e.samplingRate =
                                      ((((1 & i[1]) << 7) | (i[2] >> 1)) <<
                                        16) |
                                      ((((1 & i[2]) << 7) | (i[3] >> 1)) << 8) |
                                      ((1 & i[3]) << 7) |
                                      (i[4] >> 1)),
                                    (e.audioChannels =
                                      ((1 & i[4]) << 3) | (i[5] >> 5)),
                                    (e.sampleDuration = t[(16 & i[5]) >> 4]))
                                  : ((e.samplingRate =
                                      ((((127 & i[1]) << 1) | (i[2] >> 7)) <<
                                        16) |
                                      ((((127 & i[2]) << 1) | (i[3] >> 7)) <<
                                        8) |
                                      ((127 & i[3]) << 1) |
                                      (i[4] >> 7)),
                                    (e.audioChannels = (120 & i[4]) >> 3),
                                    (e.sampleDuration = t[(4 & i[4]) >> 2]))
                                : ((e.samplingRate = [
                                    96e3, 88200, 64e3, 48e3, 44100, 32e3, 24e3,
                                    22050, 16e3, 12e3, 11025, 8e3, 7350,
                                  ][n]),
                                  31 == r
                                    ? ((e.audioChannels =
                                        ((1 & i[1]) << 3) | (i[2] >> 5)),
                                      (e.sampleDuration = t[(16 & i[2]) >> 4]))
                                    : ((e.audioChannels = (120 & i[1]) >> 3),
                                      (e.sampleDuration = t[(4 & i[1]) >> 2]))),
                              e.audioChannels)
                            ) {
                              case 8:
                                e.silence = new Uint8Array([
                                  1, 24, 32, 1, 8, 128, 35, 4, 96, 35, 16, 4,
                                  96, 140, 4, 162, 0, 140, 17, 129, 132, 96, 0,
                                  28,
                                ]);
                                break;
                              case 6:
                                e.silence = new Uint8Array([
                                  1, 24, 32, 1, 8, 128, 35, 4, 96, 35, 16, 4,
                                  96, 140, 12, 35, 0, 0, 224,
                                ]);
                                break;
                              case 5:
                                e.silence = new Uint8Array([
                                  1, 24, 32, 1, 8, 128, 35, 4, 96, 35, 16, 4,
                                  96, 140, 28,
                                ]);
                                break;
                              case 4:
                                e.silence = new Uint8Array([
                                  1, 24, 32, 1, 8, 128, 35, 4, 96, 3, 24, 32, 7,
                                ]);
                                break;
                              case 3:
                                e.silence = new Uint8Array([
                                  1, 24, 32, 1, 8, 128, 35, 4, 96, 224,
                                ]);
                                break;
                              case 2:
                                e.silence = new Uint8Array([
                                  33, 16, 4, 96, 140, 28,
                                ]);
                                break;
                              default:
                                e.silence = new Uint8Array([1, 24, 32, 7]);
                            }
                            _.debug(
                              "AAC track codec data, AOT: " +
                                r +
                                " sRate: " +
                                e.samplingRate +
                                " sPerFrame: " +
                                e.sampleDuration +
                                " chCount: " +
                                e.audioChannels
                            );
                          }
                        })(e);
                  }
                  e.tsSampleDuration =
                    (e.sampleDuration / e.samplingRate) * e.timescale;
                })(e, t);
            }
          }

          function i(e, t, i) {
            var r = i.prevAltTs + t.sampleDuration,
              n = i.nextAltTs - r;
            if (n >= 2 * t.sampleDuration && n <= 10 * t.samplingRate) {
              _.debug(
                "recover audio gap effShift = "
                  .concat(n, ", prevTs = ")
                  .concat(i.prevTs, ", prevAltTs = ")
                  .concat(i.prevAltTs, ", nextAltTs = ")
                  .concat(i.nextAltTs)
              );
              for (
                var s = Math.floor(n / t.sampleDuration) - 1, a = 1;
                a <= s;
                a++
              ) {
                var o = {
                  data: i.data,
                  ts: i.prevTs + ((a * t.tsSampleDuration) >>> 0),
                  altTs: r,
                  altDur: t.sampleDuration,
                  offset: 0,
                  sap: !0,
                };
                e.push(o), (r += t.sampleDuration);
              }
              _.warn("adding dummy frames", e.length, r, i.nextAltTs);
            }
            return r;
          }

          function r(e, t) {
            return t < 0 || t > 10 * e.timescale;
          }

          function a(e, t, i) {
            var r = !1;
            if (e.isAudio && e.lastSilenceSampleTs > 0 && null !== i) {
              var n = e.lastSilenceSampleTs - t;
              n >= 0
                ? n < 5 * e.timescale &&
                  (_.debug(
                    "Ignore real frames after mute",
                    t,
                    e.lastSilenceSampleTs
                  ),
                  (r = !0))
                : (e.lastSilenceSampleTs = 0);
            }
            return r;
          }

          function o(e, t, n, s, o) {
            var u = [],
              c = e.lastSample,
              l = s;
            if (a(e, s, n)) return [];
            var h = !1,
              f = s - c.rawts;
            if (
              (r(e, f)
                ? (_.debug(
                    "Incorrect DTS difference ("
                      .concat(f, ") between previous (ts: ")
                      .concat(c.rawts, ", offset: ")
                      .concat(c.offset, ", sap: ")
                      .concat(c.sap, ") and current frame (ts: ")
                      .concat(s, ", offset: ")
                      .concat(o, ", sap: ")
                      .concat(t, ")")
                  ),
                  (f = e.lastSampleDuration))
                : 0 == f &&
                  (e.isAudio ||
                    c.offset != o ||
                    (_.debug("Keep zero duration sample"), (h = !0))),
              (s = c.ts + f),
              f > 0 && (e.lastSampleDuration = f),
              (c.duration = f),
              a(e, s, n))
            )
              return [];
            e.isAudio &&
              e.alignBase &&
              (e.prevSample &&
                (i(u, e, {
                  prevTs: e.prevSample.ts,
                  prevAltTs: e.prevSample.altTs,
                  nextAltTs: c.altTs,
                  data: e.silence ? e.silence : c.data,
                }),
                (e.prevSample = void 0)),
              (e.alignBase = void 0)),
              u.push(c);
            var d = 0;
            e.isAudio &&
              ((d = i(u, e, {
                prevTs: c.ts,
                prevAltTs: c.altTs,
                nextAltTs: Math.floor((e.samplingRate / e.timescale) * s + 0.5),
                data: e.silence ? e.silence : c.data,
              })),
              (c.altDur = e.sampleDuration));
            var p = n;
            if (
              (null === p &&
                e.isAudio &&
                ((p = e.silence), (e.lastSilenceSampleTs = s)),
              (e.lastSample = {
                data: p,
                ts: s,
                rawts: l,
                altTs: d,
                offset: o,
                sap: t,
              }),
              h || w.length > 0)
            ) {
              for (var v = 0; v < u.length; v++) w.push(u[v]);
              h ? (u = []) : ((u = w), (w = []));
            }
            return u;
          }

          function u(e) {
            for (var t = void 0, i = 0; i < b.length; i++)
              if (b[i].id == e) {
                t = b[i];
                break;
              }
            return (
              void 0 === t && _.error("track ID " + e + " is not found!"), t
            );
          }

          function c(e, t) {
            var i = n.default.createFullBox("tkhd", t);
            switch (
              ((i.flags = 7),
              (i.creation_time = 0),
              (i.modification_time = 0),
              (i.track_ID = e.id),
              (i.reserved1 = 0),
              (i.duration = 0),
              (i.reserved2 = [0, 0]),
              (i.layer = 0),
              (i.alternate_group = 0),
              (i.reserved3 = 0),
              (i.matrix = [1, 0, 0, 0, 1, 0, 0, 0, 16384]),
              e.type)
            ) {
              case "video":
                (i.volume = 0),
                  (i.width = e.width),
                  (i.height = e.height),
                  (i.flags |= 8);
                break;
              case "audio":
                (i.volume = 1), (i.width = 0), (i.height = 0);
            }
            return i;
          }

          function l(e) {
            return e.isAudio ? e.samplingRate : e.timescale;
          }

          function h(e, t) {
            var i = n.default.createFullBox("mdhd", t);
            return (
              (i.creation_time = 0),
              (i.modification_time = 0),
              (i.duration = 0),
              (i.language = "und"),
              (i.pre_defined = 0),
              (i.timescale = l(e)),
              i
            );
          }

          function f(e, t) {
            var i = n.default.createFullBox("hdlr", t);
            switch (((i.pre_defined = 0), e.type)) {
              case "video":
                (i.handler_type = "vide"), (i.name = "VideoHandler");
                break;
              case "audio":
                (i.handler_type = "soun"), (i.name = "AudioHandler");
            }
            return (i.reserved = [0, 0, 0]), i;
          }

          function d(e) {
            var t = n.default.createFullBox("vmhd", e);
            return (
              (t.flags = 1), (t.graphicsmode = 0), (t.opcolor = [0, 0, 0]), t
            );
          }

          function p(e) {
            var t = n.default.createFullBox("smhd", e);
            return (t.balance = 0), (t.reserved = 0), t;
          }

          function v(e) {
            var t = n.default.createFullBox("dref", e);
            (t.entry_count = 1), (t.entries = []);
            var i = n.default.createFullBox("url ", t, -1);
            return (i.location = ""), (i.flags = 1), t.entries.push(i), t;
          }

          function m(e, t) {
            var i = n.default.createFullBox("trex", t);
            return (
              (i.track_ID = e.id),
              (i.default_sample_description_index = 1),
              (i.default_sample_duration = 0),
              (i.default_sample_size = 0),
              (i.default_sample_flags = e.isAudio ? 0 : 65536),
              i
            );
          }

          function g(e, t) {
            var i = n.default.createFullBox("stsd", t);
            return (
              (i.entry_count = 1),
              (i.entries = []),
              i.entries.push(
                (function (e, t) {
                  switch (e.codec) {
                    case "AVC1":
                    case "AVC2":
                      return (
                        (e.seBox = e.codec.toLowerCase()),
                        (e.configName = "avcC"),
                        (e.compressorname = "AVC Coding"),
                        y(e, t)
                      );
                    case "HVC1":
                    case "HEV1":
                      return (
                        (e.seBox = e.codec.toLowerCase()),
                        (e.configName = "hvcC"),
                        (e.compressorname = "SHVC Coding"),
                        y(e, t)
                      );
                    case "AAC":
                      return (function (e, t) {
                        var i = n.default.createBox("mp4a", t, -1);
                        return (
                          (i.reserved1 = [0, 0, 0, 0, 0, 0]),
                          (i.data_reference_index = 1),
                          (i.reserved2 = [0, 0]),
                          (i.channelcount = e.audioChannels),
                          (i.samplesize = 16),
                          (i.pre_defined = 0),
                          (i.reserved_3 = 0),
                          (i.samplerate = e.samplingRate << 16),
                          (i.esds =
                            "AAC" == e.codec
                              ? (function (e) {
                                  var t = 37 + e.codecData.byteLength,
                                    i = new Uint8Array(t),
                                    r = 0;
                                  return (
                                    (i[r++] = (4278190080 & t) >> 24),
                                    (i[r++] = (16711680 & t) >> 16),
                                    (i[r++] = (65280 & t) >> 8),
                                    (i[r++] = 255 & t),
                                    i.set([101, 115, 100, 115], r),
                                    (r += 4),
                                    i.set([0, 0, 0, 0], r),
                                    (r += 4),
                                    (i[r++] = 3),
                                    (i[r++] = 23 + e.codecData.byteLength),
                                    (i[r++] = (65280 & e.id) >> 8),
                                    (i[r++] = 255 & e.id),
                                    (i[r++] = 0),
                                    (i[r++] = 4),
                                    (i[r++] = 15 + e.codecData.byteLength),
                                    (i[r++] = 64),
                                    (i[r] = 20),
                                    (i[r] |= 0),
                                    (i[r++] |= 1),
                                    (i[r++] = 255),
                                    (i[r++] = 255),
                                    (i[r++] = 255),
                                    i.set([0, 0, 0, 0, 0, 0, 0, 0], r),
                                    (r += 8),
                                    (i[r++] = 5),
                                    (i[r++] = e.codecData.byteLength),
                                    i.set(e.codecData, r),
                                    (r += e.codecData.byteLength),
                                    (i[r++] = 6),
                                    (i[r++] = 1),
                                    (i[r] = 2),
                                    i
                                  );
                                })(e)
                              : (function (e) {
                                  var t = new Uint8Array(35),
                                    i = 0;
                                  return (
                                    (t[i++] = 0),
                                    (t[i++] = 0),
                                    (t[i++] = 0),
                                    (t[i++] = 35),
                                    t.set([101, 115, 100, 115], i),
                                    (i += 4),
                                    t.set([0, 0, 0, 0], i),
                                    (i += 4),
                                    (t[i++] = 3),
                                    (t[i++] = 21),
                                    (t[i++] = (65280 & e.id) >> 8),
                                    (t[i++] = 255 & e.id),
                                    (t[i++] = 0),
                                    (t[i++] = 4),
                                    (t[i++] = 13),
                                    (t[i++] = 107),
                                    (t[i] = 20),
                                    (t[i] |= 0),
                                    (t[i++] |= 1),
                                    (t[i++] = 255),
                                    (t[i++] = 255),
                                    (t[i++] = 255),
                                    (t[i++] = (4278190080 & e.bitrate) >> 24),
                                    (t[i++] = (16711680 & e.bitrate) >> 16),
                                    (t[i++] = (65280 & e.bitrate) >> 8),
                                    (t[i++] = 255 & e.bitrate),
                                    (t[i++] = (4278190080 & e.bitrate) >> 24),
                                    (t[i++] = (16711680 & e.bitrate) >> 16),
                                    (t[i++] = (65280 & e.bitrate) >> 8),
                                    (t[i++] = 255 & e.bitrate),
                                    (t[i++] = 6),
                                    (t[i++] = 1),
                                    (t[i] = 2),
                                    t
                                  );
                                })(e)),
                          i
                        );
                      })(e, t);
                    case "MP3":
                      return (function (e, t) {
                        var i = n.default.createBox(".mp3", t, -1);
                        (i.reserved1 = [0, 0, 0, 0, 0, 0]),
                          (i.data_reference_index = 1),
                          (i.reserved2 = [0, 0]),
                          (i.channelcount = e.audioChannels),
                          (i.samplesize = 16),
                          (i.pre_defined = 0),
                          (i.reserved_3 = 0),
                          (i.samplerate = e.samplingRate << 16),
                          (i.entry_count = 1),
                          (i.entries = []);
                        var r = n.default.createBox("btrt", i, -1);
                        return (
                          (r.bufferSizeDB = 4294967295),
                          (r.maxBitrate = e.bitrate),
                          (r.avgBitrate = e.bitrate),
                          i.entries.push(r),
                          i
                        );
                      })(e, t);
                    default:
                      _.error("Unsupported codec: ", e.codec);
                  }
                })(e, i)
              ),
              i
            );
          }

          function y(e, t) {
            var i = n.default.createBox(e.seBox, t, -1);
            (i.reserved1 = [0, 0, 0, 0, 0, 0]),
              (i.data_reference_index = 1),
              (i.pre_defined1 = 0),
              (i.reserved2 = 0),
              (i.pre_defined2 = [0, 0, 0]),
              (i.width = e.width),
              (i.height = e.height),
              (i.horizresolution = 72),
              (i.vertresolution = 72),
              (i.reserved3 = 0),
              (i.frame_count = 1),
              (i.compressorname = [e.compressorname.length]);
            for (var r = 0; r < 31; r++)
              i.compressorname[r + 1] =
                r < e.compressorname.length
                  ? 127 & e.compressorname.charCodeAt(r)
                  : 0;
            return (
              (i.depth = 24),
              (i.pre_defined3 = 65535),
              (i.config = (function (e) {
                if (e.codecData) {
                  var t = e.codecData.byteLength + 8,
                    i = new Uint8Array(t),
                    r = 0;
                  (i[r++] = (4278190080 & t) >> 24),
                    (i[r++] = (16711680 & t) >> 16),
                    (i[r++] = (65280 & t) >> 8),
                    (i[r++] = 255 & t);
                  for (var n = 0; n < e.configName.length; n++)
                    i[r++] = 127 & e.configName.charCodeAt(n);
                  return i.set(e.codecData, r), i;
                }
                _.error("No codec data specified!");
              })(e)),
              i
            );
          }
          var _ = s.default.create(e, "BoxComposer"),
            b = [],
            A = 1,
            w = [];
          (this.init = function () {
            (b = []), (A = 1), (w = []);
          }),
            (this.addTrack = function (e, i) {
              var r = {
                id: A,
                type: e,
                isAudio: "audio" == e,
                curSeqNumber: 0,
                lastSampleDuration: 0,
                lastSilenceSampleTs: 0,
              };
              return (
                _.setPrefix("BoxComposer " + e),
                i &&
                  ("video" == e &&
                    ((r.width = "width" in i ? i.width : 0),
                    (r.height = "height" in i ? i.height : 0)),
                  (r.timescale = "timescale" in i ? i.timescale : 1e3),
                  "codec" in i && (i.codec = i.codec.toUpperCase()),
                  "codecData" in i && t(r, i)),
                b.push(r),
                A++,
                r
              );
            }),
            (this.setTrackParams = function (e, i) {
              var r = u(e);
              return (
                r &&
                  ("codec" in i && (i.codec = i.codec.toUpperCase()),
                  "width" in i && (r.width = i.width),
                  "height" in i && (r.height = i.height),
                  "timescale" in i && (r.timescale = i.timescale),
                  "codecData" in i &&
                    ((w = []), (r.lastSample = void 0), t(r, i)),
                  "sequenceNumber" in i && (r.curSeqNumber = i.sequenceNumber),
                  "alignBase" in i && (r.alignBase = i.alignBase),
                  "syncBase" in i && (r.syncBase = i.syncBase),
                  _.debug("setTrackParams: ", e, i)),
                r
              );
            }),
            (this.getTrackSampleDuration = function (e, t) {
              var i,
                r = u(e);
              return r && (i = r.tsSampleDuration), i;
            }),
            (this.getTrackAudioInfo = function (e) {
              var t,
                i = u(e);
              return (
                i &&
                  (t = {
                    samplingRate: i.samplingRate,
                    channels: i.audioChannels,
                  }),
                t
              );
            }),
            (this.isTrackSilent = function (e) {
              var t,
                i = u(e);
              return i && i.isAudio && (t = i.lastSilenceSampleTs > 0), t;
            }),
            (this.setBaseSample = function (e, t, i, n) {
              var s = u(e);
              if (s) {
                var a = i;
                if (s.syncBase) {
                  if (s.syncSample) {
                    var o = i - s.syncSample.rawts;
                    r(o) &&
                      (_.debug(
                        "setBaseSample discontinuity: " + o,
                        i,
                        s.syncSample.ts,
                        s.syncSample.rawts,
                        s.lastSampleDuration
                      ),
                      (o = s.lastSampleDuration)),
                      (i = s.syncSample.ts + o),
                      (s.syncSample = void 0);
                  }
                  s.syncBase = void 0;
                }
                var c = t,
                  l = 0;
                s.isAudio &&
                  ((s.lastSilenceSampleTs = 0),
                  null === c && ((c = s.silence), (s.lastSilenceSampleTs = i)),
                  (l = Math.floor((s.samplingRate / s.timescale) * i + 0.5))),
                  (s.lastSample = {
                    data: c,
                    ts: i,
                    rawts: a,
                    altTs: l,
                    offset: n,
                    sap: !0,
                    altDur: s.sampleDuration,
                  }),
                  _.debug(
                    "setBaseSample: ",
                    i,
                    n,
                    s.lastSample.altTs,
                    s.lastSample.altDur
                  );
              } else _.error("setBaseSample: track " + e + " not found!!!");
            }),
            (this.getRealTs = function (e, t) {
              var i = t,
                r = u(e);
              if (r) {
                if (r.lastSample) {
                  var n = r.lastSample.ts - r.lastSample.rawts;
                  0 !== n &&
                    ((n > 0 && t < r.lastSample.ts) ||
                      t >= r.lastSample.rawts) &&
                    (i = t + n);
                }
              } else _.error("getRealTs: track ".concat(e, " not found"));
              return i;
            }),
            (this.initSegment = function () {
              var e = n.default.createFile();
              return (
                (function (e) {
                  var t = n.default.createBox("ftyp", e);
                  (t.major_brand = "isom"),
                    (t.minor_version = 1),
                    (t.compatible_brands = []),
                    (t.compatible_brands[0] = "isom"),
                    (t.compatible_brands[1] = "avc1"),
                    (t.compatible_brands[2] = "dash");
                })(e),
                (function (e) {
                  var t = n.default.createBox("moov", e);
                  !(function (e) {
                    var t = n.default.createFullBox("mvhd", e);
                    (t.creation_time = 0),
                      (t.modification_time = 0),
                      (t.timescale = 1e3),
                      (t.duration = 0),
                      (t.rate = 1),
                      (t.volume = 1),
                      (t.reserved1 = 0),
                      (t.reserved2 = [0, 0]),
                      (t.matrix = [1, 0, 0, 0, 1, 0, 0, 0, 16384]),
                      (t.pre_defined = [0, 0, 0, 0, 0, 0]),
                      (t.next_track_ID = A);
                  })(t);
                  var i = n.default.createBox("mvex", t);
                  !(function (e) {
                    n.default.createFullBox("mehd", e).fragment_duration = 0;
                  })(i);
                  for (var r = 0; r < b.length; r++) {
                    var s = b[r],
                      a = n.default.createBox("trak", t);
                    c(s, a);
                    var o = n.default.createBox("mdia", a);
                    h(s, o), f(s, o);
                    var u = n.default.createBox("minf", o);
                    switch (s.type) {
                      case "video":
                        d(u);
                        break;
                      case "audio":
                        p(u);
                    }
                    v(n.default.createBox("dinf", u));
                    var l = n.default.createBox("stbl", u);
                    n.default.createFullBox("stts", l)._data = [
                      0, 0, 0, 0, 0, 0, 0, 0,
                    ];
                    n.default.createFullBox("ctts", l)._data = [
                      0, 0, 0, 0, 0, 0, 0, 0,
                    ];
                    n.default.createFullBox("stsc", l)._data = [
                      0, 0, 0, 0, 0, 0, 0, 0,
                    ];
                    n.default.createFullBox("stco", l)._data = [
                      0, 0, 0, 0, 0, 0, 0, 0,
                    ];
                    (n.default.createFullBox("stsz", l)._data = [
                      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    ]),
                      g(s, l),
                      m(s, i);
                  }
                })(e),
                e.write()
              );
            }),
            (this.mediaSegment = function (e, t, i) {
              var r = void 0,
                s = n.default.createFile(),
                a = u(e),
                c = [],
                h = [];
              if (a) {
                !(function (e) {
                  var t = n.default.createBox("styp", e);
                  (t.major_brand = "msdh"),
                    (t.minor_version = 0),
                    (t.compatible_brands = []),
                    (t.compatible_brands[0] = "msdh"),
                    (t.compatible_brands[1] = "msix");
                })(s);
                var f = 0,
                  d = [];
                for (f = 0; f < t.length; f++) {
                  var p = t[f];
                  if (a.lastSample)
                    for (
                      var v = o(a, p.sap, p.data, p.ts, p.offset), m = 0;
                      m < v.length;
                      m++
                    )
                      d.push(v[m]), c.push(v[m].ts), h.push(v[m].sap);
                  else
                    _.error(
                      "mediaSegment is executed while no base sample is set. Compelled setting of base sample: ",
                      p.sap,
                      p.ts,
                      p.offset
                    ),
                      p.sap && this.setBaseSample(e, p.data, p.ts, p.offset);
                }
                if (i && void 0 !== a.lastSample) {
                  for (var g = 0; g < w.length; g++)
                    d.push(w[g]), c.push(w[g].ts), h.push(w[g].sap);
                  (w = []),
                    (a.lastSample.duration = a.lastSampleDuration),
                    d.push(a.lastSample),
                    _.debug(
                      "Push last sample, ts = "
                        .concat(a.lastSample.ts, ", duration = ")
                        .concat(a.lastSample.duration)
                    ),
                    c.push(a.lastSample.ts),
                    h.push(a.lastSample.sap),
                    a.alignBase &&
                      (a.prevSample = {
                        ts: a.lastSample.ts,
                        altTs: a.lastSample.altTs,
                      }),
                    a.syncBase &&
                      (a.syncSample = {
                        ts: a.lastSample.ts,
                        rawts: a.lastSample.rawts,
                      }),
                    (a.lastSample = void 0);
                }
                if (d.length > 0) {
                  var y = (function (e, t, i) {
                      var r = n.default.createBox("sidx", e);
                      (r.flags = 0),
                        (r.version = 1),
                        (r.reference_ID = t.id),
                        (r.timescale = l(t)),
                        (r.first_offset = 0),
                        (r.reserved = 0),
                        (r.earliest_presentation_time = t.isAudio
                          ? i[0].altTs
                          : i[0].ts + i[0].offset),
                        (r.reference_count = 1);
                      for (
                        var s = !1, a = 0, o = 0, u = 0, c = 0, h = 0;
                        h < i.length;
                        h++
                      )
                        (a += i[h].data.byteLength),
                          !s && i[h].sap && ((s = !0), (c = o)),
                          (o += i[h].duration),
                          (u += i[h].altDur);
                      return (
                        (r.references = [
                          {
                            reference_type: 0,
                            referenced_size: a,
                            subsegment_duration: t.isAudio ? u : o,
                            starts_with_SAP: i[0].sap ? 1 : 0,
                            SAP_type: s ? 1 : 0,
                            SAP_delta_time: c,
                          },
                        ]),
                        r
                      );
                    })(s, a, d),
                    b = (function (e, t, i) {
                      var r = n.default.createBox("moof", e);
                      n.default.createFullBox("mfhd", r).sequence_number =
                        t.curSeqNumber++;
                      var s = n.default.createBox("traf", r),
                        a = n.default.createFullBox("tfhd", s);
                      (a.track_ID = t.id), (a.flags = 131072);
                      var o = n.default.createFullBox("tfdt", s, a);
                      (o.version = 1), (o.flags = 0);
                      var u = n.default.createFullBox("trun", s, o);
                      if (
                        ((u.sample_count = i.length),
                        (u.samples = []),
                        t.isAudio)
                      ) {
                        (o.baseMediaDecodeTime = i[0].altTs), (u.flags = 769);
                        for (var c = 0; c < i.length; c++)
                          u.samples.push({
                            sample_duration: i[c].altDur,
                            sample_size: i[c].data.byteLength,
                          });
                      } else {
                        (o.baseMediaDecodeTime = i[0].ts),
                          (u.flags = 2821),
                          (u.first_sample_flags = 0);
                        for (var l = 0; l < i.length; l++)
                          u.samples.push({
                            sample_duration: i[l].duration,
                            sample_size: i[l].data.byteLength,
                            sample_composition_time_offset: i[l].offset,
                          });
                      }
                      return (u.data_offset = r.getLength() + 8), r;
                    })(s, a, d);
                  (n.default.createBox("mdat", s).data = (function (e, t) {
                    var i = void 0;
                    if (e.length > 1) {
                      i = new Uint8Array(t);
                      for (var r = 0, n = 0; n < e.length; n++)
                        i.set(e[n].data, r), (r += e[n].data.length);
                    } else i = e[0].data;
                    return i;
                  })(d, y.references[0].referenced_size)),
                    (y.references[0].referenced_size += 8 + b.getLength()),
                    (r = {
                      ts: c,
                      sap: h,
                      sn: a ? a.curSeqNumber - 1 : void 0,
                      data: s.write(),
                    });
                }
              }
              return r;
            });
        }
        return {
          create: function () {
            return new t();
          },
        };
      };
    t.default = a;
  },
  function (e, t, i) {
    "use strict";

    function r(e, t) {
      for (var i = 0; i < t.length; i++) {
        var r = t[i];
        (r.enumerable = r.enumerable || !1),
          (r.configurable = !0),
          "value" in r && (r.writable = !0),
          Object.defineProperty(e, r.key, r);
      }
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.default = void 0),
      i(0);
    var n,
      s = (n = i(10)) && n.__esModule ? n : { default: n },
      a = function (e) {
        var t = s.default.create(e, "RingBuffer"),
          i = (function () {
            function e(i) {
              !(function (e, t) {
                if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function");
              })(this, e),
                i <= 0 && t.error("invalid size in constructor " + i),
                (this.buffer = []),
                (this.size = i),
                (this.start = 0);
            }
            var i, n;
            return (
              (i = e),
              (n = [
                {
                  key: "push",
                  value: function (e) {
                    this.buffer.length == this.size
                      ? ((this.buffer[this.start++] = e),
                        this.start == this.size && (this.start = 0))
                      : this.buffer.push(e);
                  },
                },
                {
                  key: "get",
                  value: function (e) {
                    var i = void 0;
                    if (e >= 0 && e < this.buffer.length) {
                      var r = this.start + e;
                      r >= this.buffer.length && (r -= this.buffer.length),
                        (i = this.buffer[r]);
                    } else if (e < 0 && -1 * e <= this.buffer.length) {
                      var n = this.start + e;
                      n < 0 && (n += this.buffer.length), (i = this.buffer[n]);
                    } else t.error("attempt to read from invalid index " + e);
                    return i;
                  },
                },
                {
                  key: "join",
                  value: function (e) {
                    var t = "";
                    this.buffer.length > 0 && (t += this.buffer[this.start]);
                    for (var i = 1; i < this.buffer.length; i++) {
                      var r = this.start + i;
                      r >= this.buffer.length && (r -= this.buffer.length),
                        (t += e + this.buffer[r]);
                    }
                    return t;
                  },
                },
                {
                  key: "clear",
                  value: function () {
                    (this.buffer = []), (this.start = 0);
                  },
                },
                {
                  key: "drop",
                  value: function () {
                    (this.buffer = []), (this.size = 0), (this.start = 0);
                  },
                },
                {
                  key: "length",
                  value: function () {
                    return this.buffer.length;
                  },
                },
              ]) && r(i.prototype, n),
              e
            );
          })();
        return {
          create: function (e) {
            return new i(e);
          },
        };
      };
    t.default = a;
  },
  function (e, t, i) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : { default: e };
    }
    i(0),
      Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.default = function (e) {
        function t(t, n, s, l, h, f, d, p, v) {
          function m() {
            void 0 !== fe && (clearTimeout(fe), (fe = void 0));
          }

          function g(e) {
            e.data &&
              ((he = e.data),
              D.setTrackParams(F, { codec: s, codecData: e.data }),
              U.pushInit(D.initSegment()));
          }

          function y(e, t) {
            var i = !1;
            if ("mp4" == O)
              if (t)
                if (((i = !0), e)) {
                  var r = t.byteLength;
                  if (r == e.byteLength) {
                    i = !1;
                    for (var n = 0; n < r; n++)
                      if (t[n] !== e[n]) {
                        i = !0;
                        break;
                      }
                  }
                } else
                  R.debug(
                    "isInitSegmentNew: current init segment data is empty"
                  ),
                    (i = !0);
              else R.error("isInitSegmentNew: received empty codecData");
            return i;
          }

          function _() {
            return Q + 1;
          }

          function b(e) {
            void 0 === e && (e = 1e3),
              (z = N = e),
              (j = (N * l) / 1e3),
              (H = N >= 1e3 ? 0.2 : N / 5e3),
              p.setLowBufferBorder(H, n[0]);
          }

          function A() {
            for (var e = 0; e < W.length; e++) {
              var t = W[e];
              x(t.sap, t.data, t.ts, t.offset);
            }
            (W = []), (Y = []), (J = !1);
          }

          function w(e, t) {
            R.debug("flush all", e);
            var i = 0,
              r = [];
            for (i = 0; i < ue.length; i++)
              (void 0 === e || ue[i].ts < e) && r.push(ue[i]);
            for (ue = [], i = 0; i < W.length; i++)
              (void 0 === e || W[i].ts < e) && r.push(W[i]);
            if (((W = []), (Y = []), G)) {
              var n = r.length;
              for (i = 0; i < n; i++) S(r[i], e);
              t || S(null, e);
            }
            U.filterOut(e);
          }

          function S(e, t) {
            var i,
              r,
              n,
              s = e ? D.mediaSegment(F, [e]) : D.mediaSegment(F, [], !0);
            s &&
              (void 0 == t || s.ts[0] < t) &&
              (U.pushSegment(s.data, s.ts, s.sap),
              (i = s.ts[0]),
              (r = s.sn),
              (n = s.sap[0]),
              (Z = i),
              (ne = r),
              n && (te = i));
          }

          function k(e) {
            W.length >= 2 &&
              void 0 !== P &&
              void 0 !== F &&
              ((V = u.BUFFER),
              P(e, W[0].ts / l),
              R.debug("process open state, base ts=".concat(W[0].ts)));
          }

          function T(e) {
            var t = (e - Z) / l,
              i = Math.min(Q / l, 0.0715);
            return [t > 0 && t <= i, t, i];
          }

          function x(e, t, i, r) {
            if (G)
              !(function (e, t, i, r) {
                var n = void 0;
                if (oe) {
                  if (
                    (C(ue, t, i, r, e),
                    ue[ue.length - 1].ts - ue[0].ts >= (z * l) / 1e3)
                  ) {
                    var s = ue.splice(0, 1);
                    n = {
                      data: s[0].data,
                      ts: s[0].ts,
                      offset: s[0].offset,
                      sap: s[0].sap,
                    };
                  }
                } else n = { data: t, ts: i, offset: r, sap: e };
                ($ = i), (ee = r), n && S(n);
              })(e, t, i, r);
            else if (e) {
              if (le && u.CLOSED !== V) {
                var n = { codec: s };
                he && (n.codecData = he),
                  D.setTrackParams(F, n),
                  U.pushInit(D.initSegment(), T(i)[0]),
                  (le = !1);
              }
              !(function (e, t, i) {
                D.setBaseSample(F, e, t, i),
                  R.debug("process first frame", Z, $, t),
                  (Z = void 0),
                  (te = void 0),
                  ($ = t),
                  (ee = i),
                  (G = !0);
              })(t, i, r);
            }
          }

          function C(e, t, i, r, n) {
            e.push({ data: t, ts: i, offset: r, sap: n });
          }
          var E,
            P,
            B,
            I,
            M,
            R = a.default.create(e, "Track " + n),
            L = t % parseInt("F0", 16),
            F = void 0,
            O = "vp8" == s || "vp9" == s ? "webm" : "mp4",
            D = "webm" == O ? r.create() : i.create(),
            U = void 0,
            V = u.OPEN,
            N = d.buffering,
            j = (N * l) / 1e3,
            H = N >= 1e3 ? 0.2 : N / 5e3,
            z = N,
            W = [],
            Y = [],
            Q = void 0,
            q = void 0,
            G = !1,
            J = !1,
            K = 0,
            X = !!d.sapAlignment,
            Z = void 0,
            $ = void 0,
            ee = void 0,
            te = void 0,
            ie = void 0,
            re = void 0,
            ne = void 0,
            se = !1,
            ae = {},
            oe = !1,
            ue = [],
            ce = void 0,
            le = !1,
            he = void 0,
            fe = void 0;
          v.add(L, n, l),
            p.setLowBufferBorder(H, n[0]),
            (this.attachToMSE = function () {
              (U = p.createSourceBuffer(n, s, l, h)).removeAll();
            }),
            (this.id = function () {
              return L;
            }),
            (this.timescale = function () {
              return l;
            }),
            (this.getBufferedStart = function () {
              var e = void 0;
              return W.length > 0 && (e = W[0].ts), e;
            }),
            (this.getAudioInfo = function () {
              return D.getTrackAudioInfo(F);
            }),
            (this.inTransition = function (e) {
              return void 0 !== e && ((se = e), (ae = {})), se;
            }),
            (this.setTransitionParams = function (e) {
              (ae = e).container =
                "vp8" == ae.codec || "vp9" == ae.codec ? "webm" : "mp4";
            }),
            (this.isTransitionSupported = function () {
              var e = !1;
              return (
                ae &&
                  ae.container == O &&
                  (e = p.isCodecSupported(n, ae.codec)),
                e || R.error("transition is not supported: ", s),
                e
              );
            }),
            (this.startTransition = function (e) {
              (ae.mode = void 0 !== e ? e : c.SMOOTH),
                (ae.initSegment = void 0),
                (ae.startupBuffer = []),
                (ae.initDataBuffer = []),
                (ae.curStreamCancelled = !1),
                (ae.newSapTimes = []),
                (ae.curSapTimes = []),
                (oe = !0),
                v.add(ae.id, n, l),
                p.transitOn(),
                R.debug("transit started", ae.id);
            }),
            (this.setSapAlignment = function (e) {
              X = e;
            }),
            (this.setBuffering = function (e) {
              b(e);
            }),
            (this.getStreamName = function () {
              return f;
            }),
            (this.getTransitionStreamName = function () {
              return ae.name;
            }),
            (this.transitionStreamId = function () {
              return ae.id;
            }),
            (this.type = function () {
              return n;
            }),
            (this.latency = function (e) {
              var t = void 0,
                i = v.getMetrics(L);
              if (i) {
                t = performance.now() / 1e3 - e - i.latencySubt;
              }
              return t;
            }),
            (this.isVideo = function () {
              return "video" == n;
            }),
            (this.isAudio = function () {
              return "audio" == n;
            }),
            (this.isActual = function () {
              return u.CLOSED != V;
            }),
            (this.isInited = function () {
              return void 0 !== F;
            }),
            (this.isTransitionInited = function () {
              return void 0 !== ae.cTrackId;
            }),
            (this.isOpen = function () {
              return u.OPEN == V;
            }),
            (this.isBuffering = function () {
              return u.BUFFER == V;
            }),
            (this.isBackingUp = function () {
              return u.BACKUP == V;
            }),
            (this.isStarving = function () {
              var e = !1;
              if (u.BUFFER == V || u.OPEN == V) {
                var t = v.getMetrics(L).avgBandwidth(),
                  i = v.getMetrics(L).avgRate();
                (e = t > 0 && 1.5 * t < i),
                  R.debug(
                    "video is " + (e ? "starving" : "not starving"),
                    t,
                    i
                  );
              }
              return e;
            }),
            (this.sapOffset = function () {
              var e = (4e3 * ($ - te)) / l;
              return isNaN(e) ? 0 : e;
            }),
            (this.reset = function () {
              R.debug("reset " + f),
                (V = u.OPEN),
                U.removeAll(),
                D.init(),
                (F = void 0),
                (W = []),
                (Y = []),
                (ue = []),
                (Q = void 0),
                (G = !1),
                (J = !1),
                (q = void 0),
                (se = void 0),
                (K = 0),
                v.remove(L),
                oe &&
                  (v.remove(ae.id),
                  (L = ae.id),
                  (d = ae.streamOptions),
                  (f = ae.name)),
                v.add(L, n, l),
                (oe = !1),
                (ae = {}),
                (ce = void 0),
                (Z = void 0),
                ($ = void 0),
                (ee = void 0),
                (te = void 0),
                (ie = void 0),
                (re = void 0),
                b(void 0 !== d.buffering ? d.buffering : N),
                (le = !1),
                (he = void 0),
                m();
            }),
            (this.close = function () {
              (V = u.CLOSED),
                (U.closed = !0),
                (D = void 0),
                (W = []),
                (Y = []),
                v.remove(L),
                void 0 !== ae.id && v.remove(ae.id),
                m();
            }),
            (this.backup = function () {
              var e = void 0;
              return (
                (U.closed = !0),
                this.isTransitionInited()
                  ? (R.debug("backup track, transition is inited"),
                    ae.curStreamCancelled ||
                      (I(this), (ae.curStreamCancelled = !0)),
                    (ce = { bufferLength: U.getBufferingLength() }),
                    this.completeTransition(),
                    W.length > 0 && (e = W[0].ts / l))
                  : ((ce = U.getSegments()),
                    R.debug("backup track", ce.segments.length, ce.start),
                    ce.init &&
                      ce.segments &&
                      ce.segments.length > ce.start &&
                      ((V = u.BACKUP),
                      (e = ce.segments[ce.start].ts / l),
                      P(this, e))),
                e
              );
            }),
            (this.recover = function () {
              if (ce)
                if (((V = u.ACTIVE), ce.init)) {
                  R.debug("recover track");
                  var e = 0,
                    t = 0,
                    i = ce.segments.length;
                  for (e = ce.start; e < i; e++)
                    if (ce.segments[e].init) ce.init = ce.segments[e].data;
                    else {
                      if (!(ce.segments[e].ts <= q)) break;
                      ce.segments[e].sap && (t = e);
                    }
                  for (U.pushInit(ce.init), e = t; e < i; e++) {
                    var r = ce.segments[e];
                    r.init
                      ? U.pushInit(r.data)
                      : U.pushSegment(r.data, [r.ts], [r.sap]);
                  }
                  (i - t - 1 > 0 || W.length > 0) &&
                    (R.debug("recover sapSet = true", i, t, W.length),
                    (G = !0)),
                    w(void 0, !0);
                } else
                  void 0 !== ce.bufferLength &&
                    (R.debug("recover track from transition"),
                    p.transitOn(),
                    U.setBufferingLength(ce.bufferLength),
                    this.applyTransition(!0));
            }),
            (this.populateInitDataBuffer = function (e) {
              Y.push({ idx: W.length, data: e }),
                R.debug("Recover populateInitDataBuffer", e.byteLength);
            }),
            (this.populateStartupBuffer = function (e, t, i, r) {
              C(W, t, i, r, e),
                ($ = i),
                (ee = r),
                R.debug("Recover populateStartupBuffer", e, t.byteLength, i, r);
            }),
            (this.isRecoverable = function () {
              return ce && (void 0 !== ce.init || void 0 !== ce.bufferLength);
            }),
            (this.flush = function () {
              w();
            }),
            (this.buffer = function () {
              (V = u.BUFFER), R.debug("buffering...");
            }),
            (this.setBufferDelay = function () {
              J = !0;
            }),
            (this.activate = function () {
              u.BUFFER === V && (A(), (V = u.ACTIVE), E());
            }),
            (this.bufferStatus = function (t) {
              var i = { lvl: void 0, low: !1 };
              if (u.ACTIVE == V) {
                var r = 0;
                (i.lvl = 0),
                  $ &&
                    ((r = D.getRealTs(F, $ + ee) / l),
                    (i.lvl = r - t),
                    i.lvl < 0 && (i.lvl = 0)),
                  p.setCurrentBufferLevel(n, i.lvl),
                  B && B(n, i.lvl),
                  o.default.display(e, n + "-buffer", i.lvl.toFixed(4)),
                  le ||
                    (i.lvl < H &&
                      (R.debug("bufferStatus low buffer ", t, $ + ee),
                      v.reportLowBuffer(L),
                      (i.low = !0)),
                    v.reportBufLevel(L, i.lvl, r));
              }
              return i;
            }),
            (this.updateBufferedState = function (t, i) {
              if (u.BUFFER == V) {
                var r = 0,
                  s = 0,
                  a = 0;
                ie &&
                  ((r = D.getRealTs(F, ie + re) / l),
                  (s = r - i) < 0 && (s = 0),
                  (a = r - t) < 0 && (a = 0)),
                  p.setCurrentBufferLevel(n, s),
                  B && B(n, s),
                  o.default.display(e, n + "-buffer", s.toFixed(4)),
                  R.debug(
                    "updateBufferedState: buf lvl " + a + ", real buf lvl " + s,
                    t,
                    i
                  ),
                  le ||
                    J ||
                    (a < H &&
                      (R.debug("updateBufferedState: low buffer"),
                      v.reportLowBuffer(L)),
                    v.reportBufLevel(L, a, r));
              }
            }),
            (this.setBaseDecodeTime = function (e) {
              q = Math.floor(e * l + 0.5);
            }),
            (this.onBaseDecodeTimeReady = function (e) {
              P = e;
            }),
            (this.onSourceReady = function (e) {
              E = e;
            }),
            (this.onCancelStream = function (e) {
              I = e;
            }),
            (this.onTransitionCompleted = function (e) {
              M = e;
            }),
            (this.initPresentation = function (e) {
              var t = { timescale: l };
              "mp4" == O && ((t.codecData = e), (he = e)),
                (t.codec = s),
                "video" == n && ((t.width = d.width), (t.height = d.height)),
                (F = D.addTrack(n, t).id),
                U.pushInit(D.initSegment()),
                R.debug(
                  "init segment pushed, codec = "
                    .concat(t.codec, ", timescale = ")
                    .concat(t.timescale)
                );
            }),
            (this.isInitSegmentNew = function (e) {
              return "audio" == n || y(he, e);
            }),
            (this.isTransitionInitNew = function (e) {
              return "audio" == n || y(ae.initSegmentData, e);
            }),
            (this.processInitSegment = function (e) {
              var t = { syncBase: !0 };
              "audio" == n && (t.alignBase = !0),
                D.setTrackParams(F, t),
                w(),
                (G = !1),
                (le = !0),
                (he = "mp4" == O ? e : void 0),
                R.debug("new init segment processed");
            }),
            (this.initTransition = function (e) {
              var t = { timescale: l };
              (t.codec = ae.codec),
                "webm" == ae.container
                  ? (ae.composer = r.create())
                  : ((ae.composer = i.create()),
                    (ae.initSegmentData = e),
                    (t.codecData = e)),
                "video" == n &&
                  ((t.width = ae.streamOptions.width),
                  (t.height = ae.streamOptions.height)),
                (ae.cTrackId = ae.composer.addTrack(n, t).id),
                (ae.initSegment = ae.composer.initSegment()),
                (ae.initDataBuffer = []),
                R.debug("transit stream init segment pushed");
            }),
            (this.processTransitionInitSegment = function (e) {
              ae.initDataBuffer.push({ idx: ae.startupBuffer.length, data: e });
            }),
            (this.processMute = function (e, t) {
              if (void 0 !== F) {
                var i = void 0;
                switch (V) {
                  case u.OPEN:
                  case u.BUFFER:
                    i =
                      0 == W.length
                        ? void 0 !== (i = t.getBufferedStart())
                          ? (l / t.timescale()) * i
                          : void 0 !== $
                          ? $
                          : (l / t.timescale()) * e - j
                        : W[W.length - 1].ts;
                    break;
                  case u.ACTIVE:
                    i = $;
                    break;
                  default:
                    R.error("processMute unexpected track state", V);
                }
                if (void 0 !== i) {
                  var r = (l / t.timescale()) * e,
                    n = r - i;
                  if (n >= j / 2) {
                    n > 2 * j && (r = i + (n = 2 * j)), (r -= j / 10);
                    var s = D.getTrackSampleDuration(F),
                      a = i + s;
                    for (R.debug("processMute filling gap", i, r); a <= r; )
                      this.processFrame(!0, null, Math.floor(a), 0), (a += s);
                  }
                }
              }
            }),
            (this.processFrame = function (e, t, i, r) {
              var n = { done: !0 };
              if (((ie = i), (re = r), oe)) {
                if (ae.curStreamCancelled) return n;
                if (
                  (R.debug(
                    "processFrame transition, current frame ts="
                      .concat(i, ", offset=")
                      .concat(r, ", sap=")
                      .concat(e)
                  ),
                  e && ae.curSapTimes.push(i),
                  (ae.curStreamLastBufferedTs = i),
                  (function (e, t) {
                    var i = !1,
                      r = ae.newSapTimes.length;
                    if (c.ABRUPT == ae.mode) i = !0;
                    else if (r > 0)
                      if (X)
                        t &&
                          (e >= ae.newSapTimes[0] ||
                            e >= ae.newSapTimes[r - 1]) &&
                          (i = !0);
                      else if (e >= ae.newSapTimes[0] + ((z * l) / 1e3) * 2)
                        R.debug(
                          "Cancel current stream, because current timestamp is twice ahead possible buffer of new stream",
                          e,
                          ae.newSapTimes[0]
                        ),
                          (i = !0);
                      else
                        for (var n = ae.newSapTimes.length - 1; n >= 0; n--) {
                          if (Math.abs(e - ae.newSapTimes[n]) < _()) {
                            R.debug(
                              "Cancel current stream. Timestamp " +
                                e +
                                " is near new stream key frame " +
                                ae.newSapTimes[n]
                            ),
                              (i = !0);
                            break;
                          }
                          if (e > ae.newSapTimes[n]) break;
                        }
                    return i;
                  })(i, e))
                )
                  return (
                    R.debug(
                      "processFrame cancel current rendition",
                      ae.curStreamLastBufferedTs,
                      e
                    ),
                    I(this),
                    (ae.curStreamCancelled = !0),
                    C(W, t, i, r, e),
                    n
                  );
              }
              switch (V) {
                case u.OPEN:
                  (W.length > 0 || e) && (C(W, t, i, r, e), k(this));
                  break;
                case u.BUFFER:
                  var s = !1;
                  C(W, t, i, r, e);
                  var a = W.length;
                  if (void 0 === Q) {
                    if (void 0 !== q && a > 3) {
                      var o = W[a - 1],
                        h = o.ts - q - j;
                      if (h >= 0) {
                        R.debug("finished buffering, have " + a + " samples"),
                          (function () {
                            Q = 0;
                            var e = 0,
                              t = {};
                            for (e = 1; e < W.length; e++) {
                              var i = W[e].ts - W[e - 1].ts;
                              t[i] = t[i] > 0 ? t[i] + 1 : 1;
                            }
                            var r = 0;
                            for (e in t)
                              if (t[e] > r) {
                                var n = parseInt(e);
                                n > 0 && ((Q = n), (r = t[e]));
                              }
                            R.debug(
                              "max sample duration calculated: ",
                              Q,
                              JSON.stringify(t)
                            );
                          })(),
                          v.setRateAdditive(L, Q),
                          p.startLogging(U.stream_id),
                          U.setBufferingLength(a),
                          (G = !1);
                        for (var f = 0, d = 0; d < a && W[d].ts <= q; d++)
                          W[d].sap && (f = d);
                        R.debug("base decode time:", q),
                          R.debug(
                            "1 ts last ts",
                            W[0].ts,
                            W[0].sap,
                            W[a - 1].ts
                          ),
                          R.debug("buffer size: " + a + " first sap: " + f);
                        var m = void 0,
                          y = 0;
                        for (y = 0; y < Y.length && Y[y].idx <= f; y++)
                          (m = Y.shift()), y--;
                        for (m && g(m), y = f; y < W.length; y++) {
                          Y.length > 0 && y == Y[0].idx && g(Y.shift());
                          var b = W[y];
                          x(b.sap, b.data, b.ts, b.offset);
                        }
                        Y.length > 0 && g(Y[0]), (W = []), (Y = []), (s = !0);
                      } else
                        -1 * h > 10 * j &&
                          (R.error(
                            "sample is far away from expected",
                            o.ts,
                            q + j
                          ),
                          (n.done = !1),
                          K++);
                    }
                  } else {
                    var w = W[a - 1].ts - W[0].ts;
                    w > 0 ? (s = w >= j) : w < 0 && (s = a >= j / Q + 1),
                      s && A();
                  }
                  s &&
                    u.CLOSED !== V &&
                    ((V = u.ACTIVE),
                    E(),
                    R.debug("track is ready for playback"));
                  break;
                case u.ACTIVE:
                  x(e, t, i, r);
              }
              return n.done ? (K = 0) : (n.errors = K), n;
            }),
            (this.processTransitionFrame = function (e, t, i, r) {
              var n = { done: !0 };
              if (e) ae.newSapTimes.push(i);
              else if (0 == ae.newSapTimes.length)
                return (
                  R.debug("processTransition: throwing useless frame", i, r), n
                );
              R.debug(
                "processTransition: new rendition frame ts="
                  .concat(i, ", offset=")
                  .concat(r, ", sap=")
                  .concat(e)
              );
              var s = ae.startupBuffer.length;
              if (s > 0) {
                void 0 == ae.lastSampleDuration &&
                  (ae.lastSampleDuration = void 0 !== Q ? Q : 0);
                var a = ae.startupBuffer[s - 1],
                  o = i - a.ts;
                o < 0
                  ? r >= -1 * o
                    ? ((r += o), (o = 0))
                    : (o = ae.lastSampleDuration)
                  : o > 2 * l && (o = ae.lastSampleDuration),
                  (i = a.ts + o),
                  (ae.lastSampleDuration = o);
              }
              if (
                (C(ae.startupBuffer, t, i, r, e),
                (function (e, t) {
                  var i = !1,
                    r = (z * l) / 1e3,
                    n = ae.curSapTimes.length,
                    s = ae.newSapTimes.length,
                    a = e - ae.startupBuffer[0].ts;
                  if (X && c.ABRUPT != ae.mode) {
                    if (a >= r)
                      if (n > 0) {
                        for (var o = 0, u = 0; u < n; u++)
                          if (
                            !(
                              ae.curSapTimes[u] < ae.newSapTimes[o] ||
                              ae.curSapTimes[u] <= Z
                            )
                          ) {
                            for (
                              var h = o;
                              h < s &&
                              ((o = h),
                              !(ae.newSapTimes[h] > ae.curSapTimes[u]));
                              h++
                            )
                              ae.newSapTimes[h] == ae.curSapTimes[u] &&
                                (R.debug(
                                  "Switch to new stream because of SAP alignment"
                                ),
                                (i = !0));
                            if (i) break;
                          }
                      } else
                        s > 0 &&
                          (R.debug(
                            "No current stream frames, switch to new stream"
                          ),
                          (i = !0));
                    !i &&
                      n >= 1 &&
                      s >= 2 &&
                      (ae.newSapTimes[s - 1] > ae.curSapTimes[0] ||
                        ae.newSapTimes[s - 1] >= ae.curSapTimes[n - 1]) &&
                      (R.debug(
                        "Switch to new stream SAP alignment does not work!"
                      ),
                      (i = !0));
                  } else if (
                    a >= 2 * r &&
                    (e >= ae.curStreamLastBufferedTs ||
                      void 0 == ae.curStreamLastBufferedTs)
                  )
                    R.debug(
                      "Switch to new stream because transition buffer is twice filled"
                    ),
                      (i = !0);
                  else if (a >= r)
                    if (
                      ae.curStreamCancelled &&
                      (e >= ae.curStreamLastBufferedTs ||
                        void 0 == ae.curStreamLastBufferedTs)
                    )
                      R.debug(
                        "Switch to new stream because buffer is filled and current stream is cancelled"
                      ),
                        (i = !0);
                    else {
                      for (var f = ae.newSapTimes.length - 1; f >= 0; f--) {
                        if (
                          Math.abs(
                            ae.curStreamLastBufferedTs - ae.newSapTimes[f]
                          ) < _()
                        ) {
                          R.debug(
                            "Switch to new stream, because new key frame " +
                              ae.newSapTimes[f] +
                              " is near to current latest timestamp " +
                              ae.curStreamLastBufferedTs
                          ),
                            (i = !0);
                          break;
                        }
                        if (ae.curStreamLastBufferedTs > ae.newSapTimes[f])
                          break;
                      }
                      !i &&
                        e + 2 * r < ae.curStreamLastBufferedTs &&
                        a >= 10 * l &&
                        (R.error(
                          "Error: new stream is " +
                            (ae.curStreamLastBufferedTs - e) / l +
                            " seconds behind previous stream. Halting."
                        ),
                        (i = !0));
                    }
                  return i;
                })(i))
              ) {
                ae.curStreamCancelled ||
                  (R.debug("processTransitionFrame cancel current rendition"),
                  I(this),
                  (ae.curStreamCancelled = !0));
                var u = $;
                ae.curStreamLastBufferedTs &&
                  ae.curStreamLastBufferedTs > u &&
                  (u = ae.curStreamLastBufferedTs);
                var h = ae.newSapTimes[0],
                  f = 0,
                  d = Math.abs(ae.newSapTimes[0] - u);
                for (f = ae.newSapTimes.length - 1; f >= 1; f--) {
                  var p = Math.abs(ae.newSapTimes[f] - u);
                  p < d && ((d = p), (h = ae.newSapTimes[f]));
                }
                for (
                  w(h), f = 0;
                  f < ae.startupBuffer.length && !(ae.startupBuffer[f].ts >= h);
                  f++
                );
                if (f > 0) {
                  ae.startupBuffer.splice(0, f);
                  for (var v = void 0, m = 0; m < ae.initDataBuffer.length; m++)
                    ae.initDataBuffer[m].idx <= f
                      ? ((v = ae.initDataBuffer.shift()), m--)
                      : (ae.initDataBuffer[m].idx -= f);
                  v &&
                    (ae.composer.setTrackParams(ae.cTrackId, {
                      codec: ae.codec,
                      codecData: v.data,
                    }),
                    (ae.initSegment = ae.composer.initSegment()));
                }
                var g = T(h);
                if ((U.pushInit(ae.initSegment, g[0]), oe)) {
                  var y = g[1];
                  R.debug(
                    "transit buffer length = ".concat(ae.startupBuffer.length)
                  ),
                    R.debug(
                      "===== Rendition switch GAP ===== "
                        .concat(1e3 * y, " msec, allowance = ")
                        .concat(1e3 * g[2])
                    ),
                    this.completeTransition(),
                    this.applyTransition(),
                    (isNaN(y) || (y < 0 && -y > 10)) &&
                      ((n.done = !1),
                      R.error(
                        "Correct rendition switch isn't possible, gap is too big (".concat(
                          y,
                          "s). Reloading stream."
                        )
                      ));
                }
              }
              return n;
            }),
            (this.completeTransition = function () {
              if (
                ((W = ae.startupBuffer),
                (ae.startupBuffer = []),
                ae.composer.setTrackParams(ae.cTrackId, {
                  sequenceNumber: ne + 1,
                }),
                v.remove(L),
                (L = ae.id),
                (d = ae.streamOptions),
                (f = ae.name),
                (D = ae.composer),
                (F = ae.cTrackId),
                (s = ae.codec),
                (O = ae.container),
                (l = ae.timescale),
                (G = !1),
                (q = void 0),
                (Q = void 0),
                (se = !1),
                (oe = !1),
                (K = 0),
                ae.buffering && (N = ae.buffering),
                b(N),
                (he = ae.initSegmentData),
                (Y = ae.initDataBuffer),
                (ae = {}),
                (le = !1),
                (Z = void 0),
                (te = void 0),
                (ie = void 0),
                (re = void 0),
                W.length > 0)
              ) {
                var e = W[W.length - 1];
                ($ = e.ts), (ee = e.offset);
              }
            }),
            (this.applyTransition = function (e) {
              if (
                (R.debug("applyTransition", e),
                e && he && g(he),
                M(this),
                (V = u.OPEN),
                k(this),
                W.length >= 2)
              ) {
                var t = W.splice(W.length - 1, 1)[0];
                this.processFrame(t.sap, t.data, t.ts, t.offset);
              }
              p.setPositionControl(), p.transitOff();
            }),
            (this.suspendMuteable = function () {
              "audio" === n &&
                (D.isTrackSilent(F) ||
                  (m(),
                  (fe = setTimeout(function () {
                    fe = void 0;
                  }, 5e3))));
            }),
            (this.isMuteable = function () {
              return void 0 === fe;
            });
        }
        var i = new n.default(e),
          r = new s.default(e);
        return {
          create: function (e, i, r, n, s, a, o, u, c) {
            return new t(e, i, r, n, s, a, o, u, c);
          },
        };
      }),
      (t.TRANSITION_MODE = void 0),
      i(90),
      i(70),
      i(152),
      i(21),
      i(86),
      i(23);
    var n = r(i(115)),
      s = r(i(176)),
      a = r(i(10)),
      o = r(i(94)),
      u = { OPEN: 0, BUFFER: 1, ACTIVE: 2, BACKUP: 3, CLOSED: 4 },
      c = { ABRUPT: 0, SMOOTH: 1 };
    t.TRANSITION_MODE = c;
  },
  function (e, t, i) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : { default: e };
    }

    function n(e, t) {
      for (var i = 0; i < t.length; i++) {
        var r = t[i];
        (r.enumerable = r.enumerable || !1),
          (r.configurable = !0),
          "value" in r && (r.writable = !0),
          Object.defineProperty(e, r.key, r);
      }
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.default = void 0),
      i(21),
      i(218),
      i(0);
    var s = r(i(175)),
      a = r(i(10)),
      o = (function () {
        function e(t, i, r) {
          !(function (e, t) {
            if (!(e instanceof t))
              throw new TypeError("Cannot call a class as a function");
          })(this, e),
            (this.dbRange = t || 100),
            (this.dbMult = 20),
            (this.bufSize = 2048),
            (this.rate = i || 6),
            (this.logger = a.default.create(r, "VU meter"));
        }
        var t, i;
        return (
          (t = e),
          (i = [
            {
              key: "start",
              value: function (e, t) {
                (this.samplingRate = t ? t.samplingRate : void 0),
                  (this.channels = (t && t.channels) || 2),
                  this.logger.debug(
                    "Start VU meter, channel count: "
                      .concat(this.channels, ", sampling rate: ")
                      .concat(this.samplingRate)
                  ),
                  (this.mediaElement = e),
                  this._setupMeter();
              },
            },
            {
              key: "stop",
              value: function (e) {
                this.logger.debug("Stop VU meter", e),
                  this._removeMeter(),
                  this._initValues(),
                  this.ui && this.ui.destroy(e);
              },
            },
            {
              key: "setup",
              value: function () {
                return this._setupMeter(), void 0 != this.context;
              },
            },
            {
              key: "refreshUI",
              value: function (e) {
                this.ui && this.ui.refresh((e && e.channels) || 2);
              },
            },
            {
              key: "onPlay",
              value: function () {
                this.context &&
                  (this.logger.debug("onPlay event, resume context"),
                  this.context.resume());
              },
            },
            {
              key: "setScriptPath",
              value: function (e) {
                this.scriptPath = e;
              },
            },
            {
              key: "setCallback",
              value: function (e) {
                this.callback = e;
              },
            },
            {
              key: "setFatalErrorCallback",
              value: function (e) {
                this.fatalErrorCallback = e;
              },
            },
            {
              key: "setUI",
              value: function (e) {
                var t = document.getElementById(e);
                t && (this.ui = new s.default(t, this.dbRange));
              },
            },
            {
              key: "isActivated",
              value: function () {
                return void 0 != this.context;
              },
            },
            {
              key: "_setupMeter",
              value: function () {
                this._enableSource() &&
                  (this._createMeter(),
                  this.rate && this.samplingRate && this._setupRateControl(),
                  this.ui && this.ui.create(this.channels));
              },
            },
            {
              key: "_initValues",
              value: function () {
                (this.suspended = !1),
                  (this.rateControl = !1),
                  (this.channelValues = []),
                  (this.channelDecibels = []);
              },
            },
            {
              key: "_enableSource",
              value: function () {
                var e = void 0 != this.context;
                if (!e) {
                  var t = window.AudioContext || window.webkitAudioContext;
                  if (t)
                    if (
                      ((this.context = new t()),
                      "suspended" !== this.context.state)
                    )
                      (this.source = this.context.createMediaElementSource(
                        this.mediaElement
                      )),
                        (this.source.channelCount = this.channels),
                        (this.suspended = !1),
                        (e = !0);
                    else {
                      var i = this.context,
                        r = this;
                      (i.onstatechange = function () {
                        r.logger.debug("onstatechange", i.state, r.suspended),
                          r.suspended &&
                            "running" === i.state &&
                            (r.logger.debug(
                              "set running state, setup VU meter"
                            ),
                            (i.onstatechange = void 0),
                            (r.context = i),
                            (r.source = r.context.createMediaElementSource(
                              r.mediaElement
                            )),
                            (r.source.channelCount = r.channels),
                            (r.suspended = !1),
                            r._setupMeter(),
                            r.onActivated &&
                              (r.onActivated(), (r.onActivated = void 0)));
                      }),
                        this.logger.debug("suspended state"),
                        (this.suspended = !0),
                        this.context.resume(),
                        (this.context = void 0);
                    }
                }
                return e;
              },
            },
            {
              key: "_dbFromVal",
              value: function (e) {
                var t = -this.dbRange;
                return (
                  e > 0 &&
                    (t = this.dbMult * Math.log10(e)) < -this.dbRange &&
                    (t = -this.dbRange),
                  t
                );
              },
            },
          ]) && n(t.prototype, i),
          e
        );
      })();
    t.default = o;
  },
  function (e, t, i) {
    "use strict";

    function r(e) {
      "@babel/helpers - typeof";
      return (r =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (e) {
              return typeof e;
            }
          : function (e) {
              return e &&
                "function" == typeof Symbol &&
                e.constructor === Symbol &&
                e !== Symbol.prototype
                ? "symbol"
                : typeof e;
            })(e);
    }
    i(0),
      Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.default = void 0),
      i(86),
      i(93),
      i(91),
      i(16),
      i(92),
      i(14),
      i(59),
      i(60);
    var n = {
        appendBox: function (e, t, i) {
          if (((t._root = e._root ? e._root : e), (t._parent = e), -1 !== i))
            if (void 0 !== i && null !== i) {
              var n,
                s = -1;
              if ("number" == typeof i) s = i;
              else {
                if ("string" == typeof i) n = i;
                else {
                  if ("object" !== r(i) || !i.type) return void e.boxes.push(t);
                  n = i.type;
                }
                for (var a = 0; a < e.boxes.length; a++)
                  if (n === e.boxes[a].type) {
                    s = a + 1;
                    break;
                  }
              }
              e.boxes.splice(s, 0, t);
            } else e.boxes.push(t);
        },
      },
      s = n;
    t.default = s;
  },
  function (e, t, i) {
    "use strict";

    function r(e, t) {
      for (var i = 0; i < t.length; i++) {
        var r = t[i];
        (r.enumerable = r.enumerable || !1),
          (r.configurable = !0),
          "value" in r && (r.writable = !0),
          Object.defineProperty(e, r.key, r);
      }
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.default = void 0),
      i(0);
    var n,
      s = (n = i(10)) && n.__esModule ? n : { default: n },
      a = {};
    (a.liveFrameTypes = {
      WEB_AAC_SEQUENCE_HEADER: 0,
      WEB_AAC_FRAME: 1,
      WEB_AVC_SEQUENCE_HEADER: 2,
      WEB_AVC_KEY_FRAME: 3,
      WEB_AVC_FRAME: 4,
      WEB_HEVC_SEQUENCE_HEADER: 5,
      WEB_HEVC_KEY_FRAME: 6,
      WEB_HEVC_FRAME: 7,
      WEB_VP6_KEY_FRAME: 8,
      WEB_VP6_FRAME: 9,
      WEB_VP8_KEY_FRAME: 10,
      WEB_VP8_FRAME: 11,
      WEB_VP9_KEY_FRAME: 12,
      WEB_VP9_FRAME: 13,
      WEB_MP3: 14,
    }),
      (a.closeCodes = {
        1e3: "CLOSE_NORMAL",
        1001: "CLOSE_GOING_AWAY",
        1002: "CLOSE_PROTOCOL_ERROR",
        1003: "CLOSE_UNSUPPORTED",
        1005: "CLOSE_NO_STATUS",
        1006: "CLOSE_ABNORMAL",
        1007: "Unsupported Data",
        1008: "Policy Violation",
        1009: "CLOSE_TOO_LARGE",
        1010: "Missing Extension",
        1011: "Internal Error",
        1012: "Service Restart",
        1013: "Try Again Later",
        1015: "TLS Handshake",
      });
    var o = function (e) {
      var t = s.default.create(e, "WSUtils"),
        i = (function () {
          function e() {
            !(function (e, t) {
              if (!(e instanceof t))
                throw new TypeError("Cannot call a class as a function");
            })(this, e),
              (this.closeCodes = a.closeCodes),
              (this.liveFrameTypes = a.liveFrameTypes),
              (this.int32pow = Math.pow(2, 32));
          }
          var i, n;
          return (
            (i = e),
            (n = [
              {
                key: "readValue",
                value: function (e, i, r) {
                  var n = r / 4,
                    s = n >>> 0,
                    a = [0, 0],
                    o = n === s ? s - 1 : s;
                  if (o > 2)
                    return (
                      t.error("[WS]: Attempt to read more than 64 bits!"), null
                    );
                  for (var u = o; u >= 0; u--)
                    for (var c = 0; c < 4; c++)
                      a[u] |= e[i + 4 * (o - u) + c] << (8 * (3 - c));
                  return (a[1] &= 2097151), a[1] * this.int32pow + (a[0] >>> 0);
                },
              },
            ]) && r(i.prototype, n),
            e
          );
        })();
      return {
        create: function () {
          return new i();
        },
      };
    };
    t.default = o;
  },
  function (e, t, i) {
    "use strict";
    var r = i(108).charAt;
    e.exports = function (e, t, i) {
      return t + (i ? r(e, t).length : 1);
    };
  },
  function (e, t, i) {
    "use strict";
    var r = i(13),
      n = i(28),
      s = i(6);
    e.exports = function (e) {
      for (
        var t = r(this),
          i = s(t.length),
          a = arguments.length,
          o = n(a > 1 ? arguments[1] : void 0, i),
          u = a > 2 ? arguments[2] : void 0,
          c = void 0 === u ? i : n(u, i);
        c > o;

      )
        t[o++] = e;
      return t;
    };
  },
  function (e, t, i) {
    "use strict";
    var r = i(20),
      n = i(18),
      s = i(6),
      a = i(75),
      o = Math.min,
      u = [].lastIndexOf,
      c = !!u && 1 / [1].lastIndexOf(1, -0) < 0,
      l = a("lastIndexOf"),
      h = c || !l;
    e.exports = h
      ? function (e) {
          if (c) return u.apply(this, arguments) || 0;
          var t = r(this),
            i = s(t.length),
            a = i - 1;
          for (
            arguments.length > 1 && (a = o(a, n(arguments[1]))),
              a < 0 && (a = i + a);
            a >= 0;
            a--
          )
            if (a in t && t[a] === e) return a || 0;
          return -1;
        }
      : u;
  },
  function (e, t, i) {
    var r = i(54),
      n = i(13),
      s = i(62),
      a = i(6),
      o = function (e) {
        return function (t, i, o, u) {
          r(i);
          var c = n(t),
            l = s(c),
            h = a(c.length),
            f = e ? h - 1 : 0,
            d = e ? -1 : 1;
          if (o < 2)
            for (;;) {
              if (f in l) {
                (u = l[f]), (f += d);
                break;
              }
              if (((f += d), e ? f < 0 : h <= f))
                throw TypeError("Reduce of empty array with no initial value");
            }
          for (; e ? f >= 0 : h > f; f += d) f in l && (u = i(u, l[f], f, c));
          return u;
        };
      };
    e.exports = { left: o(!1), right: o(!0) };
  },
  function (e, t, i) {
    var r = i(11),
      n = i(205),
      s = i(81),
      a = i(12);
    e.exports = function (e, t) {
      for (var i = n(t), o = a.f, u = s.f, c = 0; c < i.length; c++) {
        var l = i[c];
        r(e, l) || o(e, l, u(t, l));
      }
    };
  },
  function (e, t, i) {
    var r = i(3);
    e.exports = !r(function () {
      function e() {}
      return (
        (e.prototype.constructor = null),
        Object.getPrototypeOf(new e()) !== e.prototype
      );
    });
  },
  function (e, t, i) {
    "use strict";
    var r = i(137).IteratorPrototype,
      n = i(26),
      s = i(24),
      a = i(57),
      o = i(64),
      u = function () {
        return this;
      };
    e.exports = function (e, t, i) {
      var c = t + " Iterator";
      return (
        (e.prototype = n(r, { next: s(1, i) })), a(e, c, !1, !0), (o[c] = u), e
      );
    };
  },
  function (e, t, i) {
    "use strict";
    var r = i(1),
      n = i(127),
      s = i(66),
      a = i(56),
      o = i(57),
      u = i(15),
      c = i(17),
      l = i(5),
      h = i(63),
      f = i(64),
      d = i(137),
      p = d.IteratorPrototype,
      v = d.BUGGY_SAFARI_ITERATORS,
      m = l("iterator"),
      g = function () {
        return this;
      };
    e.exports = function (e, t, i, l, d, y, _) {
      n(i, t, l);
      var b,
        A,
        w,
        S = function (e) {
          if (e === d && E) return E;
          if (!v && e in x) return x[e];
          switch (e) {
            case "keys":
            case "values":
            case "entries":
              return function () {
                return new i(this, e);
              };
          }
          return function () {
            return new i(this);
          };
        },
        k = t + " Iterator",
        T = !1,
        x = e.prototype,
        C = x[m] || x["@@iterator"] || (d && x[d]),
        E = (!v && C) || S(d),
        P = ("Array" == t && x.entries) || C;
      if (
        (P &&
          ((b = s(P.call(new e()))),
          p !== Object.prototype &&
            b.next &&
            (h ||
              s(b) === p ||
              (a ? a(b, p) : "function" != typeof b[m] && u(b, m, g)),
            o(b, k, !0, !0),
            h && (f[k] = g))),
        "values" == d &&
          C &&
          "values" !== C.name &&
          ((T = !0),
          (E = function () {
            return C.call(this);
          })),
        (h && !_) || x[m] === E || u(x, m, E),
        (f[t] = E),
        d)
      )
        if (
          ((A = {
            values: S("values"),
            keys: y ? E : S("keys"),
            entries: S("entries"),
          }),
          _)
        )
          for (w in A) (!v && !T && w in x) || c(x, w, A[w]);
        else r({ target: t, proto: !0, forced: v || T }, A);
      return A;
    };
  },
  function (e, t, i) {
    var r = i(142),
      n = i(11),
      s = i(150),
      a = i(12).f;
    e.exports = function (e) {
      var t = r.Symbol || (r.Symbol = {});
      n(t, e) || a(t, e, { value: s.f(e) });
    };
  },
  function (e, t, i) {
    var r = i(4),
      n = i(9),
      s = r.document,
      a = n(s) && n(s.createElement);
    e.exports = function (e) {
      return a ? s.createElement(e) : {};
    };
  },
  function (e, t, i) {
    var r = i(25);
    e.exports = r("navigator", "userAgent") || "";
  },
  function (e, t, i) {
    "use strict";
    i(112);
    var r = i(17),
      n = i(82),
      s = i(3),
      a = i(5),
      o = i(15),
      u = a("species"),
      c = RegExp.prototype,
      l = !s(function () {
        var e = /./;
        return (
          (e.exec = function () {
            var e = [];
            return (e.groups = { a: "7" }), e;
          }),
          "7" !== "".replace(e, "$<a>")
        );
      }),
      h = "$0" === "a".replace(/./, "$0"),
      f = a("replace"),
      d = !!/./[f] && "" === /./[f]("a", "$0"),
      p = !s(function () {
        var e = /(?:)/,
          t = e.exec;
        e.exec = function () {
          return t.apply(this, arguments);
        };
        var i = "ab".split(e);
        return 2 !== i.length || "a" !== i[0] || "b" !== i[1];
      });
    e.exports = function (e, t, i, f) {
      var v = a(e),
        m = !s(function () {
          var t = {};
          return (
            (t[v] = function () {
              return 7;
            }),
            7 != ""[e](t)
          );
        }),
        g =
          m &&
          !s(function () {
            var t = !1,
              i = /a/;
            return (
              "split" === e &&
                (((i = {}).constructor = {}),
                (i.constructor[u] = function () {
                  return i;
                }),
                (i.flags = ""),
                (i[v] = /./[v])),
              (i.exec = function () {
                return (t = !0), null;
              }),
              i[v](""),
              !t
            );
          });
      if (
        !m ||
        !g ||
        ("replace" === e && (!l || !h || d)) ||
        ("split" === e && !p)
      ) {
        var y = /./[v],
          _ = i(
            v,
            ""[e],
            function (e, t, i, r, s) {
              var a = t.exec;
              return a === n || a === c.exec
                ? m && !s
                  ? { done: !0, value: y.call(t, i, r) }
                  : { done: !0, value: e.call(i, t, r) }
                : { done: !1 };
            },
            {
              REPLACE_KEEPS_$0: h,
              REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: d,
            }
          ),
          b = _[0],
          A = _[1];
        r(String.prototype, e, b),
          r(
            c,
            v,
            2 == t
              ? function (e, t) {
                  return A.call(e, this, t);
                }
              : function (e) {
                  return A.call(e, this);
                }
          );
      }
      f && o(c[v], "sham", !0);
    };
  },
  function (e, t, i) {
    "use strict";
    var r = i(54),
      n = i(9),
      s = [].slice,
      a = {};
    e.exports =
      Function.bind ||
      function (e) {
        var t = r(this),
          i = s.call(arguments, 1),
          o = function () {
            var r = i.concat(s.call(arguments));
            return this instanceof o
              ? (function (e, t, i) {
                  if (!(t in a)) {
                    for (var r = [], n = 0; n < t; n++) r[n] = "a[" + n + "]";
                    a[t] = Function("C,a", "return new C(" + r.join(",") + ")");
                  }
                  return a[t](e, i);
                })(t, r.length, r)
              : t.apply(e, r);
          };
        return n(t.prototype) && (o.prototype = t.prototype), o;
      };
  },
  function (e, t, i) {
    var r = i(8),
      n = i(3),
      s = i(130);
    e.exports =
      !r &&
      !n(function () {
        return (
          7 !=
          Object.defineProperty(s("div"), "a", {
            get: function () {
              return 7;
            },
          }).a
        );
      });
  },
  function (e, t, i) {
    var r = i(107),
      n = Function.toString;
    "function" != typeof r.inspectSource &&
      (r.inspectSource = function (e) {
        return n.call(e);
      }),
      (e.exports = r.inspectSource);
  },
  function (e, t, i) {
    var r = i(5),
      n = i(64),
      s = r("iterator"),
      a = Array.prototype;
    e.exports = function (e) {
      return void 0 !== e && (n.Array === e || a[s] === e);
    };
  },
  function (e, t, i) {
    "use strict";
    var r,
      n,
      s,
      a = i(3),
      o = i(66),
      u = i(15),
      c = i(11),
      l = i(5),
      h = i(63),
      f = l("iterator"),
      d = !1;
    [].keys &&
      ("next" in (s = [].keys())
        ? (n = o(o(s))) !== Object.prototype && (r = n)
        : (d = !0));
    var p =
      void 0 == r ||
      a(function () {
        var e = {};
        return r[f].call(e) !== e;
      });
    p && (r = {}),
      (h && !p) ||
        c(r, f) ||
        u(r, f, function () {
          return this;
        }),
      (e.exports = { IteratorPrototype: r, BUGGY_SAFARI_ITERATORS: d });
  },
  function (e, t, i) {
    var r = i(3),
      n = i(5),
      s = i(63),
      a = n("iterator");
    e.exports = !r(function () {
      var e = new URL("b?a=1&b=2&c=3", "http://a"),
        t = e.searchParams,
        i = "";
      return (
        (e.pathname = "c%20d"),
        t.forEach(function (e, r) {
          t.delete("b"), (i += r + e);
        }),
        (s && !e.toJSON) ||
          !t.sort ||
          "http://a/c%20d?a=1&c=3" !== e.href ||
          "3" !== t.get("c") ||
          "a=1" !== String(new URLSearchParams("?a=1")) ||
          !t[a] ||
          "a" !== new URL("https://a@b").username ||
          "b" !== new URLSearchParams(new URLSearchParams("a=b")).get("a") ||
          "xn--e1aybc" !== new URL("http://С‚РµСЃС‚").host ||
          "#%D0%B1" !== new URL("http://a#Р±").hash ||
          "a1c3" !== i ||
          "x" !== new URL("http://x", void 0).host
      );
    });
  },
  function (e, t, i) {
    "use strict";
    var r = i(8),
      n = i(3),
      s = i(102),
      a = i(101),
      o = i(103),
      u = i(13),
      c = i(62),
      l = Object.assign,
      h = Object.defineProperty;
    e.exports =
      !l ||
      n(function () {
        if (
          r &&
          1 !==
            l(
              { b: 1 },
              l(
                h({}, "a", {
                  enumerable: !0,
                  get: function () {
                    h(this, "b", { value: 3, enumerable: !1 });
                  },
                }),
                { b: 2 }
              )
            ).b
        )
          return !0;
        var e = {},
          t = {},
          i = Symbol();
        return (
          (e[i] = 7),
          "abcdefghijklmnopqrst".split("").forEach(function (e) {
            t[e] = e;
          }),
          7 != l({}, e)[i] || "abcdefghijklmnopqrst" != s(l({}, t)).join("")
        );
      })
        ? function (e, t) {
            for (
              var i = u(e), n = arguments.length, l = 1, h = a.f, f = o.f;
              n > l;

            )
              for (
                var d,
                  p = c(arguments[l++]),
                  v = h ? s(p).concat(h(p)) : s(p),
                  m = v.length,
                  g = 0;
                m > g;

              )
                (d = v[g++]), (r && !f.call(p, d)) || (i[d] = p[d]);
            return i;
          }
        : l;
  },
  function (e, t, i) {
    var r = i(8),
      n = i(12),
      s = i(7),
      a = i(102);
    e.exports = r
      ? Object.defineProperties
      : function (e, t) {
          s(e);
          for (var i, r = a(t), o = r.length, u = 0; o > u; )
            n.f(e, (i = r[u++]), t[i]);
          return e;
        };
  },
  function (e, t, i) {
    var r = i(11),
      n = i(20),
      s = i(74).indexOf,
      a = i(79);
    e.exports = function (e, t) {
      var i,
        o = n(e),
        u = 0,
        c = [];
      for (i in o) !r(a, i) && r(o, i) && c.push(i);
      for (; t.length > u; ) r(o, (i = t[u++])) && (~s(c, i) || c.push(i));
      return c;
    };
  },
  function (e, t, i) {
    var r = i(4);
    e.exports = r;
  },
  function (e, t, i) {
    var r = i(17);
    e.exports = function (e, t, i) {
      for (var n in t) r(e, n, t[n], i);
      return e;
    };
  },
  function (e, t, i) {
    var r = i(55),
      n = i(82);
    e.exports = function (e, t) {
      var i = e.exec;
      if ("function" == typeof i) {
        var s = i.call(e, t);
        if ("object" != typeof s)
          throw TypeError(
            "RegExp exec method returned something other than an Object or null"
          );
        return s;
      }
      if ("RegExp" !== r(e))
        throw TypeError("RegExp#exec called on incompatible receiver");
      return n.call(e, t);
    };
  },
  function (e, t, i) {
    "use strict";
    var r = i(25),
      n = i(12),
      s = i(5),
      a = i(8),
      o = s("species");
    e.exports = function (e) {
      var t = r(e),
        i = n.f;
      a &&
        t &&
        !t[o] &&
        i(t, o, {
          configurable: !0,
          get: function () {
            return this;
          },
        });
    };
  },
  function (e, t, i) {
    var r = i(27),
      n = "[" + i(110) + "]",
      s = RegExp("^" + n + n + "*"),
      a = RegExp(n + n + "*$"),
      o = function (e) {
        return function (t) {
          var i = String(r(t));
          return (
            1 & e && (i = i.replace(s, "")), 2 & e && (i = i.replace(a, "")), i
          );
        };
      };
    e.exports = { start: o(1), end: o(2), trim: o(3) };
  },
  function (e, t, i) {
    var r = i(18),
      n = i(6);
    e.exports = function (e) {
      if (void 0 === e) return 0;
      var t = r(e),
        i = n(t);
      if (t !== i) throw RangeError("Wrong length or index");
      return i;
    };
  },
  function (e, t, i) {
    var r = i(209);
    e.exports = function (e, t) {
      var i = r(e);
      if (i % t) throw RangeError("Wrong offset");
      return i;
    };
  },
  function (e, t, i) {
    var r = i(100);
    e.exports = r && !Symbol.sham && "symbol" == typeof Symbol.iterator;
  },
  function (e, t, i) {
    var r = i(5);
    t.f = r;
  },
  function (e, t, i) {
    var r = i(1),
      n = i(123);
    r(
      { target: "Array", proto: !0, forced: n !== [].lastIndexOf },
      { lastIndexOf: n }
    );
  },
  function (e, t, i) {
    "use strict";
    var r = i(1),
      n = i(18),
      s = i(208),
      a = i(207),
      o = i(3),
      u = (1).toFixed,
      c = Math.floor,
      l = function (e, t, i) {
        return 0 === t
          ? i
          : t % 2 == 1
          ? l(e, t - 1, i * e)
          : l(e * e, t / 2, i);
      },
      h = function (e, t, i) {
        for (var r = -1, n = i; ++r < 6; )
          (n += t * e[r]), (e[r] = n % 1e7), (n = c(n / 1e7));
      },
      f = function (e, t) {
        for (var i = 6, r = 0; --i >= 0; )
          (r += e[i]), (e[i] = c(r / t)), (r = (r % t) * 1e7);
      },
      d = function (e) {
        for (var t = 6, i = ""; --t >= 0; )
          if ("" !== i || 0 === t || 0 !== e[t]) {
            var r = String(e[t]);
            i = "" === i ? r : i + a.call("0", 7 - r.length) + r;
          }
        return i;
      };
    r(
      {
        target: "Number",
        proto: !0,
        forced:
          (u &&
            ("0.000" !== (8e-5).toFixed(3) ||
              "1" !== (0.9).toFixed(0) ||
              "1.25" !== (1.255).toFixed(2) ||
              "1000000000000000128" !== (0xde0b6b3a7640080).toFixed(0))) ||
          !o(function () {
            u.call({});
          }),
      },
      {
        toFixed: function (e) {
          var t,
            i,
            r,
            o,
            u = s(this),
            c = n(e),
            p = [0, 0, 0, 0, 0, 0],
            v = "",
            m = "0";
          if (c < 0 || c > 20) throw RangeError("Incorrect fraction digits");
          if (u != u) return "NaN";
          if (u <= -1e21 || u >= 1e21) return String(u);
          if ((u < 0 && ((v = "-"), (u = -u)), u > 1e-21))
            if (
              ((i =
                (t =
                  (function (e) {
                    for (var t = 0, i = e; i >= 4096; ) (t += 12), (i /= 4096);
                    for (; i >= 2; ) (t += 1), (i /= 2);
                    return t;
                  })(u * l(2, 69, 1)) - 69) < 0
                  ? u * l(2, -t, 1)
                  : u / l(2, t, 1)),
              (i *= 4503599627370496),
              (t = 52 - t) > 0)
            ) {
              for (h(p, 0, i), r = c; r >= 7; ) h(p, 1e7, 0), (r -= 7);
              for (h(p, l(10, r, 1), 0), r = t - 1; r >= 23; )
                f(p, 1 << 23), (r -= 23);
              f(p, 1 << r), h(p, 1, 1), f(p, 2), (m = d(p));
            } else h(p, 0, i), h(p, 1 << -t, 0), (m = d(p) + a.call("0", c));
          return (m =
            c > 0
              ? v +
                ((o = m.length) <= c
                  ? "0." + a.call("0", c - o) + m
                  : m.slice(0, o - c) + "." + m.slice(o - c))
              : v + m);
        },
      }
    );
  },
  function (e, t, i) {
    i(1)({ target: "Object", stat: !0, sham: !i(8) }, { create: i(26) });
  },
  function (e, t, i) {
    var r = i(1),
      n = i(3),
      s = i(13),
      a = i(66),
      o = i(126);
    r(
      {
        target: "Object",
        stat: !0,
        forced: n(function () {
          a(1);
        }),
        sham: !o,
      },
      {
        getPrototypeOf: function (e) {
          return a(s(e));
        },
      }
    );
  },
  function (e, t, i) {
    i(1)({ target: "Object", stat: !0 }, { setPrototypeOf: i(56) });
  },
  function (e, t, i) {
    var r = i(1),
      n = i(25),
      s = i(54),
      a = i(7),
      o = i(9),
      u = i(26),
      c = i(133),
      l = i(3),
      h = n("Reflect", "construct"),
      f = l(function () {
        function e() {}
        return !(h(function () {}, [], e) instanceof e);
      }),
      d = !l(function () {
        h(function () {});
      }),
      p = f || d;
    r(
      { target: "Reflect", stat: !0, forced: p, sham: p },
      {
        construct: function (e, t) {
          s(e), a(t);
          var i = arguments.length < 3 ? e : s(arguments[2]);
          if (d && !f) return h(e, t, i);
          if (e == i) {
            switch (t.length) {
              case 0:
                return new e();
              case 1:
                return new e(t[0]);
              case 2:
                return new e(t[0], t[1]);
              case 3:
                return new e(t[0], t[1], t[2]);
              case 4:
                return new e(t[0], t[1], t[2], t[3]);
            }
            var r = [null];
            return r.push.apply(r, t), new (c.apply(e, r))();
          }
          var n = i.prototype,
            l = u(o(n) ? n : Object.prototype),
            p = Function.apply.call(e, l, t);
          return o(p) ? p : l;
        },
      }
    );
  },
  function (e, t, i) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : { default: e };
    }
    i(151);
    var n,
      s = r(i(162));
    r(i(167)),
      document.currentScript &&
        (n = document.currentScript.src.substr(
          0,
          document.currentScript.src.lastIndexOf("/") + 1
        )),
      (e.exports = {
        init: function (e) {
          var t = void 0;
          t =
            e && e.instance_name
              ? e.instance_name
              : "SLDP_" + (Math.floor(1e3 * Math.random()) + 1);
          var i = new s.default(t, n);
          return i.initialize(e), i;
        },
        VERSION: "v2.18.1",
        COMMITHASH: "03739e437af3873d0b4b994bf8fd94e78e9d0d68",
      });
  },
  function (e, t, i) {
    "use strict";
    e.exports = i.p + "vumeter-v2.18.1.worklet.min.js";
  },
  function (e, t, i) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : { default: e };
    }

    function n(e, t) {
      for (var i = 0; i < t.length; i++) {
        var r = t[i];
        (r.enumerable = r.enumerable || !1),
          (r.configurable = !0),
          "value" in r && (r.writable = !0),
          Object.defineProperty(e, r.key, r);
      }
    }

    function s(e, t, i) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: i,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = i),
        e
      );
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.default = void 0),
      i(89),
      i(21),
      i(23),
      i(0);
    var a = r(i(160)),
      o = r(i(117)),
      u = r(i(10)),
      c = function (e) {
        var t = u.default.create(e, "ABR controller"),
          i = new a.default(e),
          r = (function () {
            function e(r, n) {
              !(function (e, t) {
                if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function");
              })(this, e),
                s(
                  this,
                  "_watchDog",
                  function () {
                    if (this.abrStrategy.isRunning()) {
                      var e =
                        this.abrStrategy.calculateCurVideoStreamMetric(
                          "latestBufLevel"
                        );
                      e <= this.stepDownBufferLevel &&
                        (t.debug("_watchDog", e),
                        this.abrStrategy.finish(),
                        this._increasePhases());
                    }
                  }.bind(this)
                ),
                s(
                  this,
                  "_evalHandler",
                  function () {
                    if (
                      !this.isSwitchInProgressCallback() &&
                      !this.isSeekInProgressCallback()
                    ) {
                      var e = this.abrStrategy.calculateCurStreamMetric(
                          "latestLowBufferCount"
                        ),
                        i =
                          this.abrStrategy.calculateCurVideoStreamMetric(
                            "latestBufLevel"
                          );
                      if (this.playbackStalled(i, e))
                        t.debug(
                          "evalHandler: playback stalled! Switch to lowest rendition."
                        ),
                          this.abrStrategy.cancel(),
                          this._switchStream(0, o.default.ABRUPT),
                          this._increasePhases(),
                          (this.phaseCount = 0);
                      else {
                        if (
                          (t.debug(
                            "phase "
                              .concat(this.phaseCount, " max ")
                              .concat(this.maxPhases)
                          ),
                          this.phaseCount >= 3)
                        ) {
                          var r =
                              this.abrStrategy.calculateCurStreamMetric(
                                "latestBandwidth"
                              ),
                            n =
                              this.abrStrategy.calculateCurStreamMetric(
                                "latestRate"
                              );
                          if (
                            ((r +=
                              this.abrStrategy.calculateProbeStreamMetric(
                                "latestBandwidth"
                              )),
                            t.debug(
                              "evalHandler: current buffer "
                                .concat(i, ", step down buffer ")
                                .concat(
                                  this.stepDownBufferLevel,
                                  ", current bandwidth "
                                )
                                .concat(r, ", current rate ")
                                .concat(n)
                            ),
                            i < this.stepDownBufferLevel)
                          ) {
                            if ((this.abrStrategy.cancel(), n > r)) {
                              var s = this.abrStrategy.findRelevantStream(r, n);
                              s !== this.curStream.orderedIdx &&
                                (t.debug(
                                  "evalHandler: step down to ".concat(
                                    this.streamsData.ordered[s].rendition + "p"
                                  )
                                ),
                                this._switchStream(s),
                                this._increasePhases(),
                                (this.phaseCount = 0));
                            }
                          } else
                            !this._alreadyTop() &&
                              !this.abrStrategy.isRunning() &&
                              this.phaseCount >= this.maxPhases &&
                              r > 0 &&
                              i > this.safeRunBufferLevel &&
                              0 == e &&
                              (this.abrStrategy.run(), (this.phaseCount = 0));
                        }
                        !this.abrStrategy.isRunning() &&
                          this.phaseCount < this.maxPhases &&
                          this.phaseCount++;
                      }
                    }
                  }.bind(this)
                ),
                s(
                  this,
                  "_trialComplete",
                  function () {
                    if (
                      (t.debug(
                        "trial complete for ".concat(
                          this.curStream ? this.curStream.rendition : "unknown"
                        )
                      ),
                      this.curStream)
                    ) {
                      var e = this.trials[this.curStream.orderedIdx];
                      (e.timer = null), e.required > 1 && e.required--;
                    }
                  }.bind(this)
                ),
                s(
                  this,
                  "_onStrategyResult",
                  function (e) {
                    if (
                      (t.debug(
                        "_onAbrStrategyResult: success "
                          .concat(
                            this.streamsData.ordered[e].rendition + "p",
                            ", idx "
                          )
                          .concat(e, ", current stream ")
                          .concat(this.curStream.rendition + "p", ", idx ")
                          .concat(this.curStream.orderedIdx)
                      ),
                      this.curStream.orderedIdx !== e)
                    )
                      this._switchStream(e);
                    else {
                      for (var i in this.trials) this.trials[i].runs = 0;
                      this._increasePhases();
                    }
                    this.phaseCount = 0;
                  }.bind(this)
                ),
                (this.streamsData = []),
                (this.trials = {}),
                (this.maxPhases = 3),
                (this.trialsActive = !1),
                (this.abrStrategy = i.create(r, n)),
                this._setBufferingTime(n);
            }
            var r, a;
            return (
              (r = e),
              (a = [
                {
                  key: "start",
                  value: function () {
                    (this.streamsData = this.getStreamsCallback()),
                      (this.curStream = this.getCurStreamCallback()),
                      this.streamsData.ordered.length > 1 &&
                        (t.debug("start"),
                        this._initTrials(),
                        (this.phaseCount = 0),
                        (this.trials[this.curStream.orderedIdx].timer =
                          setTimeout(this._trialComplete, 6e4)),
                        this._clearEvalTimer(),
                        this._clearWatchTimer(),
                        this._clearRestartTimer(),
                        (this.evalTimer = setInterval(this._evalHandler, 1e3)),
                        (this.watchTimer = setInterval(this._watchDog, 100)),
                        this.abrStrategy.init(this.streamsData, this.curStream),
                        (this.abrStrategy.callbacks = {
                          onStartProbe: this.probeStartCallback,
                          onCancelProbe: this.probeCancelCallback,
                          onResult: this._onStrategyResult,
                        }));
                  },
                },
                {
                  key: "restart",
                  value: function (e) {
                    if (e) {
                      this._clearEvalTimer(), this._clearWatchTimer();
                      var t = this;
                      this.restartTimer = setTimeout(function () {
                        (t.restartTimer = void 0), t.start();
                      }, 5e3);
                    } else this.start();
                  },
                },
                {
                  key: "playbackStalled",
                  value: function (e, i) {
                    return (
                      i > 0 &&
                        t.debug(
                          "Low buffer count: "
                            .concat(i, ", current buffer level: ")
                            .concat(e)
                        ),
                      i >= 10 || e + 2 <= 0
                    );
                  },
                },
                {
                  key: "scheduleInstantEvaluation",
                  value: function () {
                    this._clearEvalTimer(),
                      this._clearWatchTimer(),
                      this._evalHandler(),
                      (this.evalTimer = setInterval(this._evalHandler, 1e3)),
                      (this.watchTimer = setInterval(this._watchDog, 100));
                  },
                },
                {
                  key: "setBuffering",
                  value: function (e) {
                    this.abrStrategy.setBuffering(e), this._setBufferingTime(e);
                  },
                },
                {
                  key: "_setBufferingTime",
                  value: function (e) {
                    (this.bufferingTime = e),
                      (this.stepDownBufferLevel =
                        this.bufferingTime > 700
                          ? (0.57 * this.bufferingTime) / 1e3
                          : (0.7 * this.bufferingTime) / 1e3),
                      (this.safeRunBufferLevel =
                        this.bufferingTime > 700
                          ? (0.65 * this.bufferingTime) / 1e3
                          : (0.8 * this.bufferingTime) / 1e3);
                  },
                },
                {
                  key: "_increasePhases",
                  value: function () {
                    this.maxPhases < 30 &&
                      (this.maxPhases++,
                      t.debug("Increase maxPhases", this.maxPhases));
                  },
                },
                {
                  key: "_alreadyTop",
                  value: function () {
                    return (
                      this.curStream.orderedIdx ===
                      this.streamsData.ordered.length - 1
                    );
                  },
                },
                {
                  key: "_initTrials",
                  value: function () {
                    var e = !1;
                    if (this.trialsActive)
                      for (
                        var t = 0;
                        t < this.streamsData.ordered.length;
                        t++
                      ) {
                        if (this.trials[t]) {
                          var i = this.trials[t].idx;
                          i === this.streamsData.ordered[t].idx &&
                            this.trials[t].stream ===
                              this.streamsData.streams[i].stream &&
                            (e = !0);
                        }
                        if (!e) break;
                      }
                    if (e) this._resetTrials();
                    else {
                      (this.trials = {}), (this.trialsActive = !0);
                      for (
                        var r = 0;
                        r < this.streamsData.ordered.length;
                        r++
                      ) {
                        var n = this.streamsData.ordered[r].idx;
                        this.trials[r] = {
                          idx: n,
                          stream: this.streamsData.streams[n].stream,
                          runs: 0,
                          required: 1,
                          timer: null,
                        };
                      }
                    }
                  },
                },
                {
                  key: "_switchStream",
                  value: function (e, i) {
                    if (e !== this.curStream.orderedIdx) {
                      var r = e > this.curStream.orderedIdx;
                      if (r) this.trials[e].runs++;
                      else {
                        var n = this.trials[this.curStream.orderedIdx];
                        n.timer &&
                          ((n.required += 2),
                          n.required > 15 && (n.required = 15),
                          this._clearTrialTimer(this.curStream.orderedIdx),
                          t.debug(
                            "Increase trial for "
                              .concat(this.curStream.rendition + "p", ", idx ")
                              .concat(n.idx, " to ")
                              .concat(n.required)
                          ));
                      }
                      (!r || this.trials[e].runs >= this.trials[e].required) &&
                        this.switchStreamCallback(
                          this.streamsData.ordered[e].idx,
                          i
                        );
                    }
                  },
                },
                {
                  key: "stop",
                  value: function (e) {
                    t.debug("stop!"),
                      (this.streamsData = []),
                      (this.curStream = void 0),
                      (this.phaseCount = 0),
                      this._resetTrials(),
                      e && e.hard && (this.trials = {}),
                      this._clearEvalTimer(),
                      this._clearWatchTimer(),
                      this.abrStrategy.clear();
                  },
                },
                {
                  key: "_clearEvalTimer",
                  value: function () {
                    void 0 !== this.evalTimer &&
                      (clearInterval(this.evalTimer),
                      (this.evalTimer = void 0));
                  },
                },
                {
                  key: "_clearWatchTimer",
                  value: function () {
                    void 0 !== this.watchTimer &&
                      (clearInterval(this.watchTimer),
                      (this.watchTimer = void 0));
                  },
                },
                {
                  key: "_clearRestartTimer",
                  value: function () {
                    void 0 !== this.restartTimer &&
                      (clearTimeout(this.restartTimer),
                      (this.restartTimer = void 0));
                  },
                },
                {
                  key: "_resetTrials",
                  value: function () {
                    for (var e in this.trials)
                      (this.trials[e].runs = 0), this._clearTrialTimer(e);
                  },
                },
                {
                  key: "_clearTrialTimer",
                  value: function (e) {
                    null !== this.trials[e].timer &&
                      (clearTimeout(this.trials[e].timer),
                      (this.trials[e].timer = null));
                  },
                },
                {
                  key: "isProbing",
                  value: function (e) {
                    var t = !1,
                      i = this.abrStrategy.getProber();
                    return i && i.id() === e && (t = i.isEnabled()), t;
                  },
                },
                {
                  key: "onProbeInitReceived",
                  value: function () {
                    this.abrStrategy.getProber().receiveInit();
                  },
                },
                {
                  key: "onProbeDataReceived",
                  value: function (e, t, i) {
                    this.abrStrategy.getProber().receiveFrame(e, t, i);
                  },
                },
                {
                  key: "callbacks",
                  set: function (e) {
                    (this.switchStreamCallback = e.switchStream),
                      (this.isSwitchInProgressCallback = e.isInProgress),
                      (this.isSeekInProgressCallback = e.isSeeking),
                      (this.getStreamsCallback = e.getStreams),
                      (this.getCurStreamCallback = e.getCurStream),
                      (this.probeStartCallback = e.probeStream),
                      (this.probeCancelCallback = e.cancelStream);
                  },
                },
              ]) && n(r.prototype, a),
              e
            );
          })();
        return {
          create: function (e, t) {
            return new r(e, t);
          },
        };
      };
    t.default = c;
  },
  function (e, t, i) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : { default: e };
    }

    function n(e, t) {
      for (var i = 0; i < t.length; i++) {
        var r = t[i];
        (r.enumerable = r.enumerable || !1),
          (r.configurable = !0),
          "value" in r && (r.writable = !0),
          Object.defineProperty(e, r.key, r);
      }
    }

    function s(e, t, i) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: i,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = i),
        e
      );
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.default = void 0),
      i(89),
      i(21),
      i(0);
    var a = r(i(169)),
      o = r(i(10)),
      u = 3e3,
      c = function (e) {
        var t = o.default.create(e, "ABR strategy"),
          i = new a.default(e),
          r = (function () {
            function e(i, r) {
              !(function (e, t) {
                if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function");
              })(this, e),
                s(
                  this,
                  "onProbeFinished",
                  function () {
                    this.runsCount++,
                      this.calculateCurStreamMetric("stopCustom");
                    var e = this.calculateCurStreamMetric(
                      "customRangeBandwidth"
                    );
                    t.debug(
                      "onProbeFinished: current stream bandwidth ".concat(e)
                    );
                    var i = this.metricsManager.getMetrics(this.prober.id()),
                      r = Math.max(i.avgBandwidth(), i.latestBandwidth()),
                      n = i.avgRate();
                    (e += r),
                      t.debug(
                        "onProbeFinished prober: bandwidth "
                          .concat(r, ", rate ")
                          .concat(n)
                      );
                    var s = this.prober.period;
                    this.destroyProber(), (this.running = !1);
                    var a =
                        this.calculateCurVideoStreamMetric("latestBufLevel"),
                      o = 1e3 * a >= this.enoughBufferToContinue,
                      c =
                        this.calculateCurStreamMetric("avgRate") /
                        this.curStream.bandwidth;
                    if (
                      (t.debug(
                        "prober enough buffer "
                          .concat(o, ", period ")
                          .concat(s, ", level ")
                          .concat(a)
                      ),
                      o && s >= u)
                    ) {
                      this.curBandwidth = e;
                      for (
                        var l = this.curStreamIdx + 1;
                        l < this.streamsData.ordered.length;
                        l++
                      ) {
                        var h = this.streamsData.ordered[l],
                          f = h.bandwidth * c;
                        if (
                          (t.debug(
                            "expBandwidth "
                              .concat(f, ", curBandwidth ")
                              .concat(this.curBandwidth, ", bwCorrector ")
                              .concat(c),
                            h
                          ),
                          this.curBandwidth < 1.2 * f)
                        )
                          break;
                        this.curStreamIdx++;
                      }
                      this.doRun();
                    } else
                      o
                        ? (e < this.curBandwidth && (e /= c),
                          (this.curBandwidth = Math.max(e, this.curBandwidth)),
                          this.doRun())
                        : this.onResultCallback(this.curStreamIdx);
                  }.bind(this)
                ),
                s(
                  this,
                  "onInitReceived",
                  function () {
                    this.calculateCurStreamMetric("startCustom");
                  }.bind(this)
                ),
                (this.running = !1),
                (this.nextProberId = 0),
                (this.runsCount = 0),
                (this.metricsManager = i),
                this.setBuffering(r);
            }
            var r, a;
            return (
              (r = e),
              (a = [
                {
                  key: "init",
                  value: function (e, t) {
                    (this.streamsData = e), (this.curStream = t);
                  },
                },
                {
                  key: "clear",
                  value: function () {
                    t.debug("clear"),
                      this.cancel(),
                      (this.streamsData = void 0),
                      (this.curStream = void 0);
                  },
                },
                {
                  key: "cancel",
                  value: function () {
                    this.running &&
                      (t.debug("cancel"),
                      (this.running = !1),
                      this.prober.stop()),
                      this.destroyProber();
                  },
                },
                {
                  key: "destroyProber",
                  value: function () {
                    this.prober &&
                      (this.prober.destroy(), (this.prober = void 0));
                  },
                },
                {
                  key: "run",
                  value: function () {
                    (this.curBandwidth =
                      this.calculateCurStreamMetric("avgBandwidth")),
                      (this.curStreamIdx = this.curStream.orderedIdx),
                      (this.runsCount = 0),
                      this.doRun();
                  },
                },
                {
                  key: "finish",
                  value: function () {
                    t.debug("finish current stream ".concat(this.curStreamIdx)),
                      this.cancel(),
                      this.onResultCallback(this.curStreamIdx);
                  },
                },
                {
                  key: "setBuffering",
                  value: function (e) {
                    (this.bufferingTime = e),
                      (this.minBufferingTime = e > 1e3 ? 600 : e / 2),
                      (this.enoughBufferToContinue = e > 1e3 ? 1e3 : 0.8 * e);
                  },
                },
                {
                  key: "doRun",
                  value: function () {
                    var e = this.curStream
                      ? this.curStream.rendition + "p"
                      : "";
                    if (
                      (t.debug(
                        "run: current stream "
                          .concat(e, ", idx ")
                          .concat(this.curStreamIdx, ", bandwdith ")
                          .concat(this.curBandwidth)
                      ),
                      this.curBandwidth > 0)
                    )
                      if (
                        ((this.nextStreamIdx = this.curStreamIdx + 1),
                        this.nextStreamIdx < this.streamsData.ordered.length)
                      ) {
                        var r = this.calculateCurStreamMetric("avgRate");
                        (this.bwCorrector =
                          this.curStream.bandwidth > 0
                            ? r / this.curStream.bandwidth
                            : 1),
                          t.debug(
                            "run: bandwidth "
                              .concat(this.curBandwidth, ", rate ")
                              .concat(r, ", corrector ")
                              .concat(this.bwCorrector)
                          );
                        var n = this.streamsData.ordered[this.nextStreamIdx],
                          s = r + n.bandwidth * this.bwCorrector,
                          a = 0,
                          o =
                            1e3 *
                            this.calculateCurVideoStreamMetric(
                              "latestBufLevel"
                            );
                        this.curBandwidth < s &&
                          ((a =
                            (this.curBandwidth * (o - this.minBufferingTime)) /
                            (s - this.curBandwidth)),
                          (a = Math.floor(a + 0.5)) < 100 && (a = 100)),
                          (0 == a || a > u) && (a = u),
                          0 === this.runsCount && a > 600 && (a = 600);
                        var c = this.streamsData.streams[n.idx];
                        (this.prober = i.create(
                          this.nextProberId++,
                          c.stream,
                          c.stream_info.vtimescale,
                          a,
                          this.metricsManager
                        )),
                          (this.prober.callbacks = {
                            onStartProbe: this.startProbeCallback,
                            onCancelProbe: this.cancelProbeCallback,
                            onInitReceived: this.onInitReceived,
                            onProbeFinished: this.onProbeFinished,
                          }),
                          (this.running = !0),
                          this.prober.start();
                      } else this.onResultCallback(this.curStreamIdx);
                  },
                },
                {
                  key: "calculateCurVideoStreamMetric",
                  value: function (e) {
                    return this.metricsManager
                      .getMetrics(this.curStream.vid)
                      [e]();
                  },
                },
                {
                  key: "calculateCurStreamMetric",
                  value: function (e) {
                    var t = this.metricsManager
                      .getMetrics(this.curStream.vid)
                      [e]();
                    if (
                      ((!(t < 0) && t >= 0) || (t = 0),
                      void 0 !== this.curStream.aid)
                    ) {
                      var i = this.metricsManager
                        .getMetrics(this.curStream.aid)
                        [e]();
                      i > 0 && (t += i);
                    }
                    return t;
                  },
                },
                {
                  key: "calculateProbeStreamMetric",
                  value: function (e) {
                    var t = 0;
                    return (
                      void 0 !== this.prober &&
                        (t = this.metricsManager
                          .getMetrics(this.prober.id())
                          [e]()),
                      t
                    );
                  },
                },
                {
                  key: "findRelevantStream",
                  value: function (e, i) {
                    for (
                      var r = 0,
                        n =
                          this.curStream.bandwidth > 0
                            ? i / this.curStream.bandwidth
                            : 1,
                        s = this.curStream.orderedIdx - 1;
                      s >= 0;
                      s--
                    )
                      if (
                        e >=
                        1.1 * this.streamsData.ordered[s].bandwidth * n
                      ) {
                        r = s;
                        break;
                      }
                    return (
                      t.debug(
                        "findRelevantStream: found index ".concat(
                          this.curStream.orderedIdx
                        )
                      ),
                      r
                    );
                  },
                },
                {
                  key: "getProber",
                  value: function () {
                    return this.prober;
                  },
                },
                {
                  key: "isRunning",
                  value: function () {
                    return this.running;
                  },
                },
                {
                  key: "callbacks",
                  set: function (e) {
                    (this.startProbeCallback = e.onStartProbe),
                      (this.cancelProbeCallback = e.onCancelProbe),
                      (this.onResultCallback = e.onResult);
                  },
                },
              ]) && n(r.prototype, a),
              e
            );
          })();
        return {
          create: function (e, t) {
            return new r(e, t);
          },
        };
      };
    t.default = c;
  },
  function (e, t, i) {
    "use strict";

    function r(e, t) {
      for (var i = 0; i < t.length; i++) {
        var r = t[i];
        (r.enumerable = r.enumerable || !1),
          (r.configurable = !0),
          "value" in r && (r.writable = !0),
          Object.defineProperty(e, r.key, r);
      }
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.default = void 0),
      i(0);
    var n,
      s = (n = i(163)) && n.__esModule ? n : { default: n },
      a =
        "\n@font-face {\n  font-family: 'glyphs';\n  src:url(data:font/opentype;base64,".concat(
          s.default,
          ');\n  font-weight: normal;\n  font-style: normal;\n}\n[class^="sldp-icon-"], [class*=" sldp-icon-"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: \'glyphs\' !important;\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.sldp-icon-enlarge:before {\n  content: "\\e98b";\n}\n.sldp-icon-cog:before {\n  content: "\\e994";\n}\n.sldp-icon-play-o:before {\n  content: "\\ea15";\n}\n.sldp-icon-pause-o:before {\n  content: "\\ea16";\n}\n.sldp-icon-play:before {\n  content: "\\ea1c";\n}\n.sldp-icon-pause:before {\n  content: "\\ea1d";\n}\n.sldp-icon-volume-medium:before {\n  content: "\\ea27";\n}\n.sldp-icon-volume-mute:before {\n  content: "\\ea2a";\n}\n.sldp_player_wrp {\n  background-color: #000;\n  position: relative;\n}\n.sldp_player_wrp_video {\n  display: inline-block;\n}\n.sldp_player_wrp_audio {\n  display: flex;\n  height: 42px;\n}\n.sldp_cbar {\n  display: block;\n  padding: 5px;\n  padding-left: 5px;\n  overflow: hidden;\n  z-index: 10;\n}\n.sldp_cbar_video {\n  position: absolute;\n  bottom: 0px;\n  left: 0;\n  right: 0;\n  transition: opacity 0.5s linear;\n  background-color: rgba(0,0,0,0.7);\n}\n.sldp_cbar_audio {\n  position: relative;\n  margin: auto 6px auto 12px;\n  background-color: rgba(0,0,0,0.4);\n}\n.sldp_mobile_ctrl {\n  position: absolute;\n  transition: opacity 0.5s linear;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  z-index: 5;\n  color: #008ee8;\n}\n.sldp_mobile_ctrl_icon {\n  margin: auto;\n  font-size: 5rem;\n  opacity: 0.7;\n}\n.sldp_message_wrp {\n  height: 100%;\n  color: white;\n  display: flex;\n  z-index: 1;\n}\n.sldp_message_wrp_video {\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  width: 100%;\n}\n.sldp_message_wrp_audio_noctrl {\n  padding-left: 20px;\n}\n.sldp_message {\n  display: inline-block;\n  margin: auto;\n  background: #000;\n  font-family: Helvetica, Arial, sans-serif;\n  line-height: 22px;\n}\n.sldp_message_pad {\n  padding: 12px 20px;\n  align-self: center;\n}\n.ios_button {\n  text-align: center;\n  margin: 10px 0px;\n}\n.sldp_btn {\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  margin-right: 10px;\n  color: #008ee8;\n  font-size: 18px;\n\n  -o-transition:.5s;\n  -ms-transition:.5s;\n  -moz-transition:.5s;\n  -webkit-transition:.5s;\n  transition:.5s;\n}\n.sldp_btn:hover {\n  color: #ff8814;\n}\n.sldp_play_pause_btn {\n  float: left;\n}\n.sldp_expand_btn {\n  float: right;\n  font-size: 16px;\n}\n.sldp_volume_btn {\n  float: left;\n}\n.sldp_config_btn {\n  float: right;\n}\n.sldp_config_btn:hover {\n  transform: rotate(-30deg);\n}\n.sldp_cfg_dialog {\n  width: 100px;\n  background: black;\n  position: absolute;\n  right: 25px;\n  bottom: 30px;\n  padding: 0;\n  margin: 0;\n  font-family: Arial;\n  font-size: 14px;\n  color: white;\n  z-index: 10;\n}\n.sldp_cfg_dialog li {\n  list-style: none;\n  text-align: center;\n  line-height: 24px;\n  cursor: pointer;\n}\n.sldp_cfg_dialog li:hover {\n  background-color: grey;\n}\n.sldp_volume_wrp {\n  overflow: hidden;\n}\n.sldp_volume_desktop {\n  width: 150px;\n}\n.sldp_volume_mobile {\n  width: 20px;\n}\n.sldp_volume_slider_wrp {\n  float: left;\n  height: 20px;\n  cursor: pointer;\n}\n.sldp_volume_slider {\n  border-radius: 1px;\n  background: #008ee8;\n  width: 112px;\n  height: 3px;\n  margin-top: 9px;\n}\n.sldp_volume_thumb {\n  background: #008ee8;\n  width: 12px;\n  height: 12px;\n  border-radius: 6px;\n  position: relative;\n  left: 100px;\n  top: -4px;\n  cursor: pointer;\n}\n.sldp_volume_thumb:hover {\n  background: #ff8814;\n}\n.sldp_indicator {\n  height: 4px;\n  background-color: #008ee8;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n'
        ),
      o = (function () {
        function e() {
          !(function (e, t) {
            if (!(e instanceof t))
              throw new TypeError("Cannot call a class as a function");
          })(this, e),
            document.getElementById("sldp_player_stylesheet") ||
              ((this.style = document.createElement("style")),
              this.style.setAttribute("id", "sldp_player_stylesheet"),
              this.style.styleSheet
                ? (this.style.styleSheet.cssText = a)
                : this.style.appendChild(document.createTextNode(a)),
              document.getElementsByTagName("head")[0].appendChild(this.style));
        }
        var t, i;
        return (
          (t = e),
          (i = [
            {
              key: "destroy",
              value: function () {
                this.style && this.style.parentNode.removeChild(this.style);
              },
            },
          ]) && r(t.prototype, i),
          e
        );
      })();
    t.default = o;
  },
  function (e, t, i) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : { default: e };
    }

    function n(e) {
      "@babel/helpers - typeof";
      return (n =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (e) {
              return typeof e;
            }
          : function (e) {
              return e &&
                "function" == typeof Symbol &&
                e.constructor === Symbol &&
                e !== Symbol.prototype
                ? "symbol"
                : typeof e;
            })(e);
    }
    i(93),
      i(91),
      i(92),
      i(59),
      i(60),
      i(0),
      Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.default = void 0),
      i(14),
      i(29),
      i(16),
      i(53),
      i(30),
      i(31),
      i(32),
      i(33),
      i(35),
      i(34),
      i(36),
      i(37),
      i(38),
      i(39),
      i(40),
      i(41),
      i(42),
      i(44),
      i(43),
      i(45),
      i(46),
      i(47),
      i(48),
      i(49),
      i(50),
      i(51),
      i(52),
      i(90),
      i(21),
      i(86),
      i(151),
      i(68),
      i(219),
      i(111),
      i(112),
      i(221),
      i(23),
      i(88),
      i(114),
      i(70);
    var s = r(i(159)),
      a = r(i(184)),
      o = r(i(166)),
      u = r(i(165)),
      c = r(i(117)),
      l = r(i(170)),
      h = r(i(10)),
      f = r(i(94)),
      d = r(i(173)),
      p = {
        NULL: 0,
        INIT: 1,
        STOP: 2,
        SETUP: 3,
        SYNC: 4,
        PLAY: 5,
        WAIT: 6,
        STALL: 7,
        ERROR: 8,
        RESET: 9,
      },
      v = new Uint8Array([17, 144]),
      m = function (e, t) {
        function i(e, t, i) {}

        function r() {
          var e = "latency_tolerance" in Ce ? Ce.latency_tolerance : 0;
          Me.setLatencyTolerance(e / 1e3, Ce.buffering / 1e3, Ce.zapping);
        }

        function m() {
          ((Re = new l.default(Ce, e)).onPlay = I),
            (Re.onPause = N),
            (Re.onPlayEvent = M),
            (Re.onPauseEvent = j),
            (Re.onVolumeSet = O),
            (Re.onUserAction = F),
            (Re.onQualityChange = W),
            (Re.onResize = D),
            (Re.onEnterPip = U),
            (Re.onLeavePip = V),
            (Re.qualities = []);
        }

        function g() {
          "AudioWorklet" === Ce.vu_meter.api &&
            ((Ce.vu_meter.api = "ScriptProcessor"),
            y(),
            Re.destroy(),
            m(),
            ue(!0));
        }

        function y() {
          Ce.vu_meter &&
            Ce.vu_meter.mode &&
            Ce.vu_meter.type &&
            void 0 !== (Le = new d.default(e).create(Ce.vu_meter)) &&
            (Ce.vu_meter.container && Le.setUI(Ce.vu_meter.container),
            void 0 !== t && Le.setScriptPath(t),
            (Ce.vu_meter.initialized = !0),
            Le.setFatalErrorCallback(g));
        }

        function _() {
          (et = !0),
            be ||
              ((be = Te.create(
                Be,
                Ce.sync_buffer > 0 ? Ce.sync_buffer - 100 : Ce.buffering
              )).callbacks = {
                switchStream: Y,
                isInProgress: Q,
                isSeeking: q,
                getStreams: J,
                getCurStream: G,
                probeStream: X,
                cancelStream: K,
              });
        }

        function b() {
          (Ue = void 0),
            (Ve = void 0),
            (Ne = void 0),
            (He = void 0),
            (je = void 0),
            (ze = void 0);
        }

        function A() {
          Me.callbacks({
            onProgress: ie,
            onSourceOpen: B,
            onCrash: ue,
            onWaitUpdate: ae,
            onPlayStarted: R,
            onPlayFailed: L,
            onLatencyCalc: re,
            onLatencySeek: ne,
            onLowBuffer: se,
          });
        }

        function w() {
          Ie.callbacks = {
            onStatusReceived: le,
            onInitSegmentReceived: me,
            onDataReceived: _e,
            onConnectionClosed: ce,
          };
        }

        function S(e) {
          be && be.stop(e), Ie.close(), w();
          for (var t = 0; t < Ee.length; t++) Ee[t].close();
          (Ee = []), C(), T(), b();
        }

        function k() {
          Re.removePip(function () {
            x(),
              Me.clear(),
              A(),
              Me.init(Re.videoElement),
              Be.setVideoElement(Re.videoElement);
          });
        }

        function T() {
          Ke && (clearTimeout(Ke), (Ke = void 0)), (Je = 0);
        }

        function x(e) {
          Le && Le.stop(e);
        }

        function C() {
          void 0 !== qe && (clearTimeout(qe), (qe = void 0));
        }

        function E() {
          P() && (Pe = p.SETUP);
        }

        function P() {
          var e = !1,
            t = De || Ce.stream_url;
          return (
            t && t.length > 0
              ? i(0, (e = Ie.open(t)).streamURL)
              : ke.error(
                  "_connectCurrentStream attempt to open empty url",
                  De,
                  Ce.stream_url
                ),
            e
          );
        }

        function B() {
          switch ((ke.debug("MSE initialized", Pe), Pe)) {
            case p.STOP:
              (Re.canPlay = !0), (Pe = p.INIT);
              break;
            case p.INIT:
              Ce.stream_url && (Ce.autoplay || Ge)
                ? (E(), (Ge = !1))
                : (Re.canPlay = !0);
              break;
            case p.STALL:
              P(), (Je = 1);
              break;
            case p.ERROR:
              for (var e = !1, t = 0; t < Ee.length; t++)
                Ee[t].isActual() &&
                  (Ee[t].attachToMSE(),
                  Ee[t].recover(),
                  Ee[t].inTransition() && (e = !0));
              Ve && Ve.suspendMuteable(),
                (Pe = e ? p.SYNC : p.PLAY),
                Re.clearVideoElement(),
                Me.startPlayback({ recover: !0 }),
                $();
          }
        }

        function I(e) {
          switch ((i(), Pe)) {
            case p.INIT:
              E();
              break;
            case p.RESET:
              k(), (Pe = p.INIT), (Ge = !0);
              break;
            case p.NULL:
              break;
            default:
              C(),
                T(),
                et && Ue && be.start(),
                Me.handlePlay(e),
                Le && Le.onPlay();
          }
        }

        function M() {
          Me.handlePlayEvent();
        }

        function R() {
          Re && Re.onPlaybackStarted();
        }

        function L() {
          Re && (Re.triggerPause(!0), Re.onPlaybackStarted()),
            (qe = setTimeout(H, 2e3));
        }

        function F() {
          return p.SETUP !== Pe && p.SYNC !== Pe;
        }

        function O(e) {
          i();
        }

        function D() {
          Pe >= p.SYNC && $();
        }

        function U() {
          ke.debug("enter PIP"), Me.handleEnterPip();
        }

        function V() {
          ke.debug("leave PIP"), Me.handleLeavePip();
        }

        function N() {
          p.SYNC < Pe &&
            (T(),
            i(),
            be && be.stop(),
            Me.handlePause(),
            Ce.pause_timeout >= 0 &&
              (qe = setTimeout(H, 1e3 * Ce.pause_timeout)));
        }

        function j() {
          Me.handlePauseEvent();
        }

        function H() {
          z();
        }

        function z() {
          S(), Me.resetPosition(), (Pe = p.RESET);
        }

        function W(e, t) {
          var r = !1;
          if (Q() || Me.isPaused())
            return ke.warn("Quality change is not available at the moment"), r;
          if (p.SYNC < Pe) {
            var n = "Auto" == e;
            if (n || void 0 !== Ye[e]) {
              var s = void 0,
                a = void 0;
              n || (void 0 == t && (t = 0), (a = Ye[e][t]), (s = Oe[a].stream)),
                ke.debug("Switch quality to ", e, s),
                i(),
                n
                  ? ((et = !0), ee(), be.start())
                  : void 0 !== a && ((et = !1), be && be.stop(), Y(a)),
                (r = !0);
            }
          }
          return r;
        }

        function Y(e, t) {
          if (e != Ne) {
            if (Ue && !Me.isPaused() && p.STALL != Pe) {
              var i = Oe[e];
              if (p.WAIT === Pe)
                for (var r = 0; r < Ee.length; r++) Ee[r].activate();
              Ue.inTransition(!0);
              var n = i.stream_info,
                s = {
                  width: n.width,
                  height: n.height,
                  bandwidth: n.bandwidth,
                };
              if (
                (Ue.setTransitionParams({
                  id: Qe,
                  codec: n.vcodec,
                  timescale: n.vtimescale,
                  name: i.stream,
                  streamOptions: s,
                }),
                Ue.isTransitionSupported())
              ) {
                C(),
                  T(),
                  ke.debug(
                    "[Director] Change quality, send Play for " +
                      i.stream +
                      ", sn #" +
                      Qe
                  );
                var a = {
                  stream: i.stream,
                  sn: Qe,
                  type: "video",
                  offset: "0",
                };
                Se > 0 && (a.steady = !0),
                  he([a]),
                  Qe++,
                  (He = e),
                  Ue.startTransition(t),
                  (Pe = p.SYNC);
              } else ke.error("Transition isn't supported to ", i);
            }
          } else ee();
        }

        function Q() {
          return void 0 !== He || void 0 !== ze;
        }

        function q() {
          return Me.isSeeking();
        }

        function G() {
          var e = {};
          if (void 0 !== Ne) {
            e = {
              vid: Ue.id(),
              idx: Ne,
              bandwidth: Oe[Ne].stream_info.bandwidth,
              rendition: Oe[Ne].stream_info.height,
            };
            for (var t = 0, i = 0; i < tt.length; i++)
              if (tt[i].idx == Ne) {
                t = i;
                break;
              }
            (e.orderedIdx = t), void 0 !== je && (e.aid = Ve.id());
          }
          return e;
        }

        function J() {
          return { ordered: tt, streams: Oe };
        }

        function K(e) {
          var t;
          ke.debug("Send cancel ", e.id()),
            (t = [e.id().toString()]),
            Ie.send({ command: "Cancel", streams: t });
        }

        function X(e, t) {
          ke.debug(
            "probe stream " +
              e.streamName() +
              ", sn: " +
              e.id() +
              ", offset: " +
              Ue.sapOffset() +
              ", duration: " +
              t
          ),
            he([
              {
                stream: e.streamName(),
                sn: e.id(),
                type: "video",
                offset: Ue.sapOffset().toString(),
                duration: t,
              },
            ]);
        }

        function Z(e) {
          if (e.isVideo() && void 0 !== He) {
            (Ne = He), (He = void 0);
            var t = ee();
            $(),
              et && be.restart(!0),
              Ve && Ve.suspendMuteable(),
              i(0, t.rendition, t.name),
              Re.refresh();
          } else e.isAudio() && void 0 !== ze && ((je = ze), (ze = void 0));
        }

        function $() {
          Re.adjustHeight();
        }

        function ee() {
          var e = void 0;
          if (void 0 !== Ne && Oe[Ne]) {
            var t = Oe[Ne].stream_info.height + "p";
            Ce.initial_resolution = t;
            var i = Oe[Ne].stream_info.renditionIdx;
            if (((Ce.initial_idx = i), tt.length > 1))
              if (be)
                if (et) {
                  var r = "Auto " + t;
                  (Re.quality_ar[0].name = r),
                    (Re.currentQuality = { name: r });
                } else
                  (Re.quality_ar[0].name = "Auto"),
                    (Re.currentQuality = { name: t, idx: i });
              else Re.currentQuality = { name: t, idx: i };
            e = { name: Oe[Ne].stream, rendition: t };
          }
          return e;
        }

        function te() {
          Ze && (clearTimeout(Ze), (Ze = void 0));
        }

        function ie(e, t) {
          if (p.PLAY == Pe) {
            for (var i = 0; i < Ee.length; i++)
              if (Ee[i].isActual()) {
                var r = Ee[i].bufferStatus(e);
                if (r.low) {
                  te(),
                    (Ze = setTimeout(function () {
                      Me.wait(), (Ze = void 0);
                    }, 1e3 * r.lvl + 50)),
                    Ee[i].buffer(),
                    (Pe = p.WAIT);
                  break;
                }
                te();
              }
            t > 200 && ue(!0);
          }
        }

        function re(e) {
          var t = (Ee.length > 1 ? Ue : Ee[0]).latency(e);
          return t > 0 ? t : 0;
        }

        function ne(e, t) {
          i();
        }

        function se() {
          i();
        }

        function ae(e, t) {
          for (var i = 0; i < Ee.length; i++)
            Ee[i].isActual() && Ee[i].updateBufferedState(e, t);
        }

        function oe() {
          p.ERROR !== Pe && p.INIT !== Pe && ue(!0);
        }

        function ue(e) {
          ke.debug("onSourceBufferCrash"), (Pe = p.ERROR), (Fe = void 0);
          var t = !0;
          if (!e) {
            for (var i = [], r = 0; r < Ee.length; r++)
              if ((i.push(Ee[r].backup()), !Ee[r].isRecoverable())) {
                t = !1;
                break;
              }
            t &&
              i.length > 1 &&
              void 0 !== i[0] &&
              void 0 !== i[1] &&
              Math.abs(i[0] - i[1]) > 100 &&
              (t = !1);
          }
          t && !e ? (C(), T()) : (S(), (Ge = !0), (Pe = p.INIT)), k();
        }

        function ce() {
          switch (
            (ke.debug("onConnectionClosed, state ", Pe),
            i(),
            be && be.stop(),
            Me.isPaused() && z(),
            Pe)
          ) {
            case p.WAIT:
              te(), Me.continue();
            case p.SYNC:
              if (
                ((e = !1),
                p.SYNC === Pe &&
                  Ue &&
                  tt.length > 1 &&
                  Ne >= 0 &&
                  (e = tt[0].idx !== Ne && Ue.isStarving()),
                e)
              )
                return (Xe = !0), void ue(!0);
              !(function () {
                for (var e = 0; e < Ee.length; e++) Ee[e].flush();
              })();
            case p.PLAY:
              Me.isCurrentBrowser("Firefox")
                ? (S({ hard: !0 }), k())
                : (P(), (Je = 1)),
                (Pe = p.STALL);
              break;
            case p.STALL:
              Je >= Ce.reconnects || 0 == Je
                ? (z(), i(), Re.showNotPlaying())
                : void 0 == Ke &&
                  (Ke = setTimeout(
                    function () {
                      ke.debug("do reconnect"), Je++, (Ke = void 0), P();
                    },
                    Je < 5 ? 1e3 : 5e3
                  ));
              break;
            case p.RESET:
            case p.STOP:
              break;
            case p.SETUP:
              i(), Re.showNotPlaying();
            default:
              Pe = p.INIT;
          }
          var e;
        }

        function le(e, t, r) {
          ke.debug("onStatusReceived state=".concat(Pe), t, r),
            (Oe = e),
            (We = {}),
            (Ye = {}),
            (tt = []),
            be && be.stop();
          var n = 0,
            s = !!Ce.audio_only,
            a = !!Ce.video_only,
            o = [],
            u = void 0,
            c = [];
          for (n = 0; n < Oe.length; n++) {
            We[Oe[n].stream] = n;
            var l = Oe[n].stream_info;
            l.vtimescale && (l.vtimescale = parseInt(l.vtimescale)),
              l.atimescale && (l.atimescale = parseInt(l.atimescale));
            var h = {
              name: Oe[n].stream,
              bandwidth: l.bandwidth ? l.bandwidth : 0,
            };
            if (l.resolution && l.vcodec) {
              var f = l.resolution.split("x");
              if (
                ((l.width = parseInt(f[0])),
                (l.height = parseInt(f[1])),
                (h.width = l.width),
                (h.height = l.height),
                (h.vcodec = l.vcodec),
                Me.isCodecSupported("video", l.vcodec))
              ) {
                h.video = "supported";
                var d = f[1] + "p";
                Ye[d] || (Ye[d] = []),
                  Ye[d].push(n),
                  (l.renditionIdx = Ye[d].length - 1),
                  d != Ce.initial_resolution ||
                    (void 0 != Ce.initial_idx &&
                      Ce.initial_idx != l.renditionIdx) ||
                    (u = n),
                  (l.bwStr = l.bandwidth),
                  l.bandwidth && (l.bandwidth = parseInt(l.bandwidth) / 1024);
                var v = 0;
                for (v = 0; v < tt.length; v++) {
                  var m = Oe[tt[v].idx].stream_info;
                  if (
                    m.height > f[1] ||
                    (m.height == f[1] && m.bandwidth > l.bandwidth)
                  )
                    break;
                }
                o.splice(v, 0, { name: d, idx: l.renditionIdx }),
                  tt.splice(v, 0, {
                    idx: n,
                    bandwidth: l.bandwidth,
                    rendition: f[1],
                  });
              } else h.video = "not supported";
            }
            l.acodec &&
              ((h.acodec = l.acodec),
              (h.audio = Me.isCodecSupported("audio", l.acodec)
                ? "supported"
                : "not supported")),
              c.push(h);
          }
          if (
            (be && o.length > 1 && o.splice(0, 0, { name: "Auto" }),
            ke.debug("Player renditions:", o),
            ke.debug("Ordered streams:", tt),
            (Re.qualities = o),
            p.STALL == Pe && Me.resetPosition(),
            Xe)
          )
            tt.length > 0 && ((u = tt[0].idx), (Xe = !1));
          else
            for (n = 0; n < Ee.length; n++) {
              var g = void 0;
              (g = Ee[n].inTransition()
                ? We[Ee[n].getTransitionStreamName()]
                : We[Ee[n].getStreamName()]),
                Ee[n].isVideo()
                  ? ((Ne = g),
                    (He = void 0),
                    void 0 !== g && Oe[g].stream_info.vcodec
                      ? (p.STALL == Pe && Ee[n].reset(), (s = !0))
                      : Oe.length > 0 && Ee[n].inTransition(!0))
                  : Ee[n].isAudio()
                  ? ((je = g),
                    (ze = void 0),
                    void 0 !== g && Oe[g].stream_info.acodec
                      ? (p.STALL == Pe && Ee[n].reset(), (a = !0))
                      : Oe.length > 0 && Ee[n].inTransition(!0))
                  : ke.error("Got track of type other than video or audio!");
            }
          if (
            (void 0 !== u && (s || (s = pe(Oe[u], u)), a || (a = ve(Oe[u], u))),
            !s)
          )
            for (n = 0; n < Oe.length && !(s = pe(Oe[n], n)); n++);
          if (!a) for (n = 0; n < Oe.length && !(a = ve(Oe[n], n)); n++);
          for (n = 0; n < Ee.length; n++)
            if (Ee[n].inTransition() && !Ee[n].isTransitionSupported())
              return (
                ke.debug(
                  "onStatusReceived: Media source already contains given source buffer, it can not be filled, reload player..."
                ),
                void ue(!0)
              );
          Me.listBuffers();
          var y = [],
            _ = !1,
            b = "offset" in Ce ? Ce.offset.toString() : "0";
          for (n = 0; n < Ee.length; n++) {
            var A = { type: Ee[n].type(), offset: b };
            Ce.sync_buffer > 0 &&
              (r && t
                ? (A.steady = !0)
                : _ ||
                  ((_ = !0),
                  ke.error(
                    'Playback synchronization is set up but target Nimble Streamer doesn\'t have "sldp_add_steady_timestamps" config parameter set up. Add sldp_add_steady_timestamps = true to /etc/nimble/nimble.conf file and restart Nimble Streamer.'
                  ))),
              Ee[n].inTransition()
                ? ((A.stream = Ee[n].getTransitionStreamName()),
                  (A.sn = Ee[n].transitionStreamId()))
                : Ee[n].isOpen() &&
                  ((A.stream = Ee[n].getStreamName()), (A.sn = Ee[n].id())),
              y.push(A);
          }
          if ((ee(), i(), (s && !Ce.audio_only) || (a && !Ce.video_only))) {
            if (y.length > 0) {
              (Fe = void 0),
                a || Re.setMuted(),
                Ce.sync_buffer > 0 && r && t
                  ? (new Date(Math.round(parseInt(r) / 1e3)),
                    (we = performance.now()),
                    new Date(),
                    performance.timing.navigationStart,
                    performance.now(),
                    (Se = parseInt(t)),
                    Ie.acceptSteadyTimestamps(!0))
                  : ((we = Se = void 0),
                    Me.setSyncParams(void 0, void 0),
                    Ie.acceptSteadyTimestamps(!1)),
                ($e = 0),
                he(y),
                (Pe = p.SYNC),
                ke.debug("[Director] Request streams:");
              for (var w = 0; w < y.length; w++) {
                var k =
                  "Stream #" +
                  w +
                  ": " +
                  y[w].stream +
                  ", sn: " +
                  y[w].sn +
                  ", offset: " +
                  y[w].offset;
                y[w].steady && (k += ", steady: true"), ke.debug(k);
              }
            }
          } else S({ hard: !0 }), x();
        }

        function he(e) {
          Ie.send({ command: "Play", streams: e });
        }

        function fe(e) {
          for (var t = void 0, i = 0; i < Ee.length; i++)
            if (e == Ee[i].id()) {
              t = Ee[i];
              break;
            }
          return t;
        }

        function de(e) {
          for (var t = void 0, i = 0; i < Ee.length; i++)
            if (Ee[i].inTransition() && e == Ee[i].transitionStreamId()) {
              t = Ee[i];
              break;
            }
          return t;
        }

        function pe(e, t) {
          var i = !1,
            r = e.stream,
            n = e.stream_info;
          if (n.vcodec && n.width && n.height) {
            var s = {
              width: n.width,
              height: n.height,
              bandwidth: n.bandwidth,
              buffering: Ce.buffering,
            };
            "key_frame_alignment" in Ce &&
              (s.sapAlignment = Ce.key_frame_alignment),
              Ue
                ? Ue.inTransition() &&
                  (Ue.setTransitionParams({
                    id: Qe,
                    codec: n.vcodec,
                    timescale: n.vtimescale,
                    name: r,
                    streamOptions: s,
                  }),
                  Ue.isTransitionSupported() &&
                    (Qe++,
                    (He = t),
                    (Ne = void 0),
                    Ue.startTransition(),
                    (i = !0)))
                : Me.isCodecSupported("video", n.vcodec)
                ? ((Ue = xe.create(
                    Qe,
                    "video",
                    n.vcodec,
                    n.vtimescale,
                    "video_stream_id",
                    r,
                    s,
                    Me,
                    Be
                  )).attachToMSE(),
                  Ee.push(Ue),
                  Qe++,
                  (Ne = t),
                  (He = void 0),
                  (i = !0))
                : ke.error("Video codec is not supported: ", n.vcodec);
          } else {
            var a = n.vcodec ? "resolution" : "video codec";
            ke.warn("Error: no valid " + a + " specified");
          }
          return i;
        }

        function ve(e, t) {
          var i = !1,
            r = e.stream,
            n = e.stream_info;
          if (n.acodec) {
            var s = { buffering: Ce.buffering };
            Ve
              ? Ve.inTransition() &&
                (Ve.setTransitionParams({
                  id: Qe,
                  codec: n.acodec,
                  timescale: n.atimescale,
                  name: r,
                  streamOptions: s,
                }),
                Ve.isTransitionSupported() &&
                  (Qe++,
                  (ze = t),
                  (je = void 0),
                  Ve.startTransition(),
                  (i = !0)))
              : Me.isCodecSupported("audio", n.acodec)
              ? ((Ve = xe.create(
                  Qe,
                  "audio",
                  n.acodec,
                  n.atimescale,
                  "audio_stream_id",
                  r,
                  s,
                  Me,
                  Be
                )).attachToMSE(),
                Ee.push(Ve),
                Qe++,
                (je = t),
                (ze = void 0),
                (i = !0))
              : ke.error("Audio codec is not supported: ", n.acodec);
          }
          return i;
        }

        function me(e, t) {
          if ((ke.debug("onInitSegmentReceived", e, Pe), p.SYNC == Pe)) {
            var i = fe(e);
            i && i.isActual()
              ? i.isInited()
                ? i.isInitSegmentNew(t) &&
                  (i.processInitSegment(t), i.setBufferDelay())
                : (i.initPresentation(t),
                  i.onBaseDecodeTimeReady(ge),
                  i.onSourceReady(ye))
              : (i = de(e)) &&
                i.isActual() &&
                (i.isTransitionInited()
                  ? i.isTransitionInitNew(t) &&
                    i.processTransitionInitSegment(t)
                  : (i.initTransition(t),
                    i.onCancelStream(K),
                    i.onTransitionCompleted(Z)));
          } else if (be && be.isProbing(e)) be.onProbeInitReceived();
          else if (p.PLAY == Pe || p.WAIT == Pe || p.ERROR == Pe) {
            var r = fe(e);
            r &&
              r.isActual() &&
              (p.ERROR == Pe
                ? r.populateInitDataBuffer(t)
                : r.isInitSegmentNew(t) &&
                  (r.processInitSegment(t), r.setBufferDelay()));
          }
        }

        function ge(e, t) {
          (!Fe || t > Fe) && (Fe = t);
          var i = !0;
          if (p.ERROR != Pe)
            for (var r = 0; r < Ee.length; r++)
              if (Ee[r].isOpen() || Ee[r].inTransition()) {
                i = !1;
                break;
              }
          if (i)
            for (var n = 0; n < Ee.length; n++)
              (Ee[n].isBuffering() || Ee[n].isBackingUp()) &&
                Ee[n].setBaseDecodeTime(Fe);
        }

        function ye() {
          for (var e = !0, t = 0; t < Ee.length; t++)
            if (Ee[t].isBuffering() || Ee[t].inTransition()) {
              e = !1;
              break;
            }
          e &&
            (p.SYNC == Pe
              ? ((Pe = p.PLAY),
                Re.clearVideoElement(),
                Me.startPlayback(),
                $(),
                et && Ue && be.start())
              : p.WAIT == Pe
              ? ((Pe = p.PLAY), te(), Me.continue())
              : Ae &&
                (be.start(),
                be.setBuffering(Ce.buffering),
                (Ae = !1),
                (et = !0)),
            (function () {
              if (Le) {
                var e = Ve ? Ve.getAudioInfo() : void 0;
                Le.start(Re.videoElement, e), Re.setVUMeterHandler(Le);
              }
            })());
        }

        function _e(e, t, i, r, n, s) {
          if (p.SYNC == Pe || p.PLAY == Pe || p.WAIT == Pe) {
            var a = fe(e);
            if (a && a.isActual()) {
              Se &&
                0 == $e &&
                t &&
                (void 0 === Ue || a.isVideo()) &&
                (($e = (s - Se) / 1e3 - ((r + n) / a.timescale()) * 1e3),
                Me.setSyncParams($e + we, Ce.sync_buffer));
              var o = a.processFrame(t, i, r, n);
              if (o.done) {
                if (Ce.muteable && a.isVideo() && Ve && Ve.isMuteable()) {
                  var u = Be.getMetrics(Ve.id());
                  u &&
                    !u.hasLatest500msecBytesArrived() &&
                    (Ve.isInited() ||
                      (ke.debug(
                        "Audio is muted on start, push synthetic init segment"
                      ),
                      Ve.initPresentation(v, !0),
                      Ve.onBaseDecodeTimeReady(ge),
                      Ve.onSourceReady(ye)),
                    Ve.processMute(r, a));
                }
              } else o.errors >= 10 && oe();
            } else
              be && be.isProbing(e)
                ? be.onProbeDataReceived(t, i.byteLength, r)
                : (a = de(e)) &&
                  a.isActual() &&
                  (a.processTransitionFrame(t, i, r, n).done || oe());
          } else if (p.ERROR == Pe) {
            var c = fe(e);
            c && c.populateStartupBuffer(t, i, r, n);
          }
        }
        var be,
          Ae,
          we,
          Se,
          ke = h.default.create(e, "Director"),
          Te = new s.default(e),
          xe = new c.default(e),
          Ce = void 0,
          Ee = [],
          Pe = p.NULL,
          Be = new u.default(e).create(),
          Ie = new a.default(e).create(Be),
          Me = new o.default(e).create(),
          Re = void 0,
          Le = void 0,
          Fe = void 0,
          Oe = [],
          De = void 0,
          Ue = void 0,
          Ve = void 0,
          Ne = void 0,
          je = void 0,
          He = void 0,
          ze = void 0,
          We = {},
          Ye = {},
          Qe = 0,
          qe = void 0,
          Ge = !1,
          Je = 0,
          Ke = void 0,
          Xe = !1,
          Ze = void 0,
          $e = 0,
          et = !1,
          tt = [];
        (this.initialize = function (t) {
          if (
            ((function (t) {
              var i,
                r = "error",
                n = !1;
              t &&
                (void 0 !== t.log_level && (r = t.log_level),
                void 0 !== t.log_div && (n = t.log_div),
                void 0 !== t.inform_ids && (i = t.inform_ids)),
                h.default.setLevel(r),
                h.default.setDiv(e, n),
                f.default.init(e, i),
                ke.debug("SLDP Player v2.18.1");
            })(t),
            (function (e) {
              var t = {
                autoplay: !0,
                controls: !0,
                buffering: 1e3,
                reconnects: 10,
                adaptive_bitrate: !0,
                muteable: !1,
                fullscreen: !1,
                muted: !1,
                ios_failback_scheme: "sldp",
                ios_failback_secure_scheme: "sldps",
                ios_failback_app_url:
                  "https://itunes.apple.com/us/app/sldp-player/id1238237026",
              };
              if (
                (ke.debug("Parameters: ", JSON.stringify(e)),
                void 0 !== (Ce = Object.assign({}, t, e)).width)
              )
                if ("parent" == Ce.width) Ce.width = "100%";
                else {
                  var i = parseInt(Ce.width);
                  isNaN(i) || (Ce.width = i);
                }
              if (void 0 !== Ce.height)
                if ("parent" == Ce.height) Ce.height = "100%";
                else {
                  var r = parseInt(Ce.height);
                  isNaN(r) || (Ce.height = r);
                }
              (Ce.mobile = Me.isMobile()),
                void 0 !== Ce.pause_timeout &&
                  ((Ce.pause_timeout = parseInt(Ce.pause_timeout)),
                  isNaN(Ce.pause_timeout) && (Ce.pause_timeout = void 0)),
                Ce.latency_tolerance > 0 &&
                  Ce.latency_tolerance <= Ce.buffering &&
                  (Ce.latency_tolerance = Ce.buffering + 100),
                "seek" === Ce.latency_adjust_method
                  ? (Ce.zapping = !1)
                  : ("fast-forward" === Ce.latency_adjust_method ||
                      Me.isCurrentBrowser("Safari")) &&
                    (Ce.zapping = !0),
                void 0 !== Ce.sync_buffer &&
                  ((Ce.sync_buffer = parseInt(Ce.sync_buffer)),
                  isNaN(Ce.sync_buffer)
                    ? (Ce.sync_buffer = null)
                    : (Ce.sync_buffer < 500 && (Ce.sync_buffer = 500),
                      Ce.latency_tolerance &&
                        (ke.warn(
                          'Playback synchronization is set up. "latency_tolerance" parameter doesn\'t take any effect and is omitted.'
                        ),
                        (Ce.latency_tolerance = 0)),
                      Ce.offset &&
                        ke.warn(
                          'Playback synchronization is set up. "offset" parameter doesn\'t have any effect and is omitted.'
                        ),
                      (Ce.buffering = Ce.sync_buffer - 50),
                      (Ce.offset = Ce.sync_buffer + 3e3))),
                "object" === n(Ce.vu_meter) &&
                  null !== Ce.vu_meter &&
                  ((Ce.vu_meter.db_range = parseInt(Ce.vu_meter.db_range)),
                  isNaN(Ce.vu_meter.db_range) &&
                    (Ce.vu_meter.db_range = void 0),
                  (Ce.vu_meter.rate = parseFloat(Ce.vu_meter.rate)),
                  isNaN(Ce.vu_meter.rate)
                    ? (Ce.vu_meter.rate = void 0)
                    : Ce.vu_meter.rate < 0.001 && (Ce.vu_meter.rate = 0.001),
                  void 0 === Ce.vu_meter.mode &&
                    void 0 !== Ce.vu_meter.container &&
                    (Ce.vu_meter.mode = "peak"),
                  void 0 !== Ce.vu_meter.mode &&
                    void 0 === Ce.vu_meter.container &&
                    ((Ce.vu_meter.mode = void 0),
                    ke.warn(
                      "VU meter container is not specified, VU meter can't be created"
                    )),
                  void 0 === Ce.vu_meter.type && (Ce.vu_meter.type = "output"),
                  "input" !== Ce.vu_meter.type &&
                    "output" !== Ce.vu_meter.type &&
                    (ke.warn(
                      'VU meter type "' +
                        Ce.vu_meter.type +
                        "\" is not recognized, VU meter can't be created"
                    ),
                    (Ce.vu_meter.type = void 0)),
                  void 0 === Ce.vu_meter.api &&
                    (Ce.vu_meter.api = "ScriptProcessor"));
            })(t),
            y(),
            m(),
            !Me.isMediaSourceSupported())
          )
            return (
              ke.error("MediaSource is not supported"),
              i(),
              void Re.showNotSupported(Me.isIOS())
            );
          (Pe = p.INIT),
            Ce.adaptive_bitrate && _(),
            A(),
            w(),
            r(),
            Me.init(Re.videoElement),
            Be.setVideoElement(Re.videoElement);
        }),
          (this.tgAudio = function () {
            Ie.stop_audio = !Ie.stop_audio;
          }),
          (this.destroy = function (e) {
            !(function (e) {
              be && be.stop({ hard: !0 }),
                Ie.close(),
                Re &&
                  Re.removePip(function () {
                    x(!0), Re.destroy(), (Re = void 0), Me.clear(), e && e();
                  }),
                C(),
                T();
              for (var t = 0; t < Ee.length; t++) Ee[t].close();
              (Ee = []), b(), (Ce = void 0);
            })(e);
          }),
          (this.refreshVUMeterUI = function () {
            Le && Le.refreshUI(Ve ? Ve.getAudioInfo() : void 0);
          });
      };
    t.default = m;
  },
  function (e, t, i) {
    "use strict";
    i(0),
      Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.default = void 0),
      (t.default =
        "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");
  },
  function (e, t, i) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : { default: e };
    }

    function n(e, t) {
      for (var i = 0; i < t.length; i++) {
        var r = t[i];
        (r.enumerable = r.enumerable || !1),
          (r.configurable = !0),
          "value" in r && (r.writable = !0),
          Object.defineProperty(e, r.key, r);
      }
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.default = void 0),
      i(89),
      i(23),
      i(0);
    var s = r(i(116)),
      a = r(i(10)),
      o = 6,
      u = function (e) {
        var t = a.default.create(e, "Metrics"),
          i = new s.default(e),
          r = (function () {
            function e(t, r, n) {
              var s, a, u;
              !(function (e, t) {
                if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function");
              })(this, e),
                (s = this),
                (a = "_interval500msecHandler"),
                (u = function () {
                  if (this.isStarted()) {
                    this.timerCounter++;
                    var e = performance.now();
                    this._updateRate500msec(e),
                      2 === this.timerCounter &&
                        (this._updateBwRate1sec(e),
                        this.lb1sec.push(this.lowBuf1sec),
                        (this.lowBuf1sec = 0),
                        (this.timerCounter = 0));
                  }
                }.bind(this)),
                a in s
                  ? Object.defineProperty(s, a, {
                      value: u,
                      enumerable: !0,
                      configurable: !0,
                      writable: !0,
                    })
                  : (s[a] = u),
                (this.id = t),
                (this.type = r),
                (this.timescale = n),
                (this.pickCustom = !1),
                (this.bytesCustom = 0),
                (this.framesCount = 0),
                (this.bytesTotal = 0),
                (this.bytes1sec = 0),
                (this.lastBytes = 0),
                (this.bytes500msec = 0),
                (this.rate500msec = 0),
                (this.lowBufTotal = 0),
                (this.lowBuf1sec = 0),
                (this.bufferLevel = 0),
                (this.bufferEnd = 0),
                (this.bw1sec = i.create(o)),
                (this.rate1sec = i.create(o)),
                (this.lb1sec = i.create(o)),
                (this.timerCounter = 0),
                (this.rateAdditive = 0);
            }
            var r, s;
            return (
              (r = e),
              (s = [
                {
                  key: "clearCounters",
                  value: function () {
                    (this.bytesCustom = 0),
                      (this.customStart = void 0),
                      (this.customEnd = void 0),
                      (this.rateCustomTs1 = void 0),
                      (this.rateCustomTs2 = void 0),
                      (this.stopTime = void 0),
                      (this.bwTime1 = void 0),
                      (this.bwTime2 = void 0),
                      (this.effBwTime1 = void 0),
                      (this.lastRepTime = void 0),
                      (this.latencySubt = void 0),
                      (this.framesCount = 0),
                      (this.bytesTotal = 0),
                      (this.bytes1sec = 0),
                      (this.lastBytes = 0),
                      (this.bytes500msec = 0),
                      (this.rate500msec = 0),
                      (this.rate500msecTs1 = void 0),
                      (this.rate500msecTs2 = void 0),
                      (this.rate1secTs1 = void 0),
                      (this.rate1secTs2 = void 0),
                      (this.rateTotalTs1 = void 0),
                      (this.rateTotalTs2 = void 0),
                      (this.lowBufTotal = 0),
                      (this.lowBuf1sec = 0),
                      (this.bufferLevel = 0),
                      (this.bufferEnd = 0),
                      (this.timerCounter = 0),
                      (this.rateAdditive = 0);
                  },
                },
                {
                  key: "destroy",
                  value: function () {
                    this._clear500msecInterval(),
                      (this.videoElement = void 0),
                      this.bw1sec.clear(),
                      this.rate1sec.clear(),
                      this.lb1sec.clear();
                  },
                },
                {
                  key: "stop",
                  value: function () {
                    (this.enabled = !1),
                      (this.stopTime = this.lastRepTime),
                      this._clear500msecInterval();
                  },
                },
                {
                  key: "start",
                  value: function () {
                    this.enabled ||
                      ((this.enabled = !0),
                      this.clearCounters(),
                      (this.startTime = void 0),
                      (this.interval500msec = setInterval(
                        this._interval500msecHandler,
                        500
                      )));
                  },
                },
                {
                  key: "isStarted",
                  value: function () {
                    return this.enabled;
                  },
                },
                {
                  key: "isReady",
                  value: function () {
                    return void 0 === this.enabled;
                  },
                },
                {
                  key: "startCustom",
                  value: function () {
                    this.pickCustom ||
                      ((this.pickCustom = !0),
                      (this.customStart = void 0),
                      (this.customStop = void 0),
                      (this.bytesCustom = 0),
                      (this.rateCustomTs1 = void 0),
                      (this.rateCustomTs2 = void 0));
                  },
                },
                {
                  key: "stopCustom",
                  value: function () {
                    this.pickCustom &&
                      ((this.pickCustom = !1),
                      (this.customStop = this.lastRepTime));
                  },
                },
                {
                  key: "customRangeBandwidth",
                  value: function () {
                    var e = 0;
                    if (this.customStart) {
                      this.customStart === this.customStop &&
                        (this.customStop = performance.now());
                      var t = this.customStop - this.customStart;
                      t > 0 && (e = (1e3 * this.bytesCustom) / (128 * t));
                    }
                    return e;
                  },
                },
                {
                  key: "customRangeRate",
                  value: function () {
                    var e = 0,
                      t =
                        this.rateCustomTs2 -
                        this.rateCustomTs1 +
                        this.rateAdditive;
                    return (
                      t > 0 &&
                        (e = (this.timescale * this.bytesCustom) / (128 * t)),
                      e
                    );
                  },
                },
                {
                  key: "reportBandwidth",
                  value: function (e, t) {
                    if (this.isStarted()) {
                      var i = performance.now();
                      if (void 0 !== t) {
                        var r = i / 1e3 - t / this.timescale;
                        (void 0 == this.latencySubt || r < this.latencySubt) &&
                          (this.latencySubt = r),
                          this.framesCount++,
                          void 0 === this.rate500msecTs1 &&
                            (this.rate500msecTs1 = t),
                          (this.rate500msecTs2 = t),
                          void 0 === this.rate1secTs1 && (this.rate1secTs1 = t),
                          (this.rate1secTs2 = t),
                          void 0 === this.rateTotalTs1 &&
                            (this.rateTotalTs1 = t),
                          (this.rateTotalTs2 = t),
                          void 0 === this.startTime && (this.startTime = i),
                          void 0 === this.bwTime1 &&
                            ((this.bwTime1 = i), (this.effBwTime1 = i)),
                          (this.bwTime2 = i);
                      }
                      (this.lastRepTime = i),
                        (this.lastBytes = e),
                        (this.bytes500msec += e),
                        (this.bytes1sec += e),
                        (this.bytesTotal += e),
                        this.pickCustom &&
                          (void 0 === this.customStart &&
                            (this.customStart = i),
                          (this.bytesCustom += e),
                          void 0 !== t &&
                            (void 0 === this.rateCustomTs1 &&
                              (this.rateCustomTs1 = t),
                            (this.rateCustomTs2 = t)));
                    }
                  },
                },
                {
                  key: "reportLowBuffer",
                  value: function () {
                    this.isStarted() && (this.lowBufTotal++, this.lowBuf1sec++);
                  },
                },
                {
                  key: "reportBufLevel",
                  value: function (e, t) {
                    this.isStarted() &&
                      ((this.bufferLevel = e), (this.bufferEnd = t));
                  },
                },
                {
                  key: "setRateAdditive",
                  value: function (e) {
                    this.rateAdditive = e;
                  },
                },
                {
                  key: "setVideoElement",
                  value: function (e) {
                    this.videoElement = e;
                  },
                },
                {
                  key: "avgBandwidth",
                  value: function (e) {
                    var t,
                      i = 0;
                    e
                      ? (t = performance.now())
                      : (t =
                          void 0 !== this.stopTime
                            ? this.stopTime
                            : this.lastRepTime) === this.startTime &&
                        (t = performance.now());
                    var r = t - this.startTime;
                    return (
                      r > 0 && (i = (1e3 * this.bytesTotal) / (128 * r)), i
                    );
                  },
                },
                {
                  key: "avgRate",
                  value: function () {
                    var e = 0,
                      t =
                        this.rateTotalTs2 -
                        this.rateTotalTs1 +
                        this.rateAdditive;
                    return (
                      t > 0 &&
                        (e = (this.timescale * this.bytesTotal) / (128 * t)),
                      e
                    );
                  },
                },
                {
                  key: "curRate1sec",
                  value: function () {
                    var e = 0,
                      t =
                        this.rate1secTs2 - this.rate1secTs1 + this.rateAdditive;
                    return (
                      t > 0 &&
                        (e = (this.timescale * this.bytes1sec) / (128 * t)),
                      e
                    );
                  },
                },
                {
                  key: "curRate500msec",
                  value: function () {
                    var e = 0,
                      t =
                        this.rate500msecTs2 -
                        this.rate500msecTs1 +
                        this.rateAdditive;
                    return (
                      t > 0 &&
                        (e = (this.timescale * this.bytes500msec) / (128 * t)),
                      e
                    );
                  },
                },
                {
                  key: "curBw1sec",
                  value: function () {
                    var e = 0;
                    if (this.bwTime1) {
                      var t =
                        void 0 !== this.stopTime ? this.stopTime : this.bwTime2;
                      t === this.bwTime1 && (t = performance.now());
                      var i = t - this.effBwTime1;
                      i > 0 && (e = (1e3 * this.bytes1sec) / (128 * i));
                    }
                    return e;
                  },
                },
                {
                  key: "latestBandwidth",
                  value: function () {
                    var e = this.curBw1sec();
                    if (this.bw1sec.length() > 0) {
                      var t = this.bw1sec.get(-1);
                      e = 0 === e ? t : (e + t) / 2;
                    }
                    return e;
                  },
                },
                {
                  key: "latestRate",
                  value: function () {
                    var e = this.curRate1sec();
                    if (this.rate1sec.length() > 0) {
                      var t = this.rate1sec.get(-1);
                      e = 0 == e ? t : (e + t) / 2;
                    }
                    return e;
                  },
                },
                {
                  key: "hasLatest500msecBytesArrived",
                  value: function () {
                    return this.bytes500msec > 0 || this.rate500msec > 0;
                  },
                },
                {
                  key: "latestLowBufferCount",
                  value: function () {
                    for (var e = this.lowBuf1sec, t = 0; t < 2; t++)
                      this.lb1sec.length() > t &&
                        (e += this.lb1sec.get(-1 * (t + 1)));
                    return e;
                  },
                },
                {
                  key: "latestBufLevel",
                  value: function () {
                    if (this.videoElement) {
                      var e = this.bufferEnd - this.videoElement.currentTime;
                      return e < 0 && (e = 0), e;
                    }
                    return (
                      t.error("latestBufLevel video element is not set!!!"),
                      this.bufferLevel || 0
                    );
                  },
                },
                {
                  key: "_updateRate500msec",
                  value: function (e) {
                    (this.rate500msec = this.curRate500msec()),
                      void 0 !== this.bwTime2 && e - this.bwTime2 <= 500
                        ? ((this.rate500msecTs1 = this.rate500msecTs2),
                          (this.bytes500msec = this.lastBytes))
                        : ((this.rate500msecTs1 = void 0),
                          (this.bytes500msec = 0)),
                      (this.rate500msecTs2 = this.rate500msecTs1);
                  },
                },
                {
                  key: "_updateBwRate1sec",
                  value: function (e) {
                    var t = this.curBw1sec();
                    this.bw1sec.push(t),
                      this.rate1sec.push(this.curRate1sec()),
                      void 0 !== this.bwTime2 && e - this.bwTime2 <= 1e3
                        ? ((this.rate1secTs1 = this.rate1secTs2),
                          (this.bwTime1 = this.bwTime2),
                          (this.effBwTime1 =
                            this.bwTime2 - (7.8125 * this.lastBytes) / t),
                          (this.bytes1sec = this.lastBytes))
                        : ((this.rate1secTs1 = void 0),
                          (this.bwTime1 = void 0),
                          (this.effBwTime1 = void 0),
                          (this.bytes1sec = 0)),
                      (this.rate1secTs2 = this.rate1secTs1),
                      (this.bwTime2 = this.bwTime1);
                  },
                },
                {
                  key: "_clear500msecInterval",
                  value: function () {
                    this.interval500msec &&
                      (clearInterval(this.interval500msec),
                      (this.interval500msec = void 0)),
                      (this.timerCounter = 0);
                  },
                },
              ]) && n(r.prototype, s),
              e
            );
          })();
        return {
          create: function (e, t, i) {
            return new r(e, t, i);
          },
        };
      };
    t.default = u;
  },
  function (e, t, i) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : { default: e };
    }

    function n(e, t) {
      for (var i = 0; i < t.length; i++) {
        var r = t[i];
        (r.enumerable = r.enumerable || !1),
          (r.configurable = !0),
          "value" in r && (r.writable = !0),
          Object.defineProperty(e, r.key, r);
      }
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.default = void 0),
      i(0);
    var s = r(i(164)),
      a = r(i(10)),
      o = function (e) {
        var t = a.default.create(e, "MetricsManager"),
          i = new s.default(e),
          r = (function () {
            function e() {
              !(function (e, t) {
                if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function");
              })(this, e),
                (this.metricsList = {});
            }
            var r, s;
            return (
              (r = e),
              (s = [
                {
                  key: "add",
                  value: function (e, r, n) {
                    void 0 !== this.metricsList[e] &&
                      t.error("metric for track ID " + e + " already exists");
                    var s = i.create(e, r, n);
                    return (
                      this.videoElement && s.setVideoElement(this.videoElement),
                      (this.metricsList[e] = s),
                      s
                    );
                  },
                },
                {
                  key: "remove",
                  value: function (e) {
                    var i = this.metricsList[e];
                    return (
                      i ? i.destroy() : t.error("remove: " + e + " not found"),
                      (this.metricsList[e] = void 0),
                      i
                    );
                  },
                },
                {
                  key: "isReadyToStart",
                  value: function (e) {
                    return this.metricsList[e] && this.metricsList[e].isReady();
                  },
                },
                {
                  key: "run",
                  value: function (e) {
                    this.metricsList[e]
                      ? this.metricsList[e].start()
                      : t.warn("run: " + e + " not found");
                  },
                },
                {
                  key: "stop",
                  value: function (e) {
                    this.metricsList[e]
                      ? this.metricsList[e].stop()
                      : t.error("stop: no metric found for " + e + " track");
                  },
                },
                {
                  key: "reportBandwidth",
                  value: function (e, t, i) {
                    this.metricsList[e] &&
                      this.metricsList[e].reportBandwidth(t, i);
                  },
                },
                {
                  key: "reportLowBuffer",
                  value: function (e) {
                    this.metricsList[e]
                      ? this.metricsList[e].reportLowBuffer()
                      : t.error(
                          "report low buffer: No metric found for " +
                            e +
                            " track"
                        );
                  },
                },
                {
                  key: "reportBufLevel",
                  value: function (e, i, r) {
                    this.metricsList[e]
                      ? this.metricsList[e].reportBufLevel(i, r)
                      : t.error(
                          "report buffer level: No metric found for " +
                            e +
                            " track"
                        );
                  },
                },
                {
                  key: "setRateAdditive",
                  value: function (e, i) {
                    this.metricsList[e]
                      ? this.metricsList[e].setRateAdditive(i)
                      : t.error(
                          "setRateAdditive: No metrics found for " +
                            e +
                            " track"
                        );
                  },
                },
                {
                  key: "getMetrics",
                  value: function (e) {
                    if (this.metricsList[e]) return this.metricsList[e];
                    t.error("get metric: No metric found for " + e + " track");
                  },
                },
                {
                  key: "setVideoElement",
                  value: function (e) {
                    for (var t in ((this.videoElement = e), this.metricsList))
                      this.metricsList[t] &&
                        this.metricsList[t].setVideoElement(e);
                  },
                },
              ]) && n(r.prototype, s),
              e
            );
          })();
        return {
          create: function () {
            return new r();
          },
        };
      };
    t.default = o;
  },
  function (e, t, i) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : { default: e };
    }
    i(0),
      Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.default = void 0),
      i(23),
      i(14),
      i(16),
      i(59),
      i(60),
      i(223),
      i(86),
      i(21),
      i(69),
      i(88),
      i(114),
      i(68),
      i(111),
      i(216),
      i(152);
    var n = r(i(10)),
      s = r(i(116)),
      a = r(i(94)),
      o = r(i(185)),
      u = r(i(168)),
      c = function (e) {
        function t() {
          function t() {
            if (
              (void 0 == Se.enter &&
                ((Se.enter = performance.now()), (Se.initStart = !j)),
              void 0 == Se.time && D)
            ) {
              Se.time = D.currentTime;
              var e = D.buffered.length;
              e > 0 && (Se.bufTime = D.buffered.end(e - 1) - D.currentTime);
            }
            (Se.exit = void 0), (Se.ready = !1);
          }

          function n() {
            (Se.stopBuffer = !1),
              (Se.audioOnly = !1),
              (Se.forcePlay = !1),
              (Se.bufTime = void 0),
              (Se.seekInd = void 0),
              (Se.seekTo = void 0),
              (Se.enter = void 0),
              (Se.time = void 0),
              (Se.exit = void 0),
              (Se.ready = !1);
          }

          function s() {
            i.debug("_clearInitSwitchData"),
              (ke.activated = !1),
              (ke.from = void 0),
              (ke.to = void 0),
              (ke.aTime = void 0),
              (ke.lastCurTime = void 0);
          }

          function c(e, t) {
            var i = "vp8" == t || "vp9" == t ? "webm" : "mp4";
            return Ae.isBrowser("Firefox") && "mp4a.40.34" == t
              ? e + "/" + i + '; codecs="mp3"'
              : e + "/" + i + '; codecs="' + t + '"';
          }

          function l(e) {
            return performance.timing.navigationStart + e;
          }

          function h() {
            void 0 !== ee && (clearTimeout(ee), (ee = void 0));
          }

          function f() {
            void 0 !== te && (clearTimeout(te), (te = void 0));
          }

          function d() {
            void 0 !== $ &&
              (i.debug("_cancelSeekTimer"), clearTimeout($), ($ = void 0));
          }

          function p() {
            d(), i.debug("setSeekTimer"), ($ = setTimeout(v, 5e3));
          }

          function v() {
            i.error("error seek timeout!"),
              (Y = !1),
              ($ = void 0),
              ne(Ae.isBrowser("Firefox"));
          }

          function m(e, t) {
            var i = void 0;
            void 0 == t && (t = w());
            for (var r = 0; r < t.length; r++)
              if (e < t[r][1] && t[r][1] - t[r][0] >= ye) {
                var n = t[r][0];
                i = e >= n ? (t[r][1] - e >= ye ? e : t[r][1] - ye) : n;
                break;
              }
            return (
              void 0 == i &&
                (i = t[t.length - 1][1] - ye) < t[t.length - 1][0] &&
                (i = t[t.length - 1][0]),
              g(i),
              i
            );
          }

          function g(e) {
            D.currentTime != e &&
              (i.debug("seek", e, D.currentTime), (D.currentTime = e));
          }

          function y(e) {
            var t = D.currentTime,
              r = e - t;
            if (0 == D.currentTime) (D.currentTime = e), (t = e);
            else {
              var n,
                s = r + 1,
                a = 1;
              r > 0
                ? r > 15
                  ? ((s = 16), (a = r / 15))
                  : (a = _(r / ((s = 0.25 * (n = Math.ceil(s / 0.25))) - 1)))
                : s < 0
                ? ((a = -r), (s = 0))
                : (0 === (n = Math.floor(s / 0.25)) && (n = 1),
                  (a = _(r / ((s = 0.25 * n) - 1), -1))),
                i.debug(
                  "zapping with rate",
                  s,
                  a,
                  r > 0 ? r : 1 + r,
                  s > 1 ? (s - 1) * a : 1 - s * a
                ),
                (D.playbackRate = s),
                x(),
                Te.start(function () {
                  (D.playbackRate = 1), C();
                }, 1e3 * a),
                (t = e);
            }
            return t;
          }

          function _(e, t) {
            t < 0 && (e -= 0.001);
            var i = e.toString(),
              r = i.indexOf("."),
              n = -1 == r ? i.length : r + 4,
              s = i.substr(0, n),
              a = isNaN(s) ? 0 : s;
            return parseFloat(a);
          }

          function b() {
            if (D && D.buffered.length > 0) {
              i.debug("_seekToBufferedStart");
              for (var e = 0; e < U.length; e++)
                U[e].buffered.length > 0 &&
                  i.debug(
                    U[e].stream_id + ": " + U[e].buffered.start(0),
                    U[e].buffered.end(0)
                  );
              try {
                S() && A(),
                  Se.background && void 0 == Se.enter && t(),
                  (j = !0);
              } catch (e) {
                i.debug("seek to buffered start failed: ", e);
              }
            }
          }

          function A() {
            H.playbackTime = D.currentTime;
          }

          function w() {
            var e = [],
              t = U.length;
            if (t > 1) {
              for (var i = [], r = 0; r < t; r++)
                for (var n = 0; n < U[r].buffered.length; n++)
                  i.push([U[r].buffered.start(n), 0]),
                    i.push([U[r].buffered.end(n), 1]);
              i.sort(function (e, t) {
                return e[0] - t[0];
              });
              for (var s = 0, a = 0; a < i.length; a++)
                0 == i[a][1]
                  ? t == ++s && e.push([i[a][0], void 0])
                  : t - 1 == --s && (e[e.length - 1][1] = i[a][0]);
            } else if (t > 0)
              for (var o = 0; o < U[0].buffered.length; o++)
                e.push([U[0].buffered.start(o), U[0].buffered.end(o)]);
            return e;
          }

          function S() {
            var e = D.currentTime,
              t = !1,
              r = w(),
              n = r.length;
            if (n > 0) {
              e < r[0][0] &&
                ((e = r[0][0]),
                i.debug(
                  "Current position is behind the start of the first buffered range. Seek to the start."
                ),
                (t = !0));
              for (var s = 1; s < n; s++)
                if (
                  e >= r[s - 1][1] &&
                  e < r[s][0] &&
                  r[s][1] - r[s][0] >= ye
                ) {
                  (e = r[s][0]),
                    i.debug(
                      "Current position is between " +
                        (s - 1) +
                        " and " +
                        s +
                        " . Seek to the start of " +
                        s
                    ),
                    (t = !0);
                  break;
                }
              if (t) g(e), h();
              else if (!me)
                if (J.value == D.currentTime && J.value !== H.playbackTime) {
                  J.count += 1;
                  var a = (performance.now() - J.time) / 1e3;
                  if (J.count > 10 && a > 2) {
                    var o = D.currentTime + a,
                      u = I(o);
                    void 0 === u && (u = o),
                      i.debug(
                        "Stuck on ".concat(J.value, ". Seek to ").concat(u)
                      ),
                      m(u, r),
                      h(),
                      (t = !0);
                  }
                } else
                  (J.time = performance.now()),
                    (J.value = D.currentTime),
                    (J.count = 1);
            }
            return t;
          }

          function k() {
            var e = D.currentTime;
            if (
              (G && X && (e += (performance.now() - X) / 1e3),
              void 0 === W || e - W > 30)
            )
              for (var t = 0; t < U.length; t++) {
                var i = U[t];
                if (i.buffered.length > 0) {
                  var r = e - 30;
                  r - i.buffered.start(0) > 60 &&
                    (i.removeRange(0, Math.floor(r + 0.5)), (W = e));
                }
              }
          }

          function T(e) {
            var t = D.play();
            if (void 0 !== t) {
              var i = !e.recover;
              t.then(function () {
                q = !0;
              }).catch(function (e) {
                i && oe();
              });
            } else
              Ae.isMobile() &&
                !we &&
                (e.gesture ? (we = !0) : e.recover || oe());
          }

          function x() {
            i.debug("Seek start"), j && ((Y = !0), p());
          }

          function C() {
            if (
              (i.debug("Seek end"),
              setTimeout(function () {
                Y = !1;
              }, 1e3),
              d(),
              Se.forcePlay)
            ) {
              var e = D.play();
              void 0 !== e &&
                e.catch(function (e) {
                  i.error("_onSeekEnd play() error:", e);
                }),
                (Se.forcePlay = !1);
            }
          }

          function E(e) {
            var t = function t() {
              if (!z) {
                for (var i = 0; i < U.length; i++)
                  U[i].removeEventListener("updateend", t);
                e();
              }
            };
            if (z)
              for (var i = 0; i < U.length; i++)
                U[i].addEventListener("updateend", t);
            else e();
          }

          function P() {
            var t,
              r = U.length;
            if (r > 0) {
              for (var n = 0; n < r; n++) if (U[n].closed) return;
              if (j) {
                if (G) k();
                else if (!Se.background) {
                  var o = D.currentTime;
                  if (Q) {
                    i.debug("onProgress buffered in progress");
                    var u = o + (performance.now() - Z) / 1e3;
                    se(u, o);
                  } else {
                    var c = ue(o);
                    if (
                      (a.default.display(e, "latency", c.toFixed(4)),
                      Y || z || D.ended || void 0 != Se.exit)
                    )
                      i.debug(
                        "onProgress nothing called, _seekInProgress " +
                          Y +
                          ", _removeInProgress " +
                          z +
                          ", ended " +
                          D.ended
                      );
                    else {
                      var l = w();
                      if (l.length > 0) {
                        var h = V ? V.buffered : D.buffered,
                          f = h.length,
                          d = !1;
                        if (
                          ke.activated &&
                          (ke.from > o &&
                            (o > ke.lastCurTime
                              ? (ke.lastCurTime = o)
                              : o == ke.lastCurTime &&
                                (ke.from = ke.lastCurTime)),
                          void 0 !== ke.to)
                        ) {
                          var p = h.start(f - 1);
                          i.debug(
                            "onProgress initswitch data to = "
                              .concat(ke.to, ", curTime = ")
                              .concat(o, ", bufRangeStart = ")
                              .concat(p, ", videoBufEnd = ")
                              .concat(h.end(f - 1))
                          ),
                            p != ke.to &&
                              p >= o &&
                              (p < ke.to
                                ? ke.to - p < 2 && (ke.to = p)
                                : p - ke.to < 2
                                ? (ke.to = p)
                                : f > 1 &&
                                  h.end(f - 2) - ke.to < pe &&
                                  (ke.to = p));
                          var v = ke.to - o;
                          ke.from <= o &&
                            (ke.to <= h.end(f - 1) - 0.9 * pe || v < 0.1) &&
                            (v > 0 &&
                              (ke.to == p
                                ? (i.debug(
                                    "initswitch seek to range start " +
                                      p +
                                      " from " +
                                      o,
                                    h.start(f - 1),
                                    h.end(f - 1)
                                  ),
                                  g(p))
                                : (i.debug(
                                    "initswitch seek to " +
                                      ke.to +
                                      " from " +
                                      o,
                                    h.start(f - 1),
                                    h.end(f - 1)
                                  ),
                                  m(ke.to, l)),
                              (d = !0)),
                            s());
                        }
                        if (
                          (d ||
                            (void 0 === ee && !Ae.isBrowser("Safari")) ||
                            (d = S()),
                          !d && void 0 == ke.to)
                        ) {
                          var _ =
                            ((t = 0),
                            ge.length > 0 &&
                              ((t = ge[0]),
                              2 == ge.length && ge[1] < t && (t = ge[1])),
                            t);
                          if (void 0 == te && !me)
                            if (de > 0) {
                              if (_ > de && _ > pe) {
                                var A = o + _ - pe;
                                if (void 0 == L || L < A - 5) {
                                  var x = F ? A - 0.1 : B(A);
                                  x &&
                                    (i.debug("Adjust latency", x, _, x - o),
                                    (L = F ? y(A) : m(x, l)),
                                    ce(o, L));
                                } else
                                  i.debug(
                                    "Latency is not adjusted, try next time"
                                  );
                                d = !0;
                              }
                            } else if (be.bufferSize > 0) {
                              var C = performance.now();
                              if (C - be.lastZapTime > 4e3) {
                                var P =
                                  (C - be.timeShift - be.bufferSize) / 1e3;
                                if (P > o) {
                                  var M = Math.min(pe, 500),
                                    R = o + _ - M,
                                    O = h.end(f - 1) - M;
                                  R > O && (R = O),
                                    R <= o ? (P = o) : R < P && (P = R);
                                }
                                var N = P - o,
                                  W = Math.abs(N),
                                  J = !1;
                                W > 0.1
                                  ? (J = !0)
                                  : W > 0.04 &&
                                    ((be.integralDist += N),
                                    i.debug(
                                      "Integral distance for zapping",
                                      be.integralDist
                                    ),
                                    void 0 === be.start && (be.start = C),
                                    C - be.start > 15e3
                                      ? ((be.start = C), (be.integralDist = N))
                                      : Math.abs(be.integralDist) >= 4 &&
                                        W >= 0.02 &&
                                        ((J = !0),
                                        i.debug(
                                          "zapping by integral decision",
                                          be.integralDist
                                        ))),
                                  J &&
                                    ((be.integralDist = 0),
                                    (be.start = void 0),
                                    W > 15
                                      ? (P = m(B(P), l))
                                      : ((be.lastZapTime = C), (P = y(P))),
                                    (d = !0));
                              }
                            }
                          if (
                            !d &&
                            void 0 == ke.to &&
                            ((L = void 0),
                            V && D.getVideoPlaybackQuality && !me)
                          ) {
                            var X =
                              D.getVideoPlaybackQuality().totalVideoFrames;
                            if (
                              X == K.frames &&
                              0 !== K.time &&
                              H.playbackTime !== o
                            ) {
                              if (0 == K.seekCount) {
                                K.count++;
                                var $ = (performance.now() - K.time) / 1e3;
                                if (
                                  K.count > 10 &&
                                  $ > 3 &&
                                  ($ >= _ && ($ = _ - 0.1), $ > 0)
                                ) {
                                  var ie = o + $,
                                    ne = I(ie);
                                  void 0 === ne && (ne = ie),
                                    i.debug(
                                      "Decoder freeze on "
                                        .concat(K.frames, ". Seek to ")
                                        .concat(ne, ".")
                                    ),
                                    m(ne, l),
                                    K.seekCount++,
                                    (d = !0);
                                }
                              }
                            } else
                              (K.time = performance.now()),
                                (K.frames = X),
                                (K.count = 1),
                                (K.seekCount = 0);
                          }
                        }
                        d || k(),
                          re(o, c),
                          Ae.isBrowser("Safari") &&
                            q &&
                            !G &&
                            D.paused &&
                            (i.debug("Force Safari to play from onProgress"),
                            T({}));
                      }
                    }
                  }
                }
              } else
                E(function () {
                  b();
                });
            }
          }

          function B(e) {
            for (var t = void 0, i = ve.length() - 1; i >= 0; i--) {
              var r = ve.get(i);
              if (r < e - 0.2 * pe) break;
              if (r < e + 0.1 * pe) {
                t = r;
                break;
              }
            }
            return t;
          }

          function I(e) {
            for (var t = void 0, i = ve.length() - 1; i >= 0; i--) {
              var r = ve.get(i);
              if (r <= D.currentTime) break;
              if (r < e + 0.1) {
                t = r;
                break;
              }
            }
            return t;
          }

          function M() {
            D.removeEventListener("canplay", M), R(1), i.debug("canplay");
          }

          function R(e) {
            i.debug("setPlaybackRate", e, D.readyState),
              D.readyState <= 2
                ? D.addEventListener("canplay", M)
                : (D.playbackRate = e);
          }
          var L,
            F,
            O = void 0,
            D = void 0,
            U = [],
            V = void 0,
            N = void 0,
            j = !1,
            H = {},
            z = !1,
            W = void 0,
            Y = !1,
            Q = !1,
            q = !1,
            G = !1,
            J = { value: 0, count: 0, time: 0 },
            K = { frames: 0, count: 0, time: 0, seekCount: 0 },
            X = void 0,
            Z = void 0,
            $ = void 0,
            ee = void 0,
            te = void 0,
            ie = void 0,
            re = void 0,
            ne = void 0,
            se = void 0,
            ae = void 0,
            oe = void 0,
            ue = void 0,
            ce = void 0,
            le = void 0,
            he = !1,
            fe = void 0,
            de = -1,
            pe = 0,
            ve = r.create(10),
            me = !1,
            ge = [],
            ye = 0,
            _e = {},
            be = {
              timeShift: 0,
              bufferSize: 0,
              start: void 0,
              integralDist: 0,
              lastZapTime: 0,
            },
            Ae = new u.default(e),
            we = !1,
            Se = {
              enter: void 0,
              exit: void 0,
              time: void 0,
              bufTime: void 0,
              background: !1,
              stopBuffer: !1,
              vThreshold: 1200,
              aThreshold: 3600,
              ready: !1,
              seekTo: void 0,
              seekInd: void 0,
              audioOnly: !1,
              initStart: !1,
            },
            ke = { activated: !1, from: void 0, to: void 0 },
            Te = new o.default();
          document.addEventListener("visibilitychange", function () {
            D &&
              D.currentTime > 0 &&
              (document.hidden
                ? (t(), Te.interrupt())
                : Se.background &&
                  (G
                    ? n()
                    : (function () {
                        var e = performance.now();
                        if (Se.stopBuffer) Se.ready = !0;
                        else if (!Se.ready && D && D.buffered.length > 0) {
                          var t = (e - Se.enter) / 1e3,
                            i = D.currentTime - Se.time;
                          if (t > 2 * i) {
                            var r = D.buffered.end(D.buffered.length - 1),
                              s = r - D.currentTime;
                            s > Se.bufTime && (Se.ready = !0);
                          }
                        }
                        Se.ready
                          ? ((Se.exit = e),
                            (Se.audioOnly = void 0 == V && void 0 !== N))
                          : n();
                      })()),
              (Se.background = document.hidden));
          }),
            (this.startLogging = function (e) {
              (he = !1),
                void 0 === fe && (fe = {}),
                void 0 === fe[e] &&
                  (fe[e] = {
                    times: [],
                    prevTime: 0,
                    sumTime: 0,
                    stamps: [],
                    gaps: [],
                    thresh: 60,
                    avg: void 0,
                  });
            }),
            (this.setPositionControl = function () {
              h(),
                (ee = setTimeout(function () {
                  h();
                }, 3e4));
            }),
            (this.transitOn = function () {
              me = !0;
            }),
            (this.transitOff = function () {
              (me = !1),
                de > 0 &&
                  (f(),
                  (te = setTimeout(function () {
                    f();
                  }, 5e3)));
            }),
            (this.setLatencyTolerance = function (e, t, i) {
              (de = e) > 0 &&
                de < 3.5 &&
                Ae.isBrowser("Microsoft") &&
                (de = 3.5),
                (F = !!i),
                (pe = t);
            }),
            (this.setLowBufferBorder = function (e, t) {
              _e[t] = e + 0.06;
              var i = 0;
              for (var r in _e) _e[r] > i && (i = _e[r]);
              ye = i;
            }),
            (this.setCurrentBufferLevel = function (e, t) {
              2 == U.length ? (ge["v" == e[0] ? 0 : 1] = t) : (ge[0] = t);
            }),
            (this.isMediaSourceSupported = function () {
              return "MediaSource" in window && !!window.MediaSource;
            }),
            (this.isMobile = function () {
              return Ae.isMobile();
            }),
            (this.isIOS = function () {
              return Ae.isIOS();
            }),
            (this.isCurrentBrowser = function (e) {
              return Ae.isBrowser(e);
            }),
            (this.isCodecSupported = function (e, t) {
              var i = !1;
              if (this.isMediaSourceSupported()) {
                if (
                  Ae.isBrowser("Microsoft") &&
                  ("mp4a.40.34" == t || "mp4a.6B" == t || "mp4a.6B" == t)
                )
                  return !1;
                i = MediaSource.isTypeSupported(c(e, t));
              }
              return i;
            }),
            (this.init = function (e) {
              ie && M
                ? ((O = new MediaSource()).addEventListener("sourceopen", ie),
                  (D = e).addEventListener("progress", P),
                  D.addEventListener("timeupdate", P),
                  D.addEventListener("seeking", x),
                  D.addEventListener("seeked", C),
                  (D.src = URL.createObjectURL(O)),
                  !D.getVideoPlaybackQuality &&
                    "webkitDecodedFrameCount" in D &&
                    (D.getVideoPlaybackQuality = function () {
                      return {
                        droppedVideoFrames: this.webkitDroppedFrameCount,
                        totalVideoFrames: this.webkitDecodedFrameCount,
                      };
                    }),
                  Ae.logData())
                : i.error("Error: necessary callbacks are not defined.");
            }),
            (this.listBuffers = function () {
              i.debug("listBuffers", U);
            }),
            (this.createSourceBuffer = function (e, t, r, a) {
              function o(e, t) {
                e.updating
                  ? e.addEventListener("updateend", function i() {
                      e.updating ||
                        (e.removeEventListener("updateend", i), t());
                    })
                  : t();
              }
              var u = O.addSourceBuffer(c(e, t));
              return (
                (u.mode = "segments"),
                (u.initSegment = void 0),
                (u.segments = []),
                (u.initPositions = []),
                (u.sapPositions = []),
                (u.appendedCount = 0),
                (u.bufferLength = 0),
                (u.fBufferLength = 0),
                (u.timescale = r),
                (u.isVideo = "video" == e),
                u.isVideo ? (V = u) : (N = u),
                (u.setTimestampOffset = function (e) {
                  var t = this;
                  o(t, function () {
                    t.timestampOffset = e;
                  });
                }),
                (u.filterOut = function (e) {
                  if (void 0 !== e)
                    for (var t = this.segments.length, i = 0; i < t; i++)
                      if (this.segments[i].ts >= e) {
                        var r = t - i;
                        this.segments.splice(i, r),
                          this.adjustPositions(i, !0),
                          i < this.appendedCount && (this.appendedCount = i);
                        break;
                      }
                }),
                (u.getBufferingLength = function () {
                  return this.bufferLength;
                }),
                (u.setBufferingLength = function (e) {
                  (this.bufferLength = e), (this.fBufferLength = e);
                }),
                (u.pushInit = function (e, t) {
                  var r = { init: !0, data: e };
                  if (this.isVideo && !t) {
                    var n = this.segments.length;
                    if (n > 0) {
                      var s = void 0;
                      this.segments[n - 1].ts
                        ? (s = this.segments[n - 1].ts)
                        : n > 1 &&
                          this.segments[n - 2].ts &&
                          (s = this.segments[n - 2].ts),
                        void 0 !== s &&
                          ((ke.from = s / this.timescale),
                          (ke.activated = !0),
                          i.debug("initswitch set from = ".concat(ke.from)));
                    }
                  }
                  this.segments.push(r),
                    this.initPositions.push(this.segments.length - 1),
                    this.appendNextSegment();
                }),
                (u.pushSegment = function (e, t, r) {
                  var n = this.isVideo ? Se.vThreshold : Se.aThreshold;
                  if (
                    (Se.background &&
                      !Se.stopBuffer &&
                      this.segments.length > n &&
                      (i.debug("Throttle segments buffer", n),
                      (Se.stopBuffer = !0)),
                    !Se.background || !Se.stopBuffer)
                  ) {
                    var s = { data: e, ts: t[0], sap: r[0] };
                    Se.ready &&
                      (this.isVideo || Se.audioOnly) &&
                      s.sap &&
                      ((s.starter = !0), (Se.ready = !1)),
                      this.segments.push(s),
                      this.isVideo &&
                        s.sap &&
                        this.sapPositions.push(this.segments.length - 1),
                      this.appendNextSegment();
                  }
                  he && this.log(t);
                }),
                (u.appendNextSegment = function () {
                  var e = this;
                  o(e, function () {
                    e.closed || e.appendSegment();
                  });
                }),
                (u.appendSegment = function () {
                  if (this.appendedCount < this.segments.length) {
                    var e = this.segments[this.appendedCount];
                    !(function (e, t) {
                      var r = !0;
                      try {
                        e.appendBuffer(t);
                      } catch (t) {
                        var n = e.isVideo ? "Video frame " : "Audio frame ";
                        i.error(n + "append exception!", t), (r = !1);
                      }
                      return r;
                    })(this, e.data)
                      ? (i.debug(
                          "Append " +
                            (e.init ? "init " : "") +
                            "segment error, reloading"
                        ),
                        ne())
                      : (this.appendedCount++,
                        e.init
                          ? this.onInitAppended(e)
                          : (this.processThrottling(e),
                            this.onSegmentAppended(e)));
                  }
                }),
                (u.onInitAppended = function (e) {
                  (this.initSegment = e.data),
                    this.appendedCount > 1 &&
                      (this.segments.splice(0, this.appendedCount - 1),
                      this.adjustPositions(this.appendedCount - 1),
                      (this.appendedCount = 1));
                }),
                (u.processThrottling = function (e) {
                  if (e.starter)
                    (Se.seekTo = this.buffered.end(this.buffered.length - 1)),
                      (Se.seekInd = Se.seekTo + pe);
                  else if (Se.seekInd) {
                    var t = this.isVideo || Se.audioOnly,
                      r = this.buffered.end(this.buffered.length - 1);
                    if (t && r >= Se.seekInd) {
                      var s = !0;
                      if (2 == U.length) {
                        for (var a = 0, o = 0, u = 0; u < U.length; u++)
                          if (!U[u].isVideo) {
                            var c = U[u].buffered.length;
                            (a = U[u].buffered.start(c - 1)),
                              (o = U[u].buffered.end(c - 1));
                            break;
                          }
                        Se.seekTo < a &&
                          ((Se.seekTo = a), (Se.seekInd = Se.seekTo + pe)),
                          (Se.seekInd > o || Se.seekInd > r) && (s = !1);
                      }
                      s &&
                        (i.debug("Recover from throttling, jump to", Se.seekTo),
                        F ? y(Se.seekTo) : g(Se.seekTo),
                        n(),
                        Ae.isMobile() && (Se.forcePlay = !0),
                        Se.initStart && (A(), (Se.initStart = !1)));
                    }
                  }
                }),
                (u.onSegmentAppended = function (e) {
                  if (ke.activated && !ke.to && void 0 !== ke.from && e.sap) {
                    var t = e.ts / this.timescale,
                      r =
                        this.buffered.length > 0
                          ? this.buffered.end(this.buffered.length - 1)
                          : 0;
                    if (t >= ke.from)
                      if (this.isVideo) {
                        (ke.to = t), (ke.lastCurTime = D.currentTime);
                        var n = ke.lastCurTime - r;
                        i.debug(
                          "initSwitch onSegmentAppended v = "
                            .concat(this.isVideo, ", to = ")
                            .concat(ke.to, ", cur = ")
                            .concat(ke.lastCurTime, ", end = ")
                            .concat(r, ", timeDiff = ")
                            .concat(n)
                        ),
                          n > 0 &&
                            (void 0 !== ke.aTime
                              ? ((ke.to = ke.aTime),
                                i.debug(
                                  "initSwitch onSegmentAppended set aTime = ".concat(
                                    ke.aTime
                                  )
                                ))
                              : N && N.buffered.length > 0
                              ? (i.debug(
                                  "initSwitch onSegmentAppended set audioBuffer end = ".concat(
                                    ke.aTime
                                  )
                                ),
                                (ke.to = N.buffered.end(N.buffered.length - 1)))
                              : (i.debug(
                                  "initSwitch onSegmentAppended set euristics = ".concat(
                                    ke.aTime
                                  )
                                ),
                                (ke.to += D.currentTime - ke.from)),
                            i.debug(
                              "initSwitch onSegmentAppended seek back to ".concat(
                                ke.to
                              )
                            ),
                            (n = ke.to - ke.lastCurTime),
                            Math.abs(n) < 0.5 &&
                              (i.debug(
                                "initSwitch onSegmentAppended seek because int = ".concat(
                                  ke.to - ke.lastCurTime
                                )
                              ),
                              g(ke.to),
                              s()));
                      } else void 0 === ke.aTime && (ke.aTime = t);
                  }
                  if (this.isVideo && e.sap) {
                    var a = e.ts / this.timescale,
                      o =
                        this.buffered.length > 0
                          ? this.buffered.end(this.buffered.length - 1)
                          : 0;
                    a < o && (a = o), ve.push(a);
                  }
                  if (this.segments.length > this.bufferLength)
                    if (this.isVideo) {
                      var u = 0;
                      this.sapPositions.length > 1 &&
                        this.sapPositions[1] <= this.appendedCount &&
                        this.sapPositions[1] <=
                          this.segments.length - this.bufferLength &&
                        (u = this.sapPositions[1]),
                        u > 0 &&
                          (this.segments.splice(0, u),
                          (this.appendedCount -= u),
                          this.adjustPositions(u)),
                        this.onVideoSegmentPushed(this.appendedCount);
                    } else {
                      var c = this.segments.length - this.bufferLength;
                      c > this.appendedCount && (c = this.appendedCount),
                        1 == c
                          ? this.segments.shift()
                          : this.segments.splice(0, c),
                        (this.appendedCount -= c),
                        this.adjustInitPositions(c);
                    }
                }),
                (u.adjustPositions = function (e, t) {
                  var i = 0;
                  if (t) {
                    for (
                      i = this.sapPositions.length - 1;
                      i >= 0 && !(this.sapPositions[i] < e);
                      i--
                    );
                    this.sapPositions.length = i + 1;
                  } else
                    for (i = 0; i < this.sapPositions.length; i++)
                      this.sapPositions[i] >= e
                        ? (this.sapPositions[i] -= e)
                        : (this.sapPositions.shift(), i--);
                  this.adjustInitPositions(e, t);
                }),
                (u.adjustInitPositions = function (e, t) {
                  var i = 0;
                  if (t) {
                    for (
                      i = this.initPositions.length - 1;
                      i >= 0 && !(this.initPositions[i] < e);
                      i--
                    );
                    this.initPositions.length = i + 1;
                  } else
                    for (i = 0; i < this.initPositions.length; i++)
                      this.initPositions[i] >= e
                        ? (this.initPositions[i] -= e)
                        : (this.initPositions.shift(), i--);
                }),
                u.isVideo &&
                  (u.onVideoSegmentPushed = function (e) {
                    N && (N.bufferLength = Math.floor(N.bufLenRatio * e + 0.5));
                  }),
                (u.getSegments = function () {
                  for (
                    var e = void 0, t = 0;
                    t < this.initPositions.length;
                    t++
                  )
                    if ((e = this.initPositions[t]) == this.appendedCount)
                      t + 1 == this.initPositions.length &&
                        ((e = void 0), (this.initSegment = void 0));
                    else if (e > this.appendedCount) break;
                  var i = 0;
                  if (void 0 !== e)
                    if (
                      ((this.initSegment = this.segments[e].data), this.isVideo)
                    ) {
                      for (var r = 0; r < this.sapPositions.length; r++)
                        if (this.sapPositions[r] > e) {
                          i = this.sapPositions[r];
                          break;
                        }
                    } else i = e + 1;
                  return {
                    init: this.initSegment,
                    segments: this.segments,
                    start: i,
                  };
                }),
                (u.removeAll = function () {
                  this.abort(),
                    (this.initSegment = void 0),
                    (this.segments = []),
                    (this.sapPositions = []),
                    (this.initPositions = []),
                    (this.appendedCount = 0),
                    this.buffered.length > 0 &&
                      this.removeRange(
                        this.buffered.start(0),
                        this.buffered.end(this.buffered.length - 1)
                      );
                }),
                (u.removeRange = function (e, t) {
                  var r = this;
                  o(r, function () {
                    i.debug(
                      "Remove started",
                      e,
                      t,
                      D.currentTime,
                      r.buffered.length
                    ),
                      (z = !0),
                      r.remove(e, t),
                      o(r, function () {
                        i.debug("Remove ended"), (z = !1);
                      });
                  });
                }),
                he &&
                  (u.log = function (e) {
                    for (var t = fe[this.stream_id], r = 0; r < e.length; r++) {
                      var n =
                          t.stamps.length > 0
                            ? e[r] - t.stamps[t.stamps.length - 1]
                            : 0,
                        s = 0;
                      if (t.times.length > 0) {
                        var a = performance.now();
                        (s = a - t.prevTime), (t.prevTime = a);
                      } else t.prevTime = performance.now();
                      if (void 0 === t.avg)
                        for (var o = 1; o < t.stamps.length; o++) {
                          var u = t.stamps[o] - t.stamps[o - 1];
                          if (u > 0) {
                            t.avg = u;
                            break;
                          }
                        }
                      if (t.stamps.length == t.thresh) {
                        if (
                          (i.debug(
                            this.stream_id +
                              " processed " +
                              t.thresh +
                              " frames"
                          ),
                          0 == t.gaps.length)
                        )
                          t.sumTime > t.avg * t.thresh * 1.1 &&
                            (i.debug(
                              "frames come slow!!!",
                              t.sumTime,
                              t.avg * t.thresh
                            ),
                            i.debug("intervals: [" + t.times.join(", ") + "]"));
                        else {
                          for (var c = [], l = 0; l < t.gaps.length; l++)
                            c.push(
                              "{val: " +
                                t.gaps[l].val +
                                ", idx: " +
                                t.gaps[l].idx +
                                "}"
                            );
                          i.debug(
                            "Gaps: [" + c.join(", ") + "], avgDuration " + t.avg
                          ),
                            i.debug("Stamps: [" + t.stamps.join(", ") + "]"),
                            t.sumTime > t.avg * t.thresh * 1.1 &&
                              i.debug(
                                "Frames come slow!!!",
                                t.sumTime,
                                t.avg * t.thresh
                              ),
                            i.debug("Intervals: [" + t.times.join(", ") + "]");
                        }
                        (t.times = []),
                          (t.sumTime = 0),
                          (t.stamps = []),
                          (t.gaps = []);
                      }
                      t.times.push(s),
                        (t.sumTime += s),
                        t.stamps.push(e[r]),
                        Math.abs(n - t.avg) > 1 &&
                          t.gaps.push({ val: n, idx: t.stamps.length - 1 });
                    }
                  }),
                u.addEventListener("error", function (e) {
                  i.error("SourceBuffer Error", e, this.stream_id);
                }),
                (u.stream_id = a),
                U.push(u),
                u
              );
            }),
            (this.startPlayback = function (e) {
              i.debug("startPlayback buffered ", D.buffered.length),
                D.buffered.length > 0 &&
                  i.debug(
                    "video element buffer",
                    D.buffered.start(0),
                    D.buffered.end(0)
                  ),
                N &&
                  V &&
                  (N.bufLenRatio = (2 * N.fBufferLength) / V.fBufferLength),
                (0 == D.currentTime || G) && T(e || {});
            }),
            (this.setSyncParams = function (e, t) {
              (be.timeShift = e),
                (be.bufferSize = t),
                (be.integralDist = 0),
                (be.start = void 0),
                (be.lastZapTime = 0),
                i.debug("setSyncParams", e, t);
            }),
            (this.continue = function () {
              i.debug("continue buffered ", D.buffered.length),
                D.buffered.length > 0 &&
                  i.debug(
                    "video element buffer",
                    D.buffered.start(0),
                    D.buffered.end(0)
                  ),
                R(1),
                Y && p(),
                (K.count = 0),
                (K.time = performance.now()),
                (Z = void 0),
                (Q = !1);
            }),
            (this.wait = function () {
              Te.interrupt(),
                R(0),
                d(),
                (Z = performance.now()),
                (Q = !0),
                le();
            }),
            (this.callbacks = function (e) {
              (ie = e.onSourceOpen),
                (re = e.onProgress),
                (ne = e.onCrash),
                (se = e.onWaitUpdate),
                (ae = e.onPlayStarted),
                (oe = e.onPlayFailed),
                (ue = e.onLatencyCalc),
                (ce = e.onLatencySeek),
                (le = e.onLowBuffer);
            }),
            (this.resetPosition = function () {
              i.debug("reset position"),
                d(),
                h(),
                f(),
                D && 0 !== D.currentTime && (D.currentTime = 0),
                (j = !1),
                (H = {}),
                (J = { value: 0, count: 0, time: 0 }),
                (K = { frames: 0, count: 0, time: 0, seekCount: 0 }),
                (W = void 0),
                (X = void 0),
                (Z = void 0),
                (L = void 0),
                (q = !1),
                (G = !1),
                (Q = !1),
                (z = !1),
                (Y = !1),
                (me = !1),
                (ge = []),
                ve.clear();
              for (var e = 0; e < U.length; e++)
                (U[e].initSegment = void 0),
                  (U[e].segments = []),
                  (U[e].sapPositions = []),
                  (U[e].initPositions = []),
                  (U[e].appendedCount = 0),
                  (U[e].bufferLength = 0),
                  (U[e].fBufferLength = 0);
              s(), n();
            }),
            (this.handlePause = function () {
              D &&
                !G &&
                q &&
                ((G = !0),
                (q = !1),
                (X = performance.now()),
                Te.stop() && (Y = !1),
                d(),
                D.pause(),
                i.debug("Paused at: " + l(X)));
            }),
            (this.handleEnterPip = function () {}),
            (this.handleLeavePip = function () {
              D && D.paused && !G && T({});
            }),
            (this.isPaused = function () {
              var e = void 0;
              return D && (e = G), e;
            }),
            (this.isSeeking = function () {
              var e = void 0;
              return (
                D &&
                  (e =
                    Y ||
                    Se.background ||
                    void 0 !== Se.seekTo ||
                    void 0 !== ke.to),
                e
              );
            }),
            (this.handlePlay = function (e) {
              if (D && !q && ((q = !0), (G = !1), T({ gesture: e }), X)) {
                var t = performance.now(),
                  r = t - X;
                i.debug("Play at: " + l(t)),
                  i.debug("Going to seek by " + r / 1e3 + " seconds.");
                var n = Math.ceil(D.currentTime + r / 1e3),
                  s = w();
                if (s.length > 0) {
                  var a = s[s.length - 1][1];
                  i.debug("Calculated position " + n + ". Buffer end is " + a),
                    a < n &&
                      (i.debug("Seek to buffer end " + a + " instead of " + n),
                      (n = a - ye));
                }
                var o = I(n);
                void 0 === o && (o = n), Ae.isBrowser("Safari") ? y(o) : m(o);
              }
            }),
            (this.handlePlayEvent = function () {
              j ||
                E(function () {
                  b(), ae();
                });
            }),
            (this.handlePauseEvent = function () {}),
            (this.clear = function () {
              if (!Ae.isBrowser("Safari"))
                for (var e = 0; e < U.length; e++)
                  try {
                    O.removeSourceBuffer(U[e]);
                  } catch (e) {
                    i.error("Failed to remove source buffer:", e);
                  }
              Te.stop(),
                this.resetPosition(),
                (U = []),
                (V = void 0),
                (N = void 0),
                D &&
                  (D.removeEventListener("progress", P),
                  D.removeEventListener("timeupdate", P),
                  D.removeEventListener("seeking", x),
                  D.removeEventListener("seeked", C),
                  URL.revokeObjectURL(D.src),
                  D.removeAttribute("src"),
                  D.load(),
                  (D = void 0)),
                O && (O.removeEventListener("sourceopen", ie), (O = void 0)),
                (ie = void 0),
                (re = void 0),
                (ne = void 0),
                i.debug("cleared source buffers and video element");
            });
        }
        var i = n.default.create(e, "MSE"),
          r = new s.default(e);
        return {
          create: function () {
            return new t();
          },
        };
      };
    t.default = c;
  },
  function (e, t, i) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : { default: e };
    }
    i(0),
      Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.default = void 0);
    var n = r(i(115)),
      s = r(i(120)),
      a = {
        name: "SLDP Player",
        composer: new n.default("test").create(),
        WSUtils: new s.default("test").create(),
      };
    t.default = a;
  },
  function (e, t, i) {
    "use strict";

    function r(e, t) {
      for (var i = 0; i < t.length; i++) {
        var r = t[i];
        (r.enumerable = r.enumerable || !1),
          (r.configurable = !0),
          "value" in r && (r.writable = !0),
          Object.defineProperty(e, r.key, r);
      }
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.default = void 0),
      i(112),
      i(220),
      i(88),
      i(16),
      i(114),
      i(21),
      i(68),
      i(0);
    var n,
      s = (n = i(10)) && n.__esModule ? n : { default: n },
      a = (function () {
        function e(t) {
          if (
            ((function (e, t) {
              if (!(e instanceof t))
                throw new TypeError("Cannot call a class as a function");
            })(this, e),
            (this.logger = s.default.create(t, "PlatformDetector")),
            "undefined" != typeof window)
          )
            if (window.navigator || navigator) {
              (this.nav = window.navigator || navigator),
                (this.userAgent = (this.nav.userAgent || "").toLowerCase()),
                (this._isFirefox = "undefined" != typeof InstallTrigger),
                (this._isOpera =
                  null !==
                  this.userAgent.match(/(?:^opera.+?version|opr)\/(\d+)/));
              var i = ((this.nav && this.nav.vendor) || "").toLowerCase(),
                r = /google inc/.test(i)
                  ? this.userAgent.match(/(?:chrome|crios)\/(\d+)/)
                  : null;
              (this._isChrome = null !== r && !this._isOpera),
                (this._isSafari =
                  /constructor/i.test(window.HTMLElement) ||
                  "[object SafariRemoteNotification]" ===
                    (
                      !window.safari ||
                      ("undefined" != typeof safari && safari.pushNotification)
                    ).toString()),
                (this._isIE = !!document.documentMode),
                (this._isEdge = !this._isIE && !!window.StyleMedia),
                (this._iPadOS13 = this._isIOS13("iPad")),
                (this._isMobile =
                  /android|webos|iphone|ipad|ipod|opera mini/i.test(
                    this.userAgent
                  ) || this._iPadOS13),
                (this._isIOS =
                  (/ipad|iphone|ipod/.test(this.userAgent) &&
                    !window.MSStream) ||
                  this._iPadOS13);
            } else this.logger.error("navigator is not defined");
          else this.logger.error("window is undefined");
        }
        var t, i;
        return (
          (t = e),
          (i = [
            {
              key: "isMobile",
              value: function () {
                return this._isMobile;
              },
            },
            {
              key: "isIOS",
              value: function () {
                return this._isIOS;
              },
            },
            {
              key: "isBrowser",
              value: function (e) {
                switch (e) {
                  case "Firefox":
                    return this._isFirefox;
                  case "Chrome":
                    return this._isChrome;
                  case "Safari":
                    return this._isSafari;
                  case "Edge":
                    return this._isEdge;
                  case "IE":
                    return this._isIE;
                  case "Microsoft":
                    return this._isIE || this._isEdge;
                  default:
                    return this.logger.debug("Unknown browser name", e), null;
                }
              },
            },
            {
              key: "logData",
              value: function () {
                this.logger.debug(
                  "Firefox - "
                    .concat(this._isFirefox, ", Chrome - ")
                    .concat(this._isChrome, ", Safari - ")
                    .concat(this._isSafari, ", IE - ")
                    .concat(this._isIE, ", Edge - ")
                    .concat(this._isEdge, ", Mobile - ")
                    .concat(this._isMobile, ", iOS - ")
                    .concat(this._isIOS, ", iPadOS - ")
                    .concat(this._iPadOS13)
                );
              },
            },
            {
              key: "_isIOS13",
              value: function (e) {
                return (
                  this.nav &&
                  this.nav.platform &&
                  (-1 !== this.nav.platform.indexOf(e) ||
                    ("MacIntel" === this.nav.platform &&
                      this.nav.maxTouchPoints > 1 &&
                      !window.MSStream))
                );
              },
            },
          ]) && r(t.prototype, i),
          e
        );
      })();
    t.default = a;
  },
  function (e, t, i) {
    "use strict";

    function r(e, t) {
      for (var i = 0; i < t.length; i++) {
        var r = t[i];
        (r.enumerable = r.enumerable || !1),
          (r.configurable = !0),
          "value" in r && (r.writable = !0),
          Object.defineProperty(e, r.key, r);
      }
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.default = void 0),
      i(90),
      i(23),
      i(0);
    var n,
      s = (n = i(10)) && n.__esModule ? n : { default: n },
      a = function (e) {
        var t = s.default.create(e, "Prober"),
          i = (function () {
            function e(i, r, n, s, a) {
              !(function (e, t) {
                if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function");
              })(this, e),
                (this.enabled = !1),
                (this.period = s),
                (this.stream = r),
                (this.timescale = n),
                (this.streamId = parseInt("F0", 16) + (i % 16)),
                (this.metricsManager = a),
                this.metricsManager.add(this.streamId, "probe", n),
                t.debug(
                  "constructor: " + r + ", timescale: " + n + ", period: " + s
                );
            }
            var i, n;
            return (
              (i = e),
              (n = [
                {
                  key: "destroy",
                  value: function () {
                    this.metricsManager.remove(this.streamId),
                      this._clearBufCheckInterval();
                  },
                },
                {
                  key: "id",
                  value: function () {
                    return this.streamId;
                  },
                },
                {
                  key: "streamName",
                  value: function () {
                    return this.stream;
                  },
                },
                {
                  key: "start",
                  value: function () {
                    (this.enabled = !0),
                      (this.durations = []),
                      (this.firstTimestamp = void 0),
                      (this.lastTimestamp = void 0),
                      (this.expectedEndTimestamp = void 0),
                      this.startProbeCallback(this, this.period + 1);
                  },
                },
                {
                  key: "isEnabled",
                  value: function () {
                    return this.enabled;
                  },
                },
                {
                  key: "stop",
                  value: function () {
                    this.isEnabled() &&
                      ((this.enabled = !1),
                      this.cancelProbeCallback(this),
                      this.metricsManager.stop(this.streamId),
                      this._clearBufCheckInterval());
                  },
                },
                {
                  key: "receiveInit",
                  value: function () {
                    if (
                      !this.bufCheckInterval &&
                      ((this.initTime = performance.now()),
                      this.initReceivedCallback(),
                      this.period >= 1e3)
                    ) {
                      var e = this;
                      this.bufCheckInterval = setInterval(function () {
                        e.firstTimestamp
                          ? (e.lastTimestamp - e.firstTimestamp) / e.timescale -
                              (performance.now() - e.initTime) / 1e3 <=
                              0 && e.metricsManager.reportLowBuffer(e.streamId)
                          : e.metricsManager.reportLowBuffer(e.streamId);
                      }, 500);
                    }
                  },
                },
                {
                  key: "receiveFrame",
                  value: function (e, i, r) {
                    void 0 === this.firstTimestamp
                      ? (t.debug("receiveFrame: firstTimestamp " + r),
                        (this.firstTimestamp = r),
                        (this.expectedEndTimestamp =
                          (this.period * this.timescale) / 1e3 + r))
                      : this.durations.push(r - this.lastTimestamp),
                      (this.lastTimestamp = r);
                    var n = this._findDuration();
                    this.metricsManager.setRateAdditive(this.streamId, n),
                      r + n > this.expectedEndTimestamp &&
                        (t.debug("receiveFrame: lastTimestamp " + r),
                        (r - this.firstTimestamp) / this.timescale -
                          (performance.now() - this.initTime) / 1e3 <=
                          0 &&
                          this.metricsManager.reportLowBuffer(this.streamId),
                        this.stop(),
                        this.probeFinishedCallback());
                  },
                },
                {
                  key: "_findDuration",
                  value: function () {
                    var e = 0,
                      t = 0,
                      i = {};
                    for (t = 0; t < this.durations.length; t++) {
                      var r = this.durations[t];
                      i[r] = i[r] > 0 ? i[r] + 1 : 1;
                    }
                    var n = 0;
                    for (t in i)
                      if (i[t] > n) {
                        var s = parseInt(t);
                        s > 0 && ((e = s), (n = i[t]));
                      }
                    return e;
                  },
                },
                {
                  key: "_clearBufCheckInterval",
                  value: function () {
                    this.bufCheckInterval &&
                      (clearInterval(this.bufCheckInterval),
                      (this.bufCheckInterval = void 0));
                  },
                },
                {
                  key: "callbacks",
                  set: function (e) {
                    (this.startProbeCallback = e.onStartProbe),
                      (this.cancelProbeCallback = e.onCancelProbe),
                      (this.initReceivedCallback = e.onInitReceived),
                      (this.probeFinishedCallback = e.onProbeFinished);
                  },
                },
              ]) && r(i.prototype, n),
              e
            );
          })();
        return {
          create: function (e, t, r, n, s) {
            return new i(e, t, r, n, s);
          },
        };
      };
    t.default = a;
  },
  function (e, t, i) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : { default: e };
    }

    function n(e, t) {
      for (var i = 0; i < t.length; i++) {
        var r = t[i];
        (r.enumerable = r.enumerable || !1),
          (r.configurable = !0),
          "value" in r && (r.writable = !0),
          Object.defineProperty(e, r.key, r);
      }
    }

    function s(e, t, i) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: i,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = i),
        e
      );
    }

    function a(e) {
      var t = e.getBoundingClientRect();
      return {
        top: t.top + pageYOffset,
        left: t.left + pageXOffset,
        right: t.right + pageXOffset,
      };
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.default = void 0),
      i(89),
      i(23),
      i(68),
      i(90),
      i(70),
      i(111),
      i(0);
    var o = r(i(161)),
      u = r(i(171)),
      c = r(i(10)),
      l = (function () {
        function e(t, i) {
          if (
            ((function (e, t) {
              if (!(e instanceof t))
                throw new TypeError("Cannot call a class as a function");
            })(this, e),
            s(
              this,
              "_handleClicks",
              function (e) {
                if (this.doubleClickHandler) {
                  this.clicks++;
                  var t = this;
                  1 == this.clicks &&
                    setTimeout(function () {
                      1 == t.clicks
                        ? t.singleClickHandler && t.singleClickHandler(e)
                        : t.doubleClickHandler && t.doubleClickHandler(e),
                        (t.clicks = 0);
                    }, 300);
                } else this.singleClickHandler && this.singleClickHandler(e);
              }.bind(this)
            ),
            s(
              this,
              "_handleEnterPip",
              function (e) {
                e.pictureInPictureWindow,
                  (this.pipMode = !0),
                  this._onEnterPip && this._onEnterPip();
              }.bind(this)
            ),
            s(
              this,
              "_handleLeavePip",
              function (e) {
                (this.pipMode = !1), this._onLeavePip && this._onLeavePip();
              }.bind(this)
            ),
            s(
              this,
              "_videoElementClick",
              function (e) {
                var t = !1;
                this.mobile_ctrl
                  ? (e.target != this.mobile_ctrl &&
                      e.target != this.mobile_ctrl_btn) ||
                    (this.mobile_ctrl_visible
                      ? (t = !0)
                      : this._showControlsForPeriod(4))
                  : e.target == this.video_element && (t = !0),
                  t && this._playPauseBtnClick(e);
              }.bind(this)
            ),
            s(
              this,
              "_playPauseBtnClick",
              function (e) {
                this._isUserActionAcceptable() &&
                  (this.play_pause_button.classList.contains("sldp-icon-play")
                    ? (this.video_element &&
                        this.hackPlayByPauseOnClick &&
                        (this.video_element.pause(),
                        (this.hackPlayByPauseOnClick = !1)),
                      this._handlePlay(!0))
                    : this._handlePause()),
                  e.stopPropagation();
              }.bind(this)
            ),
            s(
              this,
              "_handlePlayEvent",
              function (e) {
                this.deactivated ||
                  (this.pipMode
                    ? this._handlePlay()
                    : this._onPlayEventCallback && this._onPlayEventCallback());
              }.bind(this)
            ),
            s(
              this,
              "_handlePauseEvent",
              function (e) {
                this.deactivated ||
                  (this.pipMode
                    ? this._handlePause()
                    : this._onPauseEventCallback &&
                      this._onPauseEventCallback());
              }.bind(this)
            ),
            s(
              this,
              "_configBtnClick",
              function (e) {
                this.cfg_dialog
                  ? (this.cfg_dialog.remove(),
                    delete this.cfg_dialog,
                    this._showControlsForPeriod(2))
                  : ((this.cfg_dialog = document.createElement("ul")),
                    (this.cfg_dialog.className = "sldp_cfg_dialog"),
                    this._updateCfgDialog(),
                    this.player_wrapper.insertBefore(
                      this.cfg_dialog,
                      this.control_bar
                    ),
                    this._showControlsForPeriod("infinite")),
                  e.stopPropagation();
              }.bind(this)
            ),
            s(
              this,
              "_volumeBtnClick",
              function (e) {
                var t = 0;
                e.currentTarget.classList.contains("sldp-icon-volume-medium")
                  ? (this.video_element.prev_volume =
                      this.volumeController.volume)
                  : (void 0 == this.video_element.prev_volume &&
                      (0 != this.volumeController.volume
                        ? (this.video_element.prev_volume =
                            this.volumeController.volume)
                        : (this.video_element.prev_volume = 1)),
                    (t = 100 * this.video_element.prev_volume)),
                  this._adjustVolume(t),
                  this._showControlsForPeriod(2),
                  e.stopPropagation();
              }.bind(this)
            ),
            s(
              this,
              "_expandBtnClick",
              function (e) {
                var t = this.player_wrapper;
                this._isFullscreenMode()
                  ? document.cancelFullScreen
                    ? document.cancelFullScreen()
                    : document.mozCancelFullScreen
                    ? document.mozCancelFullScreen()
                    : document.webkitCancelFullScreen
                    ? document.webkitCancelFullScreen()
                    : document.msExitFullscreen && document.msExitFullscreen()
                  : t.requestFullscreen
                  ? t.requestFullscreen()
                  : t.mozRequestFullScreen
                  ? t.mozRequestFullScreen()
                  : t.webkitRequestFullscreen
                  ? t.webkitRequestFullscreen()
                  : t.msRequestFullscreen && t.msRequestFullscreen(),
                  e && e.stopPropagation();
              }.bind(this)
            ),
            s(
              this,
              "_orientationchangeHandler",
              function (e) {
                this._isFullscreenMode() && this._updateDimensions();
              }.bind(this)
            ),
            s(
              this,
              "_fullscreenchangeHandler",
              function (e) {
                this._isFullscreenMode()
                  ? (this._stashCurrentSize(), this._updateDimensions())
                  : (this._applyCurrentSize(), this._resizeHandler());
              }.bind(this)
            ),
            s(
              this,
              "_resizeHandler",
              function (e) {
                this._onResize && this._onResize(),
                  this._updateLoadingIndicator();
              }.bind(this)
            ),
            (this.settings = t),
            (this.logger = c.default.create(i, "UI")),
            (this.settings.video_element = void 0),
            (this.settings.ar = void 0),
            (this.pipMode = !1),
            (this.can_play = this.settings.autoplay),
            (this.hackPlayByPauseOnClick = !this.settings.autoplay),
            this.settings.video_element)
          )
            (this.video_element = document.getElementById(
              this.settings.video_element
            )),
              (this.storageId = this.settings.video_element),
              (this.quality_ar = []),
              (this.settings.controls = !1),
              (this.volumeController = new u.default(
                this.video_element,
                this.settings.vu_meter
              )),
              (this.volumeController.muted = !!this.settings.muted),
              this._createResizeHandler(),
              this._createPipHandlers(),
              this._createPlayPauseHandlers();
          else if (
            ((this.container = document.getElementById(
              this.settings.container
            )),
            (this.storageId = this.settings.container),
            this.container)
          ) {
            (this.quality_ar = []),
              (this.css = new o.default()),
              this._create_player_wrapper();
            var r = this.settings.audio_only ? "audio" : "video";
            (this.video_element = document.createElement(r)),
              (this.volumeController = new u.default(
                this.video_element,
                this.settings.vu_meter
              )),
              (this.volumeController.muted = !!this.settings.muted),
              this._setSplashScreen(),
              this.settings.audio_only ||
                (void 0 != this.settings.height &&
                  ((this.video_element.style.height = "100%"),
                  "number" == typeof this.settings.height
                    ? (this.player_wrapper.style.height = "".concat(
                        t.height,
                        "px"
                      ))
                    : (this.player_wrapper.style.height =
                        this.settings.height))),
              void 0 !== this.settings.width &&
                ((this.video_element.style.width = "100%"),
                "number" == typeof this.settings.width
                  ? (this.player_wrapper.style.width = "".concat(t.width, "px"))
                  : (this.player_wrapper.style.width = this.settings.width)),
              this.player_wrapper.appendChild(this.video_element),
              this._createHandlers(),
              this.settings.controls &&
                (this._create_controls(),
                this.settings.audio_only &&
                  this.settings.audio_title &&
                  this._addMessage(this.settings.audio_title),
                this._createLoadingIndicator()),
              this.settings.fullscreen &&
                !this.settings.audio_only &&
                this._expandBtnClick();
          }
          this._nullifyContainerLineHeight();
        }
        var t, i;
        return (
          (t = e),
          (i = [
            {
              key: "removePip",
              value: function (e) {
                var t = this;
                this.pipMode
                  ? ((this.deactivated = !0),
                    document.exitPictureInPicture().then(function () {
                      (t.pipMode = !1), e();
                    }))
                  : e();
              },
            },
            {
              key: "destroy",
              value: function () {
                if ((this._revertContainerLineHeight(), this.container)) {
                  for (this._removeHandlers(); this.container.firstChild; )
                    this.container.removeChild(this.container.firstChild);
                  (this.play_pause_button = void 0),
                    (this.player_wrapper = void 0),
                    (this.mobile_ctrl_btn = void 0),
                    (this.mobile_ctrl = void 0),
                    this.css.destroy();
                } else
                  this._removeResizeHandler(),
                    this._removePipHandlers(),
                    (this.video_element = void 0);
                this.volumeController.destroy(),
                  (this.volumeController = void 0),
                  (this.quality_ar = []),
                  (this.stashed = !1);
              },
            },
            {
              key: "showNotSupported",
              value: function (e) {
                if (
                  (this._removeSplashScreen(),
                  this.container
                    ? (this._removeHandlers(),
                      this.settings.controls &&
                        (this._removePlayerControls(),
                        this.mobile_ctrl &&
                          ((this.mobile_ctrl.style.opacity = "0"),
                          (this.mobile_ctrl_visible = !1))))
                    : (this._removeResizeHandler(), this._removePipHandlers()),
                  e)
                ) {
                  this.settings.video_element ||
                    (this.video_element.style.display = "none"),
                    this._addMessage(
                      "In order to play this media you will need an application from App Store",
                      '<a href="' +
                        this.settings.ios_failback_app_url +
                        '" style="vertical-align: middle;display:inline-block;overflow:hidden;background:url(http://linkmaker.itunes.apple.com/images/badges/en-us/badge_appstore-lrg.svg) no-repeat;width:202px;height:60px;background-size: 202px 60px;margin-right: 10px;"></a>'
                    );
                  var t = this.settings.stream_url;
                  if (t && t.length > 0) {
                    var i = t.substring(0, 5),
                      r = t.indexOf("?") > 0;
                    "ws://" == i
                      ? (t =
                          this.settings.ios_failback_scheme +
                          "://" +
                          t.substring(5))
                      : "wss:/" == i &&
                        (t =
                          this.settings.ios_failback_secure_scheme +
                          "://" +
                          t.substring(6)),
                      this.settings.sync_buffer > 0 &&
                        (t +=
                          (r ? "&" : "?") +
                          "steady=true&buffering=" +
                          this.settings.sync_buffer),
                      (window.location = t);
                  }
                } else
                  this._addMessage(
                    "MediaSource is not supported in current browser"
                  );
              },
            },
            {
              key: "showNotPlaying",
              value: function () {
                this._removeSplashScreen(),
                  this.settings.controls && this._togglePlayButton(!0),
                  this._addMessage("No playable sources found"),
                  this._showControlsForPeriod("infinite");
              },
            },
            {
              key: "clearVideoElement",
              value: function () {
                this.settings.audio_only ||
                  (this._finishLoadingIndicator(),
                  this._removeSplashScreen(),
                  this._removeMessage());
              },
            },
            {
              key: "videoElement",
              get: function () {
                return this.video_element;
              },
            },
            {
              key: "onPlaybackStarted",
              value: function () {
                this._removeSplashScreen();
              },
            },
            {
              key: "onPlaybackFinished",
              value: function () {
                this._setSplashScreen();
              },
            },
            {
              key: "adjustHeight",
              value: function () {
                this.video_element &&
                  this.player_wrapper &&
                  "100%" === this.settings.height &&
                  !this._isFullscreenMode() &&
                  this.container.offsetHeight > 0 &&
                  (this.player_wrapper.style.height = "".concat(
                    this.container.offsetHeight,
                    "px"
                  ));
              },
            },
            { key: "adjustX", value: function (e, t, i, r) {} },
            { key: "adjustY", value: function (e, t, i) {} },
            {
              key: "refresh",
              value: function () {
                if (this.cfg_dialog) {
                  for (; this.cfg_dialog.firstChild; )
                    this.cfg_dialog.removeChild(this.cfg_dialog.firstChild);
                  this._updateCfgDialog();
                }
              },
            },
            {
              key: "triggerPlay",
              value: function () {
                return this._handlePlay();
              },
            },
            {
              key: "triggerPause",
              value: function (e) {
                this._handlePause(e);
              },
            },
            {
              key: "triggerVolume",
              value: function (e) {
                this.volumeController &&
                  (e > 100 ? (e = 100) : e < 0 && (e = 0),
                  this._adjustVolume(e));
              },
            },
            {
              key: "getVolume",
              value: function () {
                if (this.volumeController)
                  return 100 * this.volumeController.volume;
              },
            },
            {
              key: "setMuted",
              value: function () {
                this.volumeController &&
                  ((this.volumeController.muted = !0),
                  this._adjustVolume(100 * this.volumeController.volume, !0));
              },
            },
            {
              key: "setVUMeterHandler",
              value: function (e) {
                this.volumeController && this.volumeController.setVUMeter(e);
              },
            },
            {
              key: "unmuteVUMeter",
              value: function () {
                this.volumeController &&
                  this.volumeController.activateVUMeter();
              },
            },
            {
              key: "_nullifyContainerLineHeight",
              value: function () {
                if (!this.settings.audio_only) {
                  var e = this.settings.video_element
                    ? this.video_element.parentElement
                    : this.container;
                  e &&
                    ((this.prevParentLineHeight = e.style.lineHeight),
                    (e.style.lineHeight = 0));
                }
              },
            },
            {
              key: "_revertContainerLineHeight",
              value: function () {
                if (!this.settings.audio_only) {
                  var e = this.settings.video_element
                    ? this.video_element.parentElement
                    : this.container;
                  e && (e.style.lineHeight = this.prevParentLineHeight || "");
                }
              },
            },
            {
              key: "_getContainerWidth",
              value: function () {
                return this.container
                  ? this.container.offsetWidth
                  : this.video_element.parentElement.offsetWidth;
              },
            },
            {
              key: "_getContainerHeight",
              value: function () {
                return this.container
                  ? this.container.offsetHeight
                  : this.video_element.parentElement.offsetHeight;
              },
            },
            {
              key: "_stashCurrentSize",
              value: function () {
                this.stashed ||
                  ((this.video_element.pw_width_prev =
                    this.player_wrapper.style.width),
                  (this.video_element.pw_height_prev =
                    this.player_wrapper.style.height),
                  (this.video_element.v_width_prev =
                    this.video_element.style.width),
                  (this.video_element.v_height_prev =
                    this.video_element.style.height),
                  this.settings.ar ||
                    ((this.video_element.v_margin_prev =
                      this.video_element.style.margin),
                    (this.video_element.style.margin = "")),
                  (this.stashed = !0));
              },
            },
            {
              key: "_applyCurrentSize",
              value: function () {
                this.stashed &&
                  ((this.video_element.style.width =
                    this.video_element.v_width_prev),
                  (this.video_element.style.height =
                    this.video_element.v_height_prev),
                  (this.player_wrapper.style.width =
                    this.video_element.pw_width_prev),
                  (this.player_wrapper.style.height =
                    this.video_element.pw_height_prev),
                  this.settings.ar ||
                    (this.video_element.style.margin =
                      this.video_element.v_margin_prev),
                  (this.stashedContWidth = this.currentContWidth),
                  (this.stashedContHeight = this.currentContHeight),
                  (this.stashed = !1));
              },
            },
            {
              key: "_processContainerSize",
              value: function () {
                if (
                  ((this.cW = this.settings.width),
                  (this.cH = this.settings.height),
                  this._isFullscreenMode())
                )
                  (this.cW = screen.width),
                    (this.cH = screen.height),
                    this._stashCurrentSize();
                else {
                  if (this.stashed) return !1;
                  "100%" === this.settings.width &&
                    (this.stashedContWidth
                      ? ((this.cW = this.stashedContWidth),
                        (this.stashedContWidth = void 0))
                      : ((this.cW = this._getContainerWidth()),
                        this.cW ||
                          (this.cW = this.player_wrapper
                            ? this.player_wrapper.offsetWidth
                            : this.video_element.offsetWidth),
                        (this.currentContWidth = this.cW))),
                    "100%" === this.settings.height &&
                      (this.stashedContHeight
                        ? ((this.cH = this.stashedContHeight),
                          (this.stashedContHeight = void 0))
                        : ((this.cH = this._getContainerHeight()),
                          this.cH ||
                            (this.cH = this.player_wrapper
                              ? this.player_wrapper.offsetHeight
                              : this.video_element.offsetHeight),
                          (this.currentContHeight = this.cH))),
                    this.settings.width ||
                      this.settings.height ||
                      (this.cW = this.video_element.offsetWidth);
                }
                return !0;
              },
            },
            {
              key: "_create_player_wrapper",
              value: function () {
                var e = document.createElement("div");
                if (
                  ((e.className = this.settings.audio_only
                    ? "sldp_player_wrp sldp_player_wrp_audio"
                    : "sldp_player_wrp sldp_player_wrp_video"),
                  this.settings.controls && !this.settings.audio_only)
                ) {
                  if (
                    (this.settings.autoplay && this._hideControlsAfterPeriod(2),
                    this.settings.mobile)
                  ) {
                    (this.mobile_ctrl = document.createElement("div")),
                      (this.mobile_ctrl.className = "sldp_mobile_ctrl"),
                      (this.mobile_ctrl_btn = document.createElement("div"));
                    var t = this.settings.autoplay
                      ? "sldp-icon-pause-o"
                      : "sldp-icon-play-o";
                    (this.mobile_ctrl_btn.className =
                      "sldp_mobile_ctrl_icon " + t),
                      this.mobile_ctrl.appendChild(this.mobile_ctrl_btn),
                      (this.mobile_ctrl_visible = !0),
                      e.appendChild(this.mobile_ctrl);
                  }
                  (e.onmousemove = function (e) {
                    this.mobile_ctrl ||
                      this.settings.audio_only ||
                      ((this.mouseClientX = e.clientX),
                      (this.mouseClientY = e.clientY),
                      this._showControlsForPeriod(2));
                  }.bind(this)),
                    (e.onmouseout = function () {
                      this.mobile_ctrl ||
                        this.settings.audio_only ||
                        ((this.mouseClientX = this.mouseClientY = void 0),
                        this._hideControls());
                    }.bind(this));
                }
                this.container.appendChild(e), (this.player_wrapper = e);
              },
            },
            {
              key: "_hideControls",
              value: function () {
                if (
                  this.control_bar &&
                  !this.settings.audio_only &&
                  this.play_pause_button &&
                  this.play_pause_button.classList.contains("sldp-icon-pause")
                ) {
                  var e = !1;
                  if (
                    !this.mobile_ctrl &&
                    void 0 !== this.mouseClientX &&
                    void 0 !== this.mouseClientY
                  ) {
                    var t = this.control_bar.getBoundingClientRect();
                    t.left < this.mouseClientX &&
                      this.mouseClientX < t.right &&
                      t.top < this.mouseClientY &&
                      this.mouseClientY < t.bottom &&
                      (e = !0);
                  }
                  e
                    ? this._hideControlsAfterPeriod(4)
                    : this.cfg_dialog ||
                      ((this.control_bar.style.opacity = "0"),
                      this.mobile_ctrl &&
                        ((this.mobile_ctrl.style.opacity = "0"),
                        (this.mobile_ctrl_visible = !1)));
                }
              },
            },
            {
              key: "_hideControlsAfterPeriod",
              value: function (e) {
                this.settings.controls &&
                  (this.control_hide_delay &&
                    (clearTimeout(this.control_hide_delay),
                    (this.control_hide_delay = void 0)),
                  this.settings.audio_only ||
                    (this.control_hide_delay = setTimeout(
                      function () {
                        this._hideControls();
                      }.bind(this),
                      1e3 * e
                    )));
              },
            },
            {
              key: "_showControls",
              value: function () {
                this.control_bar &&
                  ((this.control_bar.style.opacity = "1"),
                  this.mobile_ctrl &&
                    ((this.mobile_ctrl.style.opacity = "1"),
                    (this.mobile_ctrl_visible = !0)));
              },
            },
            {
              key: "_showControlsForPeriod",
              value: function (e) {
                this.settings.controls &&
                  (this._showControls(),
                  this.control_hide_delay &&
                    (clearTimeout(this.control_hide_delay),
                    (this.control_hide_delay = void 0)),
                  "infinite" === e ||
                    this.settings.audio_only ||
                    (this.control_hide_delay = setTimeout(
                      function () {
                        this._hideControls();
                      }.bind(this),
                      1e3 * e
                    )));
              },
            },
            {
              key: "_addMessage",
              value: function (e, t) {
                if (this.container) {
                  this._removeMessage();
                  var i = document.createElement("div");
                  i.className = "sldp_message_wrp";
                  var r = document.createElement("div");
                  if (
                    (this.settings.audio_only
                      ? ((i.className = this.settings.controls
                          ? "sldp_message_wrp"
                          : "sldp_message_wrp sldp_message_wrp_audio_noctrl"),
                        (r.className = "sldp_message"))
                      : ((i.className =
                          "sldp_message_wrp sldp_message_wrp_video"),
                        (r.className = "sldp_message sldp_message_pad")),
                    (r.innerHTML = e),
                    t)
                  ) {
                    var n = document.createElement("div");
                    (n.className = "ios_button"),
                      (n.innerHTML = t),
                      r.appendChild(n);
                  }
                  i.appendChild(r), this.player_wrapper.appendChild(i);
                }
              },
            },
            {
              key: "_removeMessage",
              value: function () {
                if (this.container) {
                  var e =
                    this.player_wrapper.getElementsByClassName(
                      "sldp_message_wrp"
                    )[0];
                  e && this.player_wrapper.removeChild(e);
                }
              },
            },
            {
              key: "_create_controls",
              value: function () {
                var e = document.createElement("div");
                if (
                  ((e.className = this.settings.audio_only
                    ? "sldp_cbar sldp_cbar_audio"
                    : "sldp_cbar sldp_cbar_video"),
                  !this.settings.audio_only)
                ) {
                  var t = document.createElement("div");
                  (t.className = "sldp_expand_btn"),
                    t.classList.add("sldp_btn"),
                    t.classList.add("sldp-icon-enlarge"),
                    (t.onclick = this._expandBtnClick),
                    e.appendChild(t),
                    (this.expand_button = t);
                  var i = document.createElement("div");
                  (i.className = "sldp_config_btn"),
                    i.classList.add("sldp_btn"),
                    i.classList.add("sldp-icon-cog"),
                    (i.onclick = this._configBtnClick),
                    e.appendChild(i),
                    (this.config_button = i);
                }
                var r = document.createElement("div");
                (r.className = "sldp_play_pause_btn"),
                  r.classList.add("sldp_btn"),
                  r.classList.add(
                    this.settings.autoplay
                      ? "sldp-icon-pause"
                      : "sldp-icon-play"
                  ),
                  (r.onclick = this._playPauseBtnClick),
                  e.appendChild(r);
                var n = document.createElement("div");
                (n.className =
                  "sldp_volume_wrp " +
                  (this.settings.mobile
                    ? "sldp_volume_mobile"
                    : "sldp_volume_desktop")),
                  this.settings.mobile ||
                    this.settings.audio_only ||
                    ((n.onmouseover = function (e) {
                      this.volume_slider &&
                        (this.volume_slider.style.display = "block");
                    }.bind(this)),
                    (n.onmouseout = function (e) {
                      this.volume_slider &&
                        (this.volume_slider.style.display = "none");
                    }.bind(this))),
                  e.appendChild(n);
                var s = document.createElement("div");
                (s.className = "sldp_volume_btn"),
                  s.classList.add("sldp_btn"),
                  s.classList.add("sldp-icon-volume-medium"),
                  (s.onclick = this._volumeBtnClick),
                  n.appendChild(s),
                  this.player_wrapper.appendChild(e),
                  (this.volume_button = s),
                  (this.volume_wrapper = n),
                  (this.play_pause_button = r),
                  (this.control_bar = e),
                  this.settings.mobile || this._create_volume_slider(),
                  this._setStoredVolume();
              },
            },
            {
              key: "_create_volume_slider",
              value: function () {
                var e = document.createElement("div");
                e.className = "sldp_volume_slider_wrp";
                var t = document.createElement("div");
                (t.className = "sldp_volume_slider"),
                  (this.thumb = document.createElement("div")),
                  (this.thumb.className = "sldp_volume_thumb"),
                  t.appendChild(this.thumb),
                  e.appendChild(t),
                  (e.onmousedown = function (e) {
                    this.video_element.prev_volume =
                      this.volumeController.volume;
                    var i = a(t),
                      r = a(this.thumb),
                      n = e.pageX - (r.right - r.left) / 2 - i.left;
                    n < 0 ? (n = 0) : n > 100 && (n = 100),
                      this._adjustVolume(n),
                      e.stopPropagation();
                  }.bind(this)),
                  (this.thumb.onmousedown = function (e) {
                    this.video_element.prev_volume =
                      this.volumeController.volume;
                    var i = a(this.thumb),
                      r = e.pageX - i.left,
                      n = a(t);
                    return (
                      (document.onmousemove = function (e) {
                        var i = e.pageX - r - n.left;
                        i < 0 ? (i = 0) : i > 100 && (i = 100);
                        var s = t.offsetWidth - this.thumb.offsetWidth;
                        0 == s && (s = 100),
                          i > s && (i = s),
                          this._adjustVolume(i);
                      }.bind(this)),
                      (document.onmouseup = function (e) {
                        document.onmousemove = document.onmouseup = null;
                      }),
                      e.stopPropagation(),
                      !1
                    );
                  }.bind(this)),
                  (this.thumb.ondragstart = function () {
                    return !1;
                  }),
                  this.volume_wrapper.appendChild(e),
                  (this.volume_slider = t),
                  this.settings.audio_only ||
                    (this.volume_slider.style.display = "none");
              },
            },
            {
              key: "_setStoredVolume",
              value: function () {
                var e = 100;
                if ("localStorage" in window) {
                  try {
                    e = parseInt(
                      window.localStorage.getItem(
                        "sldp_player_volume_" + this.storageId
                      )
                    );
                  } catch (e) {
                    this.logger.warn(
                      "Error getting last volume from local storage",
                      e
                    );
                  }
                  isNaN(e) && (e = 100);
                }
                this._adjustVolume(e, !0);
              },
            },
            {
              key: "_adjustVolume",
              value: function (e, t) {
                this.thumb &&
                  (t && this.volumeController.muted
                    ? (this.thumb.style.left = "0px")
                    : (this.thumb.style.left = e + "px"));
                var i = e / 100;
                if (
                  (this.volumeController.volume !== i &&
                    ((this.volumeController.volume = i),
                    !t && this._onVolumeSet && this._onVolumeSet(e)),
                  0 == e || (t && this.volumeController.muted)
                    ? ((this.volumeController.muted = !0),
                      this.volume_button &&
                        (this.volume_button.classList.remove(
                          "sldp-icon-volume-medium"
                        ),
                        this.volume_button.classList.add(
                          "sldp-icon-volume-mute"
                        )))
                    : ((this.volumeController.muted = !1),
                      this.volume_button &&
                        (this.volume_button.classList.remove(
                          "sldp-icon-volume-mute"
                        ),
                        this.volume_button.classList.add(
                          "sldp-icon-volume-medium"
                        ))),
                  this.settings.controls && "localStorage" in window)
                )
                  try {
                    window.localStorage.setItem(
                      "sldp_player_volume_" + this.storageId,
                      e
                    );
                  } catch (e) {
                    this.logger.warn(
                      "Error setting current volume to localStorage",
                      e
                    );
                  }
              },
            },
            {
              key: "_setSplashScreen",
              value: function () {
                this.container &&
                  this.settings.splash_screen &&
                  ((this.video_element.style["background-image"] =
                    "url('".concat(this.settings.splash_screen, "')")),
                  (this.video_element.style["background-size"] = "cover"));
              },
            },
            {
              key: "_removeSplashScreen",
              value: function () {
                this.container &&
                  this.settings.splash_screen &&
                  ((this.video_element.style["background-image"] = ""),
                  (this.video_element.style["background-size"] = ""),
                  (this.video_element.style.background = "#000"));
              },
            },
            {
              key: "_removePlayerControls",
              value: function () {
                var e =
                  this.player_wrapper.getElementsByClassName("sldp_cbar")[0];
                e && this.player_wrapper.removeChild(e);
                var t =
                  this.player_wrapper.getElementsByClassName(
                    "sldp_indicator"
                  )[0];
                t && this.player_wrapper.removeChild(t);
              },
            },
            {
              key: "_handlePlay",
              value: function (e) {
                var t = !1;
                return (
                  this.can_play &&
                    (this.settings.audio_only && this.settings.audio_title
                      ? this._addMessage(this.settings.audio_title)
                      : this._removeMessage(),
                    this._togglePlayButton(!1),
                    this._onPlayCallback &&
                      (this._onPlayCallback(e),
                      this._showControlsForPeriod(0.5),
                      (t = !0))),
                  t
                );
              },
            },
            {
              key: "_handlePause",
              value: function (e) {
                this._togglePlayButton(!0),
                  !e && this._onPauseCallback && this._onPauseCallback(),
                  this._showControlsForPeriod("infinite");
              },
            },
            {
              key: "_togglePlayClass",
              value: function (e, t, i, r) {
                if (e) {
                  var n = t ? r : i,
                    s = t ? i : r;
                  e.classList.remove(n), e.classList.add(s);
                }
              },
            },
            {
              key: "_togglePlayButton",
              value: function (e) {
                this._togglePlayClass(
                  this.play_pause_button,
                  e,
                  "sldp-icon-play",
                  "sldp-icon-pause"
                ),
                  this._togglePlayClass(
                    this.mobile_ctrl_btn,
                    e,
                    "sldp-icon-play-o",
                    "sldp-icon-pause-o"
                  );
              },
            },
            {
              key: "_updateCfgDialog",
              value: function () {
                for (var e = this, t = 0; t < this.quality_ar.length; t++)
                  !(function (t) {
                    var i = e.quality_ar[t].name,
                      r = e.quality_ar[t].idx,
                      n = document.createElement("li");
                    i == e.cur_quality.name &&
                      r == e.cur_quality.idx &&
                      (i = "&#10003 " + i),
                      (n.innerHTML = i),
                      (n.onclick = function (e) {
                        this._onQualityChangeCallback &&
                          (this._onQualityChangeCallback(i, r),
                          this.cfg_dialog.remove(),
                          delete this.cfg_dialog,
                          this._hideControlsAfterPeriod(0.5)),
                          e.stopPropagation();
                      }.bind(e)),
                      e.cfg_dialog.appendChild(n);
                  })(t);
              },
            },
            {
              key: "_isFullscreenMode",
              value: function () {
                return (
                  document.fullscreenElement ||
                  document.mozFullScreenElement ||
                  document.webkitFullscreenElement ||
                  document.msFullscreenElement
                );
              },
            },
            {
              key: "_updateDimensions",
              value: function () {
                (this.video_element.style.width = screen.width),
                  (this.video_element.style.height = screen.height),
                  (this.player_wrapper.style.width = "".concat(
                    screen.width,
                    "px"
                  )),
                  (this.player_wrapper.style.height = "".concat(
                    screen.height,
                    "px"
                  )),
                  this._resizeHandler();
              },
            },
            {
              key: "_createHandlers",
              value: function () {
                (this.clicks = 0),
                  (this.singleClickHandler = this.settings.controls
                    ? this._videoElementClick
                    : void 0),
                  (this.doubleClickHandler = void 0),
                  this.settings.audio_only ||
                    (this.settings.mobile ||
                      (this.doubleClickHandler = this._expandBtnClick),
                    this._createFullscreenHandler(),
                    this._createResizeHandler(),
                    this._createPipHandlers(),
                    this._createOrientationChangeHandler()),
                  this._createClicksHandler(),
                  this._createPlayPauseHandlers();
              },
            },
            {
              key: "_removeHandlers",
              value: function () {
                this.settings.audio_only ||
                  (this._removeFullscreenHandler(),
                  this._removeResizeHandler(),
                  this._removePipHandlers(),
                  this._removeOrientationChangeHandler()),
                  (this.singleClickHandler = void 0),
                  (this.doubleClickHandler = void 0),
                  this._removeClicksHandler();
              },
            },
            {
              key: "_createClicksHandler",
              value: function () {
                this.player_wrapper.addEventListener(
                  "click",
                  this._handleClicks,
                  !1
                );
              },
            },
            {
              key: "_removeClicksHandler",
              value: function () {
                this.player_wrapper.removeEventListener(
                  "click",
                  this._handleClicks
                );
              },
            },
            {
              key: "_createPlayPauseHandlers",
              value: function () {
                this.video_element.addEventListener(
                  "play",
                  this._handlePlayEvent,
                  !1
                ),
                  this.video_element.addEventListener(
                    "pause",
                    this._handlePauseEvent,
                    !1
                  );
              },
            },
            {
              key: "_removePlayPauseHandlers",
              value: function () {
                this.video_element.removeEventListener(
                  "play",
                  this._handlePlayEvent
                ),
                  this.video_element.removeEventListener(
                    "pause",
                    this._handlePauseEvent
                  );
              },
            },
            {
              key: "_createResizeHandler",
              value: function () {
                window.addEventListener("resize", this._resizeHandler, !1);
              },
            },
            {
              key: "_removeResizeHandler",
              value: function () {
                window.removeEventListener("resize", this._resizeHandler);
              },
            },
            {
              key: "_createPipHandlers",
              value: function () {
                window.addEventListener(
                  "enterpictureinpicture",
                  this._handleEnterPip,
                  !1
                ),
                  window.addEventListener(
                    "leavepictureinpicture",
                    this._handleLeavePip,
                    !1
                  );
              },
            },
            {
              key: "_removePipHandlers",
              value: function () {
                window.removeEventListener(
                  "enterpictureinpicture",
                  this._handleEnterPip
                ),
                  window.removeEventListener(
                    "leavepictureinpicture",
                    this._handleLeavePip
                  ),
                  this.pipMode &&
                    (document.exitPictureInPicture(), (this.pipMode = !1));
              },
            },
            {
              key: "_createOrientationChangeHandler",
              value: function () {
                window.addEventListener(
                  "orientationchange",
                  this._orientationchangeHandler,
                  !1
                );
              },
            },
            {
              key: "_removeOrientationChangeHandler",
              value: function () {
                window.removeEventListener(
                  "orientationchange",
                  this._orientationchangeHandler
                );
              },
            },
            {
              key: "_createFullscreenHandler",
              value: function () {
                document.addEventListener(
                  "webkitfullscreenchange",
                  this._fullscreenchangeHandler,
                  !1
                ),
                  document.addEventListener(
                    "mozfullscreenchange",
                    this._fullscreenchangeHandler,
                    !1
                  ),
                  document.addEventListener(
                    "fullscreenchange",
                    this._fullscreenchangeHandler,
                    !1
                  ),
                  document.addEventListener(
                    "MSFullscreenChange",
                    this._fullscreenchangeHandler,
                    !1
                  );
              },
            },
            {
              key: "_removeFullscreenHandler",
              value: function () {
                document.removeEventListener(
                  "webkitfullscreenchange",
                  this._fullscreenchangeHandler
                ),
                  document.removeEventListener(
                    "mozfullscreenchange",
                    this._fullscreenchangeHandler
                  ),
                  document.removeEventListener(
                    "fullscreenchange",
                    this._fullscreenchangeHandler
                  ),
                  document.removeEventListener(
                    "MSFullscreenChange",
                    this._fullscreenchangeHandler
                  );
              },
            },
            {
              key: "_finishLoadingIndicator",
              value: function () {
                this.indicator && this.indicator.quickRelease();
              },
            },
            {
              key: "_updateLoadingIndicator",
              value: function () {
                this.indicator && this.indicator.updatePosition();
              },
            },
            {
              key: "_createLoadingIndicator",
              value: function () {
                var e = document.createElement("div");
                (e.className = "sldp_indicator"),
                  this.player_wrapper.appendChild(e),
                  (this.indicator = {
                    ui: this,
                    fps: 60,
                    element: e,
                    counter: 0,
                    percentage: 100,
                    fullWidth: 1,
                    releaseDuration: 0.5,
                    start: function () {
                      this.interval && clearInterval(this.interval),
                        (this.counter = 0),
                        (this.percentage = 0),
                        (this.element.style.opacity = 1),
                        (this.fullWidth = this.ui.player_wrapper.offsetWidth),
                        (this.interval = setInterval(
                          this.onInterval.bind(this),
                          1e3 / this.fps
                        ));
                    },
                    release: function () {
                      this.interval && clearInterval(this.interval),
                        (this.counter = 0),
                        (this.percentagePerFrame =
                          (100 - this.percentage) /
                          (this.releaseDuration * this.fps)),
                        (this.opacityPerFrame =
                          1 / (this.releaseDuration * this.fps)),
                        (this.interval = setInterval(
                          this.onReleaseInterval.bind(this),
                          1e3 / this.fps
                        ));
                    },
                    quickRelease: function () {
                      if (this.percentage < 100) {
                        var e = 0.1;
                        45 < this.percentage &&
                          (e =
                            (100 - this.percentage) /
                            (this.percentagePerFrame * this.fps)),
                          e >= 0.1 &&
                            ((e = this.releaseDuration),
                            (this.releaseDuration = 0.1),
                            this.release(),
                            (this.releaseDuration = e));
                      }
                    },
                    onInterval: function () {
                      (this.counter += 1),
                        (this.percentage = 8 * Math.log(this.counter)),
                        this.adjustElementWidth(),
                        45 < this.percentage && this.release();
                    },
                    onReleaseInterval: function () {
                      (this.percentage += this.percentagePerFrame),
                        100 <= this.percentage &&
                          ((this.percentage = 100),
                          clearInterval(this.interval)),
                        this.adjustElementWidth();
                      var e = parseFloat(this.element.style.opacity) || 1;
                      this.element.style.opacity =
                        "" + (e - this.opacityPerFrame);
                    },
                    adjustElementWidth: function () {
                      this.element.style.width =
                        parseInt(0.01 * this.fullWidth * this.percentage) +
                        "px";
                    },
                    updatePosition: function () {
                      this.percentage < 100 &&
                        ((this.fullWidth = this.ui.player_wrapper.offsetWidth),
                        this.adjustElementWidth());
                    },
                  }),
                  this.settings.autoplay && this.indicator.start();
              },
            },
            {
              key: "qualities",
              set: function (e) {
                (this.quality_ar = e), (this.cur_quality = e[0]);
              },
            },
            {
              key: "currentQuality",
              set: function (e) {
                this.cur_quality = e;
              },
            },
            {
              key: "onPlay",
              set: function (e) {
                this._onPlayCallback = e;
              },
            },
            {
              key: "onPlayEvent",
              set: function (e) {
                this._onPlayEventCallback = e;
              },
            },
            {
              key: "onPause",
              set: function (e) {
                this._onPauseCallback = e;
              },
            },
            {
              key: "onPauseEvent",
              set: function (e) {
                this._onPauseEventCallback = e;
              },
            },
            {
              key: "canPlay",
              set: function (e) {
                this.can_play = !!e;
              },
            },
            {
              key: "onQualityChange",
              set: function (e) {
                this._onQualityChangeCallback = e;
              },
            },
            {
              key: "onUserAction",
              set: function (e) {
                this._isUserActionAcceptable = e;
              },
            },
            {
              key: "onVolumeSet",
              set: function (e) {
                this._onVolumeSet = e;
              },
            },
            {
              key: "onResize",
              set: function (e) {
                this._onResize = e;
              },
            },
            {
              key: "onEnterPip",
              set: function (e) {
                this._onEnterPip = e;
              },
            },
            {
              key: "onLeavePip",
              set: function (e) {
                this._onLeavePip = e;
              },
            },
          ]) && n(t.prototype, i),
          e
        );
      })();
    t.default = l;
  },
  function (e, t, i) {
    "use strict";

    function r(e, t) {
      for (var i = 0; i < t.length; i++) {
        var r = t[i];
        (r.enumerable = r.enumerable || !1),
          (r.configurable = !0),
          "value" in r && (r.writable = !0),
          Object.defineProperty(e, r.key, r);
      }
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.default = void 0),
      i(0);
    var n = (function () {
      function e(t, i) {
        !(function (e, t) {
          if (!(e instanceof t))
            throw new TypeError("Cannot call a class as a function");
        })(this, e),
          (this.videoElement = t),
          i &&
            i.initialized &&
            "input" === i.type &&
            ((this.vuInput = !0), (this.curVolume = 1), (this.curMuted = !1));
      }
      var t, i;
      return (
        (t = e),
        (i = [
          {
            key: "destroy",
            value: function () {
              (this.videoElement = void 0), (this.vuMeter = void 0);
            },
          },
          {
            key: "setVUMeter",
            value: function (e) {
              var t = this;
              this.vuInput
                ? ((this.vuMeter = e),
                  this.vuMeter.isActivated()
                    ? this.onVUMeterActivated()
                    : (this.vuMeter.onActivated = function () {
                        return t.onVUMeterActivated();
                      }))
                : e.isActivated() || (this.suspendedMeter = e);
            },
          },
          {
            key: "activateVUMeter",
            value: function () {
              this.vuInput
                ? this.vuMeter &&
                  this.vuMeter.setVolume(this.curMuted ? 0 : this.curVolume)
                : this.suspendedMeter &&
                  this.suspendedMeter.setup() &&
                  (this.suspendedMeter = void 0);
            },
          },
          {
            key: "volume",
            get: function () {
              var e = 0;
              return (
                this.vuInput
                  ? this.curMuted || (e = this.curVolume)
                  : this.videoElement.muted || (e = this.videoElement.volume),
                e
              );
            },
            set: function (e) {
              this.vuInput
                ? ((this.curVolume = e),
                  this.vuMeter
                    ? this.curMuted || this.vuMeter.setVolume(e)
                    : (this.videoElement.volume = e))
                : (this.suspendedMeter &&
                    this.suspendedMeter.setup() &&
                    (this.suspendedMeter = void 0),
                  (this.videoElement.volume = e));
            },
          },
          {
            key: "muted",
            get: function () {
              return this.vuInput ? this.curMuted : this.videoElement.muted;
            },
            set: function (e) {
              this.vuInput
                ? this.curMuted !== e &&
                  ((this.curMuted = e),
                  this.vuMeter
                    ? this.vuMeter.setVolume(this.curMuted ? 0 : this.curVolume)
                    : (this.videoElement.muted = e))
                : (this.suspendedMeter &&
                    !e &&
                    this.suspendedMeter.setup() &&
                    (this.suspendedMeter = void 0),
                  (this.videoElement.muted = e));
            },
          },
          {
            key: "onVUMeterActivated",
            value: function () {
              (this.videoElement.volume = 1),
                this.vuMeter.setVolume(this.curMuted ? 0 : this.curVolume),
                (this.videoElement.muted = !1);
            },
          },
        ]) && r(t.prototype, i),
        e
      );
    })();
    t.default = n;
  },
  function (e, t, i) {
    "use strict";

    function r(e) {
      "@babel/helpers - typeof";
      return (r =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (e) {
              return typeof e;
            }
          : function (e) {
              return e &&
                "function" == typeof Symbol &&
                e.constructor === Symbol &&
                e !== Symbol.prototype
                ? "symbol"
                : typeof e;
            })(e);
    }

    function n(e) {
      return e && e.__esModule ? e : { default: e };
    }

    function s(e, t) {
      for (var i = 0; i < t.length; i++) {
        var r = t[i];
        (r.enumerable = r.enumerable || !1),
          (r.configurable = !0),
          "value" in r && (r.writable = !0),
          Object.defineProperty(e, r.key, r);
      }
    }

    function a(e, t) {
      return (a =
        Object.setPrototypeOf ||
        function (e, t) {
          return (e.__proto__ = t), e;
        })(e, t);
    }

    function o(e) {
      var t = (function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return (
            Boolean.prototype.valueOf.call(
              Reflect.construct(Boolean, [], function () {})
            ),
            !0
          );
        } catch (e) {
          return !1;
        }
      })();
      return function () {
        var i,
          n = c(e);
        if (t) {
          var s = c(this).constructor;
          i = Reflect.construct(n, arguments, s);
        } else i = n.apply(this, arguments);
        return (function (e, t) {
          return !t || ("object" !== r(t) && "function" != typeof t) ? u(e) : t;
        })(this, i);
      };
    }

    function u(e) {
      if (void 0 === e)
        throw new ReferenceError(
          "this hasn't been initialised - super() hasn't been called"
        );
      return e;
    }

    function c(e) {
      return (c = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          })(e);
    }

    function l(e, t, i) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: i,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = i),
        e
      );
    }
    i(155),
      i(154),
      i(156),
      i(153),
      i(93),
      i(91),
      i(16),
      i(92),
      i(14),
      i(59),
      i(60),
      Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.default = void 0),
      i(0);
    var h = n(i(118)),
      f = n(i(158)),
      d = (function (e) {
        function t(e, i) {
          var r;
          return (
            (function (e, t) {
              if (!(e instanceof t))
                throw new TypeError("Cannot call a class as a function");
            })(this, t),
            l(
              u((r = n.call(this, e.db_range, e.rate, i))),
              "_onWorkletModuleAdded",
              function () {
                (r.meter = new AudioWorkletNode(
                  r.context,
                  "vu-audio-processor",
                  {
                    processorOptions: {
                      channels: r.channels,
                      dbRange: r.dbRange,
                      dbMult: r.dbMult,
                      mode: r.mode,
                    },
                  }
                )),
                  r.meter.port.postMessage({ cmd: "init" }),
                  r.source.connect(r.meter),
                  "input" === r.type
                    ? ((r.gainer = r.context.createGain()),
                      (r.gainer.gain.value =
                        void 0 !== r.curVolume ? r.curVolume : 1),
                      r.source.connect(r.gainer),
                      r.meter.connect(r.gainer),
                      r.gainer.connect(r.context.destination))
                    : (r.source.connect(r.context.destination),
                      r.meter.connect(r.context.destination)),
                  r._setupRateControl(),
                  (r.meter.port.onmessage = function (e) {
                    return r._updateMeter(e);
                  });
              }
            ),
            l(u(r), "_onWorkletModuleNotFound", function (e) {
              r.procUrl.length === f.default.length
                ? r._onWorkletModuleError(e)
                : ((r.procUrl = f.default),
                  r.context.audioWorklet
                    .addModule(r.procUrl)
                    .then(r._onWorkletModuleAdded)
                    .catch(r._onWorkletModuleError));
            }),
            l(u(r), "_onWorkletModuleError", function (e) {
              r.logger.error(
                "AudioWorkletProcessor file is not found. It should be placed in the same path as SLDP Player itself. Please download it from the following path: https://softvelum.com/player/releases/vumeter-v2.18.1.worklet.min.js"
              ),
                r.stop(!0),
                r.context.close().then(function () {
                  (r.context = void 0),
                    r.fatalErrorCallback && r.fatalErrorCallback();
                });
            }),
            (r.mode = e.mode),
            (r.type = e.type),
            r.logger.debug(
              "AudioWorklet VU meter constructor: ",
              r.mode,
              r.type,
              r.dbRange,
              r.rate
            ),
            r
          );
        }
        !(function (e, t) {
          if ("function" != typeof t && null !== t)
            throw new TypeError(
              "Super expression must either be null or a function"
            );
          (e.prototype = Object.create(t && t.prototype, {
            constructor: { value: e, writable: !0, configurable: !0 },
          })),
            t && a(e, t);
        })(t, h.default);
        var i,
          r,
          n = o(t);
        return (
          (i = t),
          (r = [
            {
              key: "setVolume",
              value: function (e) {
                (this.curVolume = e),
                  this.gainer
                    ? this.gainer.gain.setValueAtTime(
                        e,
                        this.context.currentTime
                      )
                    : this.suspended &&
                      (this.logger.debug("Setup suspended VU meter"),
                      this._setupMeter(),
                      this.onActivated &&
                        this.isActivated() &&
                        (this.onActivated(), (this.onActivated = void 0)));
              },
            },
            {
              key: "_createMeter",
              value: function () {
                void 0 === this.meter &&
                  (this.logger.debug("Create AudioWorklet meter"),
                  this._initValues(),
                  (this.procUrl = f.default),
                  this.scriptPath &&
                    (this.procUrl = this.scriptPath + f.default),
                  this.logger.debug("Processor URL", this.procUrl),
                  this.context.audioWorklet
                    .addModule(this.procUrl)
                    .then(this._onWorkletModuleAdded)
                    .catch(this._onWorkletModuleNotFound));
              },
            },
            {
              key: "_removeMeter",
              value: function () {
                if (this.meter) {
                  this.logger.debug("Remove meter");
                  try {
                    this.meter.port.postMessage({ cmd: "stop" }),
                      this.source.disconnect(this.meter),
                      "input" === this.type
                        ? (this.source.disconnect(this.gainer),
                          this.gainer.disconnect(this.context.destination),
                          (this.gainer = void 0))
                        : (this.source.disconnect(this.context.destination),
                          this.meter.disconnect(this.context.destination)),
                      (this.meter = void 0),
                      (this.curVolume = void 0);
                  } catch (e) {
                    (this.curVolume = void 0),
                      (this.gainer = void 0),
                      (this.meter = void 0),
                      this.logger.warn("Exception caught: ", e);
                  }
                }
              },
            },
            {
              key: "_setupRateControl",
              value: function () {
                this.meter &&
                  this.meter.port.postMessage({
                    cmd: "rate",
                    rate: this.rate,
                    sRate: this.samplingRate,
                  });
              },
            },
            {
              key: "_updateMeter",
              value: function (e) {
                for (var t = 0; t < this.channels; t++)
                  (this.channelValues[t] = e.data[0][t]),
                    (this.channelDecibels[t] = e.data[1][t]);
                this.ui && this.ui.update(this.channelDecibels),
                  this.callback &&
                    this.callback(this.channelValues, this.channelDecibels);
              },
            },
          ]) && s(i.prototype, r),
          t
        );
      })();
    t.default = d;
  },
  function (e, t, i) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : { default: e };
    }
    i(0),
      Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.default = void 0);
    var n = r(i(174)),
      s = r(i(172)),
      a = function (e) {
        return {
          create: function (t) {
            var i;
            switch (t.mode) {
              case "peak":
              case "rms":
              case "avg":
                var r = !1;
                window.isSecureContext &&
                  (r =
                    void 0 !== window.AudioWorkletNode &&
                    "audioworklet" === t.api.toLowerCase()),
                  (i = r ? new s.default(t, e) : new n.default(t, e));
            }
            return i;
          },
        };
      };
    t.default = a;
  },
  function (e, t, i) {
    "use strict";

    function r(e) {
      "@babel/helpers - typeof";
      return (r =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (e) {
              return typeof e;
            }
          : function (e) {
              return e &&
                "function" == typeof Symbol &&
                e.constructor === Symbol &&
                e !== Symbol.prototype
                ? "symbol"
                : typeof e;
            })(e);
    }

    function n(e, t) {
      for (var i = 0; i < t.length; i++) {
        var r = t[i];
        (r.enumerable = r.enumerable || !1),
          (r.configurable = !0),
          "value" in r && (r.writable = !0),
          Object.defineProperty(e, r.key, r);
      }
    }

    function s(e, t) {
      return (s =
        Object.setPrototypeOf ||
        function (e, t) {
          return (e.__proto__ = t), e;
        })(e, t);
    }

    function a(e) {
      var t = (function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return (
            Boolean.prototype.valueOf.call(
              Reflect.construct(Boolean, [], function () {})
            ),
            !0
          );
        } catch (e) {
          return !1;
        }
      })();
      return function () {
        var i,
          n = o(e);
        if (t) {
          var s = o(this).constructor;
          i = Reflect.construct(n, arguments, s);
        } else i = n.apply(this, arguments);
        return (function (e, t) {
          return !t || ("object" !== r(t) && "function" != typeof t)
            ? (function (e) {
                if (void 0 === e)
                  throw new ReferenceError(
                    "this hasn't been initialised - super() hasn't been called"
                  );
                return e;
              })(e)
            : t;
        })(this, i);
      };
    }

    function o(e) {
      return (o = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          })(e);
    }
    i(156),
      i(153),
      i(0),
      i(93),
      i(91),
      i(16),
      i(92),
      i(14),
      i(59),
      i(60),
      Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.default = void 0),
      i(155),
      i(154);
    var u,
      c = (u = i(118)) && u.__esModule ? u : { default: u },
      l = (function (e) {
        function t(e, i) {
          var r;
          return (
            (function (e, t) {
              if (!(e instanceof t))
                throw new TypeError("Cannot call a class as a function");
            })(this, t),
            ((r = o.call(this, e.db_range, e.rate, i)).mode = e.mode),
            (r.type = e.type),
            (r.calcChannelValueFor = {
              peak: r._calcChannelValuePeak,
              avg: r._calcChannelValueAvg,
              rms: r._calcChannelValueRms,
            }[r.mode]),
            (r.channelData = []),
            r.logger.debug(
              "ScriptProcessor VU meter constructor: ",
              r.mode,
              r.type,
              r.dbRange,
              r.rate
            ),
            r
          );
        }
        !(function (e, t) {
          if ("function" != typeof t && null !== t)
            throw new TypeError(
              "Super expression must either be null or a function"
            );
          (e.prototype = Object.create(t && t.prototype, {
            constructor: { value: e, writable: !0, configurable: !0 },
          })),
            t && s(e, t);
        })(t, c.default);
        var i,
          r,
          o = a(t);
        return (
          (i = t),
          (r = [
            {
              key: "setVolume",
              value: function (e) {
                if (this.gainer) {
                  var t = this.context.currentTime;
                  this.gainer.gain.setValueAtTime(e, t);
                } else
                  this.suspended &&
                    (this.logger.debug("Setup suspended VU meter"),
                    this._setupMeter(),
                    this.onActivated &&
                      this.isActivated() &&
                      (this.onActivated(), (this.onActivated = void 0)));
              },
            },
            {
              key: "_createMeter",
              value: function () {
                var e = this;
                void 0 === this.meter &&
                  (this.logger.debug("Create ScriptProcessor meter"),
                  this._initValues(),
                  (this.meter = this.context.createScriptProcessor(
                    this.bufSize,
                    this.channels,
                    this.channels
                  )),
                  this.source.connect(this.meter),
                  "input" === this.type
                    ? ((this.gainer = this.context.createGain()),
                      (this.gainer.gain.value = 1),
                      this.source.connect(this.gainer),
                      this.meter.connect(this.gainer),
                      this.gainer.connect(this.context.destination))
                    : (this.source.connect(this.context.destination),
                      this.meter.connect(this.context.destination)),
                  (this.meter.onaudioprocess = function (t) {
                    return e._updateMeter(t);
                  }));
              },
            },
            {
              key: "_removeMeter",
              value: function () {
                if (this.meter) {
                  this.logger.debug("Remove meter");
                  try {
                    this.source.disconnect(this.meter),
                      "input" === this.type
                        ? (this.source.disconnect(this.gainer),
                          this.gainer.disconnect(this.context.destination),
                          (this.gainer = void 0))
                        : (this.source.disconnect(this.context.destination),
                          this.meter.disconnect(this.context.destination)),
                      (this.meter.onaudioprocess = void 0),
                      (this.meter = void 0);
                  } catch (e) {
                    (this.gainer = void 0),
                      (this.meter = void 0),
                      this.logger.warn("Exception caught: ", e);
                  }
                }
              },
            },
            {
              key: "_gcd",
              value: function (e, t) {
                return t ? this._gcd(t, e % t) : e;
              },
            },
            {
              key: "_setupRateControl",
              value: function () {
                if (!this.rateControl) {
                  var e = {},
                    t = this._gcd(this.samplingRate, this.bufSize);
                  if (this.rate < t / this.bufSize) {
                    t = this.rate * this.bufSize;
                    for (var i = 0; (t >>= 1); ) i++;
                    t = Math.pow(2, i);
                  }
                  var r = this.bufSize / t;
                  (e.max = this.samplingRate / t),
                    (e.exp = (r * this.rate + 0.5) >>> 0),
                    e.exp >= e.max
                      ? (e = !1)
                      : ((e.add = e.max / e.exp),
                        (e.tgt = e.cur = 0),
                        (e.cnt = -2)),
                    (this.rateControl = e);
                }
              },
            },
            {
              key: "_calcChannelValueAvg",
              value: function (e) {
                for (var t = this.channelData[e].length, i = 0; i < t; i++)
                  this.channelValues[e] += Math.abs(this.channelData[e][i]);
                this.channelValues[e] /= t;
              },
            },
            {
              key: "_calcChannelValueRms",
              value: function (e) {
                for (var t = this.channelData[e].length, i = 0; i < t; i++)
                  this.channelValues[e] +=
                    this.channelData[e][i] * this.channelData[e][i];
                this.channelValues[e] = Math.sqrt(this.channelValues[e] / t);
              },
            },
            {
              key: "_calcChannelValuePeak",
              value: function (e) {
                for (var t = this.channelData[e].length, i = 0; i < t; i++) {
                  var r = Math.abs(this.channelData[e][i]);
                  r > this.channelValues[e] && (this.channelValues[e] = r);
                }
              },
            },
            {
              key: "_updateMeter",
              value: function (e) {
                if (this.rateControl) {
                  var t = this.rateControl;
                  if ((t.cnt++, t.tgt !== t.cnt)) return;
                  t.cur + 0.1 >= t.max
                    ? ((t.cur = t.add), (t.tgt = t.add >>> 0), (t.cnt = 0))
                    : ((t.cur += t.add), (t.tgt = t.cur >>> 0));
                }
                var i = e.inputBuffer;
                this.channelData.length = 0;
                for (var r = 0; r < this.channels; r++)
                  (this.channelData[r] = i.getChannelData(r)),
                    (this.channelValues[r] = 0),
                    this.calcChannelValueFor(r),
                    (this.channelDecibels[r] = this._dbFromVal(
                      this.channelValues[r]
                    ));
                this.ui && this.ui.update(this.channelDecibels),
                  this.callback &&
                    this.callback(this.channelValues, this.channelDecibels);
              },
            },
          ]) && n(i.prototype, r),
          t
        );
      })();
    t.default = l;
  },
  function (e, t, i) {
    "use strict";

    function r(e, t) {
      for (var i = 0; i < t.length; i++) {
        var r = t[i];
        (r.enumerable = r.enumerable || !1),
          (r.configurable = !0),
          "value" in r && (r.writable = !0),
          Object.defineProperty(e, r.key, r);
      }
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.default = void 0),
      i(69),
      i(0);
    var n = (function () {
      function e(t, i) {
        !(function (e, t) {
          if (!(e instanceof t))
            throw new TypeError("Cannot call a class as a function");
        })(this, e),
          (this.container = t),
          (this.vertical = !0),
          (this.borderSize = 2),
          (this.fontSize = 10),
          (this.backgroundColor = "black"),
          (this.tickColor = "#ddd"),
          (this.gradient = ["red 1%", "#ff0 16%", "lime 45%", "#080 100%"]),
          (this.dbRange = i),
          (this.dbTickSize = 10),
          (this.levelTransition = "0.1s"),
          this._createBasicView();
      }
      var t, i;
      return (
        (t = e),
        (i = [
          {
            key: "create",
            value: function (e) {
              if (!this.fullValue) {
                void 0 === this.meter && this._createBasicView(),
                  (this.channels = e),
                  this._createGradient();
                var t = this.meterWidth / this.channels;
                this.vertical || (t = this.meterHeight / this.channels);
                var i = this.tickWidth;
                this.vertical || (i = this.meterTop);
                for (var r = 0; r < this.channels; r++)
                  this._createChannelLevel(
                    2 * this.borderSize,
                    this.meterTop,
                    i,
                    !1
                  ),
                    (this.channelLevels[r] = this._createChannelLevel(
                      t,
                      this.meterTop,
                      i,
                      this.levelTransition
                    )),
                    (i += t),
                    (this.levelValues[r] = this._calcLevel(-this.dbRange));
                (this.fullValue = !0), this._drawMeter();
              }
            },
          },
          {
            key: "refresh",
            value: function (e) {
              if (
                this.container.clientWidth !== this.elementWidth ||
                this.container.clientHeight !== this.elementHeight
              ) {
                var t = this.fullValue;
                this.destroy(!0), t ? this.create(e) : this._createBasicView();
              }
            },
          },
          {
            key: "destroy",
            value: function (e) {
              if (this.meter) {
                if (this.fullValue) {
                  for (var t = 0; t < this.fullValueItems.length; t++)
                    this.meter.removeChild(this.fullValueItems[t]);
                  (this.fullValueItems = []),
                    (this.channelLevels = []),
                    (this.fullValue = !1);
                }
                e &&
                  (this.container.removeChild(this.meter),
                  (this.meter = void 0));
              }
            },
          },
          {
            key: "update",
            value: function (e) {
              if (this.meter)
                for (var t = 0; t < this.channels; t++)
                  this.levelValues[t] = this._calcLevel(e[t]);
            },
          },
          {
            key: "_calcLevel",
            value: function (e) {
              var t = this.vertical ? this.meterHeight : this.meterWidth,
                i = Math.floor((e * t) / -this.dbRange);
              return i < 0 ? (i = 0) : i > t && (i = t), i;
            },
          },
          {
            key: "_setParams",
            value: function () {
              (this.tickWidth = 2 * this.fontSize),
                (this.elementWidth = this.container.clientWidth),
                (this.elementHeight = this.container.clientHeight),
                this.elementWidth > this.elementHeight && (this.vertical = !1),
                (this.meterTop = this.vertical
                  ? this.borderSize
                  : 1.5 * this.fontSize + this.borderSize),
                (this.meterHeight =
                  this.elementHeight - this.meterTop - this.borderSize),
                (this.meterWidth =
                  this.elementWidth - this.tickWidth - this.borderSize),
                (this.fullValueItems = []),
                (this.channelLevels = []),
                (this.levelValues = []);
            },
          },
          {
            key: "_createBasicView",
            value: function () {
              this._setParams(),
                this._createMeterDiv(),
                this._createTicks(),
                (this.fullValue = !1);
            },
          },
          {
            key: "_removePlaceholder",
            value: function () {
              this.placeholder &&
                (this.container.removeChild(this.meter),
                (this.meter = void 0),
                (this.placeholder = !1));
            },
          },
          {
            key: "_createMeterDiv",
            value: function () {
              (this.meter = document.createElement("div")),
                (this.meter.style.position = "relative"),
                (this.meter.style.width = this.elementWidth + "px"),
                (this.meter.style.height = this.elementHeight + "px"),
                (this.meter.style.backgroundColor = this.backgroundColor),
                this.container.appendChild(this.meter);
            },
          },
          {
            key: "_createTicks",
            value: function () {
              var e = (this.dbRange / this.dbTickSize) >>> 0,
                t = 0;
              if (this.vertical)
                for (
                  var i = this.fontSize + this.borderSize, r = 0;
                  r < e;
                  r++
                ) {
                  var n = document.createElement("div");
                  this.meter.appendChild(n),
                    (n.style.width = this.tickWidth + "px"),
                    (n.style.textAlign = "right"),
                    (n.style.color = this.tickColor),
                    (n.style.fontSize = this.fontSize + "px"),
                    (n.style.position = "absolute"),
                    (n.style.top = i + "px"),
                    (n.textContent = t + ""),
                    (t -= this.dbTickSize),
                    (i += this.meterHeight / e);
                }
              else {
                this.tickWidth = this.meterWidth / e;
                for (var s = 2 * this.fontSize, a = 0; a < e; a++) {
                  var o = document.createElement("div");
                  this.meter.appendChild(o),
                    (o.style.width = this.tickWidth + "px"),
                    (o.style.textAlign = "right"),
                    (o.style.color = this.tickColor),
                    (o.style.fontSize = this.fontSize + "px"),
                    (o.style.position = "absolute"),
                    (o.style.top = "5px"),
                    (o.style.right = s + "px"),
                    (o.textContent = t + ""),
                    (t -= this.dbTickSize),
                    (s += this.tickWidth);
                }
              }
            },
          },
          {
            key: "_createGradient",
            value: function () {
              var e,
                t = document.createElement("div");
              this.meter.appendChild(t),
                (t.style.width = this.meterWidth + "px"),
                (t.style.height = this.meterHeight + "px"),
                (t.style.position = "absolute"),
                (t.style.top = this.meterTop + "px"),
                this.vertical
                  ? ((t.style.left = this.tickWidth + "px"),
                    (e =
                      "linear-gradient(to bottom, " +
                      this.gradient.join(", ") +
                      ")"))
                  : ((t.style.left = this.borderSize + "px"),
                    (e =
                      "linear-gradient(to left, " +
                      this.gradient.join(", ") +
                      ")")),
                (t.style.backgroundImage = e),
                this.fullValueItems.push(t);
            },
          },
          {
            key: "_createChannelLevel",
            value: function (e, t, i, r) {
              var n = document.createElement("div");
              return (
                this.meter.appendChild(n),
                (n.style.position = "absolute"),
                this.vertical
                  ? ((n.style.width = e + "px"),
                    (n.style.height = this.meterHeight + "px"),
                    (n.style.top = t + "px"),
                    (n.style.left = i + "px"))
                  : ((n.style.width = this.meterWidth + "px"),
                    (n.style.height = e + "px"),
                    (n.style.top = i + "px"),
                    (n.style.right = 2 * this.fontSize + "px")),
                (n.style.backgroundColor = this.backgroundColor),
                r &&
                  (this.vertical
                    ? (n.style.transition = "height " + this.levelTransition)
                    : (n.style.transition = "width " + this.levelTransition)),
                this.fullValueItems.push(n),
                n
              );
            },
          },
          {
            key: "_drawMeter",
            value: function () {
              var e = this;
              if (this.fullValue) {
                for (var t = 0; t < this.channels; t++)
                  this.vertical
                    ? (this.channelLevels[t].style.height =
                        this.levelValues[t] + "px")
                    : (this.channelLevels[t].style.width =
                        this.levelValues[t] + "px");
                window.requestAnimationFrame(function () {
                  return e._drawMeter();
                });
              }
            },
          },
        ]) && r(t.prototype, i),
        e
      );
    })();
    t.default = n;
  },
  function (e, t, i) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : { default: e };
    }
    i(0),
      Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.default = void 0);
    var n = r(i(181)),
      s = r(i(10)),
      a = function (e) {
        function t() {
          function e(e, t, r, n, s) {
            var a = void 0,
              o = n,
              u = n - (a = e.lastSample).rawts;
            return (
              (u < 0 || u > 10 * e.timescale) &&
                (i.debug("Adjust DTS difference!!!", u),
                (u = e.lastSampleDuration)),
              (n = a.ts + u),
              (a.duration = u),
              (a.altDur = Math.floor(u / (e.timescale / 1e3) + 0.5)),
              (e.lastSampleDuration = u),
              (e.lastSample = {
                data: r,
                ts: n,
                rawts: o,
                altTs: Math.floor(n / (e.timescale / 1e3) + 0.5),
                sap: t,
              }),
              a
            );
          }

          function t(e) {
            for (var t = void 0, n = 0; n < r.length; n++)
              if (r[n].id == e) {
                t = r[n];
                break;
              }
            return (
              void 0 === t && i.error("track ID " + e + " is not found!"), t
            );
          }
          var r = [],
            s = 1;
          (this.init = function () {
            (r = []), (s = 1);
          }),
            (this.addTrack = function (e, t) {
              var n = {
                id: s,
                type: e,
                curSeqNumber: 0,
                lastSampleDuration: 0,
              };
              if (t)
                switch (((n.timescale = t.timescale), e)) {
                  case "video":
                    (n.codec = t.codec ? t.codec.toUpperCase() : "VP8"),
                      (n.width = t.width || 0),
                      (n.height = t.height || 0);
                    break;
                  case "audio":
                    i.error("addTrack: audio is not supported!");
                }
              return r.push(n), s++, n;
            }),
            (this.setTrackParams = function (e, r) {
              var n = t(e);
              return (
                n &&
                  ("codec" in r && (r.codec = r.codec.toUpperCase()),
                  "width" in r && (n.width = r.width),
                  "height" in r && (n.height = r.height),
                  "timescale" in r && (n.timescale = r.timescale),
                  "sequenceNumber" in r && (n.curSeqNumber = r.sequenceNumber),
                  i.debug("setTrackParams", e, r)),
                n
              );
            }),
            (this.setBaseSample = function (e, r, n, s) {
              var a = t(e);
              a
                ? (i.debug("setBaseSample:", a.type, n),
                  (a.lastSample = {
                    data: r,
                    ts: n,
                    rawts: n,
                    altTs: Math.floor(n / (a.timescale / 1e3) + 0.5),
                    sap: !0,
                  }))
                : i.error("setBaseSample: track " + e + " not found!!!");
            }),
            (this.getRealTs = function (e, r) {
              var n = r,
                s = t(e);
              return (
                s
                  ? s.lastSample &&
                    Math.abs(r - s.lastSample.ts) > 10 * s.timescale &&
                    (n = r - s.lastSample.rawts + s.lastSample.ts)
                  : i.error("getRealTs: track ".concat(e, " not found")),
                n
              );
            }),
            (this.initSegment = function () {
              var e = n.default.createFile();
              !(function (e) {
                var t = n.default.createElement("EBML", e);
                n.default.createElement("EBMLVersion", t, 1),
                  n.default.createElement("EBMLReadVersion", t, 1),
                  n.default.createElement("EBMLMaxIDLength", t, 4),
                  n.default.createElement("EBMLMaxSizeLength", t, 8),
                  n.default.createElement("DocType", t, "webm"),
                  n.default.createElement("DocTypeVersion", t, 2),
                  n.default.createElement("DocTypeReadVersion", t, 2);
              })(e);
              var t = (function (e) {
                var t = n.default.createElement("Segment", e);
                return (t._unbound = !0), t;
              })(e);
              return (
                (function (e) {
                  var t = n.default.createElement("SegmentInfo", e);
                  n.default.createElement("TimecodeScale", t, 1e6),
                    n.default.createElement("MuxingApp", t, "sldp-player"),
                    n.default.createElement("WritingApp", t, "sldp-player");
                })(t),
                (function (e) {
                  for (
                    var t = n.default.createElement("Tracks", e), i = 0;
                    i < r.length;
                    i++
                  ) {
                    var s = "video" == r[i].type,
                      a = n.default.createElement("TrackEntry", t);
                    if (
                      (n.default.createElement("TrackNumber", a, r[i].id),
                      n.default.createElement("TrackUID", a, r[i].id),
                      n.default.createElement("FlagLacing", a, 0),
                      n.default.createElement("Language", a, "und"),
                      n.default.createElement("CodecID", a, "V_" + r[i].codec),
                      n.default.createElement("CodecName", a, r[i].codec),
                      n.default.createElement("TrackType", a, s ? 1 : 2),
                      s)
                    ) {
                      var o = n.default.createElement("Video", a);
                      n.default.createElement("PixelWidth", o, r[i].width),
                        n.default.createElement("PixelHeight", o, r[i].height);
                    }
                  }
                })(t),
                e.write()
              );
            }),
            (this.mediaSegment = function (i, r, s) {
              var a = void 0,
                o = n.default.createFile(),
                u = t(i),
                c = [],
                l = [];
              if (u) {
                var h = 0,
                  f = [];
                for (h = 0; h < r.length; h++) {
                  var d = r[h],
                    p = e(u, d.sap, d.data, d.ts);
                  void 0 !== p && (f.push(p), c.push(p.ts), l.push(p.sap));
                }
                s &&
                  void 0 !== u.lastSample &&
                  ((u.lastSample.duration = u.lastSampleDuration),
                  f.push(u.lastSample),
                  c.push(f[f.length - 1].ts),
                  l.push(f[f.length - 1].sap),
                  (u.lastSample = void 0)),
                  f.length > 0 &&
                    ((function (e, t, i) {
                      var r = n.default.createElement("Cluster", e);
                      n.default.createElement("Timecode", r, i[0].altTs);
                      for (var s = 0, a = 0; a < i.length; a++) {
                        var o = n.default.createElement("SimpleBlock", r);
                        (o.sap = i[a].sap),
                          (o.timecode = s),
                          (o.trackNumber = t.id),
                          (o.frame = i[a].data),
                          (s += i[a].altDur);
                      }
                    })(o, u, f),
                    (a = {
                      ts: c,
                      sap: l,
                      sn: u ? u.curSeqNumber - 1 : void 0,
                      data: o.write(),
                    }));
              }
              return a;
            });
        }
        var i = s.default.create(e, "WebmComposer");
        return {
          create: function () {
            return new t();
          },
        };
      };
    t.default = a;
  },
  function (e, t, i) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : { default: e };
    }
    i(0),
      Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.default = void 0),
      i(113),
      i(68),
      i(29),
      i(87),
      i(16),
      i(14),
      i(53),
      i(30),
      i(31),
      i(32),
      i(33),
      i(35),
      i(34),
      i(36),
      i(37),
      i(38),
      i(39),
      i(40),
      i(41),
      i(42),
      i(44),
      i(43),
      i(45),
      i(46),
      i(47),
      i(48),
      i(49),
      i(50),
      i(51),
      i(52),
      i(70);
    var n = r(i(180)),
      s = r(i(71)),
      a = r(i(119)),
      o = function () {
        (this._cursor = new s.default()), (this.int32pow = Math.pow(2, 32));
      };
    (o.create = function (e) {
      var t = new o();
      return (t.type = e), (t.boxes = []), t;
    }),
      (o.prototype._boxContainers = [
        "dinf",
        "mdia",
        "mfra",
        "minf",
        "moof",
        "moov",
        "mvex",
        "stbl",
        "strk",
        "traf",
        "trak",
      ]),
      (o.prototype._boxProcessors = {}),
      (o.prototype._writeFieldArray = function (e, t, i) {
        for (var r = 0; r < i.length; r++) this._writeField(e, t, i[r]);
      }),
      (o.prototype._writeFullBox = function () {
        this._writeField("uint", 8, this.version),
          this._writeField("uint", 24, this.flags);
      }),
      (o.prototype._procEntries = function (e, t, i) {
        for (var r = 0; r < t; r++) i.call(this, this[e][r]);
      }),
      (o.prototype._procSubBoxes = function (e, t) {
        for (var i = 0; i < t; i++)
          this._rawo
            ? this[e][i].write()
            : (this.size += this[e][i].getLength());
      }),
      (o.prototype.append = function (e, t) {
        a.default.appendBox(this, e, t);
      }),
      (o.prototype.getLength = function () {
        if (
          ((this._rawo = null),
          (this.size = 0),
          this._writeField("uint", 32, this.size),
          this._writeField("string", 4, this.type),
          this._boxProcessors[this.type] &&
            this._boxProcessors[this.type].call(this),
          -1 !== this._boxContainers.indexOf(this.type))
        )
          for (var e = 0; e < this.boxes.length; e++)
            this.size += this.boxes[e].getLength();
        return this._data && this._writeData(this._data), this.size;
      }),
      (o.prototype.write = function () {
        if (
          ((this._cursor.offset = this._parent._cursor.offset),
          0 === this.size
            ? (this._rawo = new DataView(
                this._parent._rawo.buffer,
                this._cursor.offset,
                this.parent._rawo.byteLength - this._cursor.offset
              ))
            : (this._rawo = new DataView(
                this._parent._rawo.buffer,
                this._cursor.offset,
                this.size
              )),
          this._writeField("uint", 32, this.size),
          this._writeField("string", 4, this.type),
          this._boxProcessors[this.type] &&
            this._boxProcessors[this.type].call(this),
          -1 !== this._boxContainers.indexOf(this.type))
        )
          for (var e = 0; e < this.boxes.length; e++) this.boxes[e].write();
        return (
          this._data && this._writeData(this._data),
          (this._parent._cursor.offset += this.size),
          this.size
        );
      }),
      (o.prototype._writeInt = function (e, t) {
        if (this._rawo) {
          var i = this._cursor.offset - this._rawo.byteOffset;
          switch (e) {
            case 8:
              this._rawo.setInt8(i, t);
              break;
            case 16:
              this._rawo.setInt16(i, t);
              break;
            case 32:
              this._rawo.setInt32(i, t);
              break;
            case 64:
              var r = Math.floor(t / this.int32pow),
                n = t - r * this.int32pow;
              this._rawo.setUint32(i, r), this._rawo.setUint32(i + 4, n);
          }
          this._cursor.offset += e >> 3;
        } else this.size += e >> 3;
      }),
      (o.prototype._writeUint = function (e, t) {
        if (this._rawo) {
          var i,
            r,
            n = this._cursor.offset - this._rawo.byteOffset;
          switch (e) {
            case 8:
              this._rawo.setUint8(n, t);
              break;
            case 16:
              this._rawo.setUint16(n, t);
              break;
            case 24:
              (i = (16776960 & t) >> 8),
                (r = 255 & t),
                this._rawo.setUint16(n, i),
                this._rawo.setUint8(n + 2, r);
              break;
            case 32:
              this._rawo.setUint32(n, t);
              break;
            case 64:
              (r = t - (i = Math.floor(t / this.int32pow)) * this.int32pow),
                this._rawo.setUint32(n, i),
                this._rawo.setUint32(n + 4, r);
          }
          this._cursor.offset += e >> 3;
        } else this.size += e >> 3;
      }),
      (o.prototype._writeString = function (e, t) {
        for (var i = 0; i < e; i++) this._writeUint(8, t.charCodeAt(i));
      }),
      (o.prototype._writeTerminatedString = function (e) {
        if (0 !== e.length) {
          for (var t = 0; t < e.length; t++)
            this._writeUint(8, e.charCodeAt(t));
          this._writeUint(8, 0);
        }
      }),
      (o.prototype._writeTemplate = function (e, t) {
        var i = Math.floor(t),
          r = (t - i) * Math.pow(2, e / 2);
        this._writeUint(e / 2, i), this._writeUint(e / 2, r);
      }),
      (o.prototype._writeData = function (e) {
        if (e)
          if (this._rawo) {
            if (e instanceof Uint8Array)
              this._root.bytes.set(e, this._cursor.offset),
                (this._cursor.offset += e.length);
            else if (e instanceof Array) {
              for (
                var t = this._cursor.offset - this._rawo.byteOffset, i = 0;
                i < e.length;
                i++
              )
                this._rawo.setInt8(t + i, e[i]);
              this._cursor.offset += e.length;
            }
          } else this.size += e.length;
      }),
      (o.prototype._writeUTF8String = function (e) {
        var t = n.default.utf8ToByteArray(e);
        if (this._rawo)
          for (
            var i = new DataView(
                this._rawo.buffer,
                this._cursor.offset,
                t.length
              ),
              r = 0;
            r < t.length;
            r++
          )
            i.setUint8(r, t[r]);
        else this.size += t.length;
      }),
      (o.prototype._writeField = function (e, t, i) {
        switch (e) {
          case "uint":
            this._writeUint(t, i);
            break;
          case "int":
            this._writeInt(t, i);
            break;
          case "template":
            this._writeTemplate(t, i);
            break;
          case "string":
            -1 == t ? this._writeTerminatedString(i) : this._writeString(t, i);
            break;
          case "data":
            this._writeData(i);
            break;
          case "utf8":
            this._writeUTF8String(i);
        }
      }),
      (o.prototype._boxProcessors.avc1 =
        o.prototype._boxProcessors.avc2 =
        o.prototype._boxProcessors.avc3 =
        o.prototype._boxProcessors.avc4 =
        o.prototype._boxProcessors.hvc1 =
        o.prototype._boxProcessors.hev1 =
        o.prototype._boxProcessors.encv =
          function () {
            this._writeFieldArray("uint", 8, this.reserved1),
              this._writeField("uint", 16, this.data_reference_index),
              this._writeField("uint", 16, this.pre_defined1),
              this._writeField("uint", 16, this.reserved2),
              this._writeFieldArray("uint", 32, this.pre_defined2),
              this._writeField("uint", 16, this.width),
              this._writeField("uint", 16, this.height),
              this._writeField("template", 32, this.horizresolution),
              this._writeField("template", 32, this.vertresolution),
              this._writeField("uint", 32, this.reserved3),
              this._writeField("uint", 16, this.frame_count),
              this._writeFieldArray("uint", 8, this.compressorname),
              this._writeField("uint", 16, this.depth),
              this._writeField("int", 16, this.pre_defined3),
              this._writeField("data", -1, this.config),
              this._procSubBoxes("entries", this.entry_count);
          }),
      (o.prototype._boxProcessors.dref = function () {
        this._writeFullBox(),
          this._writeField("uint", 32, this.entry_count),
          this._procSubBoxes("entries", this.entry_count);
      }),
      (o.prototype._boxProcessors.pasp = function () {
        this._writeField("uint", 32, this.hSpacing),
          this._writeField("uint", 32, this.vSpacing);
      }),
      (o.prototype._boxProcessors.styp = o.prototype._boxProcessors.ftyp =
        function () {
          this._writeField("string", 4, this.major_brand),
            this._writeField("uint", 32, this.minor_version),
            this._writeFieldArray("string", 4, this.compatible_brands);
        }),
      (o.prototype._boxProcessors.sidx = function () {
        this._writeFullBox(),
          this._writeField("uint", 32, this.reference_ID),
          this._writeField("uint", 32, this.timescale),
          this._writeField(
            "uint",
            1 == this.version ? 64 : 32,
            this.earliest_presentation_time
          ),
          this._writeField(
            "uint",
            1 == this.version ? 64 : 32,
            this.first_offset
          ),
          this._writeField("uint", 16, this.reserved),
          this._writeField("uint", 16, this.reference_count),
          this._procEntries("references", this.reference_count, function (e) {
            (e.reference = (1 & e.reference_type) << 31),
              (e.reference |= 2147483647 & e.referenced_size),
              (e.sap = (1 & e.starts_with_SAP) << 31),
              (e.sap |= (3 & e.SAP_type) << 28),
              (e.sap |= 268435455 & e.SAP_delta_time),
              this._writeField("uint", 32, e.reference),
              this._writeField("uint", 32, e.subsegment_duration),
              this._writeField("uint", 32, e.sap);
          });
      }),
      (o.prototype._boxProcessors.hdlr = function () {
        this._writeFullBox(),
          this._writeField("uint", 32, this.pre_defined),
          this._writeField("string", 4, this.handler_type),
          this._writeFieldArray("uint", 32, this.reserved),
          this._writeField("string", -1, this.name);
      }),
      (o.prototype._boxProcessors.mdat = function () {
        this._writeField("data", -1, this.data);
      }),
      (o.prototype._boxProcessors.mdhd = function () {
        this._writeFullBox(),
          this._writeField(
            "uint",
            1 == this.version ? 64 : 32,
            this.creation_time
          ),
          this._writeField(
            "uint",
            1 == this.version ? 64 : 32,
            this.modification_time
          ),
          this._writeField("uint", 32, this.timescale),
          this._writeField("uint", 1 == this.version ? 64 : 32, this.duration),
          "string" == typeof this.language &&
            (this.language =
              ((this.language.charCodeAt(0) - 96) << 10) |
              ((this.language.charCodeAt(1) - 96) << 5) |
              (this.language.charCodeAt(2) - 96)),
          this._writeField("uint", 16, this.language),
          this._writeField("uint", 16, this.pre_defined);
      }),
      (o.prototype._boxProcessors.mehd = function () {
        this._writeFullBox(),
          this._writeField(
            "uint",
            1 == this.version ? 64 : 32,
            this.fragment_duration
          );
      }),
      (o.prototype._boxProcessors.mfhd = function () {
        this._writeFullBox(),
          this._writeField("uint", 32, this.sequence_number);
      }),
      (o.prototype._boxProcessors.mp4a = o.prototype._boxProcessors.enca =
        function () {
          this._writeFieldArray("uint", 8, this.reserved1),
            this._writeField("uint", 16, this.data_reference_index),
            this._writeFieldArray("uint", 32, this.reserved2),
            this._writeField("uint", 16, this.channelcount),
            this._writeField("uint", 16, this.samplesize),
            this._writeField("uint", 16, this.pre_defined),
            this._writeField("uint", 16, this.reserved3),
            this._writeField("uint", 32, this.samplerate),
            this._writeField("data", -1, this.esds);
        }),
      (o.prototype._boxProcessors[".mp3"] = function () {
        this._writeFieldArray("uint", 8, this.reserved1),
          this._writeField("uint", 16, this.data_reference_index),
          this._writeFieldArray("uint", 32, this.reserved2),
          this._writeField("uint", 16, this.channelcount),
          this._writeField("uint", 16, this.samplesize),
          this._writeField("uint", 16, this.pre_defined),
          this._writeField("uint", 16, this.reserved3),
          this._writeField("uint", 32, this.samplerate),
          this._procSubBoxes("entries", this.entry_count);
      }),
      (o.prototype._boxProcessors.btrt = function () {
        this._writeField("uint", 32, this.bufferSizeDB),
          this._writeField("uint", 32, this.maxBitrate),
          this._writeField("uint", 32, this.avgBitrate);
      }),
      (o.prototype._boxProcessors.mvhd = function () {
        this._writeFullBox(),
          this._writeField(
            "uint",
            1 == this.version ? 64 : 32,
            this.creation_time
          ),
          this._writeField(
            "uint",
            1 == this.version ? 64 : 32,
            this.modification_time
          ),
          this._writeField("uint", 32, this.timescale),
          this._writeField("uint", 1 == this.version ? 64 : 32, this.duration),
          this._writeField("template", 32, this.rate),
          this._writeField("template", 16, this.volume),
          this._writeField("uint", 16, this.reserved1),
          this._writeFieldArray("uint", 32, this.reserved2),
          this._writeFieldArray("template", 32, this.matrix),
          this._writeFieldArray("uint", 32, this.pre_defined),
          this._writeField("uint", 32, this.next_track_ID);
      }),
      (o.prototype._boxProcessors.smhd = function () {
        this._writeFullBox(),
          this._writeField("uint", 16, this.balance),
          this._writeField("uint", 16, this.reserved);
      }),
      (o.prototype._boxProcessors.stsd = function () {
        this._writeFullBox(),
          this._writeField("uint", 32, this.entry_count),
          this._procSubBoxes("entries", this.entry_count);
      }),
      (o.prototype._boxProcessors.tfdt = function () {
        this._writeFullBox(),
          this._writeField(
            "uint",
            1 == this.version ? 64 : 32,
            this.baseMediaDecodeTime
          );
      }),
      (o.prototype._boxProcessors.tfhd = function () {
        this._writeFullBox(),
          this._writeField("uint", 32, this.track_ID),
          1 & this.flags && this._writeField("uint", 64, this.base_data_offset),
          2 & this.flags &&
            this._writeField("uint", 32, this.sample_description_offset),
          8 & this.flags &&
            this._writeField("uint", 32, this.default_sample_duration),
          16 & this.flags &&
            this._writeField("uint", 32, this.default_sample_size),
          32 & this.flags &&
            this._writeField("uint", 32, this.default_sample_flags);
      }),
      (o.prototype._boxProcessors.tkhd = function () {
        this._writeFullBox(),
          this._writeField(
            "uint",
            1 == this.version ? 64 : 32,
            this.creation_time
          ),
          this._writeField(
            "uint",
            1 == this.version ? 64 : 32,
            this.modification_time
          ),
          this._writeField("uint", 32, this.track_ID),
          this._writeField("uint", 32, this.reserved1),
          this._writeField("uint", 1 == this.version ? 64 : 32, this.duration),
          this._writeFieldArray("uint", 32, this.reserved2),
          this._writeField("uint", 16, this.layer),
          this._writeField("uint", 16, this.alternate_group),
          this._writeField("template", 16, this.volume),
          this._writeField("uint", 16, this.reserved3),
          this._writeFieldArray("template", 32, this.matrix),
          this._writeField("template", 32, this.width),
          this._writeField("template", 32, this.height);
      }),
      (o.prototype._boxProcessors.trex = function () {
        this._writeFullBox(),
          this._writeField("uint", 32, this.track_ID),
          this._writeField("uint", 32, this.default_sample_description_index),
          this._writeField("uint", 32, this.default_sample_duration),
          this._writeField("uint", 32, this.default_sample_size),
          this._writeField("uint", 32, this.default_sample_flags);
      }),
      (o.prototype._boxProcessors.trun = function () {
        this._writeFullBox(),
          this._writeField("uint", 32, this.sample_count),
          1 & this.flags && this._writeField("int", 32, this.data_offset),
          4 & this.flags &&
            this._writeField("uint", 32, this.first_sample_flags),
          this._procEntries("samples", this.sample_count, function (e) {
            256 & this.flags && this._writeField("uint", 32, e.sample_duration),
              512 & this.flags && this._writeField("uint", 32, e.sample_size),
              1024 & this.flags && this._writeField("uint", 32, e.sample_flags),
              2048 & this.flags &&
                this._writeField(
                  1 === this.version ? "int" : "uint",
                  32,
                  e.sample_composition_time_offset
                );
          });
      }),
      (o.prototype._boxProcessors["url "] = o.prototype._boxProcessors["urn "] =
        function () {
          this._writeFullBox(),
            "urn " === this.type && this._writeField("string", -1, this.name),
            this._writeField("string", -1, this.location);
        }),
      (o.prototype._boxProcessors.vmhd = function () {
        this._writeFullBox(),
          this._writeField("uint", 16, this.graphicsmode),
          this._writeFieldArray("uint", 16, this.opcolor);
      });
    var u = o;
    t.default = u;
  },
  function (e, t, i) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : { default: e };
    }
    i(0),
      Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.default = void 0),
      i(113);
    var n = r(i(177)),
      s = r(i(179)),
      a = {
        createFile: function () {
          return new s.default();
        },
        createBox: function (e, t, i) {
          var r = n.default.create(e);
          return t && t.append(r, i), r;
        },
        createFullBox: function (e, t, i) {
          var r = a.createBox(e, t, i);
          return (r.version = 0), (r.flags = 0), r;
        },
      },
      o = a;
    t.default = o;
  },
  function (e, t, i) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : { default: e };
    }
    i(0),
      Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.default = void 0),
      i(14),
      i(29),
      i(16),
      i(53),
      i(30),
      i(31),
      i(32),
      i(33),
      i(35),
      i(34),
      i(36),
      i(37),
      i(38),
      i(39),
      i(40),
      i(41),
      i(42),
      i(44),
      i(43),
      i(45),
      i(46),
      i(47),
      i(48),
      i(49),
      i(50),
      i(51),
      i(52),
      i(87);
    var n = r(i(71)),
      s = r(i(119)),
      a = function () {
        (this._cursor = new n.default()), (this.boxes = []);
      };
    (a.prototype.write = function () {
      var e = 0,
        t = 0;
      for (t = 0; t < this.boxes.length; t++) e += this.boxes[t].getLength();
      var i = new Uint8Array(e);
      for (
        this._rawo = new DataView(i.buffer),
          this.bytes = i,
          this._cursor.offset = 0,
          t = 0;
        t < this.boxes.length;
        t++
      )
        this.boxes[t].write();
      return i.buffer;
    }),
      (a.prototype.append = function (e, t) {
        s.default.appendBox(this, e, t);
      });
    var o = a;
    t.default = o;
  },
  function (e, t, i) {
    "use strict";
    i(0),
      Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.default = void 0),
      i(69);
    var r = {
        dataViewToString: function (e, t) {
          var i = t || "utf-8";
          if ("undefined" != typeof TextDecoder)
            return new TextDecoder(i).decode(e);
          var r = [],
            n = 0;
          if ("utf-8" === i)
            for (; n < e.byteLength; ) {
              var s = e.getUint8(n++);
              s < 128 ||
                (s < 224
                  ? ((s = (31 & s) << 6), (s |= 63 & e.getUint8(n++)))
                  : s < 240
                  ? ((s = (15 & s) << 12),
                    (s |= (63 & e.getUint8(n++)) << 6),
                    (s |= 63 & e.getUint8(n++)))
                  : ((s = (7 & s) << 18),
                    (s |= (63 & e.getUint8(n++)) << 12),
                    (s |= (63 & e.getUint8(n++)) << 6),
                    (s |= 63 & e.getUint8(n++)))),
                r.push(String.fromCharCode(s));
            }
          else
            for (; n < e.byteLength; )
              r.push(String.fromCharCode(e.getUint8(n++)));
          return r.join("");
        },
        utf8ToByteArray: function (e) {
          var t, i;
          if ("undefined" != typeof TextEncoder)
            t = new TextEncoder().encode(e);
          else
            for (t = [], i = 0; i < e.length; ++i) {
              var r = e.charCodeAt(i);
              r < 128
                ? t.push(r)
                : r < 2048
                ? (t.push(192 | (r >> 6)), t.push(128 | (63 & r)))
                : r < 65536
                ? (t.push(224 | (r >> 12)),
                  t.push(128 | (63 & (r >> 6))),
                  t.push(128 | (63 & r)))
                : (t.push(240 | (r >> 18)),
                  t.push(128 | (63 & (r >> 12))),
                  t.push(128 | (63 & (r >> 6))),
                  t.push(128 | (63 & r)));
            }
          return t;
        },
      },
      n = r;
    t.default = n;
  },
  function (e, t, i) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : { default: e };
    }
    i(0),
      Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.default = void 0);
    var n = r(i(182)),
      s = r(i(183)),
      a = {
        createFile: function () {
          return new s.default();
        },
        createElement: function (e, t, i) {
          var r = n.default.create(e, i);
          return (
            t &&
              ((r._root = t._root ? t._root : t),
              (r._parent = t),
              t.elements.push(r)),
            r
          );
        },
      },
      o = a;
    t.default = o;
  },
  function (e, t, i) {
    "use strict";
    i(0),
      Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.default = void 0),
      i(29),
      i(87),
      i(16),
      i(14),
      i(53),
      i(30),
      i(31),
      i(32),
      i(33),
      i(35),
      i(34),
      i(36),
      i(37),
      i(38),
      i(39),
      i(40),
      i(41),
      i(42),
      i(44),
      i(43),
      i(45),
      i(46),
      i(47),
      i(48),
      i(49),
      i(50),
      i(51),
      i(52);
    var r,
      n = (r = i(71)) && r.__esModule ? r : { default: r },
      s = 281474976710656,
      a = {
        EBML: 440786851,
        EBMLVersion: 17030,
        EBMLReadVersion: 17143,
        EBMLMaxIDLength: 17138,
        EBMLMaxSizeLength: 17139,
        DocType: 17026,
        DocTypeVersion: 17031,
        DocTypeReadVersion: 17029,
        Segment: 408125543,
        SegmentInfo: 357149030,
        TimecodeScale: 2807729,
        MuxingApp: 19840,
        WritingApp: 22337,
        Duration: 17545,
        Tracks: 374648427,
        TrackEntry: 174,
        TrackNumber: 215,
        TrackUID: 29637,
        FlagLacing: 156,
        Language: 2274716,
        CodecID: 134,
        CodecName: 2459272,
        TrackType: 131,
        Video: 224,
        PixelWidth: 176,
        PixelHeight: 186,
        Cluster: 524531317,
        Timecode: 231,
        SimpleBlock: 163,
      },
      o = function () {
        this._cursor = new n.default();
      };
    (o.create = function (e, t) {
      var i = new o();
      return (i.id = a[e]), (i.elements = []), void 0 !== t && (i._data = t), i;
    }),
      (o.prototype._elemProcessors = {}),
      (o.prototype.getLength = function () {
        (this._rawo = null),
          (this.size = 0),
          (this._idLength = this._measureUint(this.id));
        for (var e = 0; e < this.elements.length; e++)
          this.size += this.elements[e].getLength();
        return (
          this._elemProcessors[this.id] &&
            this._elemProcessors[this.id].call(this),
          void 0 !== this._data && this._processData(this._data),
          this._unbound
            ? (this._sizeLength = 1)
            : (this._sizeLength = this._measureVarInt(this.size)),
          this.size + this._idLength + this._sizeLength
        );
      }),
      (o.prototype.write = function () {
        this._cursor.offset = this._parent._cursor.offset;
        var e = this._idLength + this._sizeLength + this.size;
        0 === this.size
          ? (this._rawo = new DataView(
              this._parent._rawo.buffer,
              this._cursor.offset,
              this.parent._rawo.byteLength - this._cursor.offset
            ))
          : (this._rawo = new DataView(
              this._parent._rawo.buffer,
              this._cursor.offset,
              e
            )),
          this._writeField("uint", this.id, this._idLength),
          this._unbound
            ? this._writeField("uint", 255, 1)
            : this._writeField("vint", this.size, this._sizeLength);
        for (var t = 0; t < this.elements.length; t++) this.elements[t].write();
        return (
          this._elemProcessors[this.id] &&
            this._elemProcessors[this.id].call(this),
          void 0 !== this._data && this._processData(this._data),
          (this._parent._cursor.offset += e),
          e
        );
      }),
      (o.prototype._setU8 = function (e) {
        this._rawo.setUint8(this._viewOffset, e), this._viewOffset++;
      }),
      (o.prototype._writeData = function (e) {
        if (e)
          if (this._rawo) {
            if (e instanceof Uint8Array)
              this._root.bytes.set(e, this._cursor.offset),
                (this._cursor.offset += e.length);
            else if (e instanceof Array) {
              this._cursor.offset, this._rawo.byteOffset;
              for (var t = 0; t < e.length; t++) this._setU8(e[t]);
              this._cursor.offset += e.length;
            }
          } else this.size += e.length;
      }),
      (o.prototype._writeString = function (e) {
        if (this._rawo) {
          this._viewOffset = this._cursor.offset - this._rawo.byteOffset;
          for (var t = 0; t < e.length; t++) this._setU8(e.charCodeAt(t));
          this._cursor.offset += e.length;
        } else this.size += e.length;
      }),
      (o.prototype._writeVarInt = function (e, t) {
        if ((void 0 === t && (t = this._measureVarInt(e)), this._rawo)) {
          switch (
            ((this._viewOffset = this._cursor.offset - this._rawo.byteOffset),
            t)
          ) {
            case 1:
              this._setU8(128 | e);
              break;
            case 2:
              this._setU8(64 | (e >> 8));
              break;
            case 3:
              this._setU8(32 | (e >> 16));
              break;
            case 4:
              this._setU8(16 | (e >> 24));
              break;
            case 5:
              this._setU8(8 | Math.floor(e / 4294967296));
              break;
            case 6:
              this._setU8(4 | Math.floor(e / 1099511627776));
              break;
            case 7:
              this._setU8(2 | Math.floor(e / s));
              break;
            case 8:
              this._setU8(1);
          }
          switch (t) {
            case 8:
              this._setU8(Math.floor(e / s));
            case 7:
              this._setU8(Math.floor(e / 1099511627776));
            case 6:
              this._setU8(Math.floor(e / 4294967296));
            case 5:
              this._setU8(e >> 24);
            case 4:
              this._setU8(e >> 16);
            case 3:
              this._setU8(e >> 8);
            case 2:
              this._setU8(e);
          }
          this._cursor.offset += t;
        } else this.size += t;
      }),
      (o.prototype._writeUint = function (e, t) {
        if ((void 0 === t && (t = this._measureUint(e)), this._rawo)) {
          switch (
            ((this._viewOffset = this._cursor.offset - this._rawo.byteOffset),
            t)
          ) {
            case 8:
              this._setU8((e / 72057594037927940) >>> 0);
            case 7:
              this._setU8((e / s) >>> 0);
            case 6:
              this._setU8((e / 1099511627776) >>> 0);
            case 5:
              this._setU8((e / 4294967296) >>> 0);
            case 4:
              this._setU8(e >> 24);
            case 3:
              this._setU8(e >> 16);
            case 2:
              this._setU8(e >> 8);
            case 1:
              this._setU8(e);
              break;
            default:
              throw new RuntimeException("Bad UINT size", t);
          }
          this._cursor.offset += t;
        } else this.size += t;
      }),
      (o.prototype._measureVarInt = function (e) {
        if (e < 127) return 1;
        if (e < 16383) return 2;
        if (e < 2097151) return 3;
        if (e < 268435455) return 4;
        if (e < 34359738367) return 5;
        if (e < 4398046511103) return 6;
        if (e < 562949953421311) return 7;
        if (e < 72057594037927940) return 8;
        throw new RuntimeException("EBML VINT size not supported", e);
      }),
      (o.prototype._measureUint = function (e) {
        return e < 256
          ? 1
          : e < 65536
          ? 2
          : e < 16777216
          ? 3
          : e < 4294967296
          ? 4
          : e < 1099511627776
          ? 5
          : e < s
          ? 6
          : e < 72057594037927940
          ? 7
          : 8;
      }),
      (o.prototype._writeField = function (e, t, i) {
        switch (e) {
          case "uint":
            this._writeUint(t, i);
            break;
          case "vint":
            this._writeVarInt(t, i);
            break;
          case "string":
            this._writeString(t, i);
            break;
          case "data":
            this._writeData(t);
        }
      }),
      (o.prototype._processData = function (e) {
        "number" == typeof e
          ? this._writeField("uint", e)
          : "string" == typeof e
          ? this._writeField("string", e)
          : this._writeField("data", e);
      }),
      (o.prototype._elemProcessors[163] = function () {
        this._writeField("vint", this.trackNumber),
          this._writeField("uint", this.timecode, 2);
        var e = this.sap ? 128 : 0;
        this._writeField("uint", e, 1), this._writeField("data", this.frame);
      });
    var u = o;
    t.default = u;
  },
  function (e, t, i) {
    "use strict";
    i(0),
      Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.default = void 0),
      i(14),
      i(29),
      i(16),
      i(53),
      i(30),
      i(31),
      i(32),
      i(33),
      i(35),
      i(34),
      i(36),
      i(37),
      i(38),
      i(39),
      i(40),
      i(41),
      i(42),
      i(44),
      i(43),
      i(45),
      i(46),
      i(47),
      i(48),
      i(49),
      i(50),
      i(51),
      i(52),
      i(87);
    var r,
      n = (r = i(71)) && r.__esModule ? r : { default: r },
      s = function () {
        (this._cursor = new n.default()), (this.elements = []);
      };
    s.prototype.write = function () {
      var e = 0,
        t = 0;
      for (t = 0; t < this.elements.length; t++)
        e += this.elements[t].getLength();
      var i = new Uint8Array(e);
      for (
        this._rawo = new DataView(i.buffer),
          this.bytes = i,
          this._cursor.offset = 0,
          t = 0;
        t < this.elements.length;
        t++
      )
        this.elements[t].write();
      return i.buffer;
    };
    var a = s;
    t.default = a;
  },
  function (e, t, i) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : { default: e };
    }

    function n(e, t) {
      for (var i = 0; i < t.length; i++) {
        var r = t[i];
        (r.enumerable = r.enumerable || !1),
          (r.configurable = !0),
          "value" in r && (r.writable = !0),
          Object.defineProperty(e, r.key, r);
      }
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.default = void 0),
      i(214),
      i(29),
      i(16),
      i(14),
      i(53),
      i(30),
      i(31),
      i(32),
      i(33),
      i(35),
      i(34),
      i(36),
      i(37),
      i(38),
      i(39),
      i(40),
      i(41),
      i(42),
      i(44),
      i(43),
      i(45),
      i(46),
      i(47),
      i(48),
      i(49),
      i(50),
      i(51),
      i(52),
      i(21),
      i(69),
      i(0);
    var s = r(i(120)),
      a = r(i(10)),
      o = function (e) {
        var t = a.default.create(e, "WS"),
          i = new s.default(e).create(),
          r = (function () {
            function e(t) {
              !(function (e, t) {
                if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function");
              })(this, e),
                (this.metricsManager = t),
                (this.stop_audio = !1),
                (this.curSocketId = 0),
                (this.isLogging = !1),
                (this.useSteady = !1),
                (this.loggerData = {
                  video: {
                    frames: [],
                    prevTime: 0,
                    sumTimes: 0,
                    times: [],
                    thresh: 60,
                    avg: void 0,
                  },
                  audio: {
                    frames: [],
                    prevTime: 0,
                    sumTimes: 0,
                    times: [],
                    thresh: 60,
                    avg: void 0,
                  },
                });
            }
            var r, s;
            return (
              (r = e),
              (s = [
                {
                  key: "open",
                  value: function (e) {
                    function r(e, t) {
                      e.isLogging &&
                        void 0 === e.loggerData[t] &&
                        (e.loggerData[t] = {
                          frames: [],
                          prevTime: 0,
                          sumTimes: 0,
                          times: [],
                          thresh: 60,
                          avg: void 0,
                        });
                    }
                    try {
                      var n = e.substring(0, 5);
                      if (
                        ("ws://" != n && "wss:/" != n && (e = "ws://" + e),
                        void 0 !== this.socket)
                      )
                        throw (
                          (t.error(
                            "attempt to open socket when socket exists!",
                            this.socket,
                            e
                          ),
                          "Socket open error")
                        );
                      this.socket = new WebSocket(e, ["sldp.softvelum.com"]);
                    } catch (e) {
                      return t.error("" + e.message), !1;
                    }
                    return (
                      (this.socket.binaryType = "arraybuffer"),
                      (this.socket.sampleCounter = 0),
                      (this.socket.transport = this),
                      (this.socket.socketId = ++this.curSocketId),
                      (this.socket.streamURL = e),
                      (this.socket.onopen = function () {
                        t.debug("Connection established.");
                      }),
                      (this.socket.onclose = function (e) {
                        e.wasClean
                          ? t.debug("Connection closed clean")
                          : (t.debug("Connection dropped", this),
                            this.socketId == this.transport.curSocketId &&
                              (3 == this.readyState &&
                                (this.transport.socket = void 0),
                              this.transport.onConnectionClosedCallback &&
                                this.transport.onConnectionClosedCallback()));
                        var r = i.closeCodes[e.code] || "";
                        t.debug(
                          "Close code " +
                            e.code +
                            "(" +
                            r +
                            ") reason: " +
                            e.reason
                        );
                      }),
                      (this.socket.onmessage = function (e) {
                        if (e.data instanceof ArrayBuffer) {
                          var n,
                            s = new Uint8Array(e.data),
                            a = s[0],
                            o = s[1],
                            u = 0,
                            c = 10,
                            l = s.byteLength;
                          switch (o) {
                            case i.liveFrameTypes.WEB_AAC_SEQUENCE_HEADER:
                            case i.liveFrameTypes.WEB_AVC_SEQUENCE_HEADER:
                            case i.liveFrameTypes.WEB_HEVC_SEQUENCE_HEADER:
                              if (
                                (t.debug(
                                  ""
                                    .concat(
                                      0 === o ? "audio" : "video",
                                      " init segment, trackId: "
                                    )
                                    .concat(a)
                                ),
                                this.transport.onInitSegmentReceivedCallback)
                              ) {
                                var h = s.subarray(2, l);
                                this.transport.onInitSegmentReceivedCallback(
                                  a,
                                  h
                                ),
                                  this.transport.metricsManager.run(a),
                                  r(this.transport, a);
                              }
                              break;
                            case i.liveFrameTypes.WEB_MP3:
                              if (
                                this.transport.metricsManager.isReadyToStart(a)
                              ) {
                                var f = s.subarray(10, 14);
                                this.transport.onInitSegmentReceivedCallback(
                                  a,
                                  f
                                ),
                                  this.transport.metricsManager.run(a),
                                  r(this.transport, a);
                              }
                            case i.liveFrameTypes.WEB_AAC_FRAME:
                              if (
                                this.transport.onDataReceivedCallback &&
                                0 == this.transport.stop_audio
                              ) {
                                (n = i.readValue(s, 2, 8)),
                                  this.transport.useSteady &&
                                    ((u = i.readValue(s, c, 8)), (c += 8));
                                var d = s.subarray(c, l);
                                this.transport.onDataReceivedCallback(
                                  a,
                                  !0,
                                  d,
                                  n,
                                  0,
                                  u
                                );
                              }
                              break;
                            case i.liveFrameTypes.WEB_AVC_KEY_FRAME:
                            case i.liveFrameTypes.WEB_AVC_FRAME:
                            case i.liveFrameTypes.WEB_HEVC_KEY_FRAME:
                            case i.liveFrameTypes.WEB_HEVC_FRAME:
                              if (this.transport.onDataReceivedCallback) {
                                (n = i.readValue(s, 2, 8)),
                                  this.transport.useSteady &&
                                    ((u = i.readValue(s, c, 8)), (c += 8));
                                var p = i.readValue(s, c, 4),
                                  v = s.subarray(c + 4, l),
                                  m =
                                    i.liveFrameTypes.WEB_AVC_KEY_FRAME == o ||
                                    i.liveFrameTypes.WEB_HEVC_KEY_FRAME == o;
                                this.transport.onDataReceivedCallback(
                                  a,
                                  m,
                                  v,
                                  n,
                                  p,
                                  u
                                ),
                                  (n += p);
                              }
                              break;
                            case i.liveFrameTypes.WEB_VP8_KEY_FRAME:
                            case i.liveFrameTypes.WEB_VP9_KEY_FRAME:
                              this.transport.metricsManager.isReadyToStart(a) &&
                                (this.transport.onInitSegmentReceivedCallback(
                                  a,
                                  null
                                ),
                                this.transport.metricsManager.run(a),
                                r(this.transport, a));
                            case i.liveFrameTypes.WEB_VP8_FRAME:
                            case i.liveFrameTypes.WEB_VP9_FRAME:
                              if (this.transport.onDataReceivedCallback) {
                                (n = i.readValue(s, 2, 8)),
                                  this.transport.useSteady &&
                                    ((u = i.readValue(s, c, 8)), (c += 8));
                                var g = s.subarray(c, l),
                                  y =
                                    i.liveFrameTypes.WEB_VP8_KEY_FRAME == o ||
                                    i.liveFrameTypes.WEB_VP9_KEY_FRAME == o;
                                this.transport.onDataReceivedCallback(
                                  a,
                                  y,
                                  g,
                                  n,
                                  0,
                                  u
                                );
                              }
                              break;
                            default:
                              t.error("Unknown type of frame received ", o);
                          }
                          this.transport.metricsManager.reportBandwidth(
                            a,
                            l,
                            n
                          ),
                            (0 == this.sampleCounter) & 1023 &&
                              t.debug("sampleCounter", this.sampleCounter),
                            (this.sampleCounter += 1);
                        } else {
                          t.debug("Command received", e.data);
                          var _ = JSON.parse(e.data);
                          "status" == _.command &&
                            this.transport.onStatusReceivedCallback &&
                            this.transport.onStatusReceivedCallback(
                              _.info,
                              _.steady,
                              _.system
                            );
                        }
                      }),
                      (this.socket.onerror = function (e) {
                        t.error("Error happened:", e);
                      }),
                      this.socket
                    );
                  },
                },
                {
                  key: "send",
                  value: function (e) {
                    this.socket && this.socket.send(JSON.stringify(e));
                  },
                },
                {
                  key: "close",
                  value: function () {
                    t.debug("socket close ", this.socket),
                      this.socket &&
                        (this.socket.close(1e3), (this.socket = void 0)),
                      (this.onStatusReceivedCallback = void 0),
                      (this.onInitSegmentReceivedCallback = void 0),
                      (this.onDataReceivedCallback = void 0),
                      (this.onConnectionClosedCallback = void 0);
                  },
                },
                {
                  key: "acceptSteadyTimestamps",
                  value: function (e) {
                    this.useSteady = e;
                  },
                },
                {
                  key: "callbacks",
                  set: function (e) {
                    (this.onStatusReceivedCallback = e.onStatusReceived),
                      (this.onInitSegmentReceivedCallback =
                        e.onInitSegmentReceived),
                      (this.onDataReceivedCallback = e.onDataReceived),
                      (this.onConnectionClosedCallback = e.onConnectionClosed);
                  },
                },
              ]) && n(r.prototype, s),
              e
            );
          })();
        return {
          create: function (e) {
            return new r(e);
          },
        };
      };
    t.default = o;
  },
  function (e, t, i) {
    "use strict";

    function r(e, t) {
      for (var i = 0; i < t.length; i++) {
        var r = t[i];
        (r.enumerable = r.enumerable || !1),
          (r.configurable = !0),
          "value" in r && (r.writable = !0),
          Object.defineProperty(e, r.key, r);
      }
    }
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.default = void 0),
      i(23),
      i(0);
    var n = (function () {
      function e(t) {
        !(function (e, t) {
          if (!(e instanceof t))
            throw new TypeError("Cannot call a class as a function");
        })(this, e),
          (this.fraction = t || 100),
          (this.timeout = this.fraction),
          (this.leeway = 8);
      }
      var t, i;
      return (
        (t = e),
        (i = [
          {
            key: "start",
            value: function (e, t) {
              var i = !1;
              if (!this.timer) {
                var r = this;
                (this.func = e),
                  (this.pos = performance.now()),
                  (this.end = this.pos + t),
                  (this.timeout = t < this.fraction ? t : this.fraction),
                  (this.timer = setTimeout(function t() {
                    var i = performance.now() - r.pos - r.timeout;
                    r.pos += r.timeout + i;
                    var n = Math.floor(r.end - r.pos);
                    n > r.leeway
                      ? ((r.timeout = n <= r.fraction ? n : r.fraction),
                        (r.timer = setTimeout(t, r.timeout)))
                      : ((r.timer = void 0), (r.timeout = this.fraction), e());
                  }, this.timeout)),
                  (i = !0);
              }
              return i;
            },
          },
          {
            key: "interrupt",
            value: function () {
              var e = !1;
              return this.timer && (this.stop(), this.func(), (e = !0)), e;
            },
          },
          {
            key: "stop",
            value: function () {
              var e = !1;
              return (
                this.timer &&
                  (clearTimeout(this.timer),
                  (this.timer = void 0),
                  (this.timeout = this.fraction),
                  (e = !0)),
                e
              );
            },
          },
        ]) && r(t.prototype, i),
        e
      );
    })();
    t.default = n;
  },
  function (e, t, i) {
    var r = i(9);
    e.exports = function (e) {
      if (!r(e) && null !== e)
        throw TypeError("Can't set " + String(e) + " as a prototype");
      return e;
    };
  },
  function (e, t, i) {
    var r = i(5),
      n = i(26),
      s = i(12),
      a = r("unscopables"),
      o = Array.prototype;
    void 0 == o[a] && s.f(o, a, { configurable: !0, value: n(null) }),
      (e.exports = function (e) {
        o[a][e] = !0;
      });
  },
  function (e, t, i) {
    "use strict";
    var r = i(13),
      n = i(28),
      s = i(6),
      a = Math.min;
    e.exports =
      [].copyWithin ||
      function (e, t) {
        var i = r(this),
          o = s(i.length),
          u = n(e, o),
          c = n(t, o),
          l = arguments.length > 2 ? arguments[2] : void 0,
          h = a((void 0 === l ? o : n(l, o)) - c, o - u),
          f = 1;
        for (
          c < u && u < c + h && ((f = -1), (c += h - 1), (u += h - 1));
          h-- > 0;

        )
          c in i ? (i[u] = i[c]) : delete i[u], (u += f), (c += f);
        return i;
      };
  },
  function (e, t, i) {
    "use strict";
    var r = i(77),
      n = i(13),
      s = i(190),
      a = i(136),
      o = i(6),
      u = i(76),
      c = i(78);
    e.exports = function (e) {
      var t,
        i,
        l,
        h,
        f,
        d,
        p = n(e),
        v = "function" == typeof this ? this : Array,
        m = arguments.length,
        g = m > 1 ? arguments[1] : void 0,
        y = void 0 !== g,
        _ = c(p),
        b = 0;
      if (
        (y && (g = r(g, m > 2 ? arguments[2] : void 0, 2)),
        void 0 == _ || (v == Array && a(_)))
      )
        for (i = new v((t = o(p.length))); t > b; b++)
          (d = y ? g(p[b], b) : p[b]), u(i, b, d);
      else
        for (f = (h = _.call(p)).next, i = new v(); !(l = f.call(h)).done; b++)
          (d = y ? s(h, g, [l.value, b], !0) : l.value), u(i, b, d);
      return (i.length = b), i;
    };
  },
  function (e, t, i) {
    var r = i(7),
      n = i(199);
    e.exports = function (e, t, i, s) {
      try {
        return s ? t(r(i)[0], i[1]) : t(i);
      } catch (t) {
        throw (n(e), t);
      }
    };
  },
  function (e, t, i) {
    var r = i(5)("iterator"),
      n = !1;
    try {
      var s = 0,
        a = {
          next: function () {
            return { done: !!s++ };
          },
          return: function () {
            n = !0;
          },
        };
      (a[r] = function () {
        return this;
      }),
        Array.from(a, function () {
          throw 2;
        });
    } catch (e) {}
    e.exports = function (e, t) {
      if (!t && !n) return !1;
      var i = !1;
      try {
        var s = {};
        (s[r] = function () {
          return {
            next: function () {
              return { done: (i = !0) };
            },
          };
        }),
          e(s);
      } catch (e) {}
      return i;
    };
  },
  function (e, t) {
    e.exports = {
      CSSRuleList: 0,
      CSSStyleDeclaration: 0,
      CSSValueList: 0,
      ClientRectList: 0,
      DOMRectList: 0,
      DOMStringList: 0,
      DOMTokenList: 1,
      DataTransferItemList: 0,
      FileList: 0,
      HTMLAllCollection: 0,
      HTMLCollection: 0,
      HTMLFormElement: 0,
      HTMLSelectElement: 0,
      MediaList: 0,
      MimeTypeArray: 0,
      NamedNodeMap: 0,
      NodeList: 1,
      PaintRequestList: 0,
      Plugin: 0,
      PluginArray: 0,
      SVGLengthList: 0,
      SVGNumberList: 0,
      SVGPathSegList: 0,
      SVGPointList: 0,
      SVGStringList: 0,
      SVGTransformList: 0,
      SourceBufferList: 0,
      StyleSheetList: 0,
      TextTrackCueList: 0,
      TextTrackList: 0,
      TouchList: 0,
    };
  },
  function (e, t, i) {
    var r = i(7),
      n = i(78);
    e.exports = function (e) {
      var t = n(e);
      if ("function" != typeof t)
        throw TypeError(String(e) + " is not iterable");
      return r(t.call(e));
    };
  },
  function (e, t, i) {
    var r = i(25);
    e.exports = r("document", "documentElement");
  },
  function (e, t) {
    var i = Math.abs,
      r = Math.pow,
      n = Math.floor,
      s = Math.log,
      a = Math.LN2;
    e.exports = {
      pack: function (e, t, o) {
        var u,
          c,
          l,
          h = new Array(o),
          f = 8 * o - t - 1,
          d = (1 << f) - 1,
          p = d >> 1,
          v = 23 === t ? r(2, -24) - r(2, -77) : 0,
          m = e < 0 || (0 === e && 1 / e < 0) ? 1 : 0,
          g = 0;
        for (
          (e = i(e)) != e || e === 1 / 0
            ? ((c = e != e ? 1 : 0), (u = d))
            : ((u = n(s(e) / a)),
              e * (l = r(2, -u)) < 1 && (u--, (l *= 2)),
              (e += u + p >= 1 ? v / l : v * r(2, 1 - p)) * l >= 2 &&
                (u++, (l /= 2)),
              u + p >= d
                ? ((c = 0), (u = d))
                : u + p >= 1
                ? ((c = (e * l - 1) * r(2, t)), (u += p))
                : ((c = e * r(2, p - 1) * r(2, t)), (u = 0)));
          t >= 8;
          h[g++] = 255 & c, c /= 256, t -= 8
        );
        for (
          u = (u << t) | c, f += t;
          f > 0;
          h[g++] = 255 & u, u /= 256, f -= 8
        );
        return (h[--g] |= 128 * m), h;
      },
      unpack: function (e, t) {
        var i,
          n = e.length,
          s = 8 * n - t - 1,
          a = (1 << s) - 1,
          o = a >> 1,
          u = s - 7,
          c = n - 1,
          l = e[c--],
          h = 127 & l;
        for (l >>= 7; u > 0; h = 256 * h + e[c], c--, u -= 8);
        for (
          i = h & ((1 << -u) - 1), h >>= -u, u += t;
          u > 0;
          i = 256 * i + e[c], c--, u -= 8
        );
        if (0 === h) h = 1 - o;
        else {
          if (h === a) return i ? NaN : l ? -1 / 0 : 1 / 0;
          (i += r(2, t)), (h -= o);
        }
        return (l ? -1 : 1) * i * r(2, h - t);
      },
    };
  },
  function (e, t, i) {
    var r = i(9),
      n = i(56);
    e.exports = function (e, t, i) {
      var s, a;
      return (
        n &&
          "function" == typeof (s = t.constructor) &&
          s !== i &&
          r((a = s.prototype)) &&
          a !== i.prototype &&
          n(e, a),
        e
      );
    };
  },
  function (e, t, i) {
    var r = i(3),
      n = /#|\.prototype\./,
      s = function (e, t) {
        var i = o[a(e)];
        return i == c || (i != u && ("function" == typeof t ? r(t) : !!t));
      },
      a = (s.normalize = function (e) {
        return String(e).replace(n, ".").toLowerCase();
      }),
      o = (s.data = {}),
      u = (s.NATIVE = "N"),
      c = (s.POLYFILL = "P");
    e.exports = s;
  },
  function (e, t, i) {
    var r = i(9),
      n = i(55),
      s = i(5)("match");
    e.exports = function (e) {
      var t;
      return r(e) && (void 0 !== (t = e[s]) ? !!t : "RegExp" == n(e));
    };
  },
  function (e, t, i) {
    var r = i(7);
    e.exports = function (e) {
      var t = e.return;
      if (void 0 !== t) return r(t.call(e)).value;
    };
  },
  function (e, t, i) {
    var r = i(4),
      n = i(135),
      s = r.WeakMap;
    e.exports = "function" == typeof s && /native code/.test(n(s));
  },
  function (e, t, i) {
    var r = i(4),
      n = i(146).trim,
      s = i(110),
      a = r.parseFloat,
      o = 1 / a(s + "-0") != -1 / 0;
    e.exports = o
      ? function (e) {
          var t = n(String(e)),
            i = a(t);
          return 0 === i && "-" == t.charAt(0) ? -0 : i;
        }
      : a;
  },
  function (e, t, i) {
    var r = i(4),
      n = i(146).trim,
      s = i(110),
      a = r.parseInt,
      o = /^[+-]?0[Xx]/,
      u = 8 !== a(s + "08") || 22 !== a(s + "0x16");
    e.exports = u
      ? function (e, t) {
          var i = n(String(e));
          return a(i, t >>> 0 || (o.test(i) ? 16 : 10));
        }
      : a;
  },
  function (e, t, i) {
    var r = i(20),
      n = i(65).f,
      s = {}.toString,
      a =
        "object" == typeof window && window && Object.getOwnPropertyNames
          ? Object.getOwnPropertyNames(window)
          : [];
    e.exports.f = function (e) {
      return a && "[object Window]" == s.call(e)
        ? (function (e) {
            try {
              return n(e);
            } catch (e) {
              return a.slice();
            }
          })(e)
        : n(r(e));
    };
  },
  function (e, t, i) {
    "use strict";
    var r = i(109),
      n = i(61);
    e.exports = r
      ? {}.toString
      : function () {
          return "[object " + n(this) + "]";
        };
  },
  function (e, t, i) {
    var r = i(25),
      n = i(65),
      s = i(101),
      a = i(7);
    e.exports =
      r("Reflect", "ownKeys") ||
      function (e) {
        var t = n.f(a(e)),
          i = s.f;
        return i ? t.concat(i(e)) : t;
      };
  },
  function (e, t, i) {
    "use strict";
    var r = /[^\0-\u007E]/,
      n = /[.\u3002\uFF0E\uFF61]/g,
      s = "Overflow: input needs wider integers to process",
      a = Math.floor,
      o = String.fromCharCode,
      u = function (e) {
        return e + 22 + 75 * (e < 26);
      },
      c = function (e, t, i) {
        var r = 0;
        for (e = i ? a(e / 700) : e >> 1, e += a(e / t); e > 455; r += 36)
          e = a(e / 35);
        return a(r + (36 * e) / (e + 38));
      },
      l = function (e) {
        var t,
          i,
          r = [],
          n = (e = (function (e) {
            for (var t = [], i = 0, r = e.length; i < r; ) {
              var n = e.charCodeAt(i++);
              if (n >= 55296 && n <= 56319 && i < r) {
                var s = e.charCodeAt(i++);
                56320 == (64512 & s)
                  ? t.push(((1023 & n) << 10) + (1023 & s) + 65536)
                  : (t.push(n), i--);
              } else t.push(n);
            }
            return t;
          })(e)).length,
          l = 128,
          h = 0,
          f = 72;
        for (t = 0; t < e.length; t++) (i = e[t]) < 128 && r.push(o(i));
        var d = r.length,
          p = d;
        for (d && r.push("-"); p < n; ) {
          var v = 2147483647;
          for (t = 0; t < e.length; t++) (i = e[t]) >= l && i < v && (v = i);
          var m = p + 1;
          if (v - l > a((2147483647 - h) / m)) throw RangeError(s);
          for (h += (v - l) * m, l = v, t = 0; t < e.length; t++) {
            if ((i = e[t]) < l && ++h > 2147483647) throw RangeError(s);
            if (i == l) {
              for (var g = h, y = 36; ; y += 36) {
                var _ = y <= f ? 1 : y >= f + 26 ? 26 : y - f;
                if (g < _) break;
                var b = g - _,
                  A = 36 - _;
                r.push(o(u(_ + (b % A)))), (g = a(b / A));
              }
              r.push(o(u(g))), (f = c(h, m, p == d)), (h = 0), ++p;
            }
          }
          ++h, ++l;
        }
        return r.join("");
      };
    e.exports = function (e) {
      var t,
        i,
        s = [],
        a = e.toLowerCase().replace(n, ".").split(".");
      for (t = 0; t < a.length; t++)
        (i = a[t]), s.push(r.test(i) ? "xn--" + l(i) : i);
      return s.join(".");
    };
  },
  function (e, t, i) {
    "use strict";
    var r = i(18),
      n = i(27);
    e.exports = function (e) {
      var t = String(n(this)),
        i = "",
        s = r(e);
      if (s < 0 || s == 1 / 0) throw RangeError("Wrong number of repetitions");
      for (; s > 0; (s >>>= 1) && (t += t)) 1 & s && (i += t);
      return i;
    };
  },
  function (e, t, i) {
    var r = i(55);
    e.exports = function (e) {
      if ("number" != typeof e && "Number" != r(e))
        throw TypeError("Incorrect invocation");
      return +e;
    };
  },
  function (e, t, i) {
    var r = i(18);
    e.exports = function (e) {
      var t = r(e);
      if (t < 0) throw RangeError("The argument can't be less than 0");
      return t;
    };
  },
  function (e, t, i) {
    "use strict";
    var r = i(1),
      n = i(4),
      s = i(8),
      a = i(211),
      o = i(2),
      u = i(73),
      c = i(72),
      l = i(24),
      h = i(15),
      f = i(6),
      d = i(147),
      p = i(148),
      v = i(67),
      m = i(11),
      g = i(61),
      y = i(9),
      _ = i(26),
      b = i(56),
      A = i(65).f,
      w = i(213),
      S = i(19).forEach,
      k = i(145),
      T = i(12),
      x = i(81),
      C = i(22),
      E = i(196),
      P = C.get,
      B = C.set,
      I = T.f,
      M = x.f,
      R = Math.round,
      L = n.RangeError,
      F = u.ArrayBuffer,
      O = u.DataView,
      D = o.NATIVE_ARRAY_BUFFER_VIEWS,
      U = o.TYPED_ARRAY_TAG,
      V = o.TypedArray,
      N = o.TypedArrayPrototype,
      j = o.aTypedArrayConstructor,
      H = o.isTypedArray,
      z = function (e, t) {
        for (var i = 0, r = t.length, n = new (j(e))(r); r > i; ) n[i] = t[i++];
        return n;
      },
      W = function (e, t) {
        I(e, t, {
          get: function () {
            return P(this)[t];
          },
        });
      },
      Y = function (e) {
        var t;
        return (
          e instanceof F ||
          "ArrayBuffer" == (t = g(e)) ||
          "SharedArrayBuffer" == t
        );
      },
      Q = function (e, t) {
        return (
          H(e) && "symbol" != typeof t && t in e && String(+t) == String(t)
        );
      },
      q = function (e, t) {
        return Q(e, (t = v(t, !0))) ? l(2, e[t]) : M(e, t);
      },
      G = function (e, t, i) {
        return !(Q(e, (t = v(t, !0))) && y(i) && m(i, "value")) ||
          m(i, "get") ||
          m(i, "set") ||
          i.configurable ||
          (m(i, "writable") && !i.writable) ||
          (m(i, "enumerable") && !i.enumerable)
          ? I(e, t, i)
          : ((e[t] = i.value), e);
      };
    s
      ? (D ||
          ((x.f = q),
          (T.f = G),
          W(N, "buffer"),
          W(N, "byteOffset"),
          W(N, "byteLength"),
          W(N, "length")),
        r(
          { target: "Object", stat: !0, forced: !D },
          { getOwnPropertyDescriptor: q, defineProperty: G }
        ),
        (e.exports = function (e, t, i) {
          var s = e.match(/\d+$/)[0] / 8,
            o = e + (i ? "Clamped" : "") + "Array",
            u = "get" + e,
            l = "set" + e,
            v = n[o],
            m = v,
            g = m && m.prototype,
            T = {},
            x = function (e, t) {
              I(e, t, {
                get: function () {
                  return (function (e, t) {
                    var i = P(e);
                    return i.view[u](t * s + i.byteOffset, !0);
                  })(this, t);
                },
                set: function (e) {
                  return (function (e, t, r) {
                    var n = P(e);
                    i && (r = (r = R(r)) < 0 ? 0 : r > 255 ? 255 : 255 & r),
                      n.view[l](t * s + n.byteOffset, r, !0);
                  })(this, t, e);
                },
                enumerable: !0,
              });
            };
          D
            ? a &&
              ((m = t(function (e, t, i, r) {
                return (
                  c(e, m, o),
                  E(
                    y(t)
                      ? Y(t)
                        ? void 0 !== r
                          ? new v(t, p(i, s), r)
                          : void 0 !== i
                          ? new v(t, p(i, s))
                          : new v(t)
                        : H(t)
                        ? z(m, t)
                        : w.call(m, t)
                      : new v(d(t)),
                    e,
                    m
                  )
                );
              })),
              b && b(m, V),
              S(A(v), function (e) {
                e in m || h(m, e, v[e]);
              }),
              (m.prototype = g))
            : ((m = t(function (e, t, i, r) {
                c(e, m, o);
                var n,
                  a,
                  u,
                  l = 0,
                  h = 0;
                if (y(t)) {
                  if (!Y(t)) return H(t) ? z(m, t) : w.call(m, t);
                  (n = t), (h = p(i, s));
                  var v = t.byteLength;
                  if (void 0 === r) {
                    if (v % s) throw L("Wrong length");
                    if ((a = v - h) < 0) throw L("Wrong length");
                  } else if ((a = f(r) * s) + h > v) throw L("Wrong length");
                  u = a / s;
                } else (u = d(t)), (n = new F((a = u * s)));
                for (
                  B(e, {
                    buffer: n,
                    byteOffset: h,
                    byteLength: a,
                    length: u,
                    view: new O(n),
                  });
                  l < u;

                )
                  x(e, l++);
              })),
              b && b(m, V),
              (g = m.prototype = _(N))),
            g.constructor !== m && h(g, "constructor", m),
            U && h(g, U, o),
            (T[o] = m),
            r({ global: !0, forced: m != v, sham: !D }, T),
            "BYTES_PER_ELEMENT" in m || h(m, "BYTES_PER_ELEMENT", s),
            "BYTES_PER_ELEMENT" in g || h(g, "BYTES_PER_ELEMENT", s),
            k(o);
        }))
      : (e.exports = function () {});
  },
  function (e, t, i) {
    var r = i(4),
      n = i(3),
      s = i(191),
      a = i(2).NATIVE_ARRAY_BUFFER_VIEWS,
      o = r.ArrayBuffer,
      u = r.Int8Array;
    e.exports =
      !a ||
      !n(function () {
        u(1);
      }) ||
      !n(function () {
        new u(-1);
      }) ||
      !s(function (e) {
        new u(), new u(null), new u(1.5), new u(e);
      }, !0) ||
      n(function () {
        return 1 !== new u(new o(2), 1, void 0).length;
      });
  },
  function (e, t, i) {
    var r = i(2).aTypedArrayConstructor,
      n = i(58);
    e.exports = function (e, t) {
      for (
        var i = n(e, e.constructor), s = 0, a = t.length, o = new (r(i))(a);
        a > s;

      )
        o[s] = t[s++];
      return o;
    };
  },
  function (e, t, i) {
    var r = i(13),
      n = i(6),
      s = i(78),
      a = i(136),
      o = i(77),
      u = i(2).aTypedArrayConstructor;
    e.exports = function (e) {
      var t,
        i,
        c,
        l,
        h,
        f,
        d = r(e),
        p = arguments.length,
        v = p > 1 ? arguments[1] : void 0,
        m = void 0 !== v,
        g = s(d);
      if (void 0 != g && !a(g))
        for (f = (h = g.call(d)).next, d = []; !(l = f.call(h)).done; )
          d.push(l.value);
      for (
        m && p > 2 && (v = o(v, arguments[2], 2)),
          i = n(d.length),
          c = new (u(this))(i),
          t = 0;
        i > t;
        t++
      )
        c[t] = m ? v(d[t], t) : d[t];
      return c;
    };
  },
  function (e, t, i) {
    "use strict";
    var r = i(1),
      n = i(4),
      s = i(73),
      a = i(145),
      o = s.ArrayBuffer;
    r({ global: !0, forced: n.ArrayBuffer !== o }, { ArrayBuffer: o }),
      a("ArrayBuffer");
  },
  function (e, t, i) {
    "use strict";
    var r = i(1),
      n = i(9),
      s = i(80),
      a = i(28),
      o = i(6),
      u = i(20),
      c = i(76),
      l = i(5),
      h = i(96)("slice"),
      f = l("species"),
      d = [].slice,
      p = Math.max;
    r(
      { target: "Array", proto: !0, forced: !h },
      {
        slice: function (e, t) {
          var i,
            r,
            l,
            h = u(this),
            v = o(h.length),
            m = a(e, v),
            g = a(void 0 === t ? v : t, v);
          if (
            s(h) &&
            ("function" != typeof (i = h.constructor) ||
            (i !== Array && !s(i.prototype))
              ? n(i) && null === (i = i[f]) && (i = void 0)
              : (i = void 0),
            i === Array || void 0 === i)
          )
            return d.call(h, m, g);
          for (
            r = new (void 0 === i ? Array : i)(p(g - m, 0)), l = 0;
            m < g;
            m++, l++
          )
            m in h && c(r, l, h[m]);
          return (r.length = l), r;
        },
      }
    );
  },
  function (e, t, i) {
    "use strict";
    var r = i(1),
      n = i(54),
      s = i(13),
      a = i(3),
      o = i(75),
      u = [],
      c = u.sort,
      l = a(function () {
        u.sort(void 0);
      }),
      h = a(function () {
        u.sort(null);
      }),
      f = o("sort");
    r(
      { target: "Array", proto: !0, forced: l || !h || !f },
      {
        sort: function (e) {
          return void 0 === e ? c.call(s(this)) : c.call(s(this), n(e));
        },
      }
    );
  },
  function (e, t, i) {
    i(1)(
      { target: "Date", stat: !0 },
      {
        now: function () {
          return new Date().getTime();
        },
      }
    );
  },
  function (e, t, i) {
    var r = i(1),
      n = Math.log,
      s = Math.LOG10E;
    r(
      { target: "Math", stat: !0 },
      {
        log10: function (e) {
          return n(e) * s;
        },
      }
    );
  },
  function (e, t, i) {
    var r = i(1),
      n = i(139);
    r(
      { target: "Object", stat: !0, forced: Object.assign !== n },
      { assign: n }
    );
  },
  function (e, t, i) {
    "use strict";
    var r = i(132),
      n = i(7),
      s = i(6),
      a = i(27),
      o = i(121),
      u = i(144);
    r("match", 1, function (e, t, i) {
      return [
        function (t) {
          var i = a(this),
            r = void 0 == t ? void 0 : t[e];
          return void 0 !== r ? r.call(t, i) : new RegExp(t)[e](String(i));
        },
        function (e) {
          var r = i(t, e, this);
          if (r.done) return r.value;
          var a = n(e),
            c = String(this);
          if (!a.global) return u(a, c);
          var l = a.unicode;
          a.lastIndex = 0;
          for (var h, f = [], d = 0; null !== (h = u(a, c)); ) {
            var p = String(h[0]);
            (f[d] = p),
              "" === p && (a.lastIndex = o(c, s(a.lastIndex), l)),
              d++;
          }
          return 0 === d ? null : f;
        },
      ];
    });
  },
  function (e, t, i) {
    "use strict";
    var r = i(132),
      n = i(198),
      s = i(7),
      a = i(27),
      o = i(58),
      u = i(121),
      c = i(6),
      l = i(144),
      h = i(82),
      f = i(105).UNSUPPORTED_Y,
      d = [].push,
      p = Math.min;
    r(
      "split",
      2,
      function (e, t, i) {
        var r;
        return (
          (r =
            "c" == "abbc".split(/(b)*/)[1] ||
            4 != "test".split(/(?:)/, -1).length ||
            2 != "ab".split(/(?:ab)*/).length ||
            4 != ".".split(/(.?)(.?)/).length ||
            ".".split(/()()/).length > 1 ||
            "".split(/.?/).length
              ? function (e, i) {
                  var r = String(a(this)),
                    s = void 0 === i ? 4294967295 : i >>> 0;
                  if (0 === s) return [];
                  if (void 0 === e) return [r];
                  if (!n(e)) return t.call(r, e, s);
                  for (
                    var o,
                      u,
                      c,
                      l = [],
                      f =
                        (e.ignoreCase ? "i" : "") +
                        (e.multiline ? "m" : "") +
                        (e.unicode ? "u" : "") +
                        (e.sticky ? "y" : ""),
                      p = 0,
                      v = new RegExp(e.source, f + "g");
                    (o = h.call(v, r)) &&
                    !(
                      (u = v.lastIndex) > p &&
                      (l.push(r.slice(p, o.index)),
                      o.length > 1 &&
                        o.index < r.length &&
                        d.apply(l, o.slice(1)),
                      (c = o[0].length),
                      (p = u),
                      l.length >= s)
                    );

                  )
                    v.lastIndex === o.index && v.lastIndex++;
                  return (
                    p === r.length
                      ? (!c && v.test("")) || l.push("")
                      : l.push(r.slice(p)),
                    l.length > s ? l.slice(0, s) : l
                  );
                }
              : "0".split(void 0, 0).length
              ? function (e, i) {
                  return void 0 === e && 0 === i ? [] : t.call(this, e, i);
                }
              : t),
          [
            function (t, i) {
              var n = a(this),
                s = void 0 == t ? void 0 : t[e];
              return void 0 !== s ? s.call(t, n, i) : r.call(String(n), t, i);
            },
            function (e, n) {
              var a = i(r, e, this, n, r !== t);
              if (a.done) return a.value;
              var h = s(e),
                d = String(this),
                v = o(h, RegExp),
                m = h.unicode,
                g =
                  (h.ignoreCase ? "i" : "") +
                  (h.multiline ? "m" : "") +
                  (h.unicode ? "u" : "") +
                  (f ? "g" : "y"),
                y = new v(f ? "^(?:" + h.source + ")" : h, g),
                _ = void 0 === n ? 4294967295 : n >>> 0;
              if (0 === _) return [];
              if (0 === d.length) return null === l(y, d) ? [d] : [];
              for (var b = 0, A = 0, w = []; A < d.length; ) {
                y.lastIndex = f ? 0 : A;
                var S,
                  k = l(y, f ? d.slice(A) : d);
                if (
                  null === k ||
                  (S = p(c(y.lastIndex + (f ? A : 0)), d.length)) === b
                )
                  A = u(d, A, m);
                else {
                  if ((w.push(d.slice(b, A)), w.length === _)) return w;
                  for (var T = 1; T <= k.length - 1; T++)
                    if ((w.push(k[T]), w.length === _)) return w;
                  A = b = S;
                }
              }
              return w.push(d.slice(b)), w;
            },
          ]
        );
      },
      f
    );
  },
  function (e, t, i) {
    "use strict";
    i(14);
    var r = i(1),
      n = i(25),
      s = i(138),
      a = i(17),
      o = i(143),
      u = i(57),
      c = i(127),
      l = i(22),
      h = i(72),
      f = i(11),
      d = i(77),
      p = i(61),
      v = i(7),
      m = i(9),
      g = i(26),
      y = i(24),
      _ = i(193),
      b = i(78),
      A = i(5),
      w = n("fetch"),
      S = n("Headers"),
      k = A("iterator"),
      T = l.set,
      x = l.getterFor("URLSearchParams"),
      C = l.getterFor("URLSearchParamsIterator"),
      E = /\+/g,
      P = Array(4),
      B = function (e) {
        return (
          P[e - 1] || (P[e - 1] = RegExp("((?:%[\\da-f]{2}){" + e + "})", "gi"))
        );
      },
      I = function (e) {
        try {
          return decodeURIComponent(e);
        } catch (t) {
          return e;
        }
      },
      M = function (e) {
        var t = e.replace(E, " "),
          i = 4;
        try {
          return decodeURIComponent(t);
        } catch (e) {
          for (; i; ) t = t.replace(B(i--), I);
          return t;
        }
      },
      R = /[!'()~]|%20/g,
      L = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
      },
      F = function (e) {
        return L[e];
      },
      O = function (e) {
        return encodeURIComponent(e).replace(R, F);
      },
      D = function (e, t) {
        if (t)
          for (var i, r, n = t.split("&"), s = 0; s < n.length; )
            (i = n[s++]).length &&
              ((r = i.split("=")),
              e.push({ key: M(r.shift()), value: M(r.join("=")) }));
      },
      U = function (e) {
        (this.entries.length = 0), D(this.entries, e);
      },
      V = function (e, t) {
        if (e < t) throw TypeError("Not enough arguments");
      },
      N = c(
        function (e, t) {
          T(this, {
            type: "URLSearchParamsIterator",
            iterator: _(x(e).entries),
            kind: t,
          });
        },
        "Iterator",
        function () {
          var e = C(this),
            t = e.kind,
            i = e.iterator.next(),
            r = i.value;
          return (
            i.done ||
              (i.value =
                "keys" === t
                  ? r.key
                  : "values" === t
                  ? r.value
                  : [r.key, r.value]),
            i
          );
        }
      ),
      j = function () {
        h(this, j, "URLSearchParams");
        var e,
          t,
          i,
          r,
          n,
          s,
          a,
          o,
          u,
          c = arguments.length > 0 ? arguments[0] : void 0,
          l = [];
        if (
          (T(this, {
            type: "URLSearchParams",
            entries: l,
            updateURL: function () {},
            updateSearchParams: U,
          }),
          void 0 !== c)
        )
          if (m(c))
            if ("function" == typeof (e = b(c)))
              for (i = (t = e.call(c)).next; !(r = i.call(t)).done; ) {
                if (
                  (a = (s = (n = _(v(r.value))).next).call(n)).done ||
                  (o = s.call(n)).done ||
                  !s.call(n).done
                )
                  throw TypeError("Expected sequence with length 2");
                l.push({ key: a.value + "", value: o.value + "" });
              }
            else for (u in c) f(c, u) && l.push({ key: u, value: c[u] + "" });
          else
            D(
              l,
              "string" == typeof c
                ? "?" === c.charAt(0)
                  ? c.slice(1)
                  : c
                : c + ""
            );
      },
      H = j.prototype;
    o(
      H,
      {
        append: function (e, t) {
          V(arguments.length, 2);
          var i = x(this);
          i.entries.push({ key: e + "", value: t + "" }), i.updateURL();
        },
        delete: function (e) {
          V(arguments.length, 1);
          for (
            var t = x(this), i = t.entries, r = e + "", n = 0;
            n < i.length;

          )
            i[n].key === r ? i.splice(n, 1) : n++;
          t.updateURL();
        },
        get: function (e) {
          V(arguments.length, 1);
          for (var t = x(this).entries, i = e + "", r = 0; r < t.length; r++)
            if (t[r].key === i) return t[r].value;
          return null;
        },
        getAll: function (e) {
          V(arguments.length, 1);
          for (
            var t = x(this).entries, i = e + "", r = [], n = 0;
            n < t.length;
            n++
          )
            t[n].key === i && r.push(t[n].value);
          return r;
        },
        has: function (e) {
          V(arguments.length, 1);
          for (var t = x(this).entries, i = e + "", r = 0; r < t.length; )
            if (t[r++].key === i) return !0;
          return !1;
        },
        set: function (e, t) {
          V(arguments.length, 1);
          for (
            var i,
              r = x(this),
              n = r.entries,
              s = !1,
              a = e + "",
              o = t + "",
              u = 0;
            u < n.length;
            u++
          )
            (i = n[u]).key === a &&
              (s ? n.splice(u--, 1) : ((s = !0), (i.value = o)));
          s || n.push({ key: a, value: o }), r.updateURL();
        },
        sort: function () {
          var e,
            t,
            i,
            r = x(this),
            n = r.entries,
            s = n.slice();
          for (n.length = 0, i = 0; i < s.length; i++) {
            for (e = s[i], t = 0; t < i; t++)
              if (n[t].key > e.key) {
                n.splice(t, 0, e);
                break;
              }
            t === i && n.push(e);
          }
          r.updateURL();
        },
        forEach: function (e) {
          for (
            var t,
              i = x(this).entries,
              r = d(e, arguments.length > 1 ? arguments[1] : void 0, 3),
              n = 0;
            n < i.length;

          )
            r((t = i[n++]).value, t.key, this);
        },
        keys: function () {
          return new N(this, "keys");
        },
        values: function () {
          return new N(this, "values");
        },
        entries: function () {
          return new N(this, "entries");
        },
      },
      { enumerable: !0 }
    ),
      a(H, k, H.entries),
      a(
        H,
        "toString",
        function () {
          for (var e, t = x(this).entries, i = [], r = 0; r < t.length; )
            (e = t[r++]), i.push(O(e.key) + "=" + O(e.value));
          return i.join("&");
        },
        { enumerable: !0 }
      ),
      u(j, "URLSearchParams"),
      r({ global: !0, forced: !s }, { URLSearchParams: j }),
      s ||
        "function" != typeof w ||
        "function" != typeof S ||
        r(
          { global: !0, enumerable: !0, forced: !0 },
          {
            fetch: function (e) {
              var t,
                i,
                r,
                n = [e];
              return (
                arguments.length > 1 &&
                  ((t = arguments[1]),
                  m(t) &&
                    ((i = t.body),
                    "URLSearchParams" === p(i) &&
                      ((r = t.headers ? new S(t.headers) : new S()).has(
                        "content-type"
                      ) ||
                        r.set(
                          "content-type",
                          "application/x-www-form-urlencoded;charset=UTF-8"
                        ),
                      (t = g(t, { body: y(0, String(i)), headers: y(0, r) })))),
                  n.push(t)),
                w.apply(this, n)
              );
            },
          }
        ),
      (e.exports = { URLSearchParams: j, getState: x });
  },
  function (e, t, i) {
    "use strict";
    i(59);
    var r,
      n = i(1),
      s = i(8),
      a = i(138),
      o = i(4),
      u = i(140),
      c = i(17),
      l = i(72),
      h = i(11),
      f = i(139),
      d = i(189),
      p = i(108).codeAt,
      v = i(206),
      m = i(57),
      g = i(222),
      y = i(22),
      _ = o.URL,
      b = g.URLSearchParams,
      A = g.getState,
      w = y.set,
      S = y.getterFor("URL"),
      k = Math.floor,
      T = Math.pow,
      x = /[A-Za-z]/,
      C = /[\d+-.A-Za-z]/,
      E = /\d/,
      P = /^(0x|0X)/,
      B = /^[0-7]+$/,
      I = /^\d+$/,
      M = /^[\dA-Fa-f]+$/,
      R = /[\0\t\n\r #%\/:?@[\\]]/,
      L = /[\0\t\n\r #\/:?@[\\]]/,
      F = /^[\u0000-\u001F ]+|[\u0000-\u001F ]+$/g,
      O = /[\t\n\r]/g,
      D = function (e, t) {
        var i, r, n;
        if ("[" == t.charAt(0)) {
          if ("]" != t.charAt(t.length - 1)) return "Invalid host";
          if (!(i = V(t.slice(1, -1)))) return "Invalid host";
          e.host = i;
        } else if (q(e)) {
          if (((t = v(t)), R.test(t))) return "Invalid host";
          if (null === (i = U(t))) return "Invalid host";
          e.host = i;
        } else {
          if (L.test(t)) return "Invalid host";
          for (i = "", r = d(t), n = 0; n < r.length; n++) i += Y(r[n], j);
          e.host = i;
        }
      },
      U = function (e) {
        var t,
          i,
          r,
          n,
          s,
          a,
          o,
          u = e.split(".");
        if ((u.length && "" == u[u.length - 1] && u.pop(), (t = u.length) > 4))
          return e;
        for (i = [], r = 0; r < t; r++) {
          if ("" == (n = u[r])) return e;
          if (
            ((s = 10),
            n.length > 1 &&
              "0" == n.charAt(0) &&
              ((s = P.test(n) ? 16 : 8), (n = n.slice(8 == s ? 1 : 2))),
            "" === n)
          )
            a = 0;
          else {
            if (!(10 == s ? I : 8 == s ? B : M).test(n)) return e;
            a = parseInt(n, s);
          }
          i.push(a);
        }
        for (r = 0; r < t; r++)
          if (((a = i[r]), r == t - 1)) {
            if (a >= T(256, 5 - t)) return null;
          } else if (a > 255) return null;
        for (o = i.pop(), r = 0; r < i.length; r++) o += i[r] * T(256, 3 - r);
        return o;
      },
      V = function (e) {
        var t,
          i,
          r,
          n,
          s,
          a,
          o,
          u = [0, 0, 0, 0, 0, 0, 0, 0],
          c = 0,
          l = null,
          h = 0,
          f = function () {
            return e.charAt(h);
          };
        if (":" == f()) {
          if (":" != e.charAt(1)) return;
          (h += 2), (l = ++c);
        }
        for (; f(); ) {
          if (8 == c) return;
          if (":" != f()) {
            for (t = i = 0; i < 4 && M.test(f()); )
              (t = 16 * t + parseInt(f(), 16)), h++, i++;
            if ("." == f()) {
              if (0 == i) return;
              if (((h -= i), c > 6)) return;
              for (r = 0; f(); ) {
                if (((n = null), r > 0)) {
                  if (!("." == f() && r < 4)) return;
                  h++;
                }
                if (!E.test(f())) return;
                for (; E.test(f()); ) {
                  if (((s = parseInt(f(), 10)), null === n)) n = s;
                  else {
                    if (0 == n) return;
                    n = 10 * n + s;
                  }
                  if (n > 255) return;
                  h++;
                }
                (u[c] = 256 * u[c] + n), (2 != ++r && 4 != r) || c++;
              }
              if (4 != r) return;
              break;
            }
            if (":" == f()) {
              if ((h++, !f())) return;
            } else if (f()) return;
            u[c++] = t;
          } else {
            if (null !== l) return;
            h++, (l = ++c);
          }
        }
        if (null !== l)
          for (a = c - l, c = 7; 0 != c && a > 0; )
            (o = u[c]), (u[c--] = u[l + a - 1]), (u[l + --a] = o);
        else if (8 != c) return;
        return u;
      },
      N = function (e) {
        var t, i, r, n;
        if ("number" == typeof e) {
          for (t = [], i = 0; i < 4; i++) t.unshift(e % 256), (e = k(e / 256));
          return t.join(".");
        }
        if ("object" == typeof e) {
          for (
            t = "",
              r = (function (e) {
                for (var t = null, i = 1, r = null, n = 0, s = 0; s < 8; s++)
                  0 !== e[s]
                    ? (n > i && ((t = r), (i = n)), (r = null), (n = 0))
                    : (null === r && (r = s), ++n);
                return n > i && ((t = r), (i = n)), t;
              })(e),
              i = 0;
            i < 8;
            i++
          )
            (n && 0 === e[i]) ||
              (n && (n = !1),
              r === i
                ? ((t += i ? ":" : "::"), (n = !0))
                : ((t += e[i].toString(16)), i < 7 && (t += ":")));
          return "[" + t + "]";
        }
        return e;
      },
      j = {},
      H = f({}, j, { " ": 1, '"': 1, "<": 1, ">": 1, "`": 1 }),
      z = f({}, H, { "#": 1, "?": 1, "{": 1, "}": 1 }),
      W = f({}, z, {
        "/": 1,
        ":": 1,
        ";": 1,
        "=": 1,
        "@": 1,
        "[": 1,
        "\\": 1,
        "]": 1,
        "^": 1,
        "|": 1,
      }),
      Y = function (e, t) {
        var i = p(e, 0);
        return i > 32 && i < 127 && !h(t, e) ? e : encodeURIComponent(e);
      },
      Q = { ftp: 21, file: null, http: 80, https: 443, ws: 80, wss: 443 },
      q = function (e) {
        return h(Q, e.scheme);
      },
      G = function (e) {
        return "" != e.username || "" != e.password;
      },
      J = function (e) {
        return !e.host || e.cannotBeABaseURL || "file" == e.scheme;
      },
      K = function (e, t) {
        var i;
        return (
          2 == e.length &&
          x.test(e.charAt(0)) &&
          (":" == (i = e.charAt(1)) || (!t && "|" == i))
        );
      },
      X = function (e) {
        var t;
        return (
          e.length > 1 &&
          K(e.slice(0, 2)) &&
          (2 == e.length ||
            "/" === (t = e.charAt(2)) ||
            "\\" === t ||
            "?" === t ||
            "#" === t)
        );
      },
      Z = function (e) {
        var t = e.path,
          i = t.length;
        !i || ("file" == e.scheme && 1 == i && K(t[0], !0)) || t.pop();
      },
      $ = function (e) {
        return "." === e || "%2e" === e.toLowerCase();
      },
      ee = {},
      te = {},
      ie = {},
      re = {},
      ne = {},
      se = {},
      ae = {},
      oe = {},
      ue = {},
      ce = {},
      le = {},
      he = {},
      fe = {},
      de = {},
      pe = {},
      ve = {},
      me = {},
      ge = {},
      ye = {},
      _e = {},
      be = {},
      Ae = function (e, t, i, n) {
        var s,
          a,
          o,
          u,
          c,
          l = i || ee,
          f = 0,
          p = "",
          v = !1,
          m = !1,
          g = !1;
        for (
          i ||
            ((e.scheme = ""),
            (e.username = ""),
            (e.password = ""),
            (e.host = null),
            (e.port = null),
            (e.path = []),
            (e.query = null),
            (e.fragment = null),
            (e.cannotBeABaseURL = !1),
            (t = t.replace(F, ""))),
            t = t.replace(O, ""),
            s = d(t);
          f <= s.length;

        ) {
          switch (((a = s[f]), l)) {
            case ee:
              if (!a || !x.test(a)) {
                if (i) return "Invalid scheme";
                l = ie;
                continue;
              }
              (p += a.toLowerCase()), (l = te);
              break;
            case te:
              if (a && (C.test(a) || "+" == a || "-" == a || "." == a))
                p += a.toLowerCase();
              else {
                if (":" != a) {
                  if (i) return "Invalid scheme";
                  (p = ""), (l = ie), (f = 0);
                  continue;
                }
                if (
                  i &&
                  (q(e) != h(Q, p) ||
                    ("file" == p && (G(e) || null !== e.port)) ||
                    ("file" == e.scheme && !e.host))
                )
                  return;
                if (((e.scheme = p), i))
                  return void (
                    q(e) &&
                    Q[e.scheme] == e.port &&
                    (e.port = null)
                  );
                (p = ""),
                  "file" == e.scheme
                    ? (l = de)
                    : q(e) && n && n.scheme == e.scheme
                    ? (l = re)
                    : q(e)
                    ? (l = oe)
                    : "/" == s[f + 1]
                    ? ((l = ne), f++)
                    : ((e.cannotBeABaseURL = !0), e.path.push(""), (l = ye));
              }
              break;
            case ie:
              if (!n || (n.cannotBeABaseURL && "#" != a))
                return "Invalid scheme";
              if (n.cannotBeABaseURL && "#" == a) {
                (e.scheme = n.scheme),
                  (e.path = n.path.slice()),
                  (e.query = n.query),
                  (e.fragment = ""),
                  (e.cannotBeABaseURL = !0),
                  (l = be);
                break;
              }
              l = "file" == n.scheme ? de : se;
              continue;
            case re:
              if ("/" != a || "/" != s[f + 1]) {
                l = se;
                continue;
              }
              (l = ue), f++;
              break;
            case ne:
              if ("/" == a) {
                l = ce;
                break;
              }
              l = ge;
              continue;
            case se:
              if (((e.scheme = n.scheme), a == r))
                (e.username = n.username),
                  (e.password = n.password),
                  (e.host = n.host),
                  (e.port = n.port),
                  (e.path = n.path.slice()),
                  (e.query = n.query);
              else if ("/" == a || ("\\" == a && q(e))) l = ae;
              else if ("?" == a)
                (e.username = n.username),
                  (e.password = n.password),
                  (e.host = n.host),
                  (e.port = n.port),
                  (e.path = n.path.slice()),
                  (e.query = ""),
                  (l = _e);
              else {
                if ("#" != a) {
                  (e.username = n.username),
                    (e.password = n.password),
                    (e.host = n.host),
                    (e.port = n.port),
                    (e.path = n.path.slice()),
                    e.path.pop(),
                    (l = ge);
                  continue;
                }
                (e.username = n.username),
                  (e.password = n.password),
                  (e.host = n.host),
                  (e.port = n.port),
                  (e.path = n.path.slice()),
                  (e.query = n.query),
                  (e.fragment = ""),
                  (l = be);
              }
              break;
            case ae:
              if (!q(e) || ("/" != a && "\\" != a)) {
                if ("/" != a) {
                  (e.username = n.username),
                    (e.password = n.password),
                    (e.host = n.host),
                    (e.port = n.port),
                    (l = ge);
                  continue;
                }
                l = ce;
              } else l = ue;
              break;
            case oe:
              if (((l = ue), "/" != a || "/" != p.charAt(f + 1))) continue;
              f++;
              break;
            case ue:
              if ("/" != a && "\\" != a) {
                l = ce;
                continue;
              }
              break;
            case ce:
              if ("@" == a) {
                v && (p = "%40" + p), (v = !0), (o = d(p));
                for (var y = 0; y < o.length; y++) {
                  var _ = o[y];
                  if (":" != _ || g) {
                    var b = Y(_, W);
                    g ? (e.password += b) : (e.username += b);
                  } else g = !0;
                }
                p = "";
              } else if (
                a == r ||
                "/" == a ||
                "?" == a ||
                "#" == a ||
                ("\\" == a && q(e))
              ) {
                if (v && "" == p) return "Invalid authority";
                (f -= d(p).length + 1), (p = ""), (l = le);
              } else p += a;
              break;
            case le:
            case he:
              if (i && "file" == e.scheme) {
                l = ve;
                continue;
              }
              if (":" != a || m) {
                if (
                  a == r ||
                  "/" == a ||
                  "?" == a ||
                  "#" == a ||
                  ("\\" == a && q(e))
                ) {
                  if (q(e) && "" == p) return "Invalid host";
                  if (i && "" == p && (G(e) || null !== e.port)) return;
                  if ((u = D(e, p))) return u;
                  if (((p = ""), (l = me), i)) return;
                  continue;
                }
                "[" == a ? (m = !0) : "]" == a && (m = !1), (p += a);
              } else {
                if ("" == p) return "Invalid host";
                if ((u = D(e, p))) return u;
                if (((p = ""), (l = fe), i == he)) return;
              }
              break;
            case fe:
              if (!E.test(a)) {
                if (
                  a == r ||
                  "/" == a ||
                  "?" == a ||
                  "#" == a ||
                  ("\\" == a && q(e)) ||
                  i
                ) {
                  if ("" != p) {
                    var A = parseInt(p, 10);
                    if (A > 65535) return "Invalid port";
                    (e.port = q(e) && A === Q[e.scheme] ? null : A), (p = "");
                  }
                  if (i) return;
                  l = me;
                  continue;
                }
                return "Invalid port";
              }
              p += a;
              break;
            case de:
              if (((e.scheme = "file"), "/" == a || "\\" == a)) l = pe;
              else {
                if (!n || "file" != n.scheme) {
                  l = ge;
                  continue;
                }
                if (a == r)
                  (e.host = n.host),
                    (e.path = n.path.slice()),
                    (e.query = n.query);
                else if ("?" == a)
                  (e.host = n.host),
                    (e.path = n.path.slice()),
                    (e.query = ""),
                    (l = _e);
                else {
                  if ("#" != a) {
                    X(s.slice(f).join("")) ||
                      ((e.host = n.host), (e.path = n.path.slice()), Z(e)),
                      (l = ge);
                    continue;
                  }
                  (e.host = n.host),
                    (e.path = n.path.slice()),
                    (e.query = n.query),
                    (e.fragment = ""),
                    (l = be);
                }
              }
              break;
            case pe:
              if ("/" == a || "\\" == a) {
                l = ve;
                break;
              }
              n &&
                "file" == n.scheme &&
                !X(s.slice(f).join("")) &&
                (K(n.path[0], !0) ? e.path.push(n.path[0]) : (e.host = n.host)),
                (l = ge);
              continue;
            case ve:
              if (a == r || "/" == a || "\\" == a || "?" == a || "#" == a) {
                if (!i && K(p)) l = ge;
                else if ("" == p) {
                  if (((e.host = ""), i)) return;
                  l = me;
                } else {
                  if ((u = D(e, p))) return u;
                  if (("localhost" == e.host && (e.host = ""), i)) return;
                  (p = ""), (l = me);
                }
                continue;
              }
              p += a;
              break;
            case me:
              if (q(e)) {
                if (((l = ge), "/" != a && "\\" != a)) continue;
              } else if (i || "?" != a)
                if (i || "#" != a) {
                  if (a != r && ((l = ge), "/" != a)) continue;
                } else (e.fragment = ""), (l = be);
              else (e.query = ""), (l = _e);
              break;
            case ge:
              if (
                a == r ||
                "/" == a ||
                ("\\" == a && q(e)) ||
                (!i && ("?" == a || "#" == a))
              ) {
                if (
                  (".." === (c = (c = p).toLowerCase()) ||
                  "%2e." === c ||
                  ".%2e" === c ||
                  "%2e%2e" === c
                    ? (Z(e), "/" == a || ("\\" == a && q(e)) || e.path.push(""))
                    : $(p)
                    ? "/" == a || ("\\" == a && q(e)) || e.path.push("")
                    : ("file" == e.scheme &&
                        !e.path.length &&
                        K(p) &&
                        (e.host && (e.host = ""), (p = p.charAt(0) + ":")),
                      e.path.push(p)),
                  (p = ""),
                  "file" == e.scheme && (a == r || "?" == a || "#" == a))
                )
                  for (; e.path.length > 1 && "" === e.path[0]; )
                    e.path.shift();
                "?" == a
                  ? ((e.query = ""), (l = _e))
                  : "#" == a && ((e.fragment = ""), (l = be));
              } else p += Y(a, z);
              break;
            case ye:
              "?" == a
                ? ((e.query = ""), (l = _e))
                : "#" == a
                ? ((e.fragment = ""), (l = be))
                : a != r && (e.path[0] += Y(a, j));
              break;
            case _e:
              i || "#" != a
                ? a != r &&
                  ("'" == a && q(e)
                    ? (e.query += "%27")
                    : (e.query += "#" == a ? "%23" : Y(a, j)))
                : ((e.fragment = ""), (l = be));
              break;
            case be:
              a != r && (e.fragment += Y(a, H));
          }
          f++;
        }
      },
      we = function (e) {
        var t,
          i,
          r = l(this, we, "URL"),
          n = arguments.length > 1 ? arguments[1] : void 0,
          a = String(e),
          o = w(r, { type: "URL" });
        if (void 0 !== n)
          if (n instanceof we) t = S(n);
          else if ((i = Ae((t = {}), String(n)))) throw TypeError(i);
        if ((i = Ae(o, a, null, t))) throw TypeError(i);
        var u = (o.searchParams = new b()),
          c = A(u);
        c.updateSearchParams(o.query),
          (c.updateURL = function () {
            o.query = String(u) || null;
          }),
          s ||
            ((r.href = ke.call(r)),
            (r.origin = Te.call(r)),
            (r.protocol = xe.call(r)),
            (r.username = Ce.call(r)),
            (r.password = Ee.call(r)),
            (r.host = Pe.call(r)),
            (r.hostname = Be.call(r)),
            (r.port = Ie.call(r)),
            (r.pathname = Me.call(r)),
            (r.search = Re.call(r)),
            (r.searchParams = Le.call(r)),
            (r.hash = Fe.call(r)));
      },
      Se = we.prototype,
      ke = function () {
        var e = S(this),
          t = e.scheme,
          i = e.username,
          r = e.password,
          n = e.host,
          s = e.port,
          a = e.path,
          o = e.query,
          u = e.fragment,
          c = t + ":";
        return (
          null !== n
            ? ((c += "//"),
              G(e) && (c += i + (r ? ":" + r : "") + "@"),
              (c += N(n)),
              null !== s && (c += ":" + s))
            : "file" == t && (c += "//"),
          (c += e.cannotBeABaseURL ? a[0] : a.length ? "/" + a.join("/") : ""),
          null !== o && (c += "?" + o),
          null !== u && (c += "#" + u),
          c
        );
      },
      Te = function () {
        var e = S(this),
          t = e.scheme,
          i = e.port;
        if ("blob" == t)
          try {
            return new we(t.path[0]).origin;
          } catch (e) {
            return "null";
          }
        return "file" != t && q(e)
          ? t + "://" + N(e.host) + (null !== i ? ":" + i : "")
          : "null";
      },
      xe = function () {
        return S(this).scheme + ":";
      },
      Ce = function () {
        return S(this).username;
      },
      Ee = function () {
        return S(this).password;
      },
      Pe = function () {
        var e = S(this),
          t = e.host,
          i = e.port;
        return null === t ? "" : null === i ? N(t) : N(t) + ":" + i;
      },
      Be = function () {
        var e = S(this).host;
        return null === e ? "" : N(e);
      },
      Ie = function () {
        var e = S(this).port;
        return null === e ? "" : String(e);
      },
      Me = function () {
        var e = S(this),
          t = e.path;
        return e.cannotBeABaseURL ? t[0] : t.length ? "/" + t.join("/") : "";
      },
      Re = function () {
        var e = S(this).query;
        return e ? "?" + e : "";
      },
      Le = function () {
        return S(this).searchParams;
      },
      Fe = function () {
        var e = S(this).fragment;
        return e ? "#" + e : "";
      },
      Oe = function (e, t) {
        return { get: e, set: t, configurable: !0, enumerable: !0 };
      };
    if (
      (s &&
        u(Se, {
          href: Oe(ke, function (e) {
            var t = S(this),
              i = String(e),
              r = Ae(t, i);
            if (r) throw TypeError(r);
            A(t.searchParams).updateSearchParams(t.query);
          }),
          origin: Oe(Te),
          protocol: Oe(xe, function (e) {
            var t = S(this);
            Ae(t, String(e) + ":", ee);
          }),
          username: Oe(Ce, function (e) {
            var t = S(this),
              i = d(String(e));
            if (!J(t)) {
              t.username = "";
              for (var r = 0; r < i.length; r++) t.username += Y(i[r], W);
            }
          }),
          password: Oe(Ee, function (e) {
            var t = S(this),
              i = d(String(e));
            if (!J(t)) {
              t.password = "";
              for (var r = 0; r < i.length; r++) t.password += Y(i[r], W);
            }
          }),
          host: Oe(Pe, function (e) {
            var t = S(this);
            t.cannotBeABaseURL || Ae(t, String(e), le);
          }),
          hostname: Oe(Be, function (e) {
            var t = S(this);
            t.cannotBeABaseURL || Ae(t, String(e), he);
          }),
          port: Oe(Ie, function (e) {
            var t = S(this);
            J(t) || ("" == (e = String(e)) ? (t.port = null) : Ae(t, e, fe));
          }),
          pathname: Oe(Me, function (e) {
            var t = S(this);
            t.cannotBeABaseURL || ((t.path = []), Ae(t, e + "", me));
          }),
          search: Oe(Re, function (e) {
            var t = S(this);
            "" == (e = String(e))
              ? (t.query = null)
              : ("?" == e.charAt(0) && (e = e.slice(1)),
                (t.query = ""),
                Ae(t, e, _e)),
              A(t.searchParams).updateSearchParams(t.query);
          }),
          searchParams: Oe(Le),
          hash: Oe(Fe, function (e) {
            var t = S(this);
            "" != (e = String(e))
              ? ("#" == e.charAt(0) && (e = e.slice(1)),
                (t.fragment = ""),
                Ae(t, e, be))
              : (t.fragment = null);
          }),
        }),
      c(
        Se,
        "toJSON",
        function () {
          return ke.call(this);
        },
        { enumerable: !0 }
      ),
      c(
        Se,
        "toString",
        function () {
          return ke.call(this);
        },
        { enumerable: !0 }
      ),
      _)
    ) {
      var De = _.createObjectURL,
        Ue = _.revokeObjectURL;
      De &&
        c(we, "createObjectURL", function (e) {
          return De.apply(_, arguments);
        }),
        Ue &&
          c(we, "revokeObjectURL", function (e) {
            return Ue.apply(_, arguments);
          });
    }
    m(we, "URL"), n({ global: !0, forced: !a, sham: !s }, { URL: we });
  },
  function (e, t) {
    var i;
    i = (function () {
      return this;
    })();
    try {
      i = i || Function("return this")() || (0, eval)("this");
    } catch (e) {
      "object" == typeof window && (i = window);
    }
    e.exports = i;
  },
  function (e, t, i) {
    e.exports = i(157);
  },
]);

export default SLDP;
